webpackJsonp([0],[
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * App entrance
	 */
	
	'use strict';
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	__webpack_require__(5);
	
	__webpack_require__(15);
	
	var _react = __webpack_require__(23);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactTapEventPlugin = __webpack_require__(174);
	
	var _reactTapEventPlugin2 = _interopRequireDefault(_reactTapEventPlugin);
	
	var _reactRouter = __webpack_require__(178);
	
	var _commonUtilsAjax = __webpack_require__(222);
	
	var _commonUtilsAjax2 = _interopRequireDefault(_commonUtilsAjax);
	
	var _dispatcherDispatcher = __webpack_require__(223);
	
	var _containersHomeMenuHomeContainerJsx = __webpack_require__(227);
	
	var _containersHomeMenuHomeContainerJsx2 = _interopRequireDefault(_containersHomeMenuHomeContainerJsx);
	
	var _containersHomeMenuEmployeeContainerJsx = __webpack_require__(308);
	
	var _containersHomeMenuEmployeeContainerJsx2 = _interopRequireDefault(_containersHomeMenuEmployeeContainerJsx);
	
	var _containersHomeMenuManagerContainerJsx = __webpack_require__(313);
	
	var _containersHomeMenuManagerContainerJsx2 = _interopRequireDefault(_containersHomeMenuManagerContainerJsx);
	
	var _containersProfileContainerJsx = __webpack_require__(314);
	
	var _containersProfileContainerJsx2 = _interopRequireDefault(_containersProfileContainerJsx);
	
	var _containersSalaryContainerJsx = __webpack_require__(330);
	
	var _containersSalaryContainerJsx2 = _interopRequireDefault(_containersSalaryContainerJsx);
	
	var _containersConfigChangePwdJsx = __webpack_require__(338);
	
	var _containersConfigChangePwdJsx2 = _interopRequireDefault(_containersConfigChangePwdJsx);
	
	var _containersConfigChangeMobileJsx = __webpack_require__(306);
	
	var _containersConfigChangeMobileJsx2 = _interopRequireDefault(_containersConfigChangeMobileJsx);
	
	var _containersConfirmMobileConfirmMobile = __webpack_require__(305);
	
	var _containersConfirmMobileConfirmMobile2 = _interopRequireDefault(_containersConfirmMobileConfirmMobile);
	
	var _containersTeamProfileContainerJsx = __webpack_require__(339);
	
	var _containersTeamProfileContainerJsx2 = _interopRequireDefault(_containersTeamProfileContainerJsx);
	
	var _containersTeamProfileEmpProfileContainerJsx = __webpack_require__(353);
	
	var _containersTeamProfileEmpProfileContainerJsx2 = _interopRequireDefault(_containersTeamProfileEmpProfileContainerJsx);
	
	var _containersLeaveLeaveContainerJsx = __webpack_require__(354);
	
	var _containersLeaveLeaveContainerJsx2 = _interopRequireDefault(_containersLeaveLeaveContainerJsx);
	
	var _containersLeaveLeaveListContainerJsx = __webpack_require__(357);
	
	var _containersLeaveLeaveListContainerJsx2 = _interopRequireDefault(_containersLeaveLeaveListContainerJsx);
	
	var _containersLeaveLeaveRecordContainerJsx = __webpack_require__(362);
	
	var _containersLeaveLeaveRecordContainerJsx2 = _interopRequireDefault(_containersLeaveLeaveRecordContainerJsx);
	
	var _containersLeaveLeaveQuotaContainerJsx = __webpack_require__(366);
	
	var _containersLeaveLeaveQuotaContainerJsx2 = _interopRequireDefault(_containersLeaveLeaveQuotaContainerJsx);
	
	var _containersLeaveLeaveSummaryContainerJsx = __webpack_require__(367);
	
	var _containersLeaveLeaveSummaryContainerJsx2 = _interopRequireDefault(_containersLeaveLeaveSummaryContainerJsx);
	
	var _containersLeaveLeaveMgrContainerJsx = __webpack_require__(368);
	
	var _containersLeaveLeaveMgrContainerJsx2 = _interopRequireDefault(_containersLeaveLeaveMgrContainerJsx);
	
	var _containersLeaveLeaveMgrHistoryContainerJsx = __webpack_require__(371);
	
	var _containersLeaveLeaveMgrHistoryContainerJsx2 = _interopRequireDefault(_containersLeaveLeaveMgrHistoryContainerJsx);
	
	var _containersLeaveLeaveMgrSummaryContainerJsx = __webpack_require__(372);
	
	var _containersLeaveLeaveMgrSummaryContainerJsx2 = _interopRequireDefault(_containersLeaveLeaveMgrSummaryContainerJsx);
	
	var _containersLeaveLeaveMgrEmpHistoryContainerJsx = __webpack_require__(373);
	
	var _containersLeaveLeaveMgrEmpHistoryContainerJsx2 = _interopRequireDefault(_containersLeaveLeaveMgrEmpHistoryContainerJsx);
	
	var _containersLeaveLeaveMgrQuotaContainerJsx = __webpack_require__(374);
	
	var _containersLeaveLeaveMgrQuotaContainerJsx2 = _interopRequireDefault(_containersLeaveLeaveMgrQuotaContainerJsx);
	
	var _containersLeaveLeaveMgrEmpQuotaContainerJsx = __webpack_require__(375);
	
	var _containersLeaveLeaveMgrEmpQuotaContainerJsx2 = _interopRequireDefault(_containersLeaveLeaveMgrEmpQuotaContainerJsx);
	
	var _containersLeaveLeaveMgrPendingContainerJsx = __webpack_require__(376);
	
	var _containersLeaveLeaveMgrPendingContainerJsx2 = _interopRequireDefault(_containersLeaveLeaveMgrPendingContainerJsx);
	
	var _containersOverTimeOvertimeContainerJsx = __webpack_require__(377);
	
	var _containersOverTimeOvertimeContainerJsx2 = _interopRequireDefault(_containersOverTimeOvertimeContainerJsx);
	
	var _containersOverTimeOvertimeEmpListContainer = __webpack_require__(379);
	
	var _containersOverTimeOvertimeEmpListContainer2 = _interopRequireDefault(_containersOverTimeOvertimeEmpListContainer);
	
	var _containersOverTimeOvertimeEmpRecordContainer = __webpack_require__(381);
	
	var _containersOverTimeOvertimeEmpRecordContainer2 = _interopRequireDefault(_containersOverTimeOvertimeEmpRecordContainer);
	
	var _containersOverTimeOvertimeEmpSummaryContainer = __webpack_require__(382);
	
	var _containersOverTimeOvertimeEmpSummaryContainer2 = _interopRequireDefault(_containersOverTimeOvertimeEmpSummaryContainer);
	
	var _containersOverTimeOvertimeMgrContainerJsx = __webpack_require__(383);
	
	var _containersOverTimeOvertimeMgrContainerJsx2 = _interopRequireDefault(_containersOverTimeOvertimeMgrContainerJsx);
	
	var _containersOverTimeOvertimeMgrPendingContainer = __webpack_require__(384);
	
	var _containersOverTimeOvertimeMgrPendingContainer2 = _interopRequireDefault(_containersOverTimeOvertimeMgrPendingContainer);
	
	var _containersOverTimeOvertimeMgrPendingRecordContainer = __webpack_require__(385);
	
	var _containersOverTimeOvertimeMgrPendingRecordContainer2 = _interopRequireDefault(_containersOverTimeOvertimeMgrPendingRecordContainer);
	
	var _containersOverTimeOvertimeMgrSummaryContainer = __webpack_require__(386);
	
	var _containersOverTimeOvertimeMgrSummaryContainer2 = _interopRequireDefault(_containersOverTimeOvertimeMgrSummaryContainer);
	
	var _containersOverTimeOvertimeMgrHistoryContainer = __webpack_require__(387);
	
	var _containersOverTimeOvertimeMgrHistoryContainer2 = _interopRequireDefault(_containersOverTimeOvertimeMgrHistoryContainer);
	
	var _containersOverTimeOvertimeMgrHistoryDetailContainer = __webpack_require__(388);
	
	var _containersOverTimeOvertimeMgrHistoryDetailContainer2 = _interopRequireDefault(_containersOverTimeOvertimeMgrHistoryDetailContainer);
	
	var _containersRepairClockInRepairClockInContainerJsx = __webpack_require__(389);
	
	var _containersRepairClockInRepairClockInContainerJsx2 = _interopRequireDefault(_containersRepairClockInRepairClockInContainerJsx);
	
	var _containersRepairClockInRepairClockInEmpListContainer = __webpack_require__(391);
	
	var _containersRepairClockInRepairClockInEmpListContainer2 = _interopRequireDefault(_containersRepairClockInRepairClockInEmpListContainer);
	
	var _containersRepairClockInRepairClockInEmpRecordContainer = __webpack_require__(392);
	
	var _containersRepairClockInRepairClockInEmpRecordContainer2 = _interopRequireDefault(_containersRepairClockInRepairClockInEmpRecordContainer);
	
	var _containersRepairClockInRepairClockInEmpCheckListContainer = __webpack_require__(393);
	
	var _containersRepairClockInRepairClockInEmpCheckListContainer2 = _interopRequireDefault(_containersRepairClockInRepairClockInEmpCheckListContainer);
	
	var _containersRepairClockInRepairClockInEmpCheckRecordContainer = __webpack_require__(394);
	
	var _containersRepairClockInRepairClockInEmpCheckRecordContainer2 = _interopRequireDefault(_containersRepairClockInRepairClockInEmpCheckRecordContainer);
	
	var _containersRepairClockInRepairClockInEmpViewListContainer = __webpack_require__(397);
	
	var _containersRepairClockInRepairClockInEmpViewListContainer2 = _interopRequireDefault(_containersRepairClockInRepairClockInEmpViewListContainer);
	
	var _containersRepairClockInRepairClockInEmpViewRecordContainer = __webpack_require__(398);
	
	var _containersRepairClockInRepairClockInEmpViewRecordContainer2 = _interopRequireDefault(_containersRepairClockInRepairClockInEmpViewRecordContainer);
	
	var _containersRepairClockInRepairClockInMgrContainerJsx = __webpack_require__(399);
	
	var _containersRepairClockInRepairClockInMgrContainerJsx2 = _interopRequireDefault(_containersRepairClockInRepairClockInMgrContainerJsx);
	
	var _containersRepairClockInRepairClockInMgrPendingContainer = __webpack_require__(400);
	
	var _containersRepairClockInRepairClockInMgrPendingContainer2 = _interopRequireDefault(_containersRepairClockInRepairClockInMgrPendingContainer);
	
	var _containersRepairClockInRepairClockInMgrPendingRecordContainer = __webpack_require__(401);
	
	var _containersRepairClockInRepairClockInMgrPendingRecordContainer2 = _interopRequireDefault(_containersRepairClockInRepairClockInMgrPendingRecordContainer);
	
	var _containersRepairClockInRepairClockInMgrHistoryContainer = __webpack_require__(402);
	
	var _containersRepairClockInRepairClockInMgrHistoryContainer2 = _interopRequireDefault(_containersRepairClockInRepairClockInMgrHistoryContainer);
	
	var _containersTestsTestContainerJsx = __webpack_require__(403);
	
	var _containersTestsTestContainerJsx2 = _interopRequireDefault(_containersTestsTestContainerJsx);
	
	// Settings
	// ---------------------------
	
	_react2['default'].initializeTouchEvents(true);
	(0, _reactTapEventPlugin2['default'])();
	
	_commonUtilsAjax2['default'].onError(function (status, err) {
	  if (status === 999) {
	    (0, _dispatcherDispatcher.dispatch)({
	      type: 'logout'
	    });
	    location.hash = '';
	  } else {
	    alert(err);
	  }
	});
	
	var style = document.createElement('style');
	
	document.head.appendChild(style);
	style.innerHTML = '.loader.loading { min-height: ' + window.innerHeight * 0.9 + 'px; }';
	
	// Routes
	// ---------------------------
	
	_react2['default'].render(_react2['default'].createElement(
	  _reactRouter.Router,
	  null,
	  _react2['default'].createElement(
	    _reactRouter.Route,
	    { path: '/', name: 'home', component: _containersHomeMenuHomeContainerJsx2['default'] },
	    _react2['default'].createElement(_reactRouter.IndexRoute, { component: _containersHomeMenuEmployeeContainerJsx2['default'] }),
	    _react2['default'].createElement(_reactRouter.Route, { path: 'change-password', name: 'change-pwd', component: _containersConfigChangePwdJsx2['default'] }),
	    _react2['default'].createElement(_reactRouter.Route, { path: 'change-mobile', name: 'change-mobile', component: _containersConfigChangeMobileJsx2['default'] }),
	    _react2['default'].createElement(_reactRouter.Route, { path: 'confirm-mobile', name: 'confirm-mobile', component: _containersConfirmMobileConfirmMobile2['default'] }),
	    _react2['default'].createElement(_reactRouter.Route, { path: 'profile(/:id)', name: 'profile', component: _containersProfileContainerJsx2['default'] }),
	    _react2['default'].createElement(_reactRouter.Route, { path: 'my-salary', name: 'my-salary', component: _containersSalaryContainerJsx2['default'] }),
	    _react2['default'].createElement(
	      _reactRouter.Route,
	      { path: 'my-leave', name: 'my-leave', component: _containersLeaveLeaveContainerJsx2['default'] },
	      _react2['default'].createElement(_reactRouter.IndexRoute, { component: _containersLeaveLeaveQuotaContainerJsx2['default'] }),
	      _react2['default'].createElement(_reactRouter.Route, { path: 'leave-quota', name: 'leave-quota', component: _containersLeaveLeaveQuotaContainerJsx2['default'] }),
	      _react2['default'].createElement(_reactRouter.Route, { path: 'leave-summary', name: 'leave-summary', component: _containersLeaveLeaveSummaryContainerJsx2['default'] })
	    ),
	    _react2['default'].createElement(_reactRouter.Route, { path: 'my-leave/leave-list(/:id)', name: 'leave-list', component: _containersLeaveLeaveListContainerJsx2['default'] }),
	    _react2['default'].createElement(_reactRouter.Route, { path: 'leave-record/:id', name: 'leave-record', component: _containersLeaveLeaveRecordContainerJsx2['default'] }),
	    _react2['default'].createElement(_reactRouter.Route, { path: 'leave-record-mgr/:id', name: 'leave-record-mgr', component: _containersLeaveLeaveRecordContainerJsx2['default'] }),
	    _react2['default'].createElement(
	      _reactRouter.Route,
	      { path: 'my-ot', name: 'my-ot', component: _containersOverTimeOvertimeContainerJsx2['default'] },
	      _react2['default'].createElement(_reactRouter.IndexRoute, { component: _containersOverTimeOvertimeEmpListContainer2['default'] }),
	      _react2['default'].createElement(_reactRouter.Route, { path: 'list', name: 'list', component: _containersOverTimeOvertimeEmpListContainer2['default'] }),
	      _react2['default'].createElement(_reactRouter.Route, { path: 'summary(/:id)', name: 'summary', component: _containersOverTimeOvertimeEmpSummaryContainer2['default'] })
	    ),
	    _react2['default'].createElement(_reactRouter.Route, { path: 'my-ot/record/:id', name: 'record', component: _containersOverTimeOvertimeEmpRecordContainer2['default'] }),
	    _react2['default'].createElement(
	      _reactRouter.Route,
	      { path: 'my-rci', name: 'my-rci', component: _containersRepairClockInRepairClockInContainerJsx2['default'] },
	      _react2['default'].createElement(_reactRouter.IndexRoute, { component: _containersRepairClockInRepairClockInEmpListContainer2['default'] }),
	      _react2['default'].createElement(_reactRouter.Route, { path: 'list', name: 'list', component: _containersRepairClockInRepairClockInEmpListContainer2['default'] }),
	      _react2['default'].createElement(_reactRouter.Route, { path: 'checklist', name: 'checklist', component: _containersRepairClockInRepairClockInEmpCheckListContainer2['default'] }),
	      _react2['default'].createElement(_reactRouter.Route, { path: 'viewlist/:id', name: 'viewlist', component: _containersRepairClockInRepairClockInEmpViewListContainer2['default'] })
	    ),
	    _react2['default'].createElement(_reactRouter.Route, { path: 'my-rci/record/:id', name: 'record', component: _containersRepairClockInRepairClockInEmpRecordContainer2['default'] }),
	    _react2['default'].createElement(_reactRouter.Route, { path: 'my-rci/crecord/:id', name: 'record', component: _containersRepairClockInRepairClockInEmpCheckRecordContainer2['default'] }),
	    _react2['default'].createElement(_reactRouter.Route, { path: 'my-rci/viewrecord/:id', name: 'viewrecord', component: _containersRepairClockInRepairClockInEmpViewRecordContainer2['default'] }),
	    _react2['default'].createElement(_reactRouter.Route, { path: 'team-profile', name: 'profile', component: _containersTeamProfileContainerJsx2['default'] }),
	    _react2['default'].createElement(_reactRouter.Route, { path: 'team-profile/profile(/:id)', name: 'profile', component: _containersTeamProfileEmpProfileContainerJsx2['default'] }),
	    _react2['default'].createElement(
	      _reactRouter.Route,
	      { path: 'leave-mgr', name: 'leave-mgr', component: _containersLeaveLeaveMgrContainerJsx2['default'] },
	      _react2['default'].createElement(_reactRouter.IndexRoute, { component: _containersLeaveLeaveMgrQuotaContainerJsx2['default'] }),
	      _react2['default'].createElement(_reactRouter.Route, { path: 'quota', name: 'quota', component: _containersLeaveLeaveMgrQuotaContainerJsx2['default'] }),
	      _react2['default'].createElement(_reactRouter.Route, { path: 'pending', name: 'pending', component: _containersLeaveLeaveMgrPendingContainerJsx2['default'] }),
	      _react2['default'].createElement(_reactRouter.Route, { path: 'history', name: 'history', component: _containersLeaveLeaveMgrHistoryContainerJsx2['default'] }),
	      _react2['default'].createElement(_reactRouter.Route, { path: 'summary', name: 'summary', component: _containersLeaveLeaveMgrSummaryContainerJsx2['default'] })
	    ),
	    _react2['default'].createElement(_reactRouter.Route, { path: 'leave-mgr/quota/:id', name: 'emp-quota', component: _containersLeaveLeaveMgrEmpQuotaContainerJsx2['default'] }),
	    _react2['default'].createElement(_reactRouter.Route, { path: 'leave-mgr/history/:id', name: 'emp-history', component: _containersLeaveLeaveMgrEmpHistoryContainerJsx2['default'] }),
	    _react2['default'].createElement(
	      _reactRouter.Route,
	      { path: 'ot-mgr', name: 'ot-mgr', component: _containersOverTimeOvertimeMgrContainerJsx2['default'] },
	      _react2['default'].createElement(_reactRouter.IndexRoute, { component: _containersOverTimeOvertimeMgrPendingContainer2['default'] }),
	      _react2['default'].createElement(_reactRouter.Route, { path: 'pending', name: 'pending', component: _containersOverTimeOvertimeMgrPendingContainer2['default'] }),
	      _react2['default'].createElement(_reactRouter.Route, { path: 'history', name: 'history', component: _containersOverTimeOvertimeMgrHistoryContainer2['default'] }),
	      _react2['default'].createElement(_reactRouter.Route, { path: 'summary', name: 'summary', component: _containersOverTimeOvertimeMgrSummaryContainer2['default'] })
	    ),
	    _react2['default'].createElement(_reactRouter.Route, { path: 'ot-mgr/history/:id', name: 'ot-history-detail', component: _containersOverTimeOvertimeMgrHistoryDetailContainer2['default'] }),
	    _react2['default'].createElement(_reactRouter.Route, { path: 'ot-record-mgr/:id', name: 'ot-record-mgr', component: _containersOverTimeOvertimeMgrPendingRecordContainer2['default'] }),
	    _react2['default'].createElement(
	      _reactRouter.Route,
	      { path: 'rci-mgr', name: 'rci-mgr', component: _containersRepairClockInRepairClockInMgrContainerJsx2['default'] },
	      _react2['default'].createElement(_reactRouter.IndexRoute, { component: _containersRepairClockInRepairClockInMgrPendingContainer2['default'] }),
	      _react2['default'].createElement(_reactRouter.Route, { path: 'pending', name: 'pending', component: _containersRepairClockInRepairClockInMgrPendingContainer2['default'] }),
	      _react2['default'].createElement(_reactRouter.Route, { path: 'history', name: 'history', component: _containersRepairClockInRepairClockInMgrHistoryContainer2['default'] })
	    ),
	    _react2['default'].createElement(_reactRouter.Route, { path: 'rci-record-mgr/:id', name: 'ot-record-mgr', component: _containersRepairClockInRepairClockInMgrPendingRecordContainer2['default'] }),
	    _react2['default'].createElement(_reactRouter.Route, { path: 'test', name: 'test', component: _containersTestsTestContainerJsx2['default'] }),
	    _react2['default'].createElement(_reactRouter.Route, { path: 'manager', name: 'manager', component: _containersHomeMenuManagerContainerJsx2['default'], routerProps: { header: true } }),
	    _react2['default'].createElement(_reactRouter.Route, { path: '*', name: 'employee', component: _containersHomeMenuEmployeeContainerJsx2['default'], routerProps: { header: true } })
	  )
	), document.getElementById('app'));

/***/ }),
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Ajax utilities
	 */
	
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _dispatcherDispatcher = __webpack_require__(223);
	
	var _dispatcherDispatcher2 = _interopRequireDefault(_dispatcherDispatcher);
	
	var domain = '';
	
	var errorCallbacks = [];
	
	/**
	 * Guess dataType by url
	 * @param {string} url
	 * @returns {string}
	 */
	function parseDataType(url) {
	
	  if (/\.html?$/.test(url)) {
	    return 'html';
	  } else if (/\.jsx?$/.test(url)) {
	    return 'script';
	  }
	
	  return 'json';
	}
	
	/**
	 * Encode an object to a query string
	 * @param {Object} obj
	 * @returns {string}
	 */
	function makeQueryString(obj) {
	  var result = [];
	
	  for (var prop in obj) {
	    if (obj.hasOwnProperty(prop)) {
	      result.push(prop + '=' + encodeURIComponent(obj[prop]));
	    }
	  }return result.length ? '?' + result.join('&') : '';
	}
	
	/**
	 * Throw error when response status is not between 200 and 299
	 * @param {Response} res
	 * @returns {Response}
	 */
	function checkStatus(res) {
	
	  if (res.status >= 200 && res.status < 300) {
	    return res;
	  } else {
	    errorCallbacks.forEach(function (cb) {
	      cb.call(null, res.status, res);
	    });
	  }
	}
	
	/**
	 * Parse response according to response
	 * @param {Response} res
	 * @param {string} dataType
	 * @returns {Response}
	 */
	function parseResponse(res, dataType) {
	  var methodMap = {
	    html: 'text',
	    script: 'text',
	    json: 'json'
	  };
	
	  return res[methodMap[dataType] || 'json']();
	}
	
	/**
	 * If response contains `res: false`, throw an error
	 * @param {*} res
	 * @returns {Object|Error}
	 */
	function checkSuccessFalse(res) {
	  if (res && res.res !== false) {
	    return res.val !== undefined ? res.val : res;
	  } else {
	    errorCallbacks.forEach(function (cb) {
	      cb.call(null, res.status, res.error);
	    });
	    throw res.error;
	  }
	}
	
	/**
	 * General settings for `post`, `put` and `delete`
	 * @param {string} url
	 * @param {string} method
	 * @param {Object} [data]
	 * @returns {Promise}
	 */
	function sendData(url, method) {
	  var data = arguments.length <= 2 || arguments[2] === undefined ? {} : arguments[2];
	
	  var option = {
	    method: method.toUpperCase(),
	    headers: {}
	  };
	
	  if ('FormData' in window && data instanceof FormData) {
	
	    // Form
	    option.body = data;
	  } else {
	
	    // JSON
	    option.headers['Content-Type'] = 'application/json';
	    option.body = JSON.stringify(data);
	    //console.log(option.body);
	  }
	
	  option.credentials = 'include';
	
	  return fetch(url, option).then(checkStatus).then(function (res) {
	    return res.json();
	  }).then(checkSuccessFalse)['catch'](function (e) {});
	}
	
	/**
	 * API
	 * @type {{get, post, put, delete}}
	 */
	var ajax = {
	
	  /**
	   * Set global domain property
	   */
	  setDomain: function setDomain(newDomain) {
	    domain = newDomain;
	  },
	
	  /**
	   * Global error callbacks
	   */
	  onError: function onError(callback) {
	    errorCallbacks.push(callback);
	  },
	
	  // CRUD
	  // ---------------------------
	
	  get: function get(url) {
	    var data = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
	
	    var query = data ? makeQueryString(data) : '';
	    var dataType = parseDataType(url);
	
	    return fetch(domain + url + query, {
	      credentials: 'include'
	    }).then(checkStatus).then(function (res) {
	      return parseResponse(res, dataType);
	    }).then(checkSuccessFalse);
	  },
	
	  getScript: function getScript(url) {
	    return fetch(domain + url).then(function () {
	      var script = document.createElement('script');
	
	      script.src = domain + url;
	      document.body.appendChild(script);
	    });
	  },
	
	  post: function post(url) {
	    var data = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
	
	    return sendData(domain + url, 'POST', data);
	  },
	
	  put: function put(url) {
	    var data = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
	
	    return sendData(domain + url, 'PUT', data);
	  },
	
	  'delete': function _delete(url) {
	    var data = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
	
	    return sendData(domain + url, 'DELETE', data);
	  }
	};
	
	exports['default'] = ajax;
	var ajaxDispatch = function ajaxDispatch(_ref) {
	  var action = _ref.action;
	  var url = _ref.url;
	  var method = _ref.method;
	  var data = _ref.data;
	
	  (0, _dispatcherDispatcher.dispatch)({
	    type: action,
	    data: data
	  });
	
	  return ajax[method](url, data).then(function (res) {
	    console.log(url);
	    console.log(res);
	    (0, _dispatcherDispatcher.dispatch)({
	      type: action + '-success',
	      data: res
	    });
	  })['catch'](function (res) {
	    (0, _dispatcherDispatcher.dispatch)({
	      type: action + '-fail',
	      data: res
	    });
	  });
	};
	exports.ajaxDispatch = ajaxDispatch;

/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Dispatcher
	 */
	
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _flux = __webpack_require__(224);
	
	var instance = new _flux.Dispatcher();
	
	exports['default'] = instance;
	var dispatch = instance.dispatch.bind(instance);
	exports.dispatch = dispatch;

/***/ }),
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Home page
	 */
	
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(23);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _fluxUtils = __webpack_require__(228);
	
	var _dispatcherDispatcher = __webpack_require__(223);
	
	var _commonLang = __webpack_require__(245);
	
	var _commonLang2 = _interopRequireDefault(_commonLang);
	
	var _componentsHeaderHeaderJsx = __webpack_require__(247);
	
	var _componentsHeaderHeaderJsx2 = _interopRequireDefault(_componentsHeaderHeaderJsx);
	
	var _componentsTabTabJsx = __webpack_require__(269);
	
	var _componentsTabTabJsx2 = _interopRequireDefault(_componentsTabTabJsx);
	
	var _componentsSideNavSideNavJsx = __webpack_require__(272);
	
	var _componentsSideNavSideNavJsx2 = _interopRequireDefault(_componentsSideNavSideNavJsx);
	
	var _LoginLoginContainerJsx = __webpack_require__(275);
	
	var _LoginLoginContainerJsx2 = _interopRequireDefault(_LoginLoginContainerJsx);
	
	var _ConfirmMobileConfirmMobile = __webpack_require__(305);
	
	var _ConfirmMobileConfirmMobile2 = _interopRequireDefault(_ConfirmMobileConfirmMobile);
	
	var _ConfirmMobileResetPassword = __webpack_require__(307);
	
	var _ConfirmMobileResetPassword2 = _interopRequireDefault(_ConfirmMobileResetPassword);
	
	var _storesUserStore = __webpack_require__(303);
	
	var _storesUserStore2 = _interopRequireDefault(_storesUserStore);
	
	var sideNavData = [{
	  text: (0, _commonLang.getItem)('CHANGE_MOBILE'),
	  link: 'change-mobile'
	}, {
	  text: (0, _commonLang.getItem)('CHANGE_PWD'),
	  link: 'change-password'
	}, {
	  text: (0, _commonLang.getItem)('LOGOUT')
	}];
	
	var langDropdown = {
	  items: [{
	    text: '中文',
	    name: 'pla_lan_001'
	  }, {
	    text: 'English',
	    name: 'pla_lan_002'
	  }, {
	    text: '日本語',
	    name: 'pla_lan_003'
	  }],
	  onClickItem: function onClickItem(langCode) {
	    (0, _dispatcherDispatcher.dispatch)({
	      type: 'set-language',
	      data: langCode
	    });
	  }
	};
	
	var tabItems = [{
	  text: (0, _commonLang.getItem)('EMPLOYEE'),
	  name: 'employee'
	}, {
	  text: (0, _commonLang.getItem)('MANAGER'),
	  name: 'manager'
	}];
	
	var Home = (function (_Component) {
	  _inherits(Home, _Component);
	
	  function Home(props) {
	    _classCallCheck(this, Home);
	
	    _get(Object.getPrototypeOf(Home.prototype), 'constructor', this).call(this, props);
	    this.logout = this.logout.bind(this);
	    this.openSideNav = this.openSideNav.bind(this);
	
	    sideNavData[2].onTouchTap = this.logout;
	  }
	
	  _createClass(Home, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (this.state.loggedIn) {
	        this.getUserMenu();
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state;
	      var loggedIn = _state.loggedIn;
	      var menu = _state.menu;
	      var picInfo = _state.picInfo;
	      var langList = _state.langList;
	      var basicInfo = _state.basicInfo;
	      var routeName = this.props.location.pathname;
	      var hasHeader = ['/employee', '/manager', '/'].indexOf(routeName) > -1;
	      var needConfirmMobile = +localStorage.needConfirmMobile;
	      var needResetPassword = +localStorage.needResetPassword;
	
	      Object.keys(menu).forEach(function (userType, index) {
	        tabItems[index].notification = menu[userType].some(function (item) {
	          return item.notification;
	        });
	      });
	
	      langDropdown.items = langList.map(function (item) {
	        return {
	          name: item.langCode,
	          text: item.langName
	        };
	      });
	
	      var pic = picInfo ? _react2['default'].createElement(
	        'div',
	        { style: {
	            background: 'rgba(0, 0, 0, 0.03)',
	            paddingBottom: '1rem',
	            paddingTop: '1rem',
	            textAlign: 'center'
	          } },
	        _react2['default'].createElement('img', { src: picInfo.url, alt: '', style: {
	            borderRadius: '50%',
	            height: '5rem',
	            width: '5rem'
	          } }),
	        _react2['default'].createElement(
	          'div',
	          null,
	          _react2['default'].createElement(
	            'span',
	            null,
	            picInfo.name
	          ),
	          _react2['default'].createElement(
	            'div',
	            { className: 'text-lighter text-sm gap-l' },
	            picInfo.position
	          )
	        )
	      ) : null;
	
	      return !loggedIn ? _react2['default'].createElement(_LoginLoginContainerJsx2['default'], null) : needConfirmMobile ? _react2['default'].createElement(_ConfirmMobileConfirmMobile2['default'], basicInfo) : needResetPassword ? _react2['default'].createElement(_ConfirmMobileResetPassword2['default'], null) : _react2['default'].createElement(
	        'div',
	        null,
	        hasHeader ? _react2['default'].createElement(
	          'div',
	          null,
	          _react2['default'].createElement(_componentsHeaderHeaderJsx2['default'], {
	            title: 'CDP Portal',
	            dropdown: langDropdown,
	            iconLeft: 'cdp-line',
	            onTapLeft: this.openSideNav }),
	          pic
	        ) : null,
	        hasHeader ? _react2['default'].createElement(_componentsSideNavSideNavJsx2['default'], { ref: 'sideNav', data: sideNavData }) : null,
	        hasHeader && menu.mss && menu.ess ? _react2['default'].createElement(_componentsTabTabJsx2['default'], { items: tabItems }) : null,
	        this.props.children
	      );
	    }
	  }, {
	    key: 'openSideNav',
	    value: function openSideNav() {
	      var _this = this;
	
	      setTimeout(function () {
	        _this.refs.sideNav.open();
	      }, 0);
	    }
	
	    /**
	     * Get custimzed menu list
	     */
	  }, {
	    key: 'getUserMenu',
	    value: function getUserMenu() {
	      (0, _dispatcherDispatcher.dispatch)({
	        type: 'get-user-menu'
	      });
	    }
	
	    /**
	     * Logout
	     */
	  }, {
	    key: 'logout',
	    value: function logout() {
	      (0, _dispatcherDispatcher.dispatch)({
	        type: 'logout'
	      });
	    }
	  }], [{
	    key: 'getStores',
	    value: function getStores() {
	      return [_storesUserStore2['default']];
	    }
	  }, {
	    key: 'calculateState',
	    value: function calculateState() {
	      return _storesUserStore2['default'].getState();
	    }
	  }]);
	
	  return Home;
	})(_react.Component);
	
	exports['default'] = _fluxUtils.Container.create(Home);
	module.exports = exports['default'];

/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	module.exports.Container = __webpack_require__(229);
	module.exports.MapStore = __webpack_require__(232);
	module.exports.Mixin = __webpack_require__(244);
	module.exports.ReduceStore = __webpack_require__(233);
	module.exports.Store = __webpack_require__(234);


/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule FluxContainer
	 * 
	 */
	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FluxStoreGroup = __webpack_require__(230);
	
	var invariant = __webpack_require__(226);
	var shallowEqual = __webpack_require__(231);
	
	var DEFAULT_OPTIONS = {
	  pure: true,
	  withProps: false
	};
	
	/**
	 * A FluxContainer is used to subscribe a react component to multiple stores.
	 * The stores that are used must be returned from a static `getStores()` method.
	 *
	 * The component receives information from the stores via state. The state
	 * is generated using a static `calculateState()` method that each container
	 * must implement. A simple container may look like:
	 */
	function create(Base, options) {
	  enforceInterface(Base);
	
	  // Construct the options using default, override with user values as necessary
	  var realOptions = _extends({}, DEFAULT_OPTIONS, options || {});
	
	  var FluxContainerClass = (function (_Base) {
	    _inherits(FluxContainerClass, _Base);
	
	    function FluxContainerClass(props) {
	      _classCallCheck(this, FluxContainerClass);
	
	      _Base.call(this, props);
	      this.state = realOptions.withProps ? Base.calculateState(null, props) : Base.calculateState(null, undefined);
	    }
	
	    // Make sure we override shouldComponentUpdate only if the pure option is
	    // specified. We can't override this above because we don't want to override
	    // the default behavior on accident. Super works weird with react ES6 classes
	    // right now
	
	    FluxContainerClass.prototype.componentDidMount = function componentDidMount() {
	      var _this = this;
	
	      if (_Base.prototype.componentDidMount) {
	        _Base.prototype.componentDidMount.call(this);
	      }
	
	      var stores = Base.getStores();
	
	      // This tracks when any store has changed and we may need to update.
	      var changed = false;
	      var setChanged = function () {
	        changed = true;
	      };
	
	      // This adds subscriptions to stores. When a store changes all we do is
	      // set changed to true.
	      this._fluxContainerSubscriptions = stores.map(function (store) {
	        return store.addListener(setChanged);
	      });
	
	      // This callback is called after the dispatch of the relevant stores. If
	      // any have reported a change we update the state, then reset changed.
	      var callback = function () {
	        if (changed) {
	          _this.setState(function (prevState) {
	            return realOptions.withProps ? Base.calculateState(prevState, _this.props) : Base.calculateState(prevState, undefined);
	          });
	        }
	        changed = false;
	      };
	      this._fluxContainerStoreGroup = new FluxStoreGroup(stores, callback);
	    };
	
	    FluxContainerClass.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps, nextContext) {
	      if (_Base.prototype.componentWillReceiveProps) {
	        _Base.prototype.componentWillReceiveProps.call(this, nextProps, nextContext);
	      }
	
	      // Don't do anything else if the container is not configured to use props
	      if (!realOptions.withProps) {
	        return;
	      }
	
	      // If it's pure we can potentially optimize out the calculate state
	      if (realOptions.pure && shallowEqual(this.props, nextProps)) {
	        return;
	      }
	
	      // Finally update the state using the new props
	      this.setState(function (prevState) {
	        return Base.calculateState(prevState, nextProps);
	      });
	    };
	
	    FluxContainerClass.prototype.componentWillUnmount = function componentWillUnmount() {
	      if (_Base.prototype.componentWillUnmount) {
	        _Base.prototype.componentWillUnmount.call(this);
	      }
	
	      this._fluxContainerStoreGroup.release();
	      for (var _iterator = this._fluxContainerSubscriptions, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
	        var _ref;
	
	        if (_isArray) {
	          if (_i >= _iterator.length) break;
	          _ref = _iterator[_i++];
	        } else {
	          _i = _iterator.next();
	          if (_i.done) break;
	          _ref = _i.value;
	        }
	
	        var subscription = _ref;
	
	        subscription.remove();
	      }
	      this._fluxContainerSubscriptions = [];
	    };
	
	    return FluxContainerClass;
	  })(Base);
	
	  var container = realOptions.pure ? createPureContainer(FluxContainerClass) : FluxContainerClass;
	
	  // Update the name of the container before returning
	  var componentName = Base.displayName || Base.name;
	  container.displayName = 'FluxContainer(' + componentName + ')';
	
	  return container;
	}
	
	// TODO: typecheck this better
	function createPureContainer(FluxContainerBase) {
	  var PureFluxContainerClass = (function (_FluxContainerBase) {
	    _inherits(PureFluxContainerClass, _FluxContainerBase);
	
	    function PureFluxContainerClass() {
	      _classCallCheck(this, PureFluxContainerClass);
	
	      _FluxContainerBase.apply(this, arguments);
	    }
	
	    PureFluxContainerClass.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps, nextState) {
	      return !shallowEqual(this.props, nextProps) || !shallowEqual(this.state, nextState);
	    };
	
	    return PureFluxContainerClass;
	  })(FluxContainerBase);
	
	  return PureFluxContainerClass;
	}
	
	function enforceInterface(o) {
	  !o.getStores ?  false ? invariant(false, 'Components that use FluxContainer must implement `static getStores()`') : invariant(false) : undefined;
	  !o.calculateState ?  false ? invariant(false, 'Components that use FluxContainer must implement `static calculateState()`') : invariant(false) : undefined;
	}
	
	module.exports = { create: create };

/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule FluxStoreGroup
	 * 
	 */
	
	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var invariant = __webpack_require__(226);
	
	/**
	 * FluxStoreGroup allows you to execute a callback on every dispatch after
	 * waiting for each of the given stores.
	 */
	
	var FluxStoreGroup = (function () {
	  function FluxStoreGroup(stores, callback) {
	    var _this = this;
	
	    _classCallCheck(this, FluxStoreGroup);
	
	    this._dispatcher = _getUniformDispatcher(stores);
	
	    // precompute store tokens
	    var storeTokens = stores.map(function (store) {
	      return store.getDispatchToken();
	    });
	
	    // register with the dispatcher
	    this._dispatchToken = this._dispatcher.register(function (payload) {
	      _this._dispatcher.waitFor(storeTokens);
	      callback();
	    });
	  }
	
	  FluxStoreGroup.prototype.release = function release() {
	    this._dispatcher.unregister(this._dispatchToken);
	  };
	
	  return FluxStoreGroup;
	})();
	
	function _getUniformDispatcher(stores) {
	  !(stores && stores.length) ?  false ? invariant(false, 'Must provide at least one store to FluxStoreGroup') : invariant(false) : undefined;
	  var dispatcher = stores[0].getDispatcher();
	  if (false) {
	    for (var _iterator = stores, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
	      var _ref;
	
	      if (_isArray) {
	        if (_i >= _iterator.length) break;
	        _ref = _iterator[_i++];
	      } else {
	        _i = _iterator.next();
	        if (_i.done) break;
	        _ref = _i.value;
	      }
	
	      var store = _ref;
	
	      !(store.getDispatcher() === dispatcher) ? process.env.NODE_ENV !== 'production' ? invariant(false, 'All stores in a FluxStoreGroup must use the same dispatcher') : invariant(false) : undefined;
	    }
	  }
	  return dispatcher;
	}
	
	module.exports = FluxStoreGroup;

/***/ }),
/* 231 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule shallowEqual
	 * @typechecks
	 * 
	 */
	
	'use strict';
	
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	/**
	 * Performs equality by iterating through keys on an object and returning false
	 * when any key has values which are not strictly equal between the arguments.
	 * Returns true when the values of all keys are strictly equal.
	 */
	function shallowEqual(objA, objB) {
	  if (objA === objB) {
	    return true;
	  }
	
	  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
	    return false;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) {
	    return false;
	  }
	
	  // Test for A's keys different from B.
	  var bHasOwnProperty = hasOwnProperty.bind(objB);
	  for (var i = 0; i < keysA.length; i++) {
	    if (!bHasOwnProperty(keysA[i]) || objA[keysA[i]] !== objB[keysA[i]]) {
	      return false;
	    }
	  }
	
	  return true;
	}
	
	module.exports = shallowEqual;

/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule FluxMapStore
	 * 
	 */
	
	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FluxReduceStore = __webpack_require__(233);
	var Immutable = __webpack_require__(243);
	
	var invariant = __webpack_require__(226);
	
	/**
	 * This is a simple store. It allows caching key value pairs. An implementation
	 * of a store using this might look like:
	 *
	 *   class FooStore extends FluxMapStore {
	 *     reduce(state, action) {
	 *       switch (action.type) {
	 *         case 'foo':
	 *           return state.set(action.id, action.foo);
	 *         case 'bar':
	 *           return state.delete(action.id);
	 *         default:
	 *           return state;
	 *       }
	 *     }
	 *   }
	 *
	 */
	
	var FluxMapStore = (function (_FluxReduceStore) {
	  _inherits(FluxMapStore, _FluxReduceStore);
	
	  function FluxMapStore() {
	    _classCallCheck(this, FluxMapStore);
	
	    _FluxReduceStore.apply(this, arguments);
	  }
	
	  FluxMapStore.prototype.getInitialState = function getInitialState() {
	    return Immutable.Map();
	  };
	
	  /**
	   * Access the value at the given key. throws an error if the key does not
	   * exist in the cache.
	   */
	
	  FluxMapStore.prototype.at = function at(key) {
	    !this.has(key) ?  false ? invariant(false, 'Expected store to have key %s', key) : invariant(false) : undefined;
	    return this.get(key);
	  };
	
	  /**
	   * Check if the cache has a particular key
	   */
	
	  FluxMapStore.prototype.has = function has(key) {
	    return this.getState().has(key);
	  };
	
	  /**
	   * Get the value of a particular key. Returns undefined if the key does not
	   * exist in the cache.
	   */
	
	  FluxMapStore.prototype.get = function get(key) {
	    return this.getState().get(key);
	  };
	
	  /**
	   * Gets an array of keys and puts the values in a map if they exist, it allows
	   * providing a previous result to update instead of generating a new map.
	   *
	   * Providing a previous result allows the possibility of keeping the same
	   * reference if the keys did not change.
	   */
	
	  FluxMapStore.prototype.getAll = function getAll(keys, prev) {
	    var _this = this;
	
	    var newKeys = Immutable.Set(keys);
	    var start = prev || Immutable.Map();
	    return start.withMutations(function (map) {
	      // remove any old keys that are not in new keys or are no longer in
	      // the cache
	      for (var _iterator = start, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
	        var _ref;
	
	        if (_isArray) {
	          if (_i >= _iterator.length) break;
	          _ref = _iterator[_i++];
	        } else {
	          _i = _iterator.next();
	          if (_i.done) break;
	          _ref = _i.value;
	        }
	
	        var entry = _ref;
	        var oldKey = entry[0];
	
	        if (!newKeys.has(oldKey) || !_this.has(oldKey)) {
	          map['delete'](oldKey);
	        }
	      }
	
	      // then add all of the new keys that exist in the cache
	      for (var _iterator2 = newKeys, _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _iterator2[Symbol.iterator]();;) {
	        var _ref2;
	
	        if (_isArray2) {
	          if (_i2 >= _iterator2.length) break;
	          _ref2 = _iterator2[_i2++];
	        } else {
	          _i2 = _iterator2.next();
	          if (_i2.done) break;
	          _ref2 = _i2.value;
	        }
	
	        var key = _ref2;
	
	        if (_this.has(key)) {
	          map.set(key, _this.at(key));
	        }
	      }
	    });
	  };
	
	  return FluxMapStore;
	})(FluxReduceStore);
	
	module.exports = FluxMapStore;

/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule FluxReduceStore
	 * 
	 */
	
	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FluxStore = __webpack_require__(234);
	
	var abstractMethod = __webpack_require__(242);
	var invariant = __webpack_require__(226);
	
	var FluxReduceStore = (function (_FluxStore) {
	  _inherits(FluxReduceStore, _FluxStore);
	
	  function FluxReduceStore(dispatcher) {
	    _classCallCheck(this, FluxReduceStore);
	
	    _FluxStore.call(this, dispatcher);
	    this._state = this.getInitialState();
	  }
	
	  /**
	   * Getter that exposes the entire state of this store. If your state is not
	   * immutable you should override this and not expose _state directly.
	   */
	
	  FluxReduceStore.prototype.getState = function getState() {
	    return this._state;
	  };
	
	  /**
	   * Constructs the initial state for this store. This is called once during
	   * construction of the store.
	   */
	
	  FluxReduceStore.prototype.getInitialState = function getInitialState() {
	    return abstractMethod('FluxReduceStore', 'getInitialState');
	  };
	
	  /**
	   * Used to reduce a stream of actions coming from the dispatcher into a
	   * single state object
	   */
	
	  FluxReduceStore.prototype.reduce = function reduce(state, action) {
	    return abstractMethod('FluxReduceStore', 'reduce');
	  };
	
	  /**
	   * Checks if two versions of state are the same. You do not need to override
	   * this if your state is immutable.
	   */
	
	  FluxReduceStore.prototype.areEqual = function areEqual(one, two) {
	    return one === two;
	  };
	
	  /**
	   * Use reduce and track _state instead of using __onDispatch
	   */
	
	  FluxReduceStore.prototype.__invokeOnDispatch = function __invokeOnDispatch(action) {
	    this.__changed = false;
	
	    // reduce the stream of incoming actions to state, update when necessary
	    var startingState = this._state;
	    var endingState = this.reduce(startingState, action);
	
	    // This means your ending state should never be undefined
	    !(endingState !== undefined) ?  false ? invariant(false, '%s returned undefined from reduce(...), did you forget to return ' + 'state in the default case? (use null if this was intentional)', this.constructor.name) : invariant(false) : undefined;
	
	    if (!this.areEqual(startingState, endingState)) {
	      this._state = endingState;
	
	      // `__emitChange()` sets `this.__changed` to true and then the actual
	      // change will be fired from the emitter at the end of the dispatch, this
	      // is required in order to support methods like `hasChanged()`
	      this.__emitChange();
	    }
	
	    if (this.__changed) {
	      this.__emitter.emit(this.__changeEvent);
	    }
	  };
	
	  return FluxReduceStore;
	})(FluxStore);
	
	module.exports = FluxReduceStore;

/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule FluxStore
	 * 
	 */
	
	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var _require = __webpack_require__(235);
	
	var EventEmitter = _require.EventEmitter;
	
	var invariant = __webpack_require__(226);
	
	/**
	 * This class should be extended by the stores in your application, like so:
	 *
	 * var FluxStore = require('FluxStore');
	 * var MyDispatcher = require('MyDispatcher');
	 *
	 * var _foo;
	 *
	 * class MyStore extends FluxStore {
	 *
	 *   getFoo() {
	 *     return _foo;
	 *   }
	 *
	 *   __onDispatch = function(action) {
	 *     switch(action.type) {
	 *
	 *       case 'an-action':
	 *         changeState(action.someData);
	 *         this.__emitChange();
	 *         break;
	 *
	 *       case 'another-action':
	 *         changeStateAnotherWay(action.otherData);
	 *         this.__emitChange();
	 *         break;
	 *
	 *       default:
	 *         // no op
	 *     }
	 *   }
	 *
	 * }
	 *
	 * module.exports = new MyStore(MyDispatcher);
	 */
	
	var FluxStore = (function () {
	
	  /**
	   * @public
	   * @param {Dispatcher} dispatcher
	   */
	
	  function FluxStore(dispatcher) {
	    var _this = this;
	
	    _classCallCheck(this, FluxStore);
	
	    this.__className = this.constructor.name;
	
	    this.__changed = false;
	    this.__changeEvent = 'change';
	    this.__dispatcher = dispatcher;
	    this.__emitter = new EventEmitter();
	    this._dispatchToken = dispatcher.register(function (payload) {
	      _this.__invokeOnDispatch(payload);
	    });
	  }
	
	  /**
	   * @public
	   * @param {function} callback
	   * @return {object} EmitterSubscription that can be used with
	   *   SubscriptionsHandler or directly used to release the subscription.
	   */
	
	  FluxStore.prototype.addListener = function addListener(callback) {
	    return this.__emitter.addListener(this.__changeEvent, callback);
	  };
	
	  /**
	   * @public
	   * @return {Dispatcher} The dispatcher that this store is registered with.
	   */
	
	  FluxStore.prototype.getDispatcher = function getDispatcher() {
	    return this.__dispatcher;
	  };
	
	  /**
	   * @public
	   * @return {string} A string the dispatcher uses to identify each store's
	   *   registered callback. This is used with the dispatcher's waitFor method
	   *   to declaratively depend on other stores updating themselves first.
	   */
	
	  FluxStore.prototype.getDispatchToken = function getDispatchToken() {
	    return this._dispatchToken;
	  };
	
	  /**
	   * @public
	   * @return {boolean} Whether the store has changed during the most recent
	   *   dispatch.
	   */
	
	  FluxStore.prototype.hasChanged = function hasChanged() {
	    !this.__dispatcher.isDispatching() ?  false ? invariant(false, '%s.hasChanged(): Must be invoked while dispatching.', this.__className) : invariant(false) : undefined;
	    return this.__changed;
	  };
	
	  /**
	   * @protected
	   * Emit an event notifying listeners that the state of the store has changed.
	   */
	
	  FluxStore.prototype.__emitChange = function __emitChange() {
	    !this.__dispatcher.isDispatching() ?  false ? invariant(false, '%s.__emitChange(): Must be invoked while dispatching.', this.__className) : invariant(false) : undefined;
	    this.__changed = true;
	  };
	
	  /**
	   * This method encapsulates all logic for invoking __onDispatch. It should
	   * be used for things like catching changes and emitting them after the
	   * subclass has handled a payload.
	   *
	   * @protected
	   * @param {object} payload The data dispatched by the dispatcher, describing
	   *   something that has happened in the real world: the user clicked, the
	   *   server responded, time passed, etc.
	   */
	
	  FluxStore.prototype.__invokeOnDispatch = function __invokeOnDispatch(payload) {
	    this.__changed = false;
	    this.__onDispatch(payload);
	    if (this.__changed) {
	      this.__emitter.emit(this.__changeEvent);
	    }
	  };
	
	  /**
	   * The callback that will be registered with the dispatcher during
	   * instantiation. Subclasses must override this method. This callback is the
	   * only way the store receives new data.
	   *
	   * @protected
	   * @override
	   * @param {object} payload The data dispatched by the dispatcher, describing
	   *   something that has happened in the real world: the user clicked, the
	   *   server responded, time passed, etc.
	   */
	
	  FluxStore.prototype.__onDispatch = function __onDispatch(payload) {
	     true ?  false ? invariant(false, '%s has not overridden FluxStore.__onDispatch(), which is required', this.__className) : invariant(false) : undefined;
	  };
	
	  return FluxStore;
	})();
	
	module.exports = FluxStore;
	
	// private
	
	// protected, available to subclasses

/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	var fbemitter = {
	  EventEmitter: __webpack_require__(236),
	  EmitterSubscription : __webpack_require__(237)
	};
	
	module.exports = fbemitter;


/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule BaseEventEmitter
	 * @typechecks
	 */
	
	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var EmitterSubscription = __webpack_require__(237);
	var EventSubscriptionVendor = __webpack_require__(239);
	
	var emptyFunction = __webpack_require__(241);
	var invariant = __webpack_require__(240);
	
	/**
	 * @class BaseEventEmitter
	 * @description
	 * An EventEmitter is responsible for managing a set of listeners and publishing
	 * events to them when it is told that such events happened. In addition to the
	 * data for the given event it also sends a event control object which allows
	 * the listeners/handlers to prevent the default behavior of the given event.
	 *
	 * The emitter is designed to be generic enough to support all the different
	 * contexts in which one might want to emit events. It is a simple multicast
	 * mechanism on top of which extra functionality can be composed. For example, a
	 * more advanced emitter may use an EventHolder and EventFactory.
	 */
	
	var BaseEventEmitter = (function () {
	  /**
	   * @constructor
	   */
	
	  function BaseEventEmitter() {
	    _classCallCheck(this, BaseEventEmitter);
	
	    this._subscriber = new EventSubscriptionVendor();
	    this._currentSubscription = null;
	  }
	
	  /**
	   * Adds a listener to be invoked when events of the specified type are
	   * emitted. An optional calling context may be provided. The data arguments
	   * emitted will be passed to the listener function.
	   *
	   * TODO: Annotate the listener arg's type. This is tricky because listeners
	   *       can be invoked with varargs.
	   *
	   * @param {string} eventType - Name of the event to listen to
	   * @param {function} listener - Function to invoke when the specified event is
	   *   emitted
	   * @param {*} context - Optional context object to use when invoking the
	   *   listener
	   */
	
	  BaseEventEmitter.prototype.addListener = function addListener(eventType, listener, context) {
	    return this._subscriber.addSubscription(eventType, new EmitterSubscription(this._subscriber, listener, context));
	  };
	
	  /**
	   * Similar to addListener, except that the listener is removed after it is
	   * invoked once.
	   *
	   * @param {string} eventType - Name of the event to listen to
	   * @param {function} listener - Function to invoke only once when the
	   *   specified event is emitted
	   * @param {*} context - Optional context object to use when invoking the
	   *   listener
	   */
	
	  BaseEventEmitter.prototype.once = function once(eventType, listener, context) {
	    var emitter = this;
	    return this.addListener(eventType, function () {
	      emitter.removeCurrentListener();
	      listener.apply(context, arguments);
	    });
	  };
	
	  /**
	   * Removes all of the registered listeners, including those registered as
	   * listener maps.
	   *
	   * @param {?string} eventType - Optional name of the event whose registered
	   *   listeners to remove
	   */
	
	  BaseEventEmitter.prototype.removeAllListeners = function removeAllListeners(eventType) {
	    this._subscriber.removeAllSubscriptions(eventType);
	  };
	
	  /**
	   * Provides an API that can be called during an eventing cycle to remove the
	   * last listener that was invoked. This allows a developer to provide an event
	   * object that can remove the listener (or listener map) during the
	   * invocation.
	   *
	   * If it is called when not inside of an emitting cycle it will throw.
	   *
	   * @throws {Error} When called not during an eventing cycle
	   *
	   * @example
	   *   var subscription = emitter.addListenerMap({
	   *     someEvent: function(data, event) {
	   *       console.log(data);
	   *       emitter.removeCurrentListener();
	   *     }
	   *   });
	   *
	   *   emitter.emit('someEvent', 'abc'); // logs 'abc'
	   *   emitter.emit('someEvent', 'def'); // does not log anything
	   */
	
	  BaseEventEmitter.prototype.removeCurrentListener = function removeCurrentListener() {
	    !!!this._currentSubscription ?  false ? invariant(false, 'Not in an emitting cycle; there is no current subscription') : invariant(false) : undefined;
	    this._subscriber.removeSubscription(this._currentSubscription);
	  };
	
	  /**
	   * Returns an array of listeners that are currently registered for the given
	   * event.
	   *
	   * @param {string} eventType - Name of the event to query
	   * @return {array}
	   */
	
	  BaseEventEmitter.prototype.listeners = function listeners(eventType) /* TODO: Array<EventSubscription> */{
	    var subscriptions = this._subscriber.getSubscriptionsForType(eventType);
	    return subscriptions ? subscriptions.filter(emptyFunction.thatReturnsTrue).map(function (subscription) {
	      return subscription.listener;
	    }) : [];
	  };
	
	  /**
	   * Emits an event of the given type with the given data. All handlers of that
	   * particular type will be notified.
	   *
	   * @param {string} eventType - Name of the event to emit
	   * @param {*} Arbitrary arguments to be passed to each registered listener
	   *
	   * @example
	   *   emitter.addListener('someEvent', function(message) {
	   *     console.log(message);
	   *   });
	   *
	   *   emitter.emit('someEvent', 'abc'); // logs 'abc'
	   */
	
	  BaseEventEmitter.prototype.emit = function emit(eventType) {
	    var subscriptions = this._subscriber.getSubscriptionsForType(eventType);
	    if (subscriptions) {
	      var keys = Object.keys(subscriptions);
	      for (var ii = 0; ii < keys.length; ii++) {
	        var key = keys[ii];
	        var subscription = subscriptions[key];
	        // The subscription may have been removed during this event loop.
	        if (subscription) {
	          this._currentSubscription = subscription;
	          this.__emitToSubscription.apply(this, [subscription].concat(Array.prototype.slice.call(arguments)));
	        }
	      }
	      this._currentSubscription = null;
	    }
	  };
	
	  /**
	   * Provides a hook to override how the emitter emits an event to a specific
	   * subscription. This allows you to set up logging and error boundaries
	   * specific to your environment.
	   *
	   * @param {EmitterSubscription} subscription
	   * @param {string} eventType
	   * @param {*} Arbitrary arguments to be passed to each registered listener
	   */
	
	  BaseEventEmitter.prototype.__emitToSubscription = function __emitToSubscription(subscription, eventType) {
	    var args = Array.prototype.slice.call(arguments, 2);
	    subscription.listener.apply(subscription.context, args);
	  };
	
	  return BaseEventEmitter;
	})();
	
	module.exports = BaseEventEmitter;

/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 * 
	 * @providesModule EmitterSubscription
	 * @typechecks
	 */
	
	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var EventSubscription = __webpack_require__(238);
	
	/**
	 * EmitterSubscription represents a subscription with listener and context data.
	 */
	
	var EmitterSubscription = (function (_EventSubscription) {
	  _inherits(EmitterSubscription, _EventSubscription);
	
	  /**
	   * @param {EventSubscriptionVendor} subscriber - The subscriber that controls
	   *   this subscription
	   * @param {function} listener - Function to invoke when the specified event is
	   *   emitted
	   * @param {*} context - Optional context object to use when invoking the
	   *   listener
	   */
	
	  function EmitterSubscription(subscriber, listener, context) {
	    _classCallCheck(this, EmitterSubscription);
	
	    _EventSubscription.call(this, subscriber);
	    this.listener = listener;
	    this.context = context;
	  }
	
	  return EmitterSubscription;
	})(EventSubscription);
	
	module.exports = EmitterSubscription;

/***/ }),
/* 238 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule EventSubscription
	 * @typechecks
	 */
	
	'use strict';
	
	/**
	 * EventSubscription represents a subscription to a particular event. It can
	 * remove its own subscription.
	 */
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var EventSubscription = (function () {
	
	  /**
	   * @param {EventSubscriptionVendor} subscriber the subscriber that controls
	   *   this subscription.
	   */
	
	  function EventSubscription(subscriber) {
	    _classCallCheck(this, EventSubscription);
	
	    this.subscriber = subscriber;
	  }
	
	  /**
	   * Removes this subscription from the subscriber that controls it.
	   */
	
	  EventSubscription.prototype.remove = function remove() {
	    if (this.subscriber) {
	      this.subscriber.removeSubscription(this);
	      this.subscriber = null;
	    }
	  };
	
	  return EventSubscription;
	})();
	
	module.exports = EventSubscription;

/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 * 
	 * @providesModule EventSubscriptionVendor
	 * @typechecks
	 */
	
	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var invariant = __webpack_require__(240);
	
	/**
	 * EventSubscriptionVendor stores a set of EventSubscriptions that are
	 * subscribed to a particular event type.
	 */
	
	var EventSubscriptionVendor = (function () {
	  function EventSubscriptionVendor() {
	    _classCallCheck(this, EventSubscriptionVendor);
	
	    this._subscriptionsForType = {};
	    this._currentSubscription = null;
	  }
	
	  /**
	   * Adds a subscription keyed by an event type.
	   *
	   * @param {string} eventType
	   * @param {EventSubscription} subscription
	   */
	
	  EventSubscriptionVendor.prototype.addSubscription = function addSubscription(eventType, subscription) {
	    !(subscription.subscriber === this) ?  false ? invariant(false, 'The subscriber of the subscription is incorrectly set.') : invariant(false) : undefined;
	    if (!this._subscriptionsForType[eventType]) {
	      this._subscriptionsForType[eventType] = [];
	    }
	    var key = this._subscriptionsForType[eventType].length;
	    this._subscriptionsForType[eventType].push(subscription);
	    subscription.eventType = eventType;
	    subscription.key = key;
	    return subscription;
	  };
	
	  /**
	   * Removes a bulk set of the subscriptions.
	   *
	   * @param {?string} eventType - Optional name of the event type whose
	   *   registered supscriptions to remove, if null remove all subscriptions.
	   */
	
	  EventSubscriptionVendor.prototype.removeAllSubscriptions = function removeAllSubscriptions(eventType) {
	    if (eventType === undefined) {
	      this._subscriptionsForType = {};
	    } else {
	      delete this._subscriptionsForType[eventType];
	    }
	  };
	
	  /**
	   * Removes a specific subscription. Instead of calling this function, call
	   * `subscription.remove()` directly.
	   *
	   * @param {object} subscription
	   */
	
	  EventSubscriptionVendor.prototype.removeSubscription = function removeSubscription(subscription) {
	    var eventType = subscription.eventType;
	    var key = subscription.key;
	
	    var subscriptionsForType = this._subscriptionsForType[eventType];
	    if (subscriptionsForType) {
	      delete subscriptionsForType[key];
	    }
	  };
	
	  /**
	   * Returns the array of subscriptions that are currently registered for the
	   * given event type.
	   *
	   * Note: This array can be potentially sparse as subscriptions are deleted
	   * from it when they are removed.
	   *
	   * TODO: This returns a nullable array. wat?
	   *
	   * @param {string} eventType
	   * @return {?array}
	   */
	
	  EventSubscriptionVendor.prototype.getSubscriptionsForType = function getSubscriptionsForType(eventType) {
	    return this._subscriptionsForType[eventType];
	  };
	
	  return EventSubscriptionVendor;
	})();
	
	module.exports = EventSubscriptionVendor;

/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var validateFormat = function validateFormat(format) {};
	
	if (false) {
	  validateFormat = function validateFormat(format) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  };
	}
	
	function invariant(condition, format, a, b, c, d, e, f) {
	  validateFormat(format);
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(format.replace(/%s/g, function () {
	        return args[argIndex++];
	      }));
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	}
	
	module.exports = invariant;

/***/ }),
/* 241 */
/***/ (function(module, exports) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	function makeEmptyFunction(arg) {
	  return function () {
	    return arg;
	  };
	}
	
	/**
	 * This function accepts and discards inputs; it has no side effects. This is
	 * primarily useful idiomatically for overridable function endpoints which
	 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
	 */
	var emptyFunction = function emptyFunction() {};
	
	emptyFunction.thatReturns = makeEmptyFunction;
	emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
	emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
	emptyFunction.thatReturnsNull = makeEmptyFunction(null);
	emptyFunction.thatReturnsThis = function () {
	  return this;
	};
	emptyFunction.thatReturnsArgument = function (arg) {
	  return arg;
	};
	
	module.exports = emptyFunction;

/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule abstractMethod
	 * 
	 */
	
	'use strict';
	
	var invariant = __webpack_require__(226);
	
	function abstractMethod(className, methodName) {
	   true ?  false ? invariant(false, 'Subclasses of %s must override %s() with their own implementation.', className, methodName) : invariant(false) : undefined;
	}
	
	module.exports = abstractMethod;

/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 *  Copyright (c) 2014-2015, Facebook, Inc.
	 *  All rights reserved.
	 *
	 *  This source code is licensed under the BSD-style license found in the
	 *  LICENSE file in the root directory of this source tree. An additional grant
	 *  of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	(function (global, factory) {
	   true ? module.exports = factory() :
	  typeof define === 'function' && define.amd ? define(factory) :
	  (global.Immutable = factory());
	}(this, function () { 'use strict';var SLICE$0 = Array.prototype.slice;
	
	  function createClass(ctor, superClass) {
	    if (superClass) {
	      ctor.prototype = Object.create(superClass.prototype);
	    }
	    ctor.prototype.constructor = ctor;
	  }
	
	  function Iterable(value) {
	      return isIterable(value) ? value : Seq(value);
	    }
	
	
	  createClass(KeyedIterable, Iterable);
	    function KeyedIterable(value) {
	      return isKeyed(value) ? value : KeyedSeq(value);
	    }
	
	
	  createClass(IndexedIterable, Iterable);
	    function IndexedIterable(value) {
	      return isIndexed(value) ? value : IndexedSeq(value);
	    }
	
	
	  createClass(SetIterable, Iterable);
	    function SetIterable(value) {
	      return isIterable(value) && !isAssociative(value) ? value : SetSeq(value);
	    }
	
	
	
	  function isIterable(maybeIterable) {
	    return !!(maybeIterable && maybeIterable[IS_ITERABLE_SENTINEL]);
	  }
	
	  function isKeyed(maybeKeyed) {
	    return !!(maybeKeyed && maybeKeyed[IS_KEYED_SENTINEL]);
	  }
	
	  function isIndexed(maybeIndexed) {
	    return !!(maybeIndexed && maybeIndexed[IS_INDEXED_SENTINEL]);
	  }
	
	  function isAssociative(maybeAssociative) {
	    return isKeyed(maybeAssociative) || isIndexed(maybeAssociative);
	  }
	
	  function isOrdered(maybeOrdered) {
	    return !!(maybeOrdered && maybeOrdered[IS_ORDERED_SENTINEL]);
	  }
	
	  Iterable.isIterable = isIterable;
	  Iterable.isKeyed = isKeyed;
	  Iterable.isIndexed = isIndexed;
	  Iterable.isAssociative = isAssociative;
	  Iterable.isOrdered = isOrdered;
	
	  Iterable.Keyed = KeyedIterable;
	  Iterable.Indexed = IndexedIterable;
	  Iterable.Set = SetIterable;
	
	
	  var IS_ITERABLE_SENTINEL = '@@__IMMUTABLE_ITERABLE__@@';
	  var IS_KEYED_SENTINEL = '@@__IMMUTABLE_KEYED__@@';
	  var IS_INDEXED_SENTINEL = '@@__IMMUTABLE_INDEXED__@@';
	  var IS_ORDERED_SENTINEL = '@@__IMMUTABLE_ORDERED__@@';
	
	  // Used for setting prototype methods that IE8 chokes on.
	  var DELETE = 'delete';
	
	  // Constants describing the size of trie nodes.
	  var SHIFT = 5; // Resulted in best performance after ______?
	  var SIZE = 1 << SHIFT;
	  var MASK = SIZE - 1;
	
	  // A consistent shared value representing "not set" which equals nothing other
	  // than itself, and nothing that could be provided externally.
	  var NOT_SET = {};
	
	  // Boolean references, Rough equivalent of `bool &`.
	  var CHANGE_LENGTH = { value: false };
	  var DID_ALTER = { value: false };
	
	  function MakeRef(ref) {
	    ref.value = false;
	    return ref;
	  }
	
	  function SetRef(ref) {
	    ref && (ref.value = true);
	  }
	
	  // A function which returns a value representing an "owner" for transient writes
	  // to tries. The return value will only ever equal itself, and will not equal
	  // the return of any subsequent call of this function.
	  function OwnerID() {}
	
	  // http://jsperf.com/copy-array-inline
	  function arrCopy(arr, offset) {
	    offset = offset || 0;
	    var len = Math.max(0, arr.length - offset);
	    var newArr = new Array(len);
	    for (var ii = 0; ii < len; ii++) {
	      newArr[ii] = arr[ii + offset];
	    }
	    return newArr;
	  }
	
	  function ensureSize(iter) {
	    if (iter.size === undefined) {
	      iter.size = iter.__iterate(returnTrue);
	    }
	    return iter.size;
	  }
	
	  function wrapIndex(iter, index) {
	    // This implements "is array index" which the ECMAString spec defines as:
	    //
	    //     A String property name P is an array index if and only if
	    //     ToString(ToUint32(P)) is equal to P and ToUint32(P) is not equal
	    //     to 2^32−1.
	    //
	    // http://www.ecma-international.org/ecma-262/6.0/#sec-array-exotic-objects
	    if (typeof index !== 'number') {
	      var uint32Index = index >>> 0; // N >>> 0 is shorthand for ToUint32
	      if ('' + uint32Index !== index || uint32Index === 4294967295) {
	        return NaN;
	      }
	      index = uint32Index;
	    }
	    return index < 0 ? ensureSize(iter) + index : index;
	  }
	
	  function returnTrue() {
	    return true;
	  }
	
	  function wholeSlice(begin, end, size) {
	    return (begin === 0 || (size !== undefined && begin <= -size)) &&
	      (end === undefined || (size !== undefined && end >= size));
	  }
	
	  function resolveBegin(begin, size) {
	    return resolveIndex(begin, size, 0);
	  }
	
	  function resolveEnd(end, size) {
	    return resolveIndex(end, size, size);
	  }
	
	  function resolveIndex(index, size, defaultIndex) {
	    return index === undefined ?
	      defaultIndex :
	      index < 0 ?
	        Math.max(0, size + index) :
	        size === undefined ?
	          index :
	          Math.min(size, index);
	  }
	
	  /* global Symbol */
	
	  var ITERATE_KEYS = 0;
	  var ITERATE_VALUES = 1;
	  var ITERATE_ENTRIES = 2;
	
	  var REAL_ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	  var FAUX_ITERATOR_SYMBOL = '@@iterator';
	
	  var ITERATOR_SYMBOL = REAL_ITERATOR_SYMBOL || FAUX_ITERATOR_SYMBOL;
	
	
	  function Iterator(next) {
	      this.next = next;
	    }
	
	    Iterator.prototype.toString = function() {
	      return '[Iterator]';
	    };
	
	
	  Iterator.KEYS = ITERATE_KEYS;
	  Iterator.VALUES = ITERATE_VALUES;
	  Iterator.ENTRIES = ITERATE_ENTRIES;
	
	  Iterator.prototype.inspect =
	  Iterator.prototype.toSource = function () { return this.toString(); }
	  Iterator.prototype[ITERATOR_SYMBOL] = function () {
	    return this;
	  };
	
	
	  function iteratorValue(type, k, v, iteratorResult) {
	    var value = type === 0 ? k : type === 1 ? v : [k, v];
	    iteratorResult ? (iteratorResult.value = value) : (iteratorResult = {
	      value: value, done: false
	    });
	    return iteratorResult;
	  }
	
	  function iteratorDone() {
	    return { value: undefined, done: true };
	  }
	
	  function hasIterator(maybeIterable) {
	    return !!getIteratorFn(maybeIterable);
	  }
	
	  function isIterator(maybeIterator) {
	    return maybeIterator && typeof maybeIterator.next === 'function';
	  }
	
	  function getIterator(iterable) {
	    var iteratorFn = getIteratorFn(iterable);
	    return iteratorFn && iteratorFn.call(iterable);
	  }
	
	  function getIteratorFn(iterable) {
	    var iteratorFn = iterable && (
	      (REAL_ITERATOR_SYMBOL && iterable[REAL_ITERATOR_SYMBOL]) ||
	      iterable[FAUX_ITERATOR_SYMBOL]
	    );
	    if (typeof iteratorFn === 'function') {
	      return iteratorFn;
	    }
	  }
	
	  function isArrayLike(value) {
	    return value && typeof value.length === 'number';
	  }
	
	  createClass(Seq, Iterable);
	    function Seq(value) {
	      return value === null || value === undefined ? emptySequence() :
	        isIterable(value) ? value.toSeq() : seqFromValue(value);
	    }
	
	    Seq.of = function(/*...values*/) {
	      return Seq(arguments);
	    };
	
	    Seq.prototype.toSeq = function() {
	      return this;
	    };
	
	    Seq.prototype.toString = function() {
	      return this.__toString('Seq {', '}');
	    };
	
	    Seq.prototype.cacheResult = function() {
	      if (!this._cache && this.__iterateUncached) {
	        this._cache = this.entrySeq().toArray();
	        this.size = this._cache.length;
	      }
	      return this;
	    };
	
	    // abstract __iterateUncached(fn, reverse)
	
	    Seq.prototype.__iterate = function(fn, reverse) {
	      return seqIterate(this, fn, reverse, true);
	    };
	
	    // abstract __iteratorUncached(type, reverse)
	
	    Seq.prototype.__iterator = function(type, reverse) {
	      return seqIterator(this, type, reverse, true);
	    };
	
	
	
	  createClass(KeyedSeq, Seq);
	    function KeyedSeq(value) {
	      return value === null || value === undefined ?
	        emptySequence().toKeyedSeq() :
	        isIterable(value) ?
	          (isKeyed(value) ? value.toSeq() : value.fromEntrySeq()) :
	          keyedSeqFromValue(value);
	    }
	
	    KeyedSeq.prototype.toKeyedSeq = function() {
	      return this;
	    };
	
	
	
	  createClass(IndexedSeq, Seq);
	    function IndexedSeq(value) {
	      return value === null || value === undefined ? emptySequence() :
	        !isIterable(value) ? indexedSeqFromValue(value) :
	        isKeyed(value) ? value.entrySeq() : value.toIndexedSeq();
	    }
	
	    IndexedSeq.of = function(/*...values*/) {
	      return IndexedSeq(arguments);
	    };
	
	    IndexedSeq.prototype.toIndexedSeq = function() {
	      return this;
	    };
	
	    IndexedSeq.prototype.toString = function() {
	      return this.__toString('Seq [', ']');
	    };
	
	    IndexedSeq.prototype.__iterate = function(fn, reverse) {
	      return seqIterate(this, fn, reverse, false);
	    };
	
	    IndexedSeq.prototype.__iterator = function(type, reverse) {
	      return seqIterator(this, type, reverse, false);
	    };
	
	
	
	  createClass(SetSeq, Seq);
	    function SetSeq(value) {
	      return (
	        value === null || value === undefined ? emptySequence() :
	        !isIterable(value) ? indexedSeqFromValue(value) :
	        isKeyed(value) ? value.entrySeq() : value
	      ).toSetSeq();
	    }
	
	    SetSeq.of = function(/*...values*/) {
	      return SetSeq(arguments);
	    };
	
	    SetSeq.prototype.toSetSeq = function() {
	      return this;
	    };
	
	
	
	  Seq.isSeq = isSeq;
	  Seq.Keyed = KeyedSeq;
	  Seq.Set = SetSeq;
	  Seq.Indexed = IndexedSeq;
	
	  var IS_SEQ_SENTINEL = '@@__IMMUTABLE_SEQ__@@';
	
	  Seq.prototype[IS_SEQ_SENTINEL] = true;
	
	
	
	  createClass(ArraySeq, IndexedSeq);
	    function ArraySeq(array) {
	      this._array = array;
	      this.size = array.length;
	    }
	
	    ArraySeq.prototype.get = function(index, notSetValue) {
	      return this.has(index) ? this._array[wrapIndex(this, index)] : notSetValue;
	    };
	
	    ArraySeq.prototype.__iterate = function(fn, reverse) {
	      var array = this._array;
	      var maxIndex = array.length - 1;
	      for (var ii = 0; ii <= maxIndex; ii++) {
	        if (fn(array[reverse ? maxIndex - ii : ii], ii, this) === false) {
	          return ii + 1;
	        }
	      }
	      return ii;
	    };
	
	    ArraySeq.prototype.__iterator = function(type, reverse) {
	      var array = this._array;
	      var maxIndex = array.length - 1;
	      var ii = 0;
	      return new Iterator(function() 
	        {return ii > maxIndex ?
	          iteratorDone() :
	          iteratorValue(type, ii, array[reverse ? maxIndex - ii++ : ii++])}
	      );
	    };
	
	
	
	  createClass(ObjectSeq, KeyedSeq);
	    function ObjectSeq(object) {
	      var keys = Object.keys(object);
	      this._object = object;
	      this._keys = keys;
	      this.size = keys.length;
	    }
	
	    ObjectSeq.prototype.get = function(key, notSetValue) {
	      if (notSetValue !== undefined && !this.has(key)) {
	        return notSetValue;
	      }
	      return this._object[key];
	    };
	
	    ObjectSeq.prototype.has = function(key) {
	      return this._object.hasOwnProperty(key);
	    };
	
	    ObjectSeq.prototype.__iterate = function(fn, reverse) {
	      var object = this._object;
	      var keys = this._keys;
	      var maxIndex = keys.length - 1;
	      for (var ii = 0; ii <= maxIndex; ii++) {
	        var key = keys[reverse ? maxIndex - ii : ii];
	        if (fn(object[key], key, this) === false) {
	          return ii + 1;
	        }
	      }
	      return ii;
	    };
	
	    ObjectSeq.prototype.__iterator = function(type, reverse) {
	      var object = this._object;
	      var keys = this._keys;
	      var maxIndex = keys.length - 1;
	      var ii = 0;
	      return new Iterator(function()  {
	        var key = keys[reverse ? maxIndex - ii : ii];
	        return ii++ > maxIndex ?
	          iteratorDone() :
	          iteratorValue(type, key, object[key]);
	      });
	    };
	
	  ObjectSeq.prototype[IS_ORDERED_SENTINEL] = true;
	
	
	  createClass(IterableSeq, IndexedSeq);
	    function IterableSeq(iterable) {
	      this._iterable = iterable;
	      this.size = iterable.length || iterable.size;
	    }
	
	    IterableSeq.prototype.__iterateUncached = function(fn, reverse) {
	      if (reverse) {
	        return this.cacheResult().__iterate(fn, reverse);
	      }
	      var iterable = this._iterable;
	      var iterator = getIterator(iterable);
	      var iterations = 0;
	      if (isIterator(iterator)) {
	        var step;
	        while (!(step = iterator.next()).done) {
	          if (fn(step.value, iterations++, this) === false) {
	            break;
	          }
	        }
	      }
	      return iterations;
	    };
	
	    IterableSeq.prototype.__iteratorUncached = function(type, reverse) {
	      if (reverse) {
	        return this.cacheResult().__iterator(type, reverse);
	      }
	      var iterable = this._iterable;
	      var iterator = getIterator(iterable);
	      if (!isIterator(iterator)) {
	        return new Iterator(iteratorDone);
	      }
	      var iterations = 0;
	      return new Iterator(function()  {
	        var step = iterator.next();
	        return step.done ? step : iteratorValue(type, iterations++, step.value);
	      });
	    };
	
	
	
	  createClass(IteratorSeq, IndexedSeq);
	    function IteratorSeq(iterator) {
	      this._iterator = iterator;
	      this._iteratorCache = [];
	    }
	
	    IteratorSeq.prototype.__iterateUncached = function(fn, reverse) {
	      if (reverse) {
	        return this.cacheResult().__iterate(fn, reverse);
	      }
	      var iterator = this._iterator;
	      var cache = this._iteratorCache;
	      var iterations = 0;
	      while (iterations < cache.length) {
	        if (fn(cache[iterations], iterations++, this) === false) {
	          return iterations;
	        }
	      }
	      var step;
	      while (!(step = iterator.next()).done) {
	        var val = step.value;
	        cache[iterations] = val;
	        if (fn(val, iterations++, this) === false) {
	          break;
	        }
	      }
	      return iterations;
	    };
	
	    IteratorSeq.prototype.__iteratorUncached = function(type, reverse) {
	      if (reverse) {
	        return this.cacheResult().__iterator(type, reverse);
	      }
	      var iterator = this._iterator;
	      var cache = this._iteratorCache;
	      var iterations = 0;
	      return new Iterator(function()  {
	        if (iterations >= cache.length) {
	          var step = iterator.next();
	          if (step.done) {
	            return step;
	          }
	          cache[iterations] = step.value;
	        }
	        return iteratorValue(type, iterations, cache[iterations++]);
	      });
	    };
	
	
	
	
	  // # pragma Helper functions
	
	  function isSeq(maybeSeq) {
	    return !!(maybeSeq && maybeSeq[IS_SEQ_SENTINEL]);
	  }
	
	  var EMPTY_SEQ;
	
	  function emptySequence() {
	    return EMPTY_SEQ || (EMPTY_SEQ = new ArraySeq([]));
	  }
	
	  function keyedSeqFromValue(value) {
	    var seq =
	      Array.isArray(value) ? new ArraySeq(value).fromEntrySeq() :
	      isIterator(value) ? new IteratorSeq(value).fromEntrySeq() :
	      hasIterator(value) ? new IterableSeq(value).fromEntrySeq() :
	      typeof value === 'object' ? new ObjectSeq(value) :
	      undefined;
	    if (!seq) {
	      throw new TypeError(
	        'Expected Array or iterable object of [k, v] entries, '+
	        'or keyed object: ' + value
	      );
	    }
	    return seq;
	  }
	
	  function indexedSeqFromValue(value) {
	    var seq = maybeIndexedSeqFromValue(value);
	    if (!seq) {
	      throw new TypeError(
	        'Expected Array or iterable object of values: ' + value
	      );
	    }
	    return seq;
	  }
	
	  function seqFromValue(value) {
	    var seq = maybeIndexedSeqFromValue(value) ||
	      (typeof value === 'object' && new ObjectSeq(value));
	    if (!seq) {
	      throw new TypeError(
	        'Expected Array or iterable object of values, or keyed object: ' + value
	      );
	    }
	    return seq;
	  }
	
	  function maybeIndexedSeqFromValue(value) {
	    return (
	      isArrayLike(value) ? new ArraySeq(value) :
	      isIterator(value) ? new IteratorSeq(value) :
	      hasIterator(value) ? new IterableSeq(value) :
	      undefined
	    );
	  }
	
	  function seqIterate(seq, fn, reverse, useKeys) {
	    var cache = seq._cache;
	    if (cache) {
	      var maxIndex = cache.length - 1;
	      for (var ii = 0; ii <= maxIndex; ii++) {
	        var entry = cache[reverse ? maxIndex - ii : ii];
	        if (fn(entry[1], useKeys ? entry[0] : ii, seq) === false) {
	          return ii + 1;
	        }
	      }
	      return ii;
	    }
	    return seq.__iterateUncached(fn, reverse);
	  }
	
	  function seqIterator(seq, type, reverse, useKeys) {
	    var cache = seq._cache;
	    if (cache) {
	      var maxIndex = cache.length - 1;
	      var ii = 0;
	      return new Iterator(function()  {
	        var entry = cache[reverse ? maxIndex - ii : ii];
	        return ii++ > maxIndex ?
	          iteratorDone() :
	          iteratorValue(type, useKeys ? entry[0] : ii - 1, entry[1]);
	      });
	    }
	    return seq.__iteratorUncached(type, reverse);
	  }
	
	  function fromJS(json, converter) {
	    return converter ?
	      fromJSWith(converter, json, '', {'': json}) :
	      fromJSDefault(json);
	  }
	
	  function fromJSWith(converter, json, key, parentJSON) {
	    if (Array.isArray(json)) {
	      return converter.call(parentJSON, key, IndexedSeq(json).map(function(v, k)  {return fromJSWith(converter, v, k, json)}));
	    }
	    if (isPlainObj(json)) {
	      return converter.call(parentJSON, key, KeyedSeq(json).map(function(v, k)  {return fromJSWith(converter, v, k, json)}));
	    }
	    return json;
	  }
	
	  function fromJSDefault(json) {
	    if (Array.isArray(json)) {
	      return IndexedSeq(json).map(fromJSDefault).toList();
	    }
	    if (isPlainObj(json)) {
	      return KeyedSeq(json).map(fromJSDefault).toMap();
	    }
	    return json;
	  }
	
	  function isPlainObj(value) {
	    return value && (value.constructor === Object || value.constructor === undefined);
	  }
	
	  /**
	   * An extension of the "same-value" algorithm as [described for use by ES6 Map
	   * and Set](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Map#Key_equality)
	   *
	   * NaN is considered the same as NaN, however -0 and 0 are considered the same
	   * value, which is different from the algorithm described by
	   * [`Object.is`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is).
	   *
	   * This is extended further to allow Objects to describe the values they
	   * represent, by way of `valueOf` or `equals` (and `hashCode`).
	   *
	   * Note: because of this extension, the key equality of Immutable.Map and the
	   * value equality of Immutable.Set will differ from ES6 Map and Set.
	   *
	   * ### Defining custom values
	   *
	   * The easiest way to describe the value an object represents is by implementing
	   * `valueOf`. For example, `Date` represents a value by returning a unix
	   * timestamp for `valueOf`:
	   *
	   *     var date1 = new Date(1234567890000); // Fri Feb 13 2009 ...
	   *     var date2 = new Date(1234567890000);
	   *     date1.valueOf(); // 1234567890000
	   *     assert( date1 !== date2 );
	   *     assert( Immutable.is( date1, date2 ) );
	   *
	   * Note: overriding `valueOf` may have other implications if you use this object
	   * where JavaScript expects a primitive, such as implicit string coercion.
	   *
	   * For more complex types, especially collections, implementing `valueOf` may
	   * not be performant. An alternative is to implement `equals` and `hashCode`.
	   *
	   * `equals` takes another object, presumably of similar type, and returns true
	   * if the it is equal. Equality is symmetrical, so the same result should be
	   * returned if this and the argument are flipped.
	   *
	   *     assert( a.equals(b) === b.equals(a) );
	   *
	   * `hashCode` returns a 32bit integer number representing the object which will
	   * be used to determine how to store the value object in a Map or Set. You must
	   * provide both or neither methods, one must not exist without the other.
	   *
	   * Also, an important relationship between these methods must be upheld: if two
	   * values are equal, they *must* return the same hashCode. If the values are not
	   * equal, they might have the same hashCode; this is called a hash collision,
	   * and while undesirable for performance reasons, it is acceptable.
	   *
	   *     if (a.equals(b)) {
	   *       assert( a.hashCode() === b.hashCode() );
	   *     }
	   *
	   * All Immutable collections implement `equals` and `hashCode`.
	   *
	   */
	  function is(valueA, valueB) {
	    if (valueA === valueB || (valueA !== valueA && valueB !== valueB)) {
	      return true;
	    }
	    if (!valueA || !valueB) {
	      return false;
	    }
	    if (typeof valueA.valueOf === 'function' &&
	        typeof valueB.valueOf === 'function') {
	      valueA = valueA.valueOf();
	      valueB = valueB.valueOf();
	      if (valueA === valueB || (valueA !== valueA && valueB !== valueB)) {
	        return true;
	      }
	      if (!valueA || !valueB) {
	        return false;
	      }
	    }
	    if (typeof valueA.equals === 'function' &&
	        typeof valueB.equals === 'function' &&
	        valueA.equals(valueB)) {
	      return true;
	    }
	    return false;
	  }
	
	  function deepEqual(a, b) {
	    if (a === b) {
	      return true;
	    }
	
	    if (
	      !isIterable(b) ||
	      a.size !== undefined && b.size !== undefined && a.size !== b.size ||
	      a.__hash !== undefined && b.__hash !== undefined && a.__hash !== b.__hash ||
	      isKeyed(a) !== isKeyed(b) ||
	      isIndexed(a) !== isIndexed(b) ||
	      isOrdered(a) !== isOrdered(b)
	    ) {
	      return false;
	    }
	
	    if (a.size === 0 && b.size === 0) {
	      return true;
	    }
	
	    var notAssociative = !isAssociative(a);
	
	    if (isOrdered(a)) {
	      var entries = a.entries();
	      return b.every(function(v, k)  {
	        var entry = entries.next().value;
	        return entry && is(entry[1], v) && (notAssociative || is(entry[0], k));
	      }) && entries.next().done;
	    }
	
	    var flipped = false;
	
	    if (a.size === undefined) {
	      if (b.size === undefined) {
	        if (typeof a.cacheResult === 'function') {
	          a.cacheResult();
	        }
	      } else {
	        flipped = true;
	        var _ = a;
	        a = b;
	        b = _;
	      }
	    }
	
	    var allEqual = true;
	    var bSize = b.__iterate(function(v, k)  {
	      if (notAssociative ? !a.has(v) :
	          flipped ? !is(v, a.get(k, NOT_SET)) : !is(a.get(k, NOT_SET), v)) {
	        allEqual = false;
	        return false;
	      }
	    });
	
	    return allEqual && a.size === bSize;
	  }
	
	  createClass(Repeat, IndexedSeq);
	
	    function Repeat(value, times) {
	      if (!(this instanceof Repeat)) {
	        return new Repeat(value, times);
	      }
	      this._value = value;
	      this.size = times === undefined ? Infinity : Math.max(0, times);
	      if (this.size === 0) {
	        if (EMPTY_REPEAT) {
	          return EMPTY_REPEAT;
	        }
	        EMPTY_REPEAT = this;
	      }
	    }
	
	    Repeat.prototype.toString = function() {
	      if (this.size === 0) {
	        return 'Repeat []';
	      }
	      return 'Repeat [ ' + this._value + ' ' + this.size + ' times ]';
	    };
	
	    Repeat.prototype.get = function(index, notSetValue) {
	      return this.has(index) ? this._value : notSetValue;
	    };
	
	    Repeat.prototype.includes = function(searchValue) {
	      return is(this._value, searchValue);
	    };
	
	    Repeat.prototype.slice = function(begin, end) {
	      var size = this.size;
	      return wholeSlice(begin, end, size) ? this :
	        new Repeat(this._value, resolveEnd(end, size) - resolveBegin(begin, size));
	    };
	
	    Repeat.prototype.reverse = function() {
	      return this;
	    };
	
	    Repeat.prototype.indexOf = function(searchValue) {
	      if (is(this._value, searchValue)) {
	        return 0;
	      }
	      return -1;
	    };
	
	    Repeat.prototype.lastIndexOf = function(searchValue) {
	      if (is(this._value, searchValue)) {
	        return this.size;
	      }
	      return -1;
	    };
	
	    Repeat.prototype.__iterate = function(fn, reverse) {
	      for (var ii = 0; ii < this.size; ii++) {
	        if (fn(this._value, ii, this) === false) {
	          return ii + 1;
	        }
	      }
	      return ii;
	    };
	
	    Repeat.prototype.__iterator = function(type, reverse) {var this$0 = this;
	      var ii = 0;
	      return new Iterator(function() 
	        {return ii < this$0.size ? iteratorValue(type, ii++, this$0._value) : iteratorDone()}
	      );
	    };
	
	    Repeat.prototype.equals = function(other) {
	      return other instanceof Repeat ?
	        is(this._value, other._value) :
	        deepEqual(other);
	    };
	
	
	  var EMPTY_REPEAT;
	
	  function invariant(condition, error) {
	    if (!condition) throw new Error(error);
	  }
	
	  createClass(Range, IndexedSeq);
	
	    function Range(start, end, step) {
	      if (!(this instanceof Range)) {
	        return new Range(start, end, step);
	      }
	      invariant(step !== 0, 'Cannot step a Range by 0');
	      start = start || 0;
	      if (end === undefined) {
	        end = Infinity;
	      }
	      step = step === undefined ? 1 : Math.abs(step);
	      if (end < start) {
	        step = -step;
	      }
	      this._start = start;
	      this._end = end;
	      this._step = step;
	      this.size = Math.max(0, Math.ceil((end - start) / step - 1) + 1);
	      if (this.size === 0) {
	        if (EMPTY_RANGE) {
	          return EMPTY_RANGE;
	        }
	        EMPTY_RANGE = this;
	      }
	    }
	
	    Range.prototype.toString = function() {
	      if (this.size === 0) {
	        return 'Range []';
	      }
	      return 'Range [ ' +
	        this._start + '...' + this._end +
	        (this._step !== 1 ? ' by ' + this._step : '') +
	      ' ]';
	    };
	
	    Range.prototype.get = function(index, notSetValue) {
	      return this.has(index) ?
	        this._start + wrapIndex(this, index) * this._step :
	        notSetValue;
	    };
	
	    Range.prototype.includes = function(searchValue) {
	      var possibleIndex = (searchValue - this._start) / this._step;
	      return possibleIndex >= 0 &&
	        possibleIndex < this.size &&
	        possibleIndex === Math.floor(possibleIndex);
	    };
	
	    Range.prototype.slice = function(begin, end) {
	      if (wholeSlice(begin, end, this.size)) {
	        return this;
	      }
	      begin = resolveBegin(begin, this.size);
	      end = resolveEnd(end, this.size);
	      if (end <= begin) {
	        return new Range(0, 0);
	      }
	      return new Range(this.get(begin, this._end), this.get(end, this._end), this._step);
	    };
	
	    Range.prototype.indexOf = function(searchValue) {
	      var offsetValue = searchValue - this._start;
	      if (offsetValue % this._step === 0) {
	        var index = offsetValue / this._step;
	        if (index >= 0 && index < this.size) {
	          return index
	        }
	      }
	      return -1;
	    };
	
	    Range.prototype.lastIndexOf = function(searchValue) {
	      return this.indexOf(searchValue);
	    };
	
	    Range.prototype.__iterate = function(fn, reverse) {
	      var maxIndex = this.size - 1;
	      var step = this._step;
	      var value = reverse ? this._start + maxIndex * step : this._start;
	      for (var ii = 0; ii <= maxIndex; ii++) {
	        if (fn(value, ii, this) === false) {
	          return ii + 1;
	        }
	        value += reverse ? -step : step;
	      }
	      return ii;
	    };
	
	    Range.prototype.__iterator = function(type, reverse) {
	      var maxIndex = this.size - 1;
	      var step = this._step;
	      var value = reverse ? this._start + maxIndex * step : this._start;
	      var ii = 0;
	      return new Iterator(function()  {
	        var v = value;
	        value += reverse ? -step : step;
	        return ii > maxIndex ? iteratorDone() : iteratorValue(type, ii++, v);
	      });
	    };
	
	    Range.prototype.equals = function(other) {
	      return other instanceof Range ?
	        this._start === other._start &&
	        this._end === other._end &&
	        this._step === other._step :
	        deepEqual(this, other);
	    };
	
	
	  var EMPTY_RANGE;
	
	  createClass(Collection, Iterable);
	    function Collection() {
	      throw TypeError('Abstract');
	    }
	
	
	  createClass(KeyedCollection, Collection);function KeyedCollection() {}
	
	  createClass(IndexedCollection, Collection);function IndexedCollection() {}
	
	  createClass(SetCollection, Collection);function SetCollection() {}
	
	
	  Collection.Keyed = KeyedCollection;
	  Collection.Indexed = IndexedCollection;
	  Collection.Set = SetCollection;
	
	  var imul =
	    typeof Math.imul === 'function' && Math.imul(0xffffffff, 2) === -2 ?
	    Math.imul :
	    function imul(a, b) {
	      a = a | 0; // int
	      b = b | 0; // int
	      var c = a & 0xffff;
	      var d = b & 0xffff;
	      // Shift by 0 fixes the sign on the high part.
	      return (c * d) + ((((a >>> 16) * d + c * (b >>> 16)) << 16) >>> 0) | 0; // int
	    };
	
	  // v8 has an optimization for storing 31-bit signed numbers.
	  // Values which have either 00 or 11 as the high order bits qualify.
	  // This function drops the highest order bit in a signed number, maintaining
	  // the sign bit.
	  function smi(i32) {
	    return ((i32 >>> 1) & 0x40000000) | (i32 & 0xBFFFFFFF);
	  }
	
	  function hash(o) {
	    if (o === false || o === null || o === undefined) {
	      return 0;
	    }
	    if (typeof o.valueOf === 'function') {
	      o = o.valueOf();
	      if (o === false || o === null || o === undefined) {
	        return 0;
	      }
	    }
	    if (o === true) {
	      return 1;
	    }
	    var type = typeof o;
	    if (type === 'number') {
	      if (o !== o || o === Infinity) {
	        return 0;
	      }
	      var h = o | 0;
	      if (h !== o) {
	        h ^= o * 0xFFFFFFFF;
	      }
	      while (o > 0xFFFFFFFF) {
	        o /= 0xFFFFFFFF;
	        h ^= o;
	      }
	      return smi(h);
	    }
	    if (type === 'string') {
	      return o.length > STRING_HASH_CACHE_MIN_STRLEN ? cachedHashString(o) : hashString(o);
	    }
	    if (typeof o.hashCode === 'function') {
	      return o.hashCode();
	    }
	    if (type === 'object') {
	      return hashJSObj(o);
	    }
	    if (typeof o.toString === 'function') {
	      return hashString(o.toString());
	    }
	    throw new Error('Value type ' + type + ' cannot be hashed.');
	  }
	
	  function cachedHashString(string) {
	    var hash = stringHashCache[string];
	    if (hash === undefined) {
	      hash = hashString(string);
	      if (STRING_HASH_CACHE_SIZE === STRING_HASH_CACHE_MAX_SIZE) {
	        STRING_HASH_CACHE_SIZE = 0;
	        stringHashCache = {};
	      }
	      STRING_HASH_CACHE_SIZE++;
	      stringHashCache[string] = hash;
	    }
	    return hash;
	  }
	
	  // http://jsperf.com/hashing-strings
	  function hashString(string) {
	    // This is the hash from JVM
	    // The hash code for a string is computed as
	    // s[0] * 31 ^ (n - 1) + s[1] * 31 ^ (n - 2) + ... + s[n - 1],
	    // where s[i] is the ith character of the string and n is the length of
	    // the string. We "mod" the result to make it between 0 (inclusive) and 2^31
	    // (exclusive) by dropping high bits.
	    var hash = 0;
	    for (var ii = 0; ii < string.length; ii++) {
	      hash = 31 * hash + string.charCodeAt(ii) | 0;
	    }
	    return smi(hash);
	  }
	
	  function hashJSObj(obj) {
	    var hash;
	    if (usingWeakMap) {
	      hash = weakMap.get(obj);
	      if (hash !== undefined) {
	        return hash;
	      }
	    }
	
	    hash = obj[UID_HASH_KEY];
	    if (hash !== undefined) {
	      return hash;
	    }
	
	    if (!canDefineProperty) {
	      hash = obj.propertyIsEnumerable && obj.propertyIsEnumerable[UID_HASH_KEY];
	      if (hash !== undefined) {
	        return hash;
	      }
	
	      hash = getIENodeHash(obj);
	      if (hash !== undefined) {
	        return hash;
	      }
	    }
	
	    hash = ++objHashUID;
	    if (objHashUID & 0x40000000) {
	      objHashUID = 0;
	    }
	
	    if (usingWeakMap) {
	      weakMap.set(obj, hash);
	    } else if (isExtensible !== undefined && isExtensible(obj) === false) {
	      throw new Error('Non-extensible objects are not allowed as keys.');
	    } else if (canDefineProperty) {
	      Object.defineProperty(obj, UID_HASH_KEY, {
	        'enumerable': false,
	        'configurable': false,
	        'writable': false,
	        'value': hash
	      });
	    } else if (obj.propertyIsEnumerable !== undefined &&
	               obj.propertyIsEnumerable === obj.constructor.prototype.propertyIsEnumerable) {
	      // Since we can't define a non-enumerable property on the object
	      // we'll hijack one of the less-used non-enumerable properties to
	      // save our hash on it. Since this is a function it will not show up in
	      // `JSON.stringify` which is what we want.
	      obj.propertyIsEnumerable = function() {
	        return this.constructor.prototype.propertyIsEnumerable.apply(this, arguments);
	      };
	      obj.propertyIsEnumerable[UID_HASH_KEY] = hash;
	    } else if (obj.nodeType !== undefined) {
	      // At this point we couldn't get the IE `uniqueID` to use as a hash
	      // and we couldn't use a non-enumerable property to exploit the
	      // dontEnum bug so we simply add the `UID_HASH_KEY` on the node
	      // itself.
	      obj[UID_HASH_KEY] = hash;
	    } else {
	      throw new Error('Unable to set a non-enumerable property on object.');
	    }
	
	    return hash;
	  }
	
	  // Get references to ES5 object methods.
	  var isExtensible = Object.isExtensible;
	
	  // True if Object.defineProperty works as expected. IE8 fails this test.
	  var canDefineProperty = (function() {
	    try {
	      Object.defineProperty({}, '@', {});
	      return true;
	    } catch (e) {
	      return false;
	    }
	  }());
	
	  // IE has a `uniqueID` property on DOM nodes. We can construct the hash from it
	  // and avoid memory leaks from the IE cloneNode bug.
	  function getIENodeHash(node) {
	    if (node && node.nodeType > 0) {
	      switch (node.nodeType) {
	        case 1: // Element
	          return node.uniqueID;
	        case 9: // Document
	          return node.documentElement && node.documentElement.uniqueID;
	      }
	    }
	  }
	
	  // If possible, use a WeakMap.
	  var usingWeakMap = typeof WeakMap === 'function';
	  var weakMap;
	  if (usingWeakMap) {
	    weakMap = new WeakMap();
	  }
	
	  var objHashUID = 0;
	
	  var UID_HASH_KEY = '__immutablehash__';
	  if (typeof Symbol === 'function') {
	    UID_HASH_KEY = Symbol(UID_HASH_KEY);
	  }
	
	  var STRING_HASH_CACHE_MIN_STRLEN = 16;
	  var STRING_HASH_CACHE_MAX_SIZE = 255;
	  var STRING_HASH_CACHE_SIZE = 0;
	  var stringHashCache = {};
	
	  function assertNotInfinite(size) {
	    invariant(
	      size !== Infinity,
	      'Cannot perform this action with an infinite size.'
	    );
	  }
	
	  createClass(Map, KeyedCollection);
	
	    // @pragma Construction
	
	    function Map(value) {
	      return value === null || value === undefined ? emptyMap() :
	        isMap(value) && !isOrdered(value) ? value :
	        emptyMap().withMutations(function(map ) {
	          var iter = KeyedIterable(value);
	          assertNotInfinite(iter.size);
	          iter.forEach(function(v, k)  {return map.set(k, v)});
	        });
	    }
	
	    Map.of = function() {var keyValues = SLICE$0.call(arguments, 0);
	      return emptyMap().withMutations(function(map ) {
	        for (var i = 0; i < keyValues.length; i += 2) {
	          if (i + 1 >= keyValues.length) {
	            throw new Error('Missing value for key: ' + keyValues[i]);
	          }
	          map.set(keyValues[i], keyValues[i + 1]);
	        }
	      });
	    };
	
	    Map.prototype.toString = function() {
	      return this.__toString('Map {', '}');
	    };
	
	    // @pragma Access
	
	    Map.prototype.get = function(k, notSetValue) {
	      return this._root ?
	        this._root.get(0, undefined, k, notSetValue) :
	        notSetValue;
	    };
	
	    // @pragma Modification
	
	    Map.prototype.set = function(k, v) {
	      return updateMap(this, k, v);
	    };
	
	    Map.prototype.setIn = function(keyPath, v) {
	      return this.updateIn(keyPath, NOT_SET, function()  {return v});
	    };
	
	    Map.prototype.remove = function(k) {
	      return updateMap(this, k, NOT_SET);
	    };
	
	    Map.prototype.deleteIn = function(keyPath) {
	      return this.updateIn(keyPath, function()  {return NOT_SET});
	    };
	
	    Map.prototype.update = function(k, notSetValue, updater) {
	      return arguments.length === 1 ?
	        k(this) :
	        this.updateIn([k], notSetValue, updater);
	    };
	
	    Map.prototype.updateIn = function(keyPath, notSetValue, updater) {
	      if (!updater) {
	        updater = notSetValue;
	        notSetValue = undefined;
	      }
	      var updatedValue = updateInDeepMap(
	        this,
	        forceIterator(keyPath),
	        notSetValue,
	        updater
	      );
	      return updatedValue === NOT_SET ? undefined : updatedValue;
	    };
	
	    Map.prototype.clear = function() {
	      if (this.size === 0) {
	        return this;
	      }
	      if (this.__ownerID) {
	        this.size = 0;
	        this._root = null;
	        this.__hash = undefined;
	        this.__altered = true;
	        return this;
	      }
	      return emptyMap();
	    };
	
	    // @pragma Composition
	
	    Map.prototype.merge = function(/*...iters*/) {
	      return mergeIntoMapWith(this, undefined, arguments);
	    };
	
	    Map.prototype.mergeWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
	      return mergeIntoMapWith(this, merger, iters);
	    };
	
	    Map.prototype.mergeIn = function(keyPath) {var iters = SLICE$0.call(arguments, 1);
	      return this.updateIn(
	        keyPath,
	        emptyMap(),
	        function(m ) {return typeof m.merge === 'function' ?
	          m.merge.apply(m, iters) :
	          iters[iters.length - 1]}
	      );
	    };
	
	    Map.prototype.mergeDeep = function(/*...iters*/) {
	      return mergeIntoMapWith(this, deepMerger, arguments);
	    };
	
	    Map.prototype.mergeDeepWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
	      return mergeIntoMapWith(this, deepMergerWith(merger), iters);
	    };
	
	    Map.prototype.mergeDeepIn = function(keyPath) {var iters = SLICE$0.call(arguments, 1);
	      return this.updateIn(
	        keyPath,
	        emptyMap(),
	        function(m ) {return typeof m.mergeDeep === 'function' ?
	          m.mergeDeep.apply(m, iters) :
	          iters[iters.length - 1]}
	      );
	    };
	
	    Map.prototype.sort = function(comparator) {
	      // Late binding
	      return OrderedMap(sortFactory(this, comparator));
	    };
	
	    Map.prototype.sortBy = function(mapper, comparator) {
	      // Late binding
	      return OrderedMap(sortFactory(this, comparator, mapper));
	    };
	
	    // @pragma Mutability
	
	    Map.prototype.withMutations = function(fn) {
	      var mutable = this.asMutable();
	      fn(mutable);
	      return mutable.wasAltered() ? mutable.__ensureOwner(this.__ownerID) : this;
	    };
	
	    Map.prototype.asMutable = function() {
	      return this.__ownerID ? this : this.__ensureOwner(new OwnerID());
	    };
	
	    Map.prototype.asImmutable = function() {
	      return this.__ensureOwner();
	    };
	
	    Map.prototype.wasAltered = function() {
	      return this.__altered;
	    };
	
	    Map.prototype.__iterator = function(type, reverse) {
	      return new MapIterator(this, type, reverse);
	    };
	
	    Map.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      var iterations = 0;
	      this._root && this._root.iterate(function(entry ) {
	        iterations++;
	        return fn(entry[1], entry[0], this$0);
	      }, reverse);
	      return iterations;
	    };
	
	    Map.prototype.__ensureOwner = function(ownerID) {
	      if (ownerID === this.__ownerID) {
	        return this;
	      }
	      if (!ownerID) {
	        this.__ownerID = ownerID;
	        this.__altered = false;
	        return this;
	      }
	      return makeMap(this.size, this._root, ownerID, this.__hash);
	    };
	
	
	  function isMap(maybeMap) {
	    return !!(maybeMap && maybeMap[IS_MAP_SENTINEL]);
	  }
	
	  Map.isMap = isMap;
	
	  var IS_MAP_SENTINEL = '@@__IMMUTABLE_MAP__@@';
	
	  var MapPrototype = Map.prototype;
	  MapPrototype[IS_MAP_SENTINEL] = true;
	  MapPrototype[DELETE] = MapPrototype.remove;
	  MapPrototype.removeIn = MapPrototype.deleteIn;
	
	
	  // #pragma Trie Nodes
	
	
	
	    function ArrayMapNode(ownerID, entries) {
	      this.ownerID = ownerID;
	      this.entries = entries;
	    }
	
	    ArrayMapNode.prototype.get = function(shift, keyHash, key, notSetValue) {
	      var entries = this.entries;
	      for (var ii = 0, len = entries.length; ii < len; ii++) {
	        if (is(key, entries[ii][0])) {
	          return entries[ii][1];
	        }
	      }
	      return notSetValue;
	    };
	
	    ArrayMapNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
	      var removed = value === NOT_SET;
	
	      var entries = this.entries;
	      var idx = 0;
	      for (var len = entries.length; idx < len; idx++) {
	        if (is(key, entries[idx][0])) {
	          break;
	        }
	      }
	      var exists = idx < len;
	
	      if (exists ? entries[idx][1] === value : removed) {
	        return this;
	      }
	
	      SetRef(didAlter);
	      (removed || !exists) && SetRef(didChangeSize);
	
	      if (removed && entries.length === 1) {
	        return; // undefined
	      }
	
	      if (!exists && !removed && entries.length >= MAX_ARRAY_MAP_SIZE) {
	        return createNodes(ownerID, entries, key, value);
	      }
	
	      var isEditable = ownerID && ownerID === this.ownerID;
	      var newEntries = isEditable ? entries : arrCopy(entries);
	
	      if (exists) {
	        if (removed) {
	          idx === len - 1 ? newEntries.pop() : (newEntries[idx] = newEntries.pop());
	        } else {
	          newEntries[idx] = [key, value];
	        }
	      } else {
	        newEntries.push([key, value]);
	      }
	
	      if (isEditable) {
	        this.entries = newEntries;
	        return this;
	      }
	
	      return new ArrayMapNode(ownerID, newEntries);
	    };
	
	
	
	
	    function BitmapIndexedNode(ownerID, bitmap, nodes) {
	      this.ownerID = ownerID;
	      this.bitmap = bitmap;
	      this.nodes = nodes;
	    }
	
	    BitmapIndexedNode.prototype.get = function(shift, keyHash, key, notSetValue) {
	      if (keyHash === undefined) {
	        keyHash = hash(key);
	      }
	      var bit = (1 << ((shift === 0 ? keyHash : keyHash >>> shift) & MASK));
	      var bitmap = this.bitmap;
	      return (bitmap & bit) === 0 ? notSetValue :
	        this.nodes[popCount(bitmap & (bit - 1))].get(shift + SHIFT, keyHash, key, notSetValue);
	    };
	
	    BitmapIndexedNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
	      if (keyHash === undefined) {
	        keyHash = hash(key);
	      }
	      var keyHashFrag = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
	      var bit = 1 << keyHashFrag;
	      var bitmap = this.bitmap;
	      var exists = (bitmap & bit) !== 0;
	
	      if (!exists && value === NOT_SET) {
	        return this;
	      }
	
	      var idx = popCount(bitmap & (bit - 1));
	      var nodes = this.nodes;
	      var node = exists ? nodes[idx] : undefined;
	      var newNode = updateNode(node, ownerID, shift + SHIFT, keyHash, key, value, didChangeSize, didAlter);
	
	      if (newNode === node) {
	        return this;
	      }
	
	      if (!exists && newNode && nodes.length >= MAX_BITMAP_INDEXED_SIZE) {
	        return expandNodes(ownerID, nodes, bitmap, keyHashFrag, newNode);
	      }
	
	      if (exists && !newNode && nodes.length === 2 && isLeafNode(nodes[idx ^ 1])) {
	        return nodes[idx ^ 1];
	      }
	
	      if (exists && newNode && nodes.length === 1 && isLeafNode(newNode)) {
	        return newNode;
	      }
	
	      var isEditable = ownerID && ownerID === this.ownerID;
	      var newBitmap = exists ? newNode ? bitmap : bitmap ^ bit : bitmap | bit;
	      var newNodes = exists ? newNode ?
	        setIn(nodes, idx, newNode, isEditable) :
	        spliceOut(nodes, idx, isEditable) :
	        spliceIn(nodes, idx, newNode, isEditable);
	
	      if (isEditable) {
	        this.bitmap = newBitmap;
	        this.nodes = newNodes;
	        return this;
	      }
	
	      return new BitmapIndexedNode(ownerID, newBitmap, newNodes);
	    };
	
	
	
	
	    function HashArrayMapNode(ownerID, count, nodes) {
	      this.ownerID = ownerID;
	      this.count = count;
	      this.nodes = nodes;
	    }
	
	    HashArrayMapNode.prototype.get = function(shift, keyHash, key, notSetValue) {
	      if (keyHash === undefined) {
	        keyHash = hash(key);
	      }
	      var idx = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
	      var node = this.nodes[idx];
	      return node ? node.get(shift + SHIFT, keyHash, key, notSetValue) : notSetValue;
	    };
	
	    HashArrayMapNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
	      if (keyHash === undefined) {
	        keyHash = hash(key);
	      }
	      var idx = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
	      var removed = value === NOT_SET;
	      var nodes = this.nodes;
	      var node = nodes[idx];
	
	      if (removed && !node) {
	        return this;
	      }
	
	      var newNode = updateNode(node, ownerID, shift + SHIFT, keyHash, key, value, didChangeSize, didAlter);
	      if (newNode === node) {
	        return this;
	      }
	
	      var newCount = this.count;
	      if (!node) {
	        newCount++;
	      } else if (!newNode) {
	        newCount--;
	        if (newCount < MIN_HASH_ARRAY_MAP_SIZE) {
	          return packNodes(ownerID, nodes, newCount, idx);
	        }
	      }
	
	      var isEditable = ownerID && ownerID === this.ownerID;
	      var newNodes = setIn(nodes, idx, newNode, isEditable);
	
	      if (isEditable) {
	        this.count = newCount;
	        this.nodes = newNodes;
	        return this;
	      }
	
	      return new HashArrayMapNode(ownerID, newCount, newNodes);
	    };
	
	
	
	
	    function HashCollisionNode(ownerID, keyHash, entries) {
	      this.ownerID = ownerID;
	      this.keyHash = keyHash;
	      this.entries = entries;
	    }
	
	    HashCollisionNode.prototype.get = function(shift, keyHash, key, notSetValue) {
	      var entries = this.entries;
	      for (var ii = 0, len = entries.length; ii < len; ii++) {
	        if (is(key, entries[ii][0])) {
	          return entries[ii][1];
	        }
	      }
	      return notSetValue;
	    };
	
	    HashCollisionNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
	      if (keyHash === undefined) {
	        keyHash = hash(key);
	      }
	
	      var removed = value === NOT_SET;
	
	      if (keyHash !== this.keyHash) {
	        if (removed) {
	          return this;
	        }
	        SetRef(didAlter);
	        SetRef(didChangeSize);
	        return mergeIntoNode(this, ownerID, shift, keyHash, [key, value]);
	      }
	
	      var entries = this.entries;
	      var idx = 0;
	      for (var len = entries.length; idx < len; idx++) {
	        if (is(key, entries[idx][0])) {
	          break;
	        }
	      }
	      var exists = idx < len;
	
	      if (exists ? entries[idx][1] === value : removed) {
	        return this;
	      }
	
	      SetRef(didAlter);
	      (removed || !exists) && SetRef(didChangeSize);
	
	      if (removed && len === 2) {
	        return new ValueNode(ownerID, this.keyHash, entries[idx ^ 1]);
	      }
	
	      var isEditable = ownerID && ownerID === this.ownerID;
	      var newEntries = isEditable ? entries : arrCopy(entries);
	
	      if (exists) {
	        if (removed) {
	          idx === len - 1 ? newEntries.pop() : (newEntries[idx] = newEntries.pop());
	        } else {
	          newEntries[idx] = [key, value];
	        }
	      } else {
	        newEntries.push([key, value]);
	      }
	
	      if (isEditable) {
	        this.entries = newEntries;
	        return this;
	      }
	
	      return new HashCollisionNode(ownerID, this.keyHash, newEntries);
	    };
	
	
	
	
	    function ValueNode(ownerID, keyHash, entry) {
	      this.ownerID = ownerID;
	      this.keyHash = keyHash;
	      this.entry = entry;
	    }
	
	    ValueNode.prototype.get = function(shift, keyHash, key, notSetValue) {
	      return is(key, this.entry[0]) ? this.entry[1] : notSetValue;
	    };
	
	    ValueNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
	      var removed = value === NOT_SET;
	      var keyMatch = is(key, this.entry[0]);
	      if (keyMatch ? value === this.entry[1] : removed) {
	        return this;
	      }
	
	      SetRef(didAlter);
	
	      if (removed) {
	        SetRef(didChangeSize);
	        return; // undefined
	      }
	
	      if (keyMatch) {
	        if (ownerID && ownerID === this.ownerID) {
	          this.entry[1] = value;
	          return this;
	        }
	        return new ValueNode(ownerID, this.keyHash, [key, value]);
	      }
	
	      SetRef(didChangeSize);
	      return mergeIntoNode(this, ownerID, shift, hash(key), [key, value]);
	    };
	
	
	
	  // #pragma Iterators
	
	  ArrayMapNode.prototype.iterate =
	  HashCollisionNode.prototype.iterate = function (fn, reverse) {
	    var entries = this.entries;
	    for (var ii = 0, maxIndex = entries.length - 1; ii <= maxIndex; ii++) {
	      if (fn(entries[reverse ? maxIndex - ii : ii]) === false) {
	        return false;
	      }
	    }
	  }
	
	  BitmapIndexedNode.prototype.iterate =
	  HashArrayMapNode.prototype.iterate = function (fn, reverse) {
	    var nodes = this.nodes;
	    for (var ii = 0, maxIndex = nodes.length - 1; ii <= maxIndex; ii++) {
	      var node = nodes[reverse ? maxIndex - ii : ii];
	      if (node && node.iterate(fn, reverse) === false) {
	        return false;
	      }
	    }
	  }
	
	  ValueNode.prototype.iterate = function (fn, reverse) {
	    return fn(this.entry);
	  }
	
	  createClass(MapIterator, Iterator);
	
	    function MapIterator(map, type, reverse) {
	      this._type = type;
	      this._reverse = reverse;
	      this._stack = map._root && mapIteratorFrame(map._root);
	    }
	
	    MapIterator.prototype.next = function() {
	      var type = this._type;
	      var stack = this._stack;
	      while (stack) {
	        var node = stack.node;
	        var index = stack.index++;
	        var maxIndex;
	        if (node.entry) {
	          if (index === 0) {
	            return mapIteratorValue(type, node.entry);
	          }
	        } else if (node.entries) {
	          maxIndex = node.entries.length - 1;
	          if (index <= maxIndex) {
	            return mapIteratorValue(type, node.entries[this._reverse ? maxIndex - index : index]);
	          }
	        } else {
	          maxIndex = node.nodes.length - 1;
	          if (index <= maxIndex) {
	            var subNode = node.nodes[this._reverse ? maxIndex - index : index];
	            if (subNode) {
	              if (subNode.entry) {
	                return mapIteratorValue(type, subNode.entry);
	              }
	              stack = this._stack = mapIteratorFrame(subNode, stack);
	            }
	            continue;
	          }
	        }
	        stack = this._stack = this._stack.__prev;
	      }
	      return iteratorDone();
	    };
	
	
	  function mapIteratorValue(type, entry) {
	    return iteratorValue(type, entry[0], entry[1]);
	  }
	
	  function mapIteratorFrame(node, prev) {
	    return {
	      node: node,
	      index: 0,
	      __prev: prev
	    };
	  }
	
	  function makeMap(size, root, ownerID, hash) {
	    var map = Object.create(MapPrototype);
	    map.size = size;
	    map._root = root;
	    map.__ownerID = ownerID;
	    map.__hash = hash;
	    map.__altered = false;
	    return map;
	  }
	
	  var EMPTY_MAP;
	  function emptyMap() {
	    return EMPTY_MAP || (EMPTY_MAP = makeMap(0));
	  }
	
	  function updateMap(map, k, v) {
	    var newRoot;
	    var newSize;
	    if (!map._root) {
	      if (v === NOT_SET) {
	        return map;
	      }
	      newSize = 1;
	      newRoot = new ArrayMapNode(map.__ownerID, [[k, v]]);
	    } else {
	      var didChangeSize = MakeRef(CHANGE_LENGTH);
	      var didAlter = MakeRef(DID_ALTER);
	      newRoot = updateNode(map._root, map.__ownerID, 0, undefined, k, v, didChangeSize, didAlter);
	      if (!didAlter.value) {
	        return map;
	      }
	      newSize = map.size + (didChangeSize.value ? v === NOT_SET ? -1 : 1 : 0);
	    }
	    if (map.__ownerID) {
	      map.size = newSize;
	      map._root = newRoot;
	      map.__hash = undefined;
	      map.__altered = true;
	      return map;
	    }
	    return newRoot ? makeMap(newSize, newRoot) : emptyMap();
	  }
	
	  function updateNode(node, ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
	    if (!node) {
	      if (value === NOT_SET) {
	        return node;
	      }
	      SetRef(didAlter);
	      SetRef(didChangeSize);
	      return new ValueNode(ownerID, keyHash, [key, value]);
	    }
	    return node.update(ownerID, shift, keyHash, key, value, didChangeSize, didAlter);
	  }
	
	  function isLeafNode(node) {
	    return node.constructor === ValueNode || node.constructor === HashCollisionNode;
	  }
	
	  function mergeIntoNode(node, ownerID, shift, keyHash, entry) {
	    if (node.keyHash === keyHash) {
	      return new HashCollisionNode(ownerID, keyHash, [node.entry, entry]);
	    }
	
	    var idx1 = (shift === 0 ? node.keyHash : node.keyHash >>> shift) & MASK;
	    var idx2 = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
	
	    var newNode;
	    var nodes = idx1 === idx2 ?
	      [mergeIntoNode(node, ownerID, shift + SHIFT, keyHash, entry)] :
	      ((newNode = new ValueNode(ownerID, keyHash, entry)), idx1 < idx2 ? [node, newNode] : [newNode, node]);
	
	    return new BitmapIndexedNode(ownerID, (1 << idx1) | (1 << idx2), nodes);
	  }
	
	  function createNodes(ownerID, entries, key, value) {
	    if (!ownerID) {
	      ownerID = new OwnerID();
	    }
	    var node = new ValueNode(ownerID, hash(key), [key, value]);
	    for (var ii = 0; ii < entries.length; ii++) {
	      var entry = entries[ii];
	      node = node.update(ownerID, 0, undefined, entry[0], entry[1]);
	    }
	    return node;
	  }
	
	  function packNodes(ownerID, nodes, count, excluding) {
	    var bitmap = 0;
	    var packedII = 0;
	    var packedNodes = new Array(count);
	    for (var ii = 0, bit = 1, len = nodes.length; ii < len; ii++, bit <<= 1) {
	      var node = nodes[ii];
	      if (node !== undefined && ii !== excluding) {
	        bitmap |= bit;
	        packedNodes[packedII++] = node;
	      }
	    }
	    return new BitmapIndexedNode(ownerID, bitmap, packedNodes);
	  }
	
	  function expandNodes(ownerID, nodes, bitmap, including, node) {
	    var count = 0;
	    var expandedNodes = new Array(SIZE);
	    for (var ii = 0; bitmap !== 0; ii++, bitmap >>>= 1) {
	      expandedNodes[ii] = bitmap & 1 ? nodes[count++] : undefined;
	    }
	    expandedNodes[including] = node;
	    return new HashArrayMapNode(ownerID, count + 1, expandedNodes);
	  }
	
	  function mergeIntoMapWith(map, merger, iterables) {
	    var iters = [];
	    for (var ii = 0; ii < iterables.length; ii++) {
	      var value = iterables[ii];
	      var iter = KeyedIterable(value);
	      if (!isIterable(value)) {
	        iter = iter.map(function(v ) {return fromJS(v)});
	      }
	      iters.push(iter);
	    }
	    return mergeIntoCollectionWith(map, merger, iters);
	  }
	
	  function deepMerger(existing, value, key) {
	    return existing && existing.mergeDeep && isIterable(value) ?
	      existing.mergeDeep(value) :
	      is(existing, value) ? existing : value;
	  }
	
	  function deepMergerWith(merger) {
	    return function(existing, value, key)  {
	      if (existing && existing.mergeDeepWith && isIterable(value)) {
	        return existing.mergeDeepWith(merger, value);
	      }
	      var nextValue = merger(existing, value, key);
	      return is(existing, nextValue) ? existing : nextValue;
	    };
	  }
	
	  function mergeIntoCollectionWith(collection, merger, iters) {
	    iters = iters.filter(function(x ) {return x.size !== 0});
	    if (iters.length === 0) {
	      return collection;
	    }
	    if (collection.size === 0 && !collection.__ownerID && iters.length === 1) {
	      return collection.constructor(iters[0]);
	    }
	    return collection.withMutations(function(collection ) {
	      var mergeIntoMap = merger ?
	        function(value, key)  {
	          collection.update(key, NOT_SET, function(existing )
	            {return existing === NOT_SET ? value : merger(existing, value, key)}
	          );
	        } :
	        function(value, key)  {
	          collection.set(key, value);
	        }
	      for (var ii = 0; ii < iters.length; ii++) {
	        iters[ii].forEach(mergeIntoMap);
	      }
	    });
	  }
	
	  function updateInDeepMap(existing, keyPathIter, notSetValue, updater) {
	    var isNotSet = existing === NOT_SET;
	    var step = keyPathIter.next();
	    if (step.done) {
	      var existingValue = isNotSet ? notSetValue : existing;
	      var newValue = updater(existingValue);
	      return newValue === existingValue ? existing : newValue;
	    }
	    invariant(
	      isNotSet || (existing && existing.set),
	      'invalid keyPath'
	    );
	    var key = step.value;
	    var nextExisting = isNotSet ? NOT_SET : existing.get(key, NOT_SET);
	    var nextUpdated = updateInDeepMap(
	      nextExisting,
	      keyPathIter,
	      notSetValue,
	      updater
	    );
	    return nextUpdated === nextExisting ? existing :
	      nextUpdated === NOT_SET ? existing.remove(key) :
	      (isNotSet ? emptyMap() : existing).set(key, nextUpdated);
	  }
	
	  function popCount(x) {
	    x = x - ((x >> 1) & 0x55555555);
	    x = (x & 0x33333333) + ((x >> 2) & 0x33333333);
	    x = (x + (x >> 4)) & 0x0f0f0f0f;
	    x = x + (x >> 8);
	    x = x + (x >> 16);
	    return x & 0x7f;
	  }
	
	  function setIn(array, idx, val, canEdit) {
	    var newArray = canEdit ? array : arrCopy(array);
	    newArray[idx] = val;
	    return newArray;
	  }
	
	  function spliceIn(array, idx, val, canEdit) {
	    var newLen = array.length + 1;
	    if (canEdit && idx + 1 === newLen) {
	      array[idx] = val;
	      return array;
	    }
	    var newArray = new Array(newLen);
	    var after = 0;
	    for (var ii = 0; ii < newLen; ii++) {
	      if (ii === idx) {
	        newArray[ii] = val;
	        after = -1;
	      } else {
	        newArray[ii] = array[ii + after];
	      }
	    }
	    return newArray;
	  }
	
	  function spliceOut(array, idx, canEdit) {
	    var newLen = array.length - 1;
	    if (canEdit && idx === newLen) {
	      array.pop();
	      return array;
	    }
	    var newArray = new Array(newLen);
	    var after = 0;
	    for (var ii = 0; ii < newLen; ii++) {
	      if (ii === idx) {
	        after = 1;
	      }
	      newArray[ii] = array[ii + after];
	    }
	    return newArray;
	  }
	
	  var MAX_ARRAY_MAP_SIZE = SIZE / 4;
	  var MAX_BITMAP_INDEXED_SIZE = SIZE / 2;
	  var MIN_HASH_ARRAY_MAP_SIZE = SIZE / 4;
	
	  createClass(List, IndexedCollection);
	
	    // @pragma Construction
	
	    function List(value) {
	      var empty = emptyList();
	      if (value === null || value === undefined) {
	        return empty;
	      }
	      if (isList(value)) {
	        return value;
	      }
	      var iter = IndexedIterable(value);
	      var size = iter.size;
	      if (size === 0) {
	        return empty;
	      }
	      assertNotInfinite(size);
	      if (size > 0 && size < SIZE) {
	        return makeList(0, size, SHIFT, null, new VNode(iter.toArray()));
	      }
	      return empty.withMutations(function(list ) {
	        list.setSize(size);
	        iter.forEach(function(v, i)  {return list.set(i, v)});
	      });
	    }
	
	    List.of = function(/*...values*/) {
	      return this(arguments);
	    };
	
	    List.prototype.toString = function() {
	      return this.__toString('List [', ']');
	    };
	
	    // @pragma Access
	
	    List.prototype.get = function(index, notSetValue) {
	      index = wrapIndex(this, index);
	      if (index >= 0 && index < this.size) {
	        index += this._origin;
	        var node = listNodeFor(this, index);
	        return node && node.array[index & MASK];
	      }
	      return notSetValue;
	    };
	
	    // @pragma Modification
	
	    List.prototype.set = function(index, value) {
	      return updateList(this, index, value);
	    };
	
	    List.prototype.remove = function(index) {
	      return !this.has(index) ? this :
	        index === 0 ? this.shift() :
	        index === this.size - 1 ? this.pop() :
	        this.splice(index, 1);
	    };
	
	    List.prototype.insert = function(index, value) {
	      return this.splice(index, 0, value);
	    };
	
	    List.prototype.clear = function() {
	      if (this.size === 0) {
	        return this;
	      }
	      if (this.__ownerID) {
	        this.size = this._origin = this._capacity = 0;
	        this._level = SHIFT;
	        this._root = this._tail = null;
	        this.__hash = undefined;
	        this.__altered = true;
	        return this;
	      }
	      return emptyList();
	    };
	
	    List.prototype.push = function(/*...values*/) {
	      var values = arguments;
	      var oldSize = this.size;
	      return this.withMutations(function(list ) {
	        setListBounds(list, 0, oldSize + values.length);
	        for (var ii = 0; ii < values.length; ii++) {
	          list.set(oldSize + ii, values[ii]);
	        }
	      });
	    };
	
	    List.prototype.pop = function() {
	      return setListBounds(this, 0, -1);
	    };
	
	    List.prototype.unshift = function(/*...values*/) {
	      var values = arguments;
	      return this.withMutations(function(list ) {
	        setListBounds(list, -values.length);
	        for (var ii = 0; ii < values.length; ii++) {
	          list.set(ii, values[ii]);
	        }
	      });
	    };
	
	    List.prototype.shift = function() {
	      return setListBounds(this, 1);
	    };
	
	    // @pragma Composition
	
	    List.prototype.merge = function(/*...iters*/) {
	      return mergeIntoListWith(this, undefined, arguments);
	    };
	
	    List.prototype.mergeWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
	      return mergeIntoListWith(this, merger, iters);
	    };
	
	    List.prototype.mergeDeep = function(/*...iters*/) {
	      return mergeIntoListWith(this, deepMerger, arguments);
	    };
	
	    List.prototype.mergeDeepWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
	      return mergeIntoListWith(this, deepMergerWith(merger), iters);
	    };
	
	    List.prototype.setSize = function(size) {
	      return setListBounds(this, 0, size);
	    };
	
	    // @pragma Iteration
	
	    List.prototype.slice = function(begin, end) {
	      var size = this.size;
	      if (wholeSlice(begin, end, size)) {
	        return this;
	      }
	      return setListBounds(
	        this,
	        resolveBegin(begin, size),
	        resolveEnd(end, size)
	      );
	    };
	
	    List.prototype.__iterator = function(type, reverse) {
	      var index = 0;
	      var values = iterateList(this, reverse);
	      return new Iterator(function()  {
	        var value = values();
	        return value === DONE ?
	          iteratorDone() :
	          iteratorValue(type, index++, value);
	      });
	    };
	
	    List.prototype.__iterate = function(fn, reverse) {
	      var index = 0;
	      var values = iterateList(this, reverse);
	      var value;
	      while ((value = values()) !== DONE) {
	        if (fn(value, index++, this) === false) {
	          break;
	        }
	      }
	      return index;
	    };
	
	    List.prototype.__ensureOwner = function(ownerID) {
	      if (ownerID === this.__ownerID) {
	        return this;
	      }
	      if (!ownerID) {
	        this.__ownerID = ownerID;
	        return this;
	      }
	      return makeList(this._origin, this._capacity, this._level, this._root, this._tail, ownerID, this.__hash);
	    };
	
	
	  function isList(maybeList) {
	    return !!(maybeList && maybeList[IS_LIST_SENTINEL]);
	  }
	
	  List.isList = isList;
	
	  var IS_LIST_SENTINEL = '@@__IMMUTABLE_LIST__@@';
	
	  var ListPrototype = List.prototype;
	  ListPrototype[IS_LIST_SENTINEL] = true;
	  ListPrototype[DELETE] = ListPrototype.remove;
	  ListPrototype.setIn = MapPrototype.setIn;
	  ListPrototype.deleteIn =
	  ListPrototype.removeIn = MapPrototype.removeIn;
	  ListPrototype.update = MapPrototype.update;
	  ListPrototype.updateIn = MapPrototype.updateIn;
	  ListPrototype.mergeIn = MapPrototype.mergeIn;
	  ListPrototype.mergeDeepIn = MapPrototype.mergeDeepIn;
	  ListPrototype.withMutations = MapPrototype.withMutations;
	  ListPrototype.asMutable = MapPrototype.asMutable;
	  ListPrototype.asImmutable = MapPrototype.asImmutable;
	  ListPrototype.wasAltered = MapPrototype.wasAltered;
	
	
	
	    function VNode(array, ownerID) {
	      this.array = array;
	      this.ownerID = ownerID;
	    }
	
	    // TODO: seems like these methods are very similar
	
	    VNode.prototype.removeBefore = function(ownerID, level, index) {
	      if (index === level ? 1 << level : 0 || this.array.length === 0) {
	        return this;
	      }
	      var originIndex = (index >>> level) & MASK;
	      if (originIndex >= this.array.length) {
	        return new VNode([], ownerID);
	      }
	      var removingFirst = originIndex === 0;
	      var newChild;
	      if (level > 0) {
	        var oldChild = this.array[originIndex];
	        newChild = oldChild && oldChild.removeBefore(ownerID, level - SHIFT, index);
	        if (newChild === oldChild && removingFirst) {
	          return this;
	        }
	      }
	      if (removingFirst && !newChild) {
	        return this;
	      }
	      var editable = editableVNode(this, ownerID);
	      if (!removingFirst) {
	        for (var ii = 0; ii < originIndex; ii++) {
	          editable.array[ii] = undefined;
	        }
	      }
	      if (newChild) {
	        editable.array[originIndex] = newChild;
	      }
	      return editable;
	    };
	
	    VNode.prototype.removeAfter = function(ownerID, level, index) {
	      if (index === (level ? 1 << level : 0) || this.array.length === 0) {
	        return this;
	      }
	      var sizeIndex = ((index - 1) >>> level) & MASK;
	      if (sizeIndex >= this.array.length) {
	        return this;
	      }
	
	      var newChild;
	      if (level > 0) {
	        var oldChild = this.array[sizeIndex];
	        newChild = oldChild && oldChild.removeAfter(ownerID, level - SHIFT, index);
	        if (newChild === oldChild && sizeIndex === this.array.length - 1) {
	          return this;
	        }
	      }
	
	      var editable = editableVNode(this, ownerID);
	      editable.array.splice(sizeIndex + 1);
	      if (newChild) {
	        editable.array[sizeIndex] = newChild;
	      }
	      return editable;
	    };
	
	
	
	  var DONE = {};
	
	  function iterateList(list, reverse) {
	    var left = list._origin;
	    var right = list._capacity;
	    var tailPos = getTailOffset(right);
	    var tail = list._tail;
	
	    return iterateNodeOrLeaf(list._root, list._level, 0);
	
	    function iterateNodeOrLeaf(node, level, offset) {
	      return level === 0 ?
	        iterateLeaf(node, offset) :
	        iterateNode(node, level, offset);
	    }
	
	    function iterateLeaf(node, offset) {
	      var array = offset === tailPos ? tail && tail.array : node && node.array;
	      var from = offset > left ? 0 : left - offset;
	      var to = right - offset;
	      if (to > SIZE) {
	        to = SIZE;
	      }
	      return function()  {
	        if (from === to) {
	          return DONE;
	        }
	        var idx = reverse ? --to : from++;
	        return array && array[idx];
	      };
	    }
	
	    function iterateNode(node, level, offset) {
	      var values;
	      var array = node && node.array;
	      var from = offset > left ? 0 : (left - offset) >> level;
	      var to = ((right - offset) >> level) + 1;
	      if (to > SIZE) {
	        to = SIZE;
	      }
	      return function()  {
	        do {
	          if (values) {
	            var value = values();
	            if (value !== DONE) {
	              return value;
	            }
	            values = null;
	          }
	          if (from === to) {
	            return DONE;
	          }
	          var idx = reverse ? --to : from++;
	          values = iterateNodeOrLeaf(
	            array && array[idx], level - SHIFT, offset + (idx << level)
	          );
	        } while (true);
	      };
	    }
	  }
	
	  function makeList(origin, capacity, level, root, tail, ownerID, hash) {
	    var list = Object.create(ListPrototype);
	    list.size = capacity - origin;
	    list._origin = origin;
	    list._capacity = capacity;
	    list._level = level;
	    list._root = root;
	    list._tail = tail;
	    list.__ownerID = ownerID;
	    list.__hash = hash;
	    list.__altered = false;
	    return list;
	  }
	
	  var EMPTY_LIST;
	  function emptyList() {
	    return EMPTY_LIST || (EMPTY_LIST = makeList(0, 0, SHIFT));
	  }
	
	  function updateList(list, index, value) {
	    index = wrapIndex(list, index);
	
	    if (index !== index) {
	      return list;
	    }
	
	    if (index >= list.size || index < 0) {
	      return list.withMutations(function(list ) {
	        index < 0 ?
	          setListBounds(list, index).set(0, value) :
	          setListBounds(list, 0, index + 1).set(index, value)
	      });
	    }
	
	    index += list._origin;
	
	    var newTail = list._tail;
	    var newRoot = list._root;
	    var didAlter = MakeRef(DID_ALTER);
	    if (index >= getTailOffset(list._capacity)) {
	      newTail = updateVNode(newTail, list.__ownerID, 0, index, value, didAlter);
	    } else {
	      newRoot = updateVNode(newRoot, list.__ownerID, list._level, index, value, didAlter);
	    }
	
	    if (!didAlter.value) {
	      return list;
	    }
	
	    if (list.__ownerID) {
	      list._root = newRoot;
	      list._tail = newTail;
	      list.__hash = undefined;
	      list.__altered = true;
	      return list;
	    }
	    return makeList(list._origin, list._capacity, list._level, newRoot, newTail);
	  }
	
	  function updateVNode(node, ownerID, level, index, value, didAlter) {
	    var idx = (index >>> level) & MASK;
	    var nodeHas = node && idx < node.array.length;
	    if (!nodeHas && value === undefined) {
	      return node;
	    }
	
	    var newNode;
	
	    if (level > 0) {
	      var lowerNode = node && node.array[idx];
	      var newLowerNode = updateVNode(lowerNode, ownerID, level - SHIFT, index, value, didAlter);
	      if (newLowerNode === lowerNode) {
	        return node;
	      }
	      newNode = editableVNode(node, ownerID);
	      newNode.array[idx] = newLowerNode;
	      return newNode;
	    }
	
	    if (nodeHas && node.array[idx] === value) {
	      return node;
	    }
	
	    SetRef(didAlter);
	
	    newNode = editableVNode(node, ownerID);
	    if (value === undefined && idx === newNode.array.length - 1) {
	      newNode.array.pop();
	    } else {
	      newNode.array[idx] = value;
	    }
	    return newNode;
	  }
	
	  function editableVNode(node, ownerID) {
	    if (ownerID && node && ownerID === node.ownerID) {
	      return node;
	    }
	    return new VNode(node ? node.array.slice() : [], ownerID);
	  }
	
	  function listNodeFor(list, rawIndex) {
	    if (rawIndex >= getTailOffset(list._capacity)) {
	      return list._tail;
	    }
	    if (rawIndex < 1 << (list._level + SHIFT)) {
	      var node = list._root;
	      var level = list._level;
	      while (node && level > 0) {
	        node = node.array[(rawIndex >>> level) & MASK];
	        level -= SHIFT;
	      }
	      return node;
	    }
	  }
	
	  function setListBounds(list, begin, end) {
	    // Sanitize begin & end using this shorthand for ToInt32(argument)
	    // http://www.ecma-international.org/ecma-262/6.0/#sec-toint32
	    if (begin !== undefined) {
	      begin = begin | 0;
	    }
	    if (end !== undefined) {
	      end = end | 0;
	    }
	    var owner = list.__ownerID || new OwnerID();
	    var oldOrigin = list._origin;
	    var oldCapacity = list._capacity;
	    var newOrigin = oldOrigin + begin;
	    var newCapacity = end === undefined ? oldCapacity : end < 0 ? oldCapacity + end : oldOrigin + end;
	    if (newOrigin === oldOrigin && newCapacity === oldCapacity) {
	      return list;
	    }
	
	    // If it's going to end after it starts, it's empty.
	    if (newOrigin >= newCapacity) {
	      return list.clear();
	    }
	
	    var newLevel = list._level;
	    var newRoot = list._root;
	
	    // New origin might need creating a higher root.
	    var offsetShift = 0;
	    while (newOrigin + offsetShift < 0) {
	      newRoot = new VNode(newRoot && newRoot.array.length ? [undefined, newRoot] : [], owner);
	      newLevel += SHIFT;
	      offsetShift += 1 << newLevel;
	    }
	    if (offsetShift) {
	      newOrigin += offsetShift;
	      oldOrigin += offsetShift;
	      newCapacity += offsetShift;
	      oldCapacity += offsetShift;
	    }
	
	    var oldTailOffset = getTailOffset(oldCapacity);
	    var newTailOffset = getTailOffset(newCapacity);
	
	    // New size might need creating a higher root.
	    while (newTailOffset >= 1 << (newLevel + SHIFT)) {
	      newRoot = new VNode(newRoot && newRoot.array.length ? [newRoot] : [], owner);
	      newLevel += SHIFT;
	    }
	
	    // Locate or create the new tail.
	    var oldTail = list._tail;
	    var newTail = newTailOffset < oldTailOffset ?
	      listNodeFor(list, newCapacity - 1) :
	      newTailOffset > oldTailOffset ? new VNode([], owner) : oldTail;
	
	    // Merge Tail into tree.
	    if (oldTail && newTailOffset > oldTailOffset && newOrigin < oldCapacity && oldTail.array.length) {
	      newRoot = editableVNode(newRoot, owner);
	      var node = newRoot;
	      for (var level = newLevel; level > SHIFT; level -= SHIFT) {
	        var idx = (oldTailOffset >>> level) & MASK;
	        node = node.array[idx] = editableVNode(node.array[idx], owner);
	      }
	      node.array[(oldTailOffset >>> SHIFT) & MASK] = oldTail;
	    }
	
	    // If the size has been reduced, there's a chance the tail needs to be trimmed.
	    if (newCapacity < oldCapacity) {
	      newTail = newTail && newTail.removeAfter(owner, 0, newCapacity);
	    }
	
	    // If the new origin is within the tail, then we do not need a root.
	    if (newOrigin >= newTailOffset) {
	      newOrigin -= newTailOffset;
	      newCapacity -= newTailOffset;
	      newLevel = SHIFT;
	      newRoot = null;
	      newTail = newTail && newTail.removeBefore(owner, 0, newOrigin);
	
	    // Otherwise, if the root has been trimmed, garbage collect.
	    } else if (newOrigin > oldOrigin || newTailOffset < oldTailOffset) {
	      offsetShift = 0;
	
	      // Identify the new top root node of the subtree of the old root.
	      while (newRoot) {
	        var beginIndex = (newOrigin >>> newLevel) & MASK;
	        if (beginIndex !== (newTailOffset >>> newLevel) & MASK) {
	          break;
	        }
	        if (beginIndex) {
	          offsetShift += (1 << newLevel) * beginIndex;
	        }
	        newLevel -= SHIFT;
	        newRoot = newRoot.array[beginIndex];
	      }
	
	      // Trim the new sides of the new root.
	      if (newRoot && newOrigin > oldOrigin) {
	        newRoot = newRoot.removeBefore(owner, newLevel, newOrigin - offsetShift);
	      }
	      if (newRoot && newTailOffset < oldTailOffset) {
	        newRoot = newRoot.removeAfter(owner, newLevel, newTailOffset - offsetShift);
	      }
	      if (offsetShift) {
	        newOrigin -= offsetShift;
	        newCapacity -= offsetShift;
	      }
	    }
	
	    if (list.__ownerID) {
	      list.size = newCapacity - newOrigin;
	      list._origin = newOrigin;
	      list._capacity = newCapacity;
	      list._level = newLevel;
	      list._root = newRoot;
	      list._tail = newTail;
	      list.__hash = undefined;
	      list.__altered = true;
	      return list;
	    }
	    return makeList(newOrigin, newCapacity, newLevel, newRoot, newTail);
	  }
	
	  function mergeIntoListWith(list, merger, iterables) {
	    var iters = [];
	    var maxSize = 0;
	    for (var ii = 0; ii < iterables.length; ii++) {
	      var value = iterables[ii];
	      var iter = IndexedIterable(value);
	      if (iter.size > maxSize) {
	        maxSize = iter.size;
	      }
	      if (!isIterable(value)) {
	        iter = iter.map(function(v ) {return fromJS(v)});
	      }
	      iters.push(iter);
	    }
	    if (maxSize > list.size) {
	      list = list.setSize(maxSize);
	    }
	    return mergeIntoCollectionWith(list, merger, iters);
	  }
	
	  function getTailOffset(size) {
	    return size < SIZE ? 0 : (((size - 1) >>> SHIFT) << SHIFT);
	  }
	
	  createClass(OrderedMap, Map);
	
	    // @pragma Construction
	
	    function OrderedMap(value) {
	      return value === null || value === undefined ? emptyOrderedMap() :
	        isOrderedMap(value) ? value :
	        emptyOrderedMap().withMutations(function(map ) {
	          var iter = KeyedIterable(value);
	          assertNotInfinite(iter.size);
	          iter.forEach(function(v, k)  {return map.set(k, v)});
	        });
	    }
	
	    OrderedMap.of = function(/*...values*/) {
	      return this(arguments);
	    };
	
	    OrderedMap.prototype.toString = function() {
	      return this.__toString('OrderedMap {', '}');
	    };
	
	    // @pragma Access
	
	    OrderedMap.prototype.get = function(k, notSetValue) {
	      var index = this._map.get(k);
	      return index !== undefined ? this._list.get(index)[1] : notSetValue;
	    };
	
	    // @pragma Modification
	
	    OrderedMap.prototype.clear = function() {
	      if (this.size === 0) {
	        return this;
	      }
	      if (this.__ownerID) {
	        this.size = 0;
	        this._map.clear();
	        this._list.clear();
	        return this;
	      }
	      return emptyOrderedMap();
	    };
	
	    OrderedMap.prototype.set = function(k, v) {
	      return updateOrderedMap(this, k, v);
	    };
	
	    OrderedMap.prototype.remove = function(k) {
	      return updateOrderedMap(this, k, NOT_SET);
	    };
	
	    OrderedMap.prototype.wasAltered = function() {
	      return this._map.wasAltered() || this._list.wasAltered();
	    };
	
	    OrderedMap.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      return this._list.__iterate(
	        function(entry ) {return entry && fn(entry[1], entry[0], this$0)},
	        reverse
	      );
	    };
	
	    OrderedMap.prototype.__iterator = function(type, reverse) {
	      return this._list.fromEntrySeq().__iterator(type, reverse);
	    };
	
	    OrderedMap.prototype.__ensureOwner = function(ownerID) {
	      if (ownerID === this.__ownerID) {
	        return this;
	      }
	      var newMap = this._map.__ensureOwner(ownerID);
	      var newList = this._list.__ensureOwner(ownerID);
	      if (!ownerID) {
	        this.__ownerID = ownerID;
	        this._map = newMap;
	        this._list = newList;
	        return this;
	      }
	      return makeOrderedMap(newMap, newList, ownerID, this.__hash);
	    };
	
	
	  function isOrderedMap(maybeOrderedMap) {
	    return isMap(maybeOrderedMap) && isOrdered(maybeOrderedMap);
	  }
	
	  OrderedMap.isOrderedMap = isOrderedMap;
	
	  OrderedMap.prototype[IS_ORDERED_SENTINEL] = true;
	  OrderedMap.prototype[DELETE] = OrderedMap.prototype.remove;
	
	
	
	  function makeOrderedMap(map, list, ownerID, hash) {
	    var omap = Object.create(OrderedMap.prototype);
	    omap.size = map ? map.size : 0;
	    omap._map = map;
	    omap._list = list;
	    omap.__ownerID = ownerID;
	    omap.__hash = hash;
	    return omap;
	  }
	
	  var EMPTY_ORDERED_MAP;
	  function emptyOrderedMap() {
	    return EMPTY_ORDERED_MAP || (EMPTY_ORDERED_MAP = makeOrderedMap(emptyMap(), emptyList()));
	  }
	
	  function updateOrderedMap(omap, k, v) {
	    var map = omap._map;
	    var list = omap._list;
	    var i = map.get(k);
	    var has = i !== undefined;
	    var newMap;
	    var newList;
	    if (v === NOT_SET) { // removed
	      if (!has) {
	        return omap;
	      }
	      if (list.size >= SIZE && list.size >= map.size * 2) {
	        newList = list.filter(function(entry, idx)  {return entry !== undefined && i !== idx});
	        newMap = newList.toKeyedSeq().map(function(entry ) {return entry[0]}).flip().toMap();
	        if (omap.__ownerID) {
	          newMap.__ownerID = newList.__ownerID = omap.__ownerID;
	        }
	      } else {
	        newMap = map.remove(k);
	        newList = i === list.size - 1 ? list.pop() : list.set(i, undefined);
	      }
	    } else {
	      if (has) {
	        if (v === list.get(i)[1]) {
	          return omap;
	        }
	        newMap = map;
	        newList = list.set(i, [k, v]);
	      } else {
	        newMap = map.set(k, list.size);
	        newList = list.set(list.size, [k, v]);
	      }
	    }
	    if (omap.__ownerID) {
	      omap.size = newMap.size;
	      omap._map = newMap;
	      omap._list = newList;
	      omap.__hash = undefined;
	      return omap;
	    }
	    return makeOrderedMap(newMap, newList);
	  }
	
	  createClass(ToKeyedSequence, KeyedSeq);
	    function ToKeyedSequence(indexed, useKeys) {
	      this._iter = indexed;
	      this._useKeys = useKeys;
	      this.size = indexed.size;
	    }
	
	    ToKeyedSequence.prototype.get = function(key, notSetValue) {
	      return this._iter.get(key, notSetValue);
	    };
	
	    ToKeyedSequence.prototype.has = function(key) {
	      return this._iter.has(key);
	    };
	
	    ToKeyedSequence.prototype.valueSeq = function() {
	      return this._iter.valueSeq();
	    };
	
	    ToKeyedSequence.prototype.reverse = function() {var this$0 = this;
	      var reversedSequence = reverseFactory(this, true);
	      if (!this._useKeys) {
	        reversedSequence.valueSeq = function()  {return this$0._iter.toSeq().reverse()};
	      }
	      return reversedSequence;
	    };
	
	    ToKeyedSequence.prototype.map = function(mapper, context) {var this$0 = this;
	      var mappedSequence = mapFactory(this, mapper, context);
	      if (!this._useKeys) {
	        mappedSequence.valueSeq = function()  {return this$0._iter.toSeq().map(mapper, context)};
	      }
	      return mappedSequence;
	    };
	
	    ToKeyedSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      var ii;
	      return this._iter.__iterate(
	        this._useKeys ?
	          function(v, k)  {return fn(v, k, this$0)} :
	          ((ii = reverse ? resolveSize(this) : 0),
	            function(v ) {return fn(v, reverse ? --ii : ii++, this$0)}),
	        reverse
	      );
	    };
	
	    ToKeyedSequence.prototype.__iterator = function(type, reverse) {
	      if (this._useKeys) {
	        return this._iter.__iterator(type, reverse);
	      }
	      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
	      var ii = reverse ? resolveSize(this) : 0;
	      return new Iterator(function()  {
	        var step = iterator.next();
	        return step.done ? step :
	          iteratorValue(type, reverse ? --ii : ii++, step.value, step);
	      });
	    };
	
	  ToKeyedSequence.prototype[IS_ORDERED_SENTINEL] = true;
	
	
	  createClass(ToIndexedSequence, IndexedSeq);
	    function ToIndexedSequence(iter) {
	      this._iter = iter;
	      this.size = iter.size;
	    }
	
	    ToIndexedSequence.prototype.includes = function(value) {
	      return this._iter.includes(value);
	    };
	
	    ToIndexedSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      var iterations = 0;
	      return this._iter.__iterate(function(v ) {return fn(v, iterations++, this$0)}, reverse);
	    };
	
	    ToIndexedSequence.prototype.__iterator = function(type, reverse) {
	      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
	      var iterations = 0;
	      return new Iterator(function()  {
	        var step = iterator.next();
	        return step.done ? step :
	          iteratorValue(type, iterations++, step.value, step)
	      });
	    };
	
	
	
	  createClass(ToSetSequence, SetSeq);
	    function ToSetSequence(iter) {
	      this._iter = iter;
	      this.size = iter.size;
	    }
	
	    ToSetSequence.prototype.has = function(key) {
	      return this._iter.includes(key);
	    };
	
	    ToSetSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      return this._iter.__iterate(function(v ) {return fn(v, v, this$0)}, reverse);
	    };
	
	    ToSetSequence.prototype.__iterator = function(type, reverse) {
	      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
	      return new Iterator(function()  {
	        var step = iterator.next();
	        return step.done ? step :
	          iteratorValue(type, step.value, step.value, step);
	      });
	    };
	
	
	
	  createClass(FromEntriesSequence, KeyedSeq);
	    function FromEntriesSequence(entries) {
	      this._iter = entries;
	      this.size = entries.size;
	    }
	
	    FromEntriesSequence.prototype.entrySeq = function() {
	      return this._iter.toSeq();
	    };
	
	    FromEntriesSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      return this._iter.__iterate(function(entry ) {
	        // Check if entry exists first so array access doesn't throw for holes
	        // in the parent iteration.
	        if (entry) {
	          validateEntry(entry);
	          var indexedIterable = isIterable(entry);
	          return fn(
	            indexedIterable ? entry.get(1) : entry[1],
	            indexedIterable ? entry.get(0) : entry[0],
	            this$0
	          );
	        }
	      }, reverse);
	    };
	
	    FromEntriesSequence.prototype.__iterator = function(type, reverse) {
	      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
	      return new Iterator(function()  {
	        while (true) {
	          var step = iterator.next();
	          if (step.done) {
	            return step;
	          }
	          var entry = step.value;
	          // Check if entry exists first so array access doesn't throw for holes
	          // in the parent iteration.
	          if (entry) {
	            validateEntry(entry);
	            var indexedIterable = isIterable(entry);
	            return iteratorValue(
	              type,
	              indexedIterable ? entry.get(0) : entry[0],
	              indexedIterable ? entry.get(1) : entry[1],
	              step
	            );
	          }
	        }
	      });
	    };
	
	
	  ToIndexedSequence.prototype.cacheResult =
	  ToKeyedSequence.prototype.cacheResult =
	  ToSetSequence.prototype.cacheResult =
	  FromEntriesSequence.prototype.cacheResult =
	    cacheResultThrough;
	
	
	  function flipFactory(iterable) {
	    var flipSequence = makeSequence(iterable);
	    flipSequence._iter = iterable;
	    flipSequence.size = iterable.size;
	    flipSequence.flip = function()  {return iterable};
	    flipSequence.reverse = function () {
	      var reversedSequence = iterable.reverse.apply(this); // super.reverse()
	      reversedSequence.flip = function()  {return iterable.reverse()};
	      return reversedSequence;
	    };
	    flipSequence.has = function(key ) {return iterable.includes(key)};
	    flipSequence.includes = function(key ) {return iterable.has(key)};
	    flipSequence.cacheResult = cacheResultThrough;
	    flipSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
	      return iterable.__iterate(function(v, k)  {return fn(k, v, this$0) !== false}, reverse);
	    }
	    flipSequence.__iteratorUncached = function(type, reverse) {
	      if (type === ITERATE_ENTRIES) {
	        var iterator = iterable.__iterator(type, reverse);
	        return new Iterator(function()  {
	          var step = iterator.next();
	          if (!step.done) {
	            var k = step.value[0];
	            step.value[0] = step.value[1];
	            step.value[1] = k;
	          }
	          return step;
	        });
	      }
	      return iterable.__iterator(
	        type === ITERATE_VALUES ? ITERATE_KEYS : ITERATE_VALUES,
	        reverse
	      );
	    }
	    return flipSequence;
	  }
	
	
	  function mapFactory(iterable, mapper, context) {
	    var mappedSequence = makeSequence(iterable);
	    mappedSequence.size = iterable.size;
	    mappedSequence.has = function(key ) {return iterable.has(key)};
	    mappedSequence.get = function(key, notSetValue)  {
	      var v = iterable.get(key, NOT_SET);
	      return v === NOT_SET ?
	        notSetValue :
	        mapper.call(context, v, key, iterable);
	    };
	    mappedSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
	      return iterable.__iterate(
	        function(v, k, c)  {return fn(mapper.call(context, v, k, c), k, this$0) !== false},
	        reverse
	      );
	    }
	    mappedSequence.__iteratorUncached = function (type, reverse) {
	      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
	      return new Iterator(function()  {
	        var step = iterator.next();
	        if (step.done) {
	          return step;
	        }
	        var entry = step.value;
	        var key = entry[0];
	        return iteratorValue(
	          type,
	          key,
	          mapper.call(context, entry[1], key, iterable),
	          step
	        );
	      });
	    }
	    return mappedSequence;
	  }
	
	
	  function reverseFactory(iterable, useKeys) {
	    var reversedSequence = makeSequence(iterable);
	    reversedSequence._iter = iterable;
	    reversedSequence.size = iterable.size;
	    reversedSequence.reverse = function()  {return iterable};
	    if (iterable.flip) {
	      reversedSequence.flip = function () {
	        var flipSequence = flipFactory(iterable);
	        flipSequence.reverse = function()  {return iterable.flip()};
	        return flipSequence;
	      };
	    }
	    reversedSequence.get = function(key, notSetValue) 
	      {return iterable.get(useKeys ? key : -1 - key, notSetValue)};
	    reversedSequence.has = function(key )
	      {return iterable.has(useKeys ? key : -1 - key)};
	    reversedSequence.includes = function(value ) {return iterable.includes(value)};
	    reversedSequence.cacheResult = cacheResultThrough;
	    reversedSequence.__iterate = function (fn, reverse) {var this$0 = this;
	      return iterable.__iterate(function(v, k)  {return fn(v, k, this$0)}, !reverse);
	    };
	    reversedSequence.__iterator =
	      function(type, reverse)  {return iterable.__iterator(type, !reverse)};
	    return reversedSequence;
	  }
	
	
	  function filterFactory(iterable, predicate, context, useKeys) {
	    var filterSequence = makeSequence(iterable);
	    if (useKeys) {
	      filterSequence.has = function(key ) {
	        var v = iterable.get(key, NOT_SET);
	        return v !== NOT_SET && !!predicate.call(context, v, key, iterable);
	      };
	      filterSequence.get = function(key, notSetValue)  {
	        var v = iterable.get(key, NOT_SET);
	        return v !== NOT_SET && predicate.call(context, v, key, iterable) ?
	          v : notSetValue;
	      };
	    }
	    filterSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
	      var iterations = 0;
	      iterable.__iterate(function(v, k, c)  {
	        if (predicate.call(context, v, k, c)) {
	          iterations++;
	          return fn(v, useKeys ? k : iterations - 1, this$0);
	        }
	      }, reverse);
	      return iterations;
	    };
	    filterSequence.__iteratorUncached = function (type, reverse) {
	      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
	      var iterations = 0;
	      return new Iterator(function()  {
	        while (true) {
	          var step = iterator.next();
	          if (step.done) {
	            return step;
	          }
	          var entry = step.value;
	          var key = entry[0];
	          var value = entry[1];
	          if (predicate.call(context, value, key, iterable)) {
	            return iteratorValue(type, useKeys ? key : iterations++, value, step);
	          }
	        }
	      });
	    }
	    return filterSequence;
	  }
	
	
	  function countByFactory(iterable, grouper, context) {
	    var groups = Map().asMutable();
	    iterable.__iterate(function(v, k)  {
	      groups.update(
	        grouper.call(context, v, k, iterable),
	        0,
	        function(a ) {return a + 1}
	      );
	    });
	    return groups.asImmutable();
	  }
	
	
	  function groupByFactory(iterable, grouper, context) {
	    var isKeyedIter = isKeyed(iterable);
	    var groups = (isOrdered(iterable) ? OrderedMap() : Map()).asMutable();
	    iterable.__iterate(function(v, k)  {
	      groups.update(
	        grouper.call(context, v, k, iterable),
	        function(a ) {return (a = a || [], a.push(isKeyedIter ? [k, v] : v), a)}
	      );
	    });
	    var coerce = iterableClass(iterable);
	    return groups.map(function(arr ) {return reify(iterable, coerce(arr))});
	  }
	
	
	  function sliceFactory(iterable, begin, end, useKeys) {
	    var originalSize = iterable.size;
	
	    // Sanitize begin & end using this shorthand for ToInt32(argument)
	    // http://www.ecma-international.org/ecma-262/6.0/#sec-toint32
	    if (begin !== undefined) {
	      begin = begin | 0;
	    }
	    if (end !== undefined) {
	      if (end === Infinity) {
	        end = originalSize;
	      } else {
	        end = end | 0;
	      }
	    }
	
	    if (wholeSlice(begin, end, originalSize)) {
	      return iterable;
	    }
	
	    var resolvedBegin = resolveBegin(begin, originalSize);
	    var resolvedEnd = resolveEnd(end, originalSize);
	
	    // begin or end will be NaN if they were provided as negative numbers and
	    // this iterable's size is unknown. In that case, cache first so there is
	    // a known size and these do not resolve to NaN.
	    if (resolvedBegin !== resolvedBegin || resolvedEnd !== resolvedEnd) {
	      return sliceFactory(iterable.toSeq().cacheResult(), begin, end, useKeys);
	    }
	
	    // Note: resolvedEnd is undefined when the original sequence's length is
	    // unknown and this slice did not supply an end and should contain all
	    // elements after resolvedBegin.
	    // In that case, resolvedSize will be NaN and sliceSize will remain undefined.
	    var resolvedSize = resolvedEnd - resolvedBegin;
	    var sliceSize;
	    if (resolvedSize === resolvedSize) {
	      sliceSize = resolvedSize < 0 ? 0 : resolvedSize;
	    }
	
	    var sliceSeq = makeSequence(iterable);
	
	    // If iterable.size is undefined, the size of the realized sliceSeq is
	    // unknown at this point unless the number of items to slice is 0
	    sliceSeq.size = sliceSize === 0 ? sliceSize : iterable.size && sliceSize || undefined;
	
	    if (!useKeys && isSeq(iterable) && sliceSize >= 0) {
	      sliceSeq.get = function (index, notSetValue) {
	        index = wrapIndex(this, index);
	        return index >= 0 && index < sliceSize ?
	          iterable.get(index + resolvedBegin, notSetValue) :
	          notSetValue;
	      }
	    }
	
	    sliceSeq.__iterateUncached = function(fn, reverse) {var this$0 = this;
	      if (sliceSize === 0) {
	        return 0;
	      }
	      if (reverse) {
	        return this.cacheResult().__iterate(fn, reverse);
	      }
	      var skipped = 0;
	      var isSkipping = true;
	      var iterations = 0;
	      iterable.__iterate(function(v, k)  {
	        if (!(isSkipping && (isSkipping = skipped++ < resolvedBegin))) {
	          iterations++;
	          return fn(v, useKeys ? k : iterations - 1, this$0) !== false &&
	                 iterations !== sliceSize;
	        }
	      });
	      return iterations;
	    };
	
	    sliceSeq.__iteratorUncached = function(type, reverse) {
	      if (sliceSize !== 0 && reverse) {
	        return this.cacheResult().__iterator(type, reverse);
	      }
	      // Don't bother instantiating parent iterator if taking 0.
	      var iterator = sliceSize !== 0 && iterable.__iterator(type, reverse);
	      var skipped = 0;
	      var iterations = 0;
	      return new Iterator(function()  {
	        while (skipped++ < resolvedBegin) {
	          iterator.next();
	        }
	        if (++iterations > sliceSize) {
	          return iteratorDone();
	        }
	        var step = iterator.next();
	        if (useKeys || type === ITERATE_VALUES) {
	          return step;
	        } else if (type === ITERATE_KEYS) {
	          return iteratorValue(type, iterations - 1, undefined, step);
	        } else {
	          return iteratorValue(type, iterations - 1, step.value[1], step);
	        }
	      });
	    }
	
	    return sliceSeq;
	  }
	
	
	  function takeWhileFactory(iterable, predicate, context) {
	    var takeSequence = makeSequence(iterable);
	    takeSequence.__iterateUncached = function(fn, reverse) {var this$0 = this;
	      if (reverse) {
	        return this.cacheResult().__iterate(fn, reverse);
	      }
	      var iterations = 0;
	      iterable.__iterate(function(v, k, c) 
	        {return predicate.call(context, v, k, c) && ++iterations && fn(v, k, this$0)}
	      );
	      return iterations;
	    };
	    takeSequence.__iteratorUncached = function(type, reverse) {var this$0 = this;
	      if (reverse) {
	        return this.cacheResult().__iterator(type, reverse);
	      }
	      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
	      var iterating = true;
	      return new Iterator(function()  {
	        if (!iterating) {
	          return iteratorDone();
	        }
	        var step = iterator.next();
	        if (step.done) {
	          return step;
	        }
	        var entry = step.value;
	        var k = entry[0];
	        var v = entry[1];
	        if (!predicate.call(context, v, k, this$0)) {
	          iterating = false;
	          return iteratorDone();
	        }
	        return type === ITERATE_ENTRIES ? step :
	          iteratorValue(type, k, v, step);
	      });
	    };
	    return takeSequence;
	  }
	
	
	  function skipWhileFactory(iterable, predicate, context, useKeys) {
	    var skipSequence = makeSequence(iterable);
	    skipSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
	      if (reverse) {
	        return this.cacheResult().__iterate(fn, reverse);
	      }
	      var isSkipping = true;
	      var iterations = 0;
	      iterable.__iterate(function(v, k, c)  {
	        if (!(isSkipping && (isSkipping = predicate.call(context, v, k, c)))) {
	          iterations++;
	          return fn(v, useKeys ? k : iterations - 1, this$0);
	        }
	      });
	      return iterations;
	    };
	    skipSequence.__iteratorUncached = function(type, reverse) {var this$0 = this;
	      if (reverse) {
	        return this.cacheResult().__iterator(type, reverse);
	      }
	      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
	      var skipping = true;
	      var iterations = 0;
	      return new Iterator(function()  {
	        var step, k, v;
	        do {
	          step = iterator.next();
	          if (step.done) {
	            if (useKeys || type === ITERATE_VALUES) {
	              return step;
	            } else if (type === ITERATE_KEYS) {
	              return iteratorValue(type, iterations++, undefined, step);
	            } else {
	              return iteratorValue(type, iterations++, step.value[1], step);
	            }
	          }
	          var entry = step.value;
	          k = entry[0];
	          v = entry[1];
	          skipping && (skipping = predicate.call(context, v, k, this$0));
	        } while (skipping);
	        return type === ITERATE_ENTRIES ? step :
	          iteratorValue(type, k, v, step);
	      });
	    };
	    return skipSequence;
	  }
	
	
	  function concatFactory(iterable, values) {
	    var isKeyedIterable = isKeyed(iterable);
	    var iters = [iterable].concat(values).map(function(v ) {
	      if (!isIterable(v)) {
	        v = isKeyedIterable ?
	          keyedSeqFromValue(v) :
	          indexedSeqFromValue(Array.isArray(v) ? v : [v]);
	      } else if (isKeyedIterable) {
	        v = KeyedIterable(v);
	      }
	      return v;
	    }).filter(function(v ) {return v.size !== 0});
	
	    if (iters.length === 0) {
	      return iterable;
	    }
	
	    if (iters.length === 1) {
	      var singleton = iters[0];
	      if (singleton === iterable ||
	          isKeyedIterable && isKeyed(singleton) ||
	          isIndexed(iterable) && isIndexed(singleton)) {
	        return singleton;
	      }
	    }
	
	    var concatSeq = new ArraySeq(iters);
	    if (isKeyedIterable) {
	      concatSeq = concatSeq.toKeyedSeq();
	    } else if (!isIndexed(iterable)) {
	      concatSeq = concatSeq.toSetSeq();
	    }
	    concatSeq = concatSeq.flatten(true);
	    concatSeq.size = iters.reduce(
	      function(sum, seq)  {
	        if (sum !== undefined) {
	          var size = seq.size;
	          if (size !== undefined) {
	            return sum + size;
	          }
	        }
	      },
	      0
	    );
	    return concatSeq;
	  }
	
	
	  function flattenFactory(iterable, depth, useKeys) {
	    var flatSequence = makeSequence(iterable);
	    flatSequence.__iterateUncached = function(fn, reverse) {
	      var iterations = 0;
	      var stopped = false;
	      function flatDeep(iter, currentDepth) {var this$0 = this;
	        iter.__iterate(function(v, k)  {
	          if ((!depth || currentDepth < depth) && isIterable(v)) {
	            flatDeep(v, currentDepth + 1);
	          } else if (fn(v, useKeys ? k : iterations++, this$0) === false) {
	            stopped = true;
	          }
	          return !stopped;
	        }, reverse);
	      }
	      flatDeep(iterable, 0);
	      return iterations;
	    }
	    flatSequence.__iteratorUncached = function(type, reverse) {
	      var iterator = iterable.__iterator(type, reverse);
	      var stack = [];
	      var iterations = 0;
	      return new Iterator(function()  {
	        while (iterator) {
	          var step = iterator.next();
	          if (step.done !== false) {
	            iterator = stack.pop();
	            continue;
	          }
	          var v = step.value;
	          if (type === ITERATE_ENTRIES) {
	            v = v[1];
	          }
	          if ((!depth || stack.length < depth) && isIterable(v)) {
	            stack.push(iterator);
	            iterator = v.__iterator(type, reverse);
	          } else {
	            return useKeys ? step : iteratorValue(type, iterations++, v, step);
	          }
	        }
	        return iteratorDone();
	      });
	    }
	    return flatSequence;
	  }
	
	
	  function flatMapFactory(iterable, mapper, context) {
	    var coerce = iterableClass(iterable);
	    return iterable.toSeq().map(
	      function(v, k)  {return coerce(mapper.call(context, v, k, iterable))}
	    ).flatten(true);
	  }
	
	
	  function interposeFactory(iterable, separator) {
	    var interposedSequence = makeSequence(iterable);
	    interposedSequence.size = iterable.size && iterable.size * 2 -1;
	    interposedSequence.__iterateUncached = function(fn, reverse) {var this$0 = this;
	      var iterations = 0;
	      iterable.__iterate(function(v, k) 
	        {return (!iterations || fn(separator, iterations++, this$0) !== false) &&
	        fn(v, iterations++, this$0) !== false},
	        reverse
	      );
	      return iterations;
	    };
	    interposedSequence.__iteratorUncached = function(type, reverse) {
	      var iterator = iterable.__iterator(ITERATE_VALUES, reverse);
	      var iterations = 0;
	      var step;
	      return new Iterator(function()  {
	        if (!step || iterations % 2) {
	          step = iterator.next();
	          if (step.done) {
	            return step;
	          }
	        }
	        return iterations % 2 ?
	          iteratorValue(type, iterations++, separator) :
	          iteratorValue(type, iterations++, step.value, step);
	      });
	    };
	    return interposedSequence;
	  }
	
	
	  function sortFactory(iterable, comparator, mapper) {
	    if (!comparator) {
	      comparator = defaultComparator;
	    }
	    var isKeyedIterable = isKeyed(iterable);
	    var index = 0;
	    var entries = iterable.toSeq().map(
	      function(v, k)  {return [k, v, index++, mapper ? mapper(v, k, iterable) : v]}
	    ).toArray();
	    entries.sort(function(a, b)  {return comparator(a[3], b[3]) || a[2] - b[2]}).forEach(
	      isKeyedIterable ?
	      function(v, i)  { entries[i].length = 2; } :
	      function(v, i)  { entries[i] = v[1]; }
	    );
	    return isKeyedIterable ? KeyedSeq(entries) :
	      isIndexed(iterable) ? IndexedSeq(entries) :
	      SetSeq(entries);
	  }
	
	
	  function maxFactory(iterable, comparator, mapper) {
	    if (!comparator) {
	      comparator = defaultComparator;
	    }
	    if (mapper) {
	      var entry = iterable.toSeq()
	        .map(function(v, k)  {return [v, mapper(v, k, iterable)]})
	        .reduce(function(a, b)  {return maxCompare(comparator, a[1], b[1]) ? b : a});
	      return entry && entry[0];
	    } else {
	      return iterable.reduce(function(a, b)  {return maxCompare(comparator, a, b) ? b : a});
	    }
	  }
	
	  function maxCompare(comparator, a, b) {
	    var comp = comparator(b, a);
	    // b is considered the new max if the comparator declares them equal, but
	    // they are not equal and b is in fact a nullish value.
	    return (comp === 0 && b !== a && (b === undefined || b === null || b !== b)) || comp > 0;
	  }
	
	
	  function zipWithFactory(keyIter, zipper, iters) {
	    var zipSequence = makeSequence(keyIter);
	    zipSequence.size = new ArraySeq(iters).map(function(i ) {return i.size}).min();
	    // Note: this a generic base implementation of __iterate in terms of
	    // __iterator which may be more generically useful in the future.
	    zipSequence.__iterate = function(fn, reverse) {
	      /* generic:
	      var iterator = this.__iterator(ITERATE_ENTRIES, reverse);
	      var step;
	      var iterations = 0;
	      while (!(step = iterator.next()).done) {
	        iterations++;
	        if (fn(step.value[1], step.value[0], this) === false) {
	          break;
	        }
	      }
	      return iterations;
	      */
	      // indexed:
	      var iterator = this.__iterator(ITERATE_VALUES, reverse);
	      var step;
	      var iterations = 0;
	      while (!(step = iterator.next()).done) {
	        if (fn(step.value, iterations++, this) === false) {
	          break;
	        }
	      }
	      return iterations;
	    };
	    zipSequence.__iteratorUncached = function(type, reverse) {
	      var iterators = iters.map(function(i )
	        {return (i = Iterable(i), getIterator(reverse ? i.reverse() : i))}
	      );
	      var iterations = 0;
	      var isDone = false;
	      return new Iterator(function()  {
	        var steps;
	        if (!isDone) {
	          steps = iterators.map(function(i ) {return i.next()});
	          isDone = steps.some(function(s ) {return s.done});
	        }
	        if (isDone) {
	          return iteratorDone();
	        }
	        return iteratorValue(
	          type,
	          iterations++,
	          zipper.apply(null, steps.map(function(s ) {return s.value}))
	        );
	      });
	    };
	    return zipSequence
	  }
	
	
	  // #pragma Helper Functions
	
	  function reify(iter, seq) {
	    return isSeq(iter) ? seq : iter.constructor(seq);
	  }
	
	  function validateEntry(entry) {
	    if (entry !== Object(entry)) {
	      throw new TypeError('Expected [K, V] tuple: ' + entry);
	    }
	  }
	
	  function resolveSize(iter) {
	    assertNotInfinite(iter.size);
	    return ensureSize(iter);
	  }
	
	  function iterableClass(iterable) {
	    return isKeyed(iterable) ? KeyedIterable :
	      isIndexed(iterable) ? IndexedIterable :
	      SetIterable;
	  }
	
	  function makeSequence(iterable) {
	    return Object.create(
	      (
	        isKeyed(iterable) ? KeyedSeq :
	        isIndexed(iterable) ? IndexedSeq :
	        SetSeq
	      ).prototype
	    );
	  }
	
	  function cacheResultThrough() {
	    if (this._iter.cacheResult) {
	      this._iter.cacheResult();
	      this.size = this._iter.size;
	      return this;
	    } else {
	      return Seq.prototype.cacheResult.call(this);
	    }
	  }
	
	  function defaultComparator(a, b) {
	    return a > b ? 1 : a < b ? -1 : 0;
	  }
	
	  function forceIterator(keyPath) {
	    var iter = getIterator(keyPath);
	    if (!iter) {
	      // Array might not be iterable in this environment, so we need a fallback
	      // to our wrapped type.
	      if (!isArrayLike(keyPath)) {
	        throw new TypeError('Expected iterable or array-like: ' + keyPath);
	      }
	      iter = getIterator(Iterable(keyPath));
	    }
	    return iter;
	  }
	
	  createClass(Record, KeyedCollection);
	
	    function Record(defaultValues, name) {
	      var hasInitialized;
	
	      var RecordType = function Record(values) {
	        if (values instanceof RecordType) {
	          return values;
	        }
	        if (!(this instanceof RecordType)) {
	          return new RecordType(values);
	        }
	        if (!hasInitialized) {
	          hasInitialized = true;
	          var keys = Object.keys(defaultValues);
	          setProps(RecordTypePrototype, keys);
	          RecordTypePrototype.size = keys.length;
	          RecordTypePrototype._name = name;
	          RecordTypePrototype._keys = keys;
	          RecordTypePrototype._defaultValues = defaultValues;
	        }
	        this._map = Map(values);
	      };
	
	      var RecordTypePrototype = RecordType.prototype = Object.create(RecordPrototype);
	      RecordTypePrototype.constructor = RecordType;
	
	      return RecordType;
	    }
	
	    Record.prototype.toString = function() {
	      return this.__toString(recordName(this) + ' {', '}');
	    };
	
	    // @pragma Access
	
	    Record.prototype.has = function(k) {
	      return this._defaultValues.hasOwnProperty(k);
	    };
	
	    Record.prototype.get = function(k, notSetValue) {
	      if (!this.has(k)) {
	        return notSetValue;
	      }
	      var defaultVal = this._defaultValues[k];
	      return this._map ? this._map.get(k, defaultVal) : defaultVal;
	    };
	
	    // @pragma Modification
	
	    Record.prototype.clear = function() {
	      if (this.__ownerID) {
	        this._map && this._map.clear();
	        return this;
	      }
	      var RecordType = this.constructor;
	      return RecordType._empty || (RecordType._empty = makeRecord(this, emptyMap()));
	    };
	
	    Record.prototype.set = function(k, v) {
	      if (!this.has(k)) {
	        throw new Error('Cannot set unknown key "' + k + '" on ' + recordName(this));
	      }
	      if (this._map && !this._map.has(k)) {
	        var defaultVal = this._defaultValues[k];
	        if (v === defaultVal) {
	          return this;
	        }
	      }
	      var newMap = this._map && this._map.set(k, v);
	      if (this.__ownerID || newMap === this._map) {
	        return this;
	      }
	      return makeRecord(this, newMap);
	    };
	
	    Record.prototype.remove = function(k) {
	      if (!this.has(k)) {
	        return this;
	      }
	      var newMap = this._map && this._map.remove(k);
	      if (this.__ownerID || newMap === this._map) {
	        return this;
	      }
	      return makeRecord(this, newMap);
	    };
	
	    Record.prototype.wasAltered = function() {
	      return this._map.wasAltered();
	    };
	
	    Record.prototype.__iterator = function(type, reverse) {var this$0 = this;
	      return KeyedIterable(this._defaultValues).map(function(_, k)  {return this$0.get(k)}).__iterator(type, reverse);
	    };
	
	    Record.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      return KeyedIterable(this._defaultValues).map(function(_, k)  {return this$0.get(k)}).__iterate(fn, reverse);
	    };
	
	    Record.prototype.__ensureOwner = function(ownerID) {
	      if (ownerID === this.__ownerID) {
	        return this;
	      }
	      var newMap = this._map && this._map.__ensureOwner(ownerID);
	      if (!ownerID) {
	        this.__ownerID = ownerID;
	        this._map = newMap;
	        return this;
	      }
	      return makeRecord(this, newMap, ownerID);
	    };
	
	
	  var RecordPrototype = Record.prototype;
	  RecordPrototype[DELETE] = RecordPrototype.remove;
	  RecordPrototype.deleteIn =
	  RecordPrototype.removeIn = MapPrototype.removeIn;
	  RecordPrototype.merge = MapPrototype.merge;
	  RecordPrototype.mergeWith = MapPrototype.mergeWith;
	  RecordPrototype.mergeIn = MapPrototype.mergeIn;
	  RecordPrototype.mergeDeep = MapPrototype.mergeDeep;
	  RecordPrototype.mergeDeepWith = MapPrototype.mergeDeepWith;
	  RecordPrototype.mergeDeepIn = MapPrototype.mergeDeepIn;
	  RecordPrototype.setIn = MapPrototype.setIn;
	  RecordPrototype.update = MapPrototype.update;
	  RecordPrototype.updateIn = MapPrototype.updateIn;
	  RecordPrototype.withMutations = MapPrototype.withMutations;
	  RecordPrototype.asMutable = MapPrototype.asMutable;
	  RecordPrototype.asImmutable = MapPrototype.asImmutable;
	
	
	  function makeRecord(likeRecord, map, ownerID) {
	    var record = Object.create(Object.getPrototypeOf(likeRecord));
	    record._map = map;
	    record.__ownerID = ownerID;
	    return record;
	  }
	
	  function recordName(record) {
	    return record._name || record.constructor.name || 'Record';
	  }
	
	  function setProps(prototype, names) {
	    try {
	      names.forEach(setProp.bind(undefined, prototype));
	    } catch (error) {
	      // Object.defineProperty failed. Probably IE8.
	    }
	  }
	
	  function setProp(prototype, name) {
	    Object.defineProperty(prototype, name, {
	      get: function() {
	        return this.get(name);
	      },
	      set: function(value) {
	        invariant(this.__ownerID, 'Cannot set on an immutable record.');
	        this.set(name, value);
	      }
	    });
	  }
	
	  createClass(Set, SetCollection);
	
	    // @pragma Construction
	
	    function Set(value) {
	      return value === null || value === undefined ? emptySet() :
	        isSet(value) && !isOrdered(value) ? value :
	        emptySet().withMutations(function(set ) {
	          var iter = SetIterable(value);
	          assertNotInfinite(iter.size);
	          iter.forEach(function(v ) {return set.add(v)});
	        });
	    }
	
	    Set.of = function(/*...values*/) {
	      return this(arguments);
	    };
	
	    Set.fromKeys = function(value) {
	      return this(KeyedIterable(value).keySeq());
	    };
	
	    Set.prototype.toString = function() {
	      return this.__toString('Set {', '}');
	    };
	
	    // @pragma Access
	
	    Set.prototype.has = function(value) {
	      return this._map.has(value);
	    };
	
	    // @pragma Modification
	
	    Set.prototype.add = function(value) {
	      return updateSet(this, this._map.set(value, true));
	    };
	
	    Set.prototype.remove = function(value) {
	      return updateSet(this, this._map.remove(value));
	    };
	
	    Set.prototype.clear = function() {
	      return updateSet(this, this._map.clear());
	    };
	
	    // @pragma Composition
	
	    Set.prototype.union = function() {var iters = SLICE$0.call(arguments, 0);
	      iters = iters.filter(function(x ) {return x.size !== 0});
	      if (iters.length === 0) {
	        return this;
	      }
	      if (this.size === 0 && !this.__ownerID && iters.length === 1) {
	        return this.constructor(iters[0]);
	      }
	      return this.withMutations(function(set ) {
	        for (var ii = 0; ii < iters.length; ii++) {
	          SetIterable(iters[ii]).forEach(function(value ) {return set.add(value)});
	        }
	      });
	    };
	
	    Set.prototype.intersect = function() {var iters = SLICE$0.call(arguments, 0);
	      if (iters.length === 0) {
	        return this;
	      }
	      iters = iters.map(function(iter ) {return SetIterable(iter)});
	      var originalSet = this;
	      return this.withMutations(function(set ) {
	        originalSet.forEach(function(value ) {
	          if (!iters.every(function(iter ) {return iter.includes(value)})) {
	            set.remove(value);
	          }
	        });
	      });
	    };
	
	    Set.prototype.subtract = function() {var iters = SLICE$0.call(arguments, 0);
	      if (iters.length === 0) {
	        return this;
	      }
	      iters = iters.map(function(iter ) {return SetIterable(iter)});
	      var originalSet = this;
	      return this.withMutations(function(set ) {
	        originalSet.forEach(function(value ) {
	          if (iters.some(function(iter ) {return iter.includes(value)})) {
	            set.remove(value);
	          }
	        });
	      });
	    };
	
	    Set.prototype.merge = function() {
	      return this.union.apply(this, arguments);
	    };
	
	    Set.prototype.mergeWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
	      return this.union.apply(this, iters);
	    };
	
	    Set.prototype.sort = function(comparator) {
	      // Late binding
	      return OrderedSet(sortFactory(this, comparator));
	    };
	
	    Set.prototype.sortBy = function(mapper, comparator) {
	      // Late binding
	      return OrderedSet(sortFactory(this, comparator, mapper));
	    };
	
	    Set.prototype.wasAltered = function() {
	      return this._map.wasAltered();
	    };
	
	    Set.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      return this._map.__iterate(function(_, k)  {return fn(k, k, this$0)}, reverse);
	    };
	
	    Set.prototype.__iterator = function(type, reverse) {
	      return this._map.map(function(_, k)  {return k}).__iterator(type, reverse);
	    };
	
	    Set.prototype.__ensureOwner = function(ownerID) {
	      if (ownerID === this.__ownerID) {
	        return this;
	      }
	      var newMap = this._map.__ensureOwner(ownerID);
	      if (!ownerID) {
	        this.__ownerID = ownerID;
	        this._map = newMap;
	        return this;
	      }
	      return this.__make(newMap, ownerID);
	    };
	
	
	  function isSet(maybeSet) {
	    return !!(maybeSet && maybeSet[IS_SET_SENTINEL]);
	  }
	
	  Set.isSet = isSet;
	
	  var IS_SET_SENTINEL = '@@__IMMUTABLE_SET__@@';
	
	  var SetPrototype = Set.prototype;
	  SetPrototype[IS_SET_SENTINEL] = true;
	  SetPrototype[DELETE] = SetPrototype.remove;
	  SetPrototype.mergeDeep = SetPrototype.merge;
	  SetPrototype.mergeDeepWith = SetPrototype.mergeWith;
	  SetPrototype.withMutations = MapPrototype.withMutations;
	  SetPrototype.asMutable = MapPrototype.asMutable;
	  SetPrototype.asImmutable = MapPrototype.asImmutable;
	
	  SetPrototype.__empty = emptySet;
	  SetPrototype.__make = makeSet;
	
	  function updateSet(set, newMap) {
	    if (set.__ownerID) {
	      set.size = newMap.size;
	      set._map = newMap;
	      return set;
	    }
	    return newMap === set._map ? set :
	      newMap.size === 0 ? set.__empty() :
	      set.__make(newMap);
	  }
	
	  function makeSet(map, ownerID) {
	    var set = Object.create(SetPrototype);
	    set.size = map ? map.size : 0;
	    set._map = map;
	    set.__ownerID = ownerID;
	    return set;
	  }
	
	  var EMPTY_SET;
	  function emptySet() {
	    return EMPTY_SET || (EMPTY_SET = makeSet(emptyMap()));
	  }
	
	  createClass(OrderedSet, Set);
	
	    // @pragma Construction
	
	    function OrderedSet(value) {
	      return value === null || value === undefined ? emptyOrderedSet() :
	        isOrderedSet(value) ? value :
	        emptyOrderedSet().withMutations(function(set ) {
	          var iter = SetIterable(value);
	          assertNotInfinite(iter.size);
	          iter.forEach(function(v ) {return set.add(v)});
	        });
	    }
	
	    OrderedSet.of = function(/*...values*/) {
	      return this(arguments);
	    };
	
	    OrderedSet.fromKeys = function(value) {
	      return this(KeyedIterable(value).keySeq());
	    };
	
	    OrderedSet.prototype.toString = function() {
	      return this.__toString('OrderedSet {', '}');
	    };
	
	
	  function isOrderedSet(maybeOrderedSet) {
	    return isSet(maybeOrderedSet) && isOrdered(maybeOrderedSet);
	  }
	
	  OrderedSet.isOrderedSet = isOrderedSet;
	
	  var OrderedSetPrototype = OrderedSet.prototype;
	  OrderedSetPrototype[IS_ORDERED_SENTINEL] = true;
	
	  OrderedSetPrototype.__empty = emptyOrderedSet;
	  OrderedSetPrototype.__make = makeOrderedSet;
	
	  function makeOrderedSet(map, ownerID) {
	    var set = Object.create(OrderedSetPrototype);
	    set.size = map ? map.size : 0;
	    set._map = map;
	    set.__ownerID = ownerID;
	    return set;
	  }
	
	  var EMPTY_ORDERED_SET;
	  function emptyOrderedSet() {
	    return EMPTY_ORDERED_SET || (EMPTY_ORDERED_SET = makeOrderedSet(emptyOrderedMap()));
	  }
	
	  createClass(Stack, IndexedCollection);
	
	    // @pragma Construction
	
	    function Stack(value) {
	      return value === null || value === undefined ? emptyStack() :
	        isStack(value) ? value :
	        emptyStack().unshiftAll(value);
	    }
	
	    Stack.of = function(/*...values*/) {
	      return this(arguments);
	    };
	
	    Stack.prototype.toString = function() {
	      return this.__toString('Stack [', ']');
	    };
	
	    // @pragma Access
	
	    Stack.prototype.get = function(index, notSetValue) {
	      var head = this._head;
	      index = wrapIndex(this, index);
	      while (head && index--) {
	        head = head.next;
	      }
	      return head ? head.value : notSetValue;
	    };
	
	    Stack.prototype.peek = function() {
	      return this._head && this._head.value;
	    };
	
	    // @pragma Modification
	
	    Stack.prototype.push = function(/*...values*/) {
	      if (arguments.length === 0) {
	        return this;
	      }
	      var newSize = this.size + arguments.length;
	      var head = this._head;
	      for (var ii = arguments.length - 1; ii >= 0; ii--) {
	        head = {
	          value: arguments[ii],
	          next: head
	        };
	      }
	      if (this.__ownerID) {
	        this.size = newSize;
	        this._head = head;
	        this.__hash = undefined;
	        this.__altered = true;
	        return this;
	      }
	      return makeStack(newSize, head);
	    };
	
	    Stack.prototype.pushAll = function(iter) {
	      iter = IndexedIterable(iter);
	      if (iter.size === 0) {
	        return this;
	      }
	      assertNotInfinite(iter.size);
	      var newSize = this.size;
	      var head = this._head;
	      iter.reverse().forEach(function(value ) {
	        newSize++;
	        head = {
	          value: value,
	          next: head
	        };
	      });
	      if (this.__ownerID) {
	        this.size = newSize;
	        this._head = head;
	        this.__hash = undefined;
	        this.__altered = true;
	        return this;
	      }
	      return makeStack(newSize, head);
	    };
	
	    Stack.prototype.pop = function() {
	      return this.slice(1);
	    };
	
	    Stack.prototype.unshift = function(/*...values*/) {
	      return this.push.apply(this, arguments);
	    };
	
	    Stack.prototype.unshiftAll = function(iter) {
	      return this.pushAll(iter);
	    };
	
	    Stack.prototype.shift = function() {
	      return this.pop.apply(this, arguments);
	    };
	
	    Stack.prototype.clear = function() {
	      if (this.size === 0) {
	        return this;
	      }
	      if (this.__ownerID) {
	        this.size = 0;
	        this._head = undefined;
	        this.__hash = undefined;
	        this.__altered = true;
	        return this;
	      }
	      return emptyStack();
	    };
	
	    Stack.prototype.slice = function(begin, end) {
	      if (wholeSlice(begin, end, this.size)) {
	        return this;
	      }
	      var resolvedBegin = resolveBegin(begin, this.size);
	      var resolvedEnd = resolveEnd(end, this.size);
	      if (resolvedEnd !== this.size) {
	        // super.slice(begin, end);
	        return IndexedCollection.prototype.slice.call(this, begin, end);
	      }
	      var newSize = this.size - resolvedBegin;
	      var head = this._head;
	      while (resolvedBegin--) {
	        head = head.next;
	      }
	      if (this.__ownerID) {
	        this.size = newSize;
	        this._head = head;
	        this.__hash = undefined;
	        this.__altered = true;
	        return this;
	      }
	      return makeStack(newSize, head);
	    };
	
	    // @pragma Mutability
	
	    Stack.prototype.__ensureOwner = function(ownerID) {
	      if (ownerID === this.__ownerID) {
	        return this;
	      }
	      if (!ownerID) {
	        this.__ownerID = ownerID;
	        this.__altered = false;
	        return this;
	      }
	      return makeStack(this.size, this._head, ownerID, this.__hash);
	    };
	
	    // @pragma Iteration
	
	    Stack.prototype.__iterate = function(fn, reverse) {
	      if (reverse) {
	        return this.reverse().__iterate(fn);
	      }
	      var iterations = 0;
	      var node = this._head;
	      while (node) {
	        if (fn(node.value, iterations++, this) === false) {
	          break;
	        }
	        node = node.next;
	      }
	      return iterations;
	    };
	
	    Stack.prototype.__iterator = function(type, reverse) {
	      if (reverse) {
	        return this.reverse().__iterator(type);
	      }
	      var iterations = 0;
	      var node = this._head;
	      return new Iterator(function()  {
	        if (node) {
	          var value = node.value;
	          node = node.next;
	          return iteratorValue(type, iterations++, value);
	        }
	        return iteratorDone();
	      });
	    };
	
	
	  function isStack(maybeStack) {
	    return !!(maybeStack && maybeStack[IS_STACK_SENTINEL]);
	  }
	
	  Stack.isStack = isStack;
	
	  var IS_STACK_SENTINEL = '@@__IMMUTABLE_STACK__@@';
	
	  var StackPrototype = Stack.prototype;
	  StackPrototype[IS_STACK_SENTINEL] = true;
	  StackPrototype.withMutations = MapPrototype.withMutations;
	  StackPrototype.asMutable = MapPrototype.asMutable;
	  StackPrototype.asImmutable = MapPrototype.asImmutable;
	  StackPrototype.wasAltered = MapPrototype.wasAltered;
	
	
	  function makeStack(size, head, ownerID, hash) {
	    var map = Object.create(StackPrototype);
	    map.size = size;
	    map._head = head;
	    map.__ownerID = ownerID;
	    map.__hash = hash;
	    map.__altered = false;
	    return map;
	  }
	
	  var EMPTY_STACK;
	  function emptyStack() {
	    return EMPTY_STACK || (EMPTY_STACK = makeStack(0));
	  }
	
	  /**
	   * Contributes additional methods to a constructor
	   */
	  function mixin(ctor, methods) {
	    var keyCopier = function(key ) { ctor.prototype[key] = methods[key]; };
	    Object.keys(methods).forEach(keyCopier);
	    Object.getOwnPropertySymbols &&
	      Object.getOwnPropertySymbols(methods).forEach(keyCopier);
	    return ctor;
	  }
	
	  Iterable.Iterator = Iterator;
	
	  mixin(Iterable, {
	
	    // ### Conversion to other types
	
	    toArray: function() {
	      assertNotInfinite(this.size);
	      var array = new Array(this.size || 0);
	      this.valueSeq().__iterate(function(v, i)  { array[i] = v; });
	      return array;
	    },
	
	    toIndexedSeq: function() {
	      return new ToIndexedSequence(this);
	    },
	
	    toJS: function() {
	      return this.toSeq().map(
	        function(value ) {return value && typeof value.toJS === 'function' ? value.toJS() : value}
	      ).__toJS();
	    },
	
	    toJSON: function() {
	      return this.toSeq().map(
	        function(value ) {return value && typeof value.toJSON === 'function' ? value.toJSON() : value}
	      ).__toJS();
	    },
	
	    toKeyedSeq: function() {
	      return new ToKeyedSequence(this, true);
	    },
	
	    toMap: function() {
	      // Use Late Binding here to solve the circular dependency.
	      return Map(this.toKeyedSeq());
	    },
	
	    toObject: function() {
	      assertNotInfinite(this.size);
	      var object = {};
	      this.__iterate(function(v, k)  { object[k] = v; });
	      return object;
	    },
	
	    toOrderedMap: function() {
	      // Use Late Binding here to solve the circular dependency.
	      return OrderedMap(this.toKeyedSeq());
	    },
	
	    toOrderedSet: function() {
	      // Use Late Binding here to solve the circular dependency.
	      return OrderedSet(isKeyed(this) ? this.valueSeq() : this);
	    },
	
	    toSet: function() {
	      // Use Late Binding here to solve the circular dependency.
	      return Set(isKeyed(this) ? this.valueSeq() : this);
	    },
	
	    toSetSeq: function() {
	      return new ToSetSequence(this);
	    },
	
	    toSeq: function() {
	      return isIndexed(this) ? this.toIndexedSeq() :
	        isKeyed(this) ? this.toKeyedSeq() :
	        this.toSetSeq();
	    },
	
	    toStack: function() {
	      // Use Late Binding here to solve the circular dependency.
	      return Stack(isKeyed(this) ? this.valueSeq() : this);
	    },
	
	    toList: function() {
	      // Use Late Binding here to solve the circular dependency.
	      return List(isKeyed(this) ? this.valueSeq() : this);
	    },
	
	
	    // ### Common JavaScript methods and properties
	
	    toString: function() {
	      return '[Iterable]';
	    },
	
	    __toString: function(head, tail) {
	      if (this.size === 0) {
	        return head + tail;
	      }
	      return head + ' ' + this.toSeq().map(this.__toStringMapper).join(', ') + ' ' + tail;
	    },
	
	
	    // ### ES6 Collection methods (ES6 Array and Map)
	
	    concat: function() {var values = SLICE$0.call(arguments, 0);
	      return reify(this, concatFactory(this, values));
	    },
	
	    includes: function(searchValue) {
	      return this.some(function(value ) {return is(value, searchValue)});
	    },
	
	    entries: function() {
	      return this.__iterator(ITERATE_ENTRIES);
	    },
	
	    every: function(predicate, context) {
	      assertNotInfinite(this.size);
	      var returnValue = true;
	      this.__iterate(function(v, k, c)  {
	        if (!predicate.call(context, v, k, c)) {
	          returnValue = false;
	          return false;
	        }
	      });
	      return returnValue;
	    },
	
	    filter: function(predicate, context) {
	      return reify(this, filterFactory(this, predicate, context, true));
	    },
	
	    find: function(predicate, context, notSetValue) {
	      var entry = this.findEntry(predicate, context);
	      return entry ? entry[1] : notSetValue;
	    },
	
	    forEach: function(sideEffect, context) {
	      assertNotInfinite(this.size);
	      return this.__iterate(context ? sideEffect.bind(context) : sideEffect);
	    },
	
	    join: function(separator) {
	      assertNotInfinite(this.size);
	      separator = separator !== undefined ? '' + separator : ',';
	      var joined = '';
	      var isFirst = true;
	      this.__iterate(function(v ) {
	        isFirst ? (isFirst = false) : (joined += separator);
	        joined += v !== null && v !== undefined ? v.toString() : '';
	      });
	      return joined;
	    },
	
	    keys: function() {
	      return this.__iterator(ITERATE_KEYS);
	    },
	
	    map: function(mapper, context) {
	      return reify(this, mapFactory(this, mapper, context));
	    },
	
	    reduce: function(reducer, initialReduction, context) {
	      assertNotInfinite(this.size);
	      var reduction;
	      var useFirst;
	      if (arguments.length < 2) {
	        useFirst = true;
	      } else {
	        reduction = initialReduction;
	      }
	      this.__iterate(function(v, k, c)  {
	        if (useFirst) {
	          useFirst = false;
	          reduction = v;
	        } else {
	          reduction = reducer.call(context, reduction, v, k, c);
	        }
	      });
	      return reduction;
	    },
	
	    reduceRight: function(reducer, initialReduction, context) {
	      var reversed = this.toKeyedSeq().reverse();
	      return reversed.reduce.apply(reversed, arguments);
	    },
	
	    reverse: function() {
	      return reify(this, reverseFactory(this, true));
	    },
	
	    slice: function(begin, end) {
	      return reify(this, sliceFactory(this, begin, end, true));
	    },
	
	    some: function(predicate, context) {
	      return !this.every(not(predicate), context);
	    },
	
	    sort: function(comparator) {
	      return reify(this, sortFactory(this, comparator));
	    },
	
	    values: function() {
	      return this.__iterator(ITERATE_VALUES);
	    },
	
	
	    // ### More sequential methods
	
	    butLast: function() {
	      return this.slice(0, -1);
	    },
	
	    isEmpty: function() {
	      return this.size !== undefined ? this.size === 0 : !this.some(function()  {return true});
	    },
	
	    count: function(predicate, context) {
	      return ensureSize(
	        predicate ? this.toSeq().filter(predicate, context) : this
	      );
	    },
	
	    countBy: function(grouper, context) {
	      return countByFactory(this, grouper, context);
	    },
	
	    equals: function(other) {
	      return deepEqual(this, other);
	    },
	
	    entrySeq: function() {
	      var iterable = this;
	      if (iterable._cache) {
	        // We cache as an entries array, so we can just return the cache!
	        return new ArraySeq(iterable._cache);
	      }
	      var entriesSequence = iterable.toSeq().map(entryMapper).toIndexedSeq();
	      entriesSequence.fromEntrySeq = function()  {return iterable.toSeq()};
	      return entriesSequence;
	    },
	
	    filterNot: function(predicate, context) {
	      return this.filter(not(predicate), context);
	    },
	
	    findEntry: function(predicate, context, notSetValue) {
	      var found = notSetValue;
	      this.__iterate(function(v, k, c)  {
	        if (predicate.call(context, v, k, c)) {
	          found = [k, v];
	          return false;
	        }
	      });
	      return found;
	    },
	
	    findKey: function(predicate, context) {
	      var entry = this.findEntry(predicate, context);
	      return entry && entry[0];
	    },
	
	    findLast: function(predicate, context, notSetValue) {
	      return this.toKeyedSeq().reverse().find(predicate, context, notSetValue);
	    },
	
	    findLastEntry: function(predicate, context, notSetValue) {
	      return this.toKeyedSeq().reverse().findEntry(predicate, context, notSetValue);
	    },
	
	    findLastKey: function(predicate, context) {
	      return this.toKeyedSeq().reverse().findKey(predicate, context);
	    },
	
	    first: function() {
	      return this.find(returnTrue);
	    },
	
	    flatMap: function(mapper, context) {
	      return reify(this, flatMapFactory(this, mapper, context));
	    },
	
	    flatten: function(depth) {
	      return reify(this, flattenFactory(this, depth, true));
	    },
	
	    fromEntrySeq: function() {
	      return new FromEntriesSequence(this);
	    },
	
	    get: function(searchKey, notSetValue) {
	      return this.find(function(_, key)  {return is(key, searchKey)}, undefined, notSetValue);
	    },
	
	    getIn: function(searchKeyPath, notSetValue) {
	      var nested = this;
	      // Note: in an ES6 environment, we would prefer:
	      // for (var key of searchKeyPath) {
	      var iter = forceIterator(searchKeyPath);
	      var step;
	      while (!(step = iter.next()).done) {
	        var key = step.value;
	        nested = nested && nested.get ? nested.get(key, NOT_SET) : NOT_SET;
	        if (nested === NOT_SET) {
	          return notSetValue;
	        }
	      }
	      return nested;
	    },
	
	    groupBy: function(grouper, context) {
	      return groupByFactory(this, grouper, context);
	    },
	
	    has: function(searchKey) {
	      return this.get(searchKey, NOT_SET) !== NOT_SET;
	    },
	
	    hasIn: function(searchKeyPath) {
	      return this.getIn(searchKeyPath, NOT_SET) !== NOT_SET;
	    },
	
	    isSubset: function(iter) {
	      iter = typeof iter.includes === 'function' ? iter : Iterable(iter);
	      return this.every(function(value ) {return iter.includes(value)});
	    },
	
	    isSuperset: function(iter) {
	      iter = typeof iter.isSubset === 'function' ? iter : Iterable(iter);
	      return iter.isSubset(this);
	    },
	
	    keyOf: function(searchValue) {
	      return this.findKey(function(value ) {return is(value, searchValue)});
	    },
	
	    keySeq: function() {
	      return this.toSeq().map(keyMapper).toIndexedSeq();
	    },
	
	    last: function() {
	      return this.toSeq().reverse().first();
	    },
	
	    lastKeyOf: function(searchValue) {
	      return this.toKeyedSeq().reverse().keyOf(searchValue);
	    },
	
	    max: function(comparator) {
	      return maxFactory(this, comparator);
	    },
	
	    maxBy: function(mapper, comparator) {
	      return maxFactory(this, comparator, mapper);
	    },
	
	    min: function(comparator) {
	      return maxFactory(this, comparator ? neg(comparator) : defaultNegComparator);
	    },
	
	    minBy: function(mapper, comparator) {
	      return maxFactory(this, comparator ? neg(comparator) : defaultNegComparator, mapper);
	    },
	
	    rest: function() {
	      return this.slice(1);
	    },
	
	    skip: function(amount) {
	      return this.slice(Math.max(0, amount));
	    },
	
	    skipLast: function(amount) {
	      return reify(this, this.toSeq().reverse().skip(amount).reverse());
	    },
	
	    skipWhile: function(predicate, context) {
	      return reify(this, skipWhileFactory(this, predicate, context, true));
	    },
	
	    skipUntil: function(predicate, context) {
	      return this.skipWhile(not(predicate), context);
	    },
	
	    sortBy: function(mapper, comparator) {
	      return reify(this, sortFactory(this, comparator, mapper));
	    },
	
	    take: function(amount) {
	      return this.slice(0, Math.max(0, amount));
	    },
	
	    takeLast: function(amount) {
	      return reify(this, this.toSeq().reverse().take(amount).reverse());
	    },
	
	    takeWhile: function(predicate, context) {
	      return reify(this, takeWhileFactory(this, predicate, context));
	    },
	
	    takeUntil: function(predicate, context) {
	      return this.takeWhile(not(predicate), context);
	    },
	
	    valueSeq: function() {
	      return this.toIndexedSeq();
	    },
	
	
	    // ### Hashable Object
	
	    hashCode: function() {
	      return this.__hash || (this.__hash = hashIterable(this));
	    }
	
	
	    // ### Internal
	
	    // abstract __iterate(fn, reverse)
	
	    // abstract __iterator(type, reverse)
	  });
	
	  // var IS_ITERABLE_SENTINEL = '@@__IMMUTABLE_ITERABLE__@@';
	  // var IS_KEYED_SENTINEL = '@@__IMMUTABLE_KEYED__@@';
	  // var IS_INDEXED_SENTINEL = '@@__IMMUTABLE_INDEXED__@@';
	  // var IS_ORDERED_SENTINEL = '@@__IMMUTABLE_ORDERED__@@';
	
	  var IterablePrototype = Iterable.prototype;
	  IterablePrototype[IS_ITERABLE_SENTINEL] = true;
	  IterablePrototype[ITERATOR_SYMBOL] = IterablePrototype.values;
	  IterablePrototype.__toJS = IterablePrototype.toArray;
	  IterablePrototype.__toStringMapper = quoteString;
	  IterablePrototype.inspect =
	  IterablePrototype.toSource = function() { return this.toString(); };
	  IterablePrototype.chain = IterablePrototype.flatMap;
	  IterablePrototype.contains = IterablePrototype.includes;
	
	  mixin(KeyedIterable, {
	
	    // ### More sequential methods
	
	    flip: function() {
	      return reify(this, flipFactory(this));
	    },
	
	    mapEntries: function(mapper, context) {var this$0 = this;
	      var iterations = 0;
	      return reify(this,
	        this.toSeq().map(
	          function(v, k)  {return mapper.call(context, [k, v], iterations++, this$0)}
	        ).fromEntrySeq()
	      );
	    },
	
	    mapKeys: function(mapper, context) {var this$0 = this;
	      return reify(this,
	        this.toSeq().flip().map(
	          function(k, v)  {return mapper.call(context, k, v, this$0)}
	        ).flip()
	      );
	    }
	
	  });
	
	  var KeyedIterablePrototype = KeyedIterable.prototype;
	  KeyedIterablePrototype[IS_KEYED_SENTINEL] = true;
	  KeyedIterablePrototype[ITERATOR_SYMBOL] = IterablePrototype.entries;
	  KeyedIterablePrototype.__toJS = IterablePrototype.toObject;
	  KeyedIterablePrototype.__toStringMapper = function(v, k)  {return JSON.stringify(k) + ': ' + quoteString(v)};
	
	
	
	  mixin(IndexedIterable, {
	
	    // ### Conversion to other types
	
	    toKeyedSeq: function() {
	      return new ToKeyedSequence(this, false);
	    },
	
	
	    // ### ES6 Collection methods (ES6 Array and Map)
	
	    filter: function(predicate, context) {
	      return reify(this, filterFactory(this, predicate, context, false));
	    },
	
	    findIndex: function(predicate, context) {
	      var entry = this.findEntry(predicate, context);
	      return entry ? entry[0] : -1;
	    },
	
	    indexOf: function(searchValue) {
	      var key = this.keyOf(searchValue);
	      return key === undefined ? -1 : key;
	    },
	
	    lastIndexOf: function(searchValue) {
	      var key = this.lastKeyOf(searchValue);
	      return key === undefined ? -1 : key;
	    },
	
	    reverse: function() {
	      return reify(this, reverseFactory(this, false));
	    },
	
	    slice: function(begin, end) {
	      return reify(this, sliceFactory(this, begin, end, false));
	    },
	
	    splice: function(index, removeNum /*, ...values*/) {
	      var numArgs = arguments.length;
	      removeNum = Math.max(removeNum | 0, 0);
	      if (numArgs === 0 || (numArgs === 2 && !removeNum)) {
	        return this;
	      }
	      // If index is negative, it should resolve relative to the size of the
	      // collection. However size may be expensive to compute if not cached, so
	      // only call count() if the number is in fact negative.
	      index = resolveBegin(index, index < 0 ? this.count() : this.size);
	      var spliced = this.slice(0, index);
	      return reify(
	        this,
	        numArgs === 1 ?
	          spliced :
	          spliced.concat(arrCopy(arguments, 2), this.slice(index + removeNum))
	      );
	    },
	
	
	    // ### More collection methods
	
	    findLastIndex: function(predicate, context) {
	      var entry = this.findLastEntry(predicate, context);
	      return entry ? entry[0] : -1;
	    },
	
	    first: function() {
	      return this.get(0);
	    },
	
	    flatten: function(depth) {
	      return reify(this, flattenFactory(this, depth, false));
	    },
	
	    get: function(index, notSetValue) {
	      index = wrapIndex(this, index);
	      return (index < 0 || (this.size === Infinity ||
	          (this.size !== undefined && index > this.size))) ?
	        notSetValue :
	        this.find(function(_, key)  {return key === index}, undefined, notSetValue);
	    },
	
	    has: function(index) {
	      index = wrapIndex(this, index);
	      return index >= 0 && (this.size !== undefined ?
	        this.size === Infinity || index < this.size :
	        this.indexOf(index) !== -1
	      );
	    },
	
	    interpose: function(separator) {
	      return reify(this, interposeFactory(this, separator));
	    },
	
	    interleave: function(/*...iterables*/) {
	      var iterables = [this].concat(arrCopy(arguments));
	      var zipped = zipWithFactory(this.toSeq(), IndexedSeq.of, iterables);
	      var interleaved = zipped.flatten(true);
	      if (zipped.size) {
	        interleaved.size = zipped.size * iterables.length;
	      }
	      return reify(this, interleaved);
	    },
	
	    keySeq: function() {
	      return Range(0, this.size);
	    },
	
	    last: function() {
	      return this.get(-1);
	    },
	
	    skipWhile: function(predicate, context) {
	      return reify(this, skipWhileFactory(this, predicate, context, false));
	    },
	
	    zip: function(/*, ...iterables */) {
	      var iterables = [this].concat(arrCopy(arguments));
	      return reify(this, zipWithFactory(this, defaultZipper, iterables));
	    },
	
	    zipWith: function(zipper/*, ...iterables */) {
	      var iterables = arrCopy(arguments);
	      iterables[0] = this;
	      return reify(this, zipWithFactory(this, zipper, iterables));
	    }
	
	  });
	
	  IndexedIterable.prototype[IS_INDEXED_SENTINEL] = true;
	  IndexedIterable.prototype[IS_ORDERED_SENTINEL] = true;
	
	
	
	  mixin(SetIterable, {
	
	    // ### ES6 Collection methods (ES6 Array and Map)
	
	    get: function(value, notSetValue) {
	      return this.has(value) ? value : notSetValue;
	    },
	
	    includes: function(value) {
	      return this.has(value);
	    },
	
	
	    // ### More sequential methods
	
	    keySeq: function() {
	      return this.valueSeq();
	    }
	
	  });
	
	  SetIterable.prototype.has = IterablePrototype.includes;
	  SetIterable.prototype.contains = SetIterable.prototype.includes;
	
	
	  // Mixin subclasses
	
	  mixin(KeyedSeq, KeyedIterable.prototype);
	  mixin(IndexedSeq, IndexedIterable.prototype);
	  mixin(SetSeq, SetIterable.prototype);
	
	  mixin(KeyedCollection, KeyedIterable.prototype);
	  mixin(IndexedCollection, IndexedIterable.prototype);
	  mixin(SetCollection, SetIterable.prototype);
	
	
	  // #pragma Helper functions
	
	  function keyMapper(v, k) {
	    return k;
	  }
	
	  function entryMapper(v, k) {
	    return [k, v];
	  }
	
	  function not(predicate) {
	    return function() {
	      return !predicate.apply(this, arguments);
	    }
	  }
	
	  function neg(predicate) {
	    return function() {
	      return -predicate.apply(this, arguments);
	    }
	  }
	
	  function quoteString(value) {
	    return typeof value === 'string' ? JSON.stringify(value) : String(value);
	  }
	
	  function defaultZipper() {
	    return arrCopy(arguments);
	  }
	
	  function defaultNegComparator(a, b) {
	    return a < b ? 1 : a > b ? -1 : 0;
	  }
	
	  function hashIterable(iterable) {
	    if (iterable.size === Infinity) {
	      return 0;
	    }
	    var ordered = isOrdered(iterable);
	    var keyed = isKeyed(iterable);
	    var h = ordered ? 1 : 0;
	    var size = iterable.__iterate(
	      keyed ?
	        ordered ?
	          function(v, k)  { h = 31 * h + hashMerge(hash(v), hash(k)) | 0; } :
	          function(v, k)  { h = h + hashMerge(hash(v), hash(k)) | 0; } :
	        ordered ?
	          function(v ) { h = 31 * h + hash(v) | 0; } :
	          function(v ) { h = h + hash(v) | 0; }
	    );
	    return murmurHashOfSize(size, h);
	  }
	
	  function murmurHashOfSize(size, h) {
	    h = imul(h, 0xCC9E2D51);
	    h = imul(h << 15 | h >>> -15, 0x1B873593);
	    h = imul(h << 13 | h >>> -13, 5);
	    h = (h + 0xE6546B64 | 0) ^ size;
	    h = imul(h ^ h >>> 16, 0x85EBCA6B);
	    h = imul(h ^ h >>> 13, 0xC2B2AE35);
	    h = smi(h ^ h >>> 16);
	    return h;
	  }
	
	  function hashMerge(a, b) {
	    return a ^ b + 0x9E3779B9 + (a << 6) + (a >> 2) | 0; // int
	  }
	
	  var Immutable = {
	
	    Iterable: Iterable,
	
	    Seq: Seq,
	    Collection: Collection,
	    Map: Map,
	    OrderedMap: OrderedMap,
	    List: List,
	    Stack: Stack,
	    Set: Set,
	    OrderedSet: OrderedSet,
	
	    Record: Record,
	    Range: Range,
	    Repeat: Repeat,
	
	    is: is,
	    fromJS: fromJS
	
	  };
	
	  return Immutable;
	
	}));

/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule FluxMixinLegacy
	 * 
	 */
	
	'use strict';
	
	var FluxStoreGroup = __webpack_require__(230);
	
	var invariant = __webpack_require__(226);
	
	/**
	 * `FluxContainer` should be preferred over this mixin, but it requires using
	 * react with classes. So this mixin is provided where it is not yet possible
	 * to convert a container to be a class.
	 *
	 * This mixin should be used for React components that have state based purely
	 * on stores. `this.props` will not be available inside of `calculateState()`.
	 *
	 * This mixin will only `setState` not replace it, so you should always return
	 * every key in your state unless you know what you are doing. Consider this:
	 *
	 *   var Foo = React.createClass({
	 *     mixins: [
	 *       FluxMixinLegacy([FooStore])
	 *     ],
	 *
	 *     statics: {
	 *       calculateState(prevState) {
	 *         if (!prevState) {
	 *           return {
	 *             foo: FooStore.getFoo(),
	 *           };
	 *         }
	 *
	 *         return {
	 *           bar: FooStore.getBar(),
	 *         };
	 *       }
	 *     },
	 *   });
	 *
	 * On the second calculateState when prevState is not null, the state will be
	 * updated to contain the previous foo AND the bar that was just returned. Only
	 * returning bar will not delete foo.
	 *
	 */
	function FluxMixinLegacy(stores) {
	  return {
	    getInitialState: function () {
	      enforceInterface(this);
	      return this.constructor.calculateState(null);
	    },
	
	    componentDidMount: function () {
	      var _this = this;
	
	      // This tracks when any store has changed and we may need to update.
	      var changed = false;
	      var setChanged = function () {
	        changed = true;
	      };
	
	      // This adds subscriptions to stores. When a store changes all we do is
	      // set changed to true.
	      this._fluxMixinSubscriptions = stores.map(function (store) {
	        return store.addListener(setChanged);
	      });
	
	      // This callback is called after the dispatch of the relevant stores. If
	      // any have reported a change we update the state, then reset changed.
	      var callback = function () {
	        if (changed) {
	          _this.setState(function (prevState) {
	            return _this.constructor.calculateState(_this.state);
	          });
	        }
	        changed = false;
	      };
	      this._fluxMixinStoreGroup = new FluxStoreGroup(stores, callback);
	    },
	
	    componentWillUnmount: function () {
	      this._fluxMixinStoreGroup.release();
	      for (var _iterator = this._fluxMixinSubscriptions, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
	        var _ref;
	
	        if (_isArray) {
	          if (_i >= _iterator.length) break;
	          _ref = _iterator[_i++];
	        } else {
	          _i = _iterator.next();
	          if (_i.done) break;
	          _ref = _i.value;
	        }
	
	        var subscription = _ref;
	
	        subscription.remove();
	      }
	      this._fluxMixinSubscriptions = [];
	    }
	  };
	}
	
	function enforceInterface(o) {
	  !o.constructor.calculateState ?  false ? invariant(false, 'Components that use FluxMixinLegacy must implement ' + '`calculateState()` on the statics object') : invariant(false) : undefined;
	}
	
	module.exports = FluxMixinLegacy;

/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Lauguages
	 */
	
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _commonUtilsCookies = __webpack_require__(246);
	
	var _commonUtilsCookies2 = _interopRequireDefault(_commonUtilsCookies);
	
	var supported = ['zh', 'en', 'jp'];
	
	var langMap = {
	  'pla_lan_001': 'zh',
	  'pla_lan_002': 'en',
	  'pla_lan_003': 'jp'
	};
	
	var lang = {
	
	  zh: {
	
	    // Login
	    COMPANY: '公司',
	    EMAIL: '邮箱',
	    USERNAME: '用户',
	    PASSWORD: '密码',
	    LOGIN: '登　录',
	    REMEMBER: '记住我',
	    FORGOT_PWD: '忘记密码',
	    COPYRIGHT: 'CDP © 2015 版权所有',
	
	    // Forgot password
	    MOBILE: '手机',
	    CAPTCHA: '验证码',
	    GET_CAPTCHA: '获得验证码',
	    RETRY_CAPTCHA: '秒后重试',
	    NEXT: '下一步',
	    NEW_PWD: '新密码',
	    REPEAT_PWD: '再次输入密码',
	    RESET_PWD: '重置密码',
	    AT_LEAST_6: '至少 6 位',
	    SAME_PWD: '必须和密码相同',
	    PWD_RESET_SUCCESS: '密码重置成功',
	
	    // Buttons
	    EDIT: '编辑',
	    OK: '确定',
	    CANCEL: '取消',
	    SAVE: '保存',
	    SUBMIT: '提交',
	    DROP: '删除',
	    REVOKE: '撤销',
	    COMMIT_APPLY: '提交申请',
	
	    // HOME
	    EMPLOYEE: '员工',
	    MANAGER: '经理',
	
	    PROFILE: '我的信息',
	    MY_SALARY: '我的薪酬',
	    MY_LEAVE: '请假',
	    MY_OT: '加班',
	    MY_RCI: '补打卡',
	    TEAM_PROFILE: '团队信息',
	    LEAVE_MGR: '请假管理',
	    OT_MGR: '加班管理',
	
	    CHANGE_PWD: '修改密码',
	    CHANGE_MOBILE: '修改手机号',
	    LOGOUT: '退出登录',
	
	    // Mobile
	    NEW_MOBILE: '新手机号',
	    MOBILE_TIP: '请填入 11 位数字',
	    EDIT_SUCCESS: '修改成功',
	    EDIT_FAIL: '修改失败',
	
	    // Password
	    OLD_PASSWORD: '当前密码',
	
	    // Profile
	    WORK_EXP: '工作经历',
	
	    // Salary
	    YEAR: '年',
	    MONTH: '月',
	    ACTUAL_SALARY: '实发工资',
	
	    // Team profile
	    ENTER_USER_SEARCH: '员工姓名、基本资料…',
	    NAME: '姓名',
	    POSITION: '职位',
	
	    // Leave
	    APPLY_LEAVE: '申请休假',
	    MY_APPLY: '我的申请',
	    LEAVE_QUOTA: '假期配额',
	    LEAVE_SUMMARY: '假期汇总',
	    APPLY_SUCCESS: '申请成功',
	    ALL: '全部',
	    TIME: '时间',
	    THIS_WEEK: '本周',
	    THIS_MONTH: '本月',
	    THIS_YEAR: '今年',
	    TYPE: '类型',
	    STATUS: '状态',
	    EDITING: '编辑中',
	    APPROVED: '已批准',
	    PENDING: '未审批',
	    REJECTED: '不批准',
	    APPROVE_ALL: '全部通过',
	    APPROVE_OPINION: '审批意见',
	    REJECT_ALL: '全部拒绝',
	    APPROVE: '通过',
	    REJECT: '拒绝',
	    HISTORY: '审批历史',
	    APP_DATE: '申请日期',
	    START_DATE: '开始日期',
	    END_DATE: '结束日期',
	
	    // Overtime
	    OT_SUMMARY: '加班汇总',
	
	    // Validation
	    REQUIRED: '必填',
	
	    // Pull loader
	    PULL_TO_LOAD: '上拉加载更多',
	    NO_MORE_DATA: '没有更多数据了',
	
	    // Punctuation
	    COLON: '：',
	    COMMA: '，',
	
	    // Message
	    CONFIRM_MSG: '确认执行此操作',
	    //RepairClockIn
	    RCI_CHECK_DATA: '核算数据',
	    RCI_VIEW_DATA: '查看数据',
	    RCI_VIEW_INFO: '考勤信息',
	    RCI_REASON_REMARK: '原因 / 备注',
	    RCI_AUS_CHECK: '确认继续核算吗？',
	    RCI_INFO_TYPENAME: '班次名称',
	    RCI_INFO_CTIME: '上班时间',
	    RCI_INFO_ETIME: '下班时间',
	    RCI_INFO_EXEDESC: '异常原因',
	    RCI_INFO_LV: '迟到分钟数',
	    RCI_INFO_LE: '早退分钟数',
	    FORM_ADD_FIX: '添加附件'
	  },
	
	  en: {
	
	    // Login
	    COMPANY: 'Company',
	    EMAIL: 'Email',
	    USERNAME: 'User',
	    PASSWORD: 'Password',
	    LOGIN: 'Login',
	    REMEMBER: 'Remember me',
	    FORGOT_PWD: 'Forgot password',
	    COPYRIGHT: 'CDP © 2015 All rights reserved',
	
	    // Forgot password
	    MOBILE: 'Mobile',
	    CAPTCHA: 'Captcha',
	    GET_CAPTCHA: 'Get Captcha',
	    RETRY_CAPTCHA: 'seconds',
	    NEXT: 'Next',
	    NEW_PWD: 'New password',
	    REPEAT_PWD: 'Enter password again',
	    RESET_PWD: 'Reset Password',
	    AT_LEAST_6: 'At least 6 characters',
	    SAME_PWD: 'Must the same as password',
	    PWD_RESET_SUCCESS: 'Password reset succeeded.',
	
	    // Buttons
	    EDIT: 'Edit',
	    OK: 'Confirm',
	    CANCEL: 'Cancel',
	    SAVE: 'Save',
	    SUBMIT: 'Submit',
	    DROP: 'Drop',
	    REVOKE: 'Undo',
	    COMMIT_APPLY: 'Commit apply',
	
	    // HOME
	    EMPLOYEE: 'Employee',
	    MANAGER: 'Manager',
	
	    PROFILE: 'Profile',
	    MY_SALARY: 'My Salary',
	    MY_LEAVE: 'Leave',
	    MY_OT: 'Overtime',
	    MY_RCI: 'Repair timeclock',
	    TEAM_PROFILE: 'Team Profile',
	    LEAVE_MGR: 'Leave Management',
	    OT_MGR: 'Overtime Management',
	
	    CHANGE_PWD: 'Change Password',
	    CHANGE_MOBILE: 'Change Mobile',
	    LOGOUT: 'Log out',
	
	    // Mobile
	    NEW_MOBILE: 'New mobile number',
	    MOBILE_TIP: 'Please enter 11 digits',
	    EDIT_SUCCESS: 'Change succeeded.',
	    EDIT_FAIL: 'Change failed.',
	
	    // Password
	    OLD_PASSWORD: 'Current Password',
	
	    // Profile
	    WORK_EXP: 'Work Experience',
	
	    // Salary
	    YEAR: 'Year',
	    MONTH: 'Month',
	    ACTUAL_SALARY: 'Actual income',
	
	    // Team profile
	    ENTER_USER_SEARCH: 'Employee name, info, etc.',
	    NAME: 'Name',
	    POSITION: 'Position',
	
	    // Leave
	    APPLY_LEAVE: 'Apply for Leave',
	    MY_APPLY: 'Applications',
	    LEAVE_QUOTA: 'Quota',
	    LEAVE_SUMMARY: 'Summary',
	    APPLY_SUCCESS: 'Your application was successfully sent.',
	    ALL: 'All',
	    TIME: 'Time',
	    THIS_WEEK: 'This Week',
	    THIS_MONTH: 'This Month',
	    THIS_YEAR: 'This Year',
	    TYPE: 'Type',
	    STATUS: 'Status',
	    EDITING: 'Editing',
	    APPROVED: 'Approved',
	    PENDING: 'Pending',
	    REJECTED: 'Rejected',
	    APPROVE_ALL: 'Approve all',
	    APPROVE_OPINION: 'Approve opinion',
	    REJECT_ALL: 'Reject all',
	    APPROVE: 'Approve',
	    REJECT: 'Reject',
	    HISTORY: 'History',
	    APP_DATE: '申请日期',
	    START_DATE: '开始日期',
	    END_DATE: '结束日期',
	
	    // Overtime
	    OT_SUMMARY: 'Summary',
	
	    // Validation
	    REQUIRED: 'Required',
	
	    // Pull loader
	    PULL_TO_LOAD: 'Pull up to load more',
	    NO_MORE_DATA: 'No more data',
	
	    // Punctuation
	    COLON: ': ',
	    COMMA: ', ',
	
	    // Message
	    CONFIRM_MSG: 'Are you sure',
	    //RepairClockIn
	    RCI_CHECK_DATA: 'Accounting data',
	    RCI_VIEW_DATA: 'View data',
	    RCI_VIEW_INFO: 'Attendance info',
	    RCI_REASON_REMARK: 'Reason / remark',
	    RCI_AUS_CHECK: 'Confirm business accounting?',
	    RCI_INFO_TYPENAME: 'Type name',
	    RCI_INFO_CTIME: 'Working time',
	    RCI_INFO_ETIME: 'Closing time',
	    RCI_INFO_EXEDESC: 'Exception cause',
	    RCI_INFO_LV: 'Minutes to be late',
	    RCI_INFO_LE: 'Minutes before leave',
	    FORM_ADD_FIX: 'Add attachments'
	  },
	
	  jp: {
	
	    // Login
	    COMPANY: '株式会社',
	    EMAIL: '電子メール',
	    USERNAME: 'ユーザー',
	    PASSWORD: 'パスワード',
	    LOGIN: 'ログイン',
	    REMEMBER: '私を覚えて',
	    FORGOT_PWD: 'パスワードを忘れました',
	    COPYRIGHT: 'CDP © 2015 版権所有',
	
	    // Forgot password
	    MOBILE: '携帯電話',
	    CAPTCHA: 'キャプチャ',
	    GET_CAPTCHA: 'キャプチャを得る',
	    RETRY_CAPTCHA: '秒後リトライ',
	    NEXT: '次に',
	    NEW_PWD: '新パスワード',
	    REPEAT_PWD: 'パスワードを再入力',
	    RESET_PWD: 'パスワードをリセット',
	    AT_LEAST_6: '至少 6 位',
	    SAME_PWD: 'パスワードと同じなければならない',
	    PWD_RESET_SUCCESS: 'パスワードをリセットし',
	
	    // Buttons
	    EDIT: '編集',
	    OK: '確定',
	    CANCEL: 'キャンセル',
	    SAVE: '保存',
	    SUBMIT: '提交',
	    DROP: '删除',
	    REVOKE: 'キャンセル',
	    COMMIT_APPLY: '申請',
	
	    // HOME
	    EMPLOYEE: '従業員',
	    MANAGER: 'マネージャー',
	
	    PROFILE: 'プロフィール',
	    MY_SALARY: '私の給料',
	    MY_LEAVE: '休暇',
	    MY_OT: '残業',
	    MY_RCI: '補カード',
	    TEAM_PROFILE: 'チームプロフィール',
	    LEAVE_MGR: '休暇管理',
	    OT_MGR: '残業管理',
	
	    CHANGE_PWD: 'Change Password',
	    CHANGE_MOBILE: 'Change Mobile',
	    LOGOUT: 'ログアウト',
	
	    // Mobile
	    NEW_MOBILE: '新しい携帯電話号',
	    MOBILE_TIP: '11 位数字を入力してください。',
	    EDIT_SUCCESS: '改正成功',
	    EDIT_FAIL: '改正失敗',
	
	    // Password
	    OLD_PASSWORD: '現在のパスワード',
	
	    // Profile
	    WORK_EXP: '仕事の経歴',
	
	    // Salary
	    YEAR: '年',
	    MONTH: '月',
	    ACTUAL_SALARY: '実給料',
	
	    // Team profile
	    ENTER_USER_SEARCH: '社員の名前、情报…',
	    NAME: '名前',
	    POSITION: 'オフィス',
	
	    // Leave
	    APPLY_LEAVE: '申請する',
	    MY_APPLY: '私を申請',
	    LEAVE_QUOTA: '割当',
	    LEAVE_SUMMARY: 'まとめ',
	    APPLY_SUCCESS: '申請成功',
	    ALL: '全部',
	    TIME: '時間',
	    THIS_WEEK: '今週',
	    THIS_MONTH: '今月',
	    THIS_YEAR: '今年',
	    TYPE: 'タイプ',
	    STATUS: '状態',
	    APPROVED: 'すでに審査',
	    PENDING: '未承認',
	    REJECTED: 'すでに拒否',
	    APPROVE_ALL: '全て通し',
	    APPROVE_OPINION: '承認意見',
	    REJECT_ALL: '全部拒否',
	    APPROVE: '通し',
	    REJECT: '拒否',
	    HISTORY: '历史',
	    APP_DATE: '申请日期',
	    START_DATE: '开始日期',
	    END_DATE: '结束日期',
	
	    // Overtime
	    OT_SUMMARY: 'まとめ',
	
	    // Validation
	    REQUIRED: '必要です',
	
	    // Pull loader
	    PULL_TO_LOAD: 'プルアップ',
	    NO_MORE_DATA: 'もっとのデータがない',
	
	    // Punctuation
	    COLON: '：',
	    COMMA: '，',
	
	    // Message
	    CONFIRM_MSG: 'あなたがこれを行うにしてもよろしいですか',
	    //RepairClockIn
	    RCI_CHECK_DATA: '採算',
	    RCI_VIEW_DATA: 'データを見る',
	    RCI_VIEW_INFO: '勤怠情報',
	    RCI_REASON_REMARK: '原因 / 注',
	    RCI_AUS_CHECK: '計算を確認して確認します?',
	    RCI_INFO_TYPENAME: '型の名前',
	    RCI_INFO_CTIME: '作業時間',
	    RCI_INFO_ETIME: '終業時間',
	    RCI_INFO_EXEDESC: '例外の原因',
	    RCI_INFO_LV: '遅れる分',
	    RCI_INFO_LE: '去る前に分',
	    FORM_ADD_FIX: '添付ファイルを追加'
	  }
	};
	
	var bl = navigator.browserLanguage;
	var ls = navigator.languages;
	var l = navigator.language;
	
	var defaultLang = _commonUtilsCookies2['default'].getItem('lang') || bl && bl.split('-')[0] // IE11+
	 || ls && ls[0] && ls[0].split('-')[0] || l && l.split('-')[0];
	
	if (supported.indexOf(defaultLang) === -1) {
	  defaultLang = 'en';
	}
	
	exports['default'] = {
	
	  setLang: function setLang(code) {
	    defaultLang = code;
	    _commonUtilsCookies2['default'].setItem('lang', langMap[code]);
	  },
	
	  getLang: function getLang() {
	    return defaultLang;
	  },
	
	  getItem: function getItem(key) {
	    return lang[defaultLang][key] || '';
	  }
	};
	module.exports = exports['default'];

/***/ }),
/* 246 */
/***/ (function(module, exports) {

	/*\
	|*|
	|*|  :: cookies.js ::
	|*|
	|*|  A complete cookies reader/writer framework with full unicode support.
	|*|
	|*|  Revision #1 - September 4, 2014
	|*|
	|*|  https://developer.mozilla.org/en-US/docs/Web/API/document.cookie
	|*|  https://developer.mozilla.org/User:fusionchess
	|*|
	|*|  This framework is released under the GNU Public License, version 3 or later.
	|*|  http://www.gnu.org/licenses/gpl-3.0-standalone.html
	|*|
	|*|  Syntaxes:
	|*|
	|*|  * docCookies.setItem(name, value[, end[, path[, domain[, secure]]]])
	|*|  * docCookies.getItem(name)
	|*|  * docCookies.removeItem(name[, path[, domain]])
	|*|  * docCookies.hasItem(name)
	|*|  * docCookies.keys()
	|*|
	\*/
	
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = {
	  getItem: function getItem(sKey) {
	    if (!sKey) {
	      return null;
	    }
	    return decodeURIComponent(document.cookie.replace(new RegExp('(?:(?:^|.*;)\\s*' + encodeURIComponent(sKey).replace(/[\-\.\+\*]/g, '\\$&') + '\\s*\\=\\s*([^;]*).*$)|^.*$'), '$1')) || null;
	  },
	  setItem: function setItem(sKey, sValue, vEnd, sPath, sDomain, bSecure) {
	
	    if (!sKey || /^(?:expires|max\-age|path|domain|secure)$/i.test(sKey)) {
	      return false;
	    }
	    var sExpires = '';
	    if (vEnd) {
	      switch (vEnd.constructor) {
	        case Number:
	          sExpires = vEnd === Infinity ? '; expires=Fri, 31 Dec 9999 23:59:59 GMT' : '; max-age=' + vEnd;
	          break;
	        case String:
	          sExpires = '; expires=' + vEnd;
	          break;
	        case Date:
	          sExpires = '; expires=' + vEnd.toUTCString();
	          break;
	      }
	      //console.log('remmber_expires:'+sExpires);
	    }
	    document.cookie = encodeURIComponent(sKey) + '=' + encodeURIComponent(sValue) + sExpires + (sDomain ? '; domain=' + sDomain : '') + (sPath ? '; path=' + sPath : '') + (bSecure ? '; secure' : '');
	    return true;
	  },
	  removeItem: function removeItem(sKey, sPath, sDomain) {
	    if (!this.hasItem(sKey)) {
	      return false;
	    }
	    document.cookie = encodeURIComponent(sKey) + '=; expires=Thu, 01 Jan 1970 00:00:00 GMT' + (sDomain ? '; domain=' + sDomain : '') + (sPath ? '; path=' + sPath : '');
	    return true;
	  },
	  hasItem: function hasItem(sKey) {
	    if (!sKey) {
	      return false;
	    }
	    return new RegExp('(?:^|;\\s*)' + encodeURIComponent(sKey).replace(/[\-\.\+\*]/g, '\\$&') + '\\s*\\=').test(document.cookie);
	  },
	  keys: function keys() {
	    var aKeys = document.cookie.replace(/((?:^|\s*;)[^\=]+)(?=;|$)|^\s*|\s*(?:\=[^;]*)?(?:\1|$)/g, '').split(/\s*(?:\=[^;]*)?;\s*/);
	    for (var nLen = aKeys.length, nIdx = 0; nIdx < nLen; nIdx++) {
	      aKeys[nIdx] = decodeURIComponent(aKeys[nIdx]);
	    }
	    return aKeys;
	  }
	};
	module.exports = exports['default'];

/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Created by AshZhang on 15/9/25.
	 */
	
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	__webpack_require__(248);
	
	var _react = __webpack_require__(23);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ButtonButtonJsx = __webpack_require__(250);
	
	var _ButtonButtonJsx2 = _interopRequireDefault(_ButtonButtonJsx);
	
	var _DropdownDropdownJsx = __webpack_require__(256);
	
	var _DropdownDropdownJsx2 = _interopRequireDefault(_DropdownDropdownJsx);
	
	var Header = (function (_Component) {
	  _inherits(Header, _Component);
	
	  function Header() {
	    _classCallCheck(this, Header);
	
	    _get(Object.getPrototypeOf(Header.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(Header, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props;
	      var title = _props.title;
	      var iconLeft = _props.iconLeft;
	      var iconRight = _props.iconRight;
	      var onTapLeft = _props.onTapLeft;
	      var onTapRight = _props.onTapRight;
	      var back = _props.back;
	      var goBack = _props.goBack;
	      var dropdown = _props.dropdown;
	      var callback = _props.callback;
	
	      var buttonLeft = back || goBack ? _react2['default'].createElement(_ButtonButtonJsx2['default'], { className: 'header-icon-left',
	        icon: 'cdp-left-arrow',
	        iconType: 'icomoon',
	        onClick: callback ? callback : back ? this.back.bind(this, back) : this.goBack }) : iconLeft ? _react2['default'].createElement(_ButtonButtonJsx2['default'], { className: 'header-icon-left',
	        icon: iconLeft,
	        iconType: 'icomoon',
	        onClick: onTapLeft }) : null;
	      var buttonRight = iconRight ? _react2['default'].createElement(_ButtonButtonJsx2['default'], { className: 'header-icon-right',
	        icon: iconRight, iconType: ' icomoon',
	        onClick: onTapRight }) : null;
	      var dropdownMenu = dropdown ? _react2['default'].createElement(_DropdownDropdownJsx2['default'], dropdown) : null;
	
	      return _react2['default'].createElement(
	        'header',
	        null,
	        _react2['default'].createElement(
	          'h1',
	          null,
	          title
	        ),
	        buttonLeft,
	        buttonRight,
	        dropdownMenu,
	        this.props.children
	      );
	    }
	
	    /**
	     * `Back` event for `back` icon
	     */
	  }, {
	    key: 'back',
	    value: function back(hash) {
	      location.hash = typeof hash === 'string' ? hash : '';
	    }
	
	    /**
	     * `Back` event for `back` icon
	     */
	  }, {
	    key: 'goBack',
	    value: function goBack() {
	      history.back();
	    }
	  }]);
	
	  return Header;
	})(_react.Component);
	
	exports['default'] = Header;
	module.exports = exports['default'];

/***/ }),
/* 248 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 249 */,
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Created by AshZhang on 15/9/25.
	 */
	
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(23);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(251);
	
	var _IconIconJsx = __webpack_require__(253);
	
	var _IconIconJsx2 = _interopRequireDefault(_IconIconJsx);
	
	var Button = (function (_Component) {
	  _inherits(Button, _Component);
	
	  function Button() {
	    _classCallCheck(this, Button);
	
	    _get(Object.getPrototypeOf(Button.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(Button, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props;
	      var _props$type = _props.type;
	      var type = _props$type === undefined ? 'button' : _props$type;
	      var text = _props.text;
	      var icon = _props.icon;
	      var iconType = _props.iconType;
	      var action = _props.action;
	      var hollow = _props.hollow;
	      var link = _props.link;
	      var className = _props.className;
	      var submitting = _props.submitting;
	
	      var attr = _objectWithoutProperties(_props, ['type', 'text', 'icon', 'iconType', 'action', 'hollow', 'link', 'className', 'submitting']);
	
	      var btnClassName = (className || '') + (submitting ? ' btn-submitting' : '') + (hollow ? ' btn-hollow' : '') + (action ? ' btn-action' : '') + (link ? ' btn-link' : '');
	
	      return _react2['default'].createElement(
	        'button',
	        _extends({ type: type, className: btnClassName.trim() }, attr),
	        icon ? _react2['default'].createElement(_IconIconJsx2['default'], { name: icon, type: iconType, button: true }) : null,
	        submitting ? _react2['default'].createElement(_IconIconJsx2['default'], { name: 'spinner fa-pulse', button: true }) : null,
	        text
	      );
	    }
	  }]);
	
	  return Button;
	})(_react.Component);
	
	exports['default'] = Button;
	module.exports = exports['default'];

/***/ }),
/* 251 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 252 */,
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Created by AshZhang on 15/9/25.
	 */
	
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	__webpack_require__(254);
	
	var _react = __webpack_require__(23);
	
	var _react2 = _interopRequireDefault(_react);
	
	var Icon = (function (_Component) {
	  _inherits(Icon, _Component);
	
	  function Icon() {
	    _classCallCheck(this, Icon);
	
	    _get(Object.getPrototypeOf(Icon.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(Icon, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props;
	      var name = _props.name;
	      var button = _props.button;
	      var className = _props.className;
	      var type = _props.type;
	
	      return _react2['default'].createElement(
	        'i',
	        { className: (type ? 'icon-' + type + ' icon-' : 'fa fa-') + name + (button ? ' icon-button' : '') + (className ? ' ' + className : '') },
	        this.props.children
	      );
	    }
	  }]);
	
	  return Icon;
	})(_react.Component);
	
	exports['default'] = Icon;
	module.exports = exports['default'];

/***/ }),
/* 254 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 255 */,
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Created by AshZhang on 15/9/25.
	 */
	
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	__webpack_require__(257);
	
	var _react = __webpack_require__(23);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactLibReactCSSTransitionGroup = __webpack_require__(259);
	
	var _reactLibReactCSSTransitionGroup2 = _interopRequireDefault(_reactLibReactCSSTransitionGroup);
	
	var _commonUtilsDom = __webpack_require__(268);
	
	var _commonUtilsDom2 = _interopRequireDefault(_commonUtilsDom);
	
	var _ButtonButtonJsx = __webpack_require__(250);
	
	var _ButtonButtonJsx2 = _interopRequireDefault(_ButtonButtonJsx);
	
	var Dropdown = (function (_Component) {
	  _inherits(Dropdown, _Component);
	
	  function Dropdown(props) {
	    _classCallCheck(this, Dropdown);
	
	    _get(Object.getPrototypeOf(Dropdown.prototype), 'constructor', this).call(this, props);
	
	    this.state = {
	      opened: false
	    };
	
	    this.close = this.close.bind(this);
	    this.toggle = this.toggle.bind(this);
	    this._clickAwayClose = this._clickAwayClose.bind(this);
	  }
	
	  _createClass(Dropdown, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      document.addEventListener('touchend', this._clickAwayClose, false);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      document.removeEventListener('touchend', this._clickAwayClose, false);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this = this;
	
	      var _props = this.props;
	      var items = _props.items;
	      var onClickItem = _props.onClickItem;
	
	      var dropdownItems = this.state.opened ? _react2['default'].createElement(
	        'ul',
	        { className: 'dropdown' },
	        items.map(function (item, index) {
	          return _react2['default'].createElement(
	            'li',
	            { className: 'dropdown-item', key: index,
	              onClick: _this._clickItem.bind(_this, item.name) },
	            item.text
	          );
	        })
	      ) : null;
	
	      this.onClickItem = onClickItem;
	
	      return _react2['default'].createElement(
	        'div',
	        null,
	        _react2['default'].createElement(_ButtonButtonJsx2['default'], { className: 'dropdown-toggle', icon: 'cdp-point', iconType: 'icomoon', onTouchTap: this.toggle }),
	        _react2['default'].createElement(
	          _reactLibReactCSSTransitionGroup2['default'],
	          { component: 'div', transitionName: 'dropdown' },
	          dropdownItems
	        )
	      );
	    }
	
	    /**
	     * Test whether the dropdown is opened
	     * @returns {boolean}
	     */
	  }, {
	    key: 'isOpened',
	    value: function isOpened() {
	      return this.state.opened;
	    }
	
	    /**
	     * Open the dropdown
	     */
	  }, {
	    key: 'open',
	    value: function open() {
	      this.setState({
	        opened: true
	      });
	    }
	
	    /**
	     * Close the dropdown
	     */
	  }, {
	    key: 'close',
	    value: function close() {
	      this.setState({
	        opened: false
	      });
	    }
	
	    /**
	     * Toggle openedn status
	     */
	  }, {
	    key: 'toggle',
	    value: function toggle() {
	      this.setState({
	        opened: !this.state.opened
	      });
	    }
	
	    /**
	     * Triggers callback and close the dropdown
	     * @param {string} name
	     * @private
	     */
	  }, {
	    key: '_clickItem',
	    value: function _clickItem(name) {
	      if (typeof this.onClickItem === 'function') {
	        this.onClickItem.call(this, name);
	      }
	      this.close();
	    }
	
	    /**
	     * Click away to close
	     * @param {Event} e
	     * @private
	     */
	  }, {
	    key: '_clickAwayClose',
	    value: function _clickAwayClose(e) {
	      if (!_commonUtilsDom2['default'].contains(_react2['default'].findDOMNode(this), e.target)) {
	        this.close();
	      }
	    }
	  }]);
	
	  return Dropdown;
	})(_react.Component);
	
	exports['default'] = Dropdown;
	module.exports = exports['default'];

/***/ }),
/* 257 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 258 */,
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 * @providesModule ReactCSSTransitionGroup
	 */
	
	'use strict';
	
	var React = __webpack_require__(24);
	
	var assign = __webpack_require__(34);
	
	var ReactTransitionGroup = React.createFactory(
	  __webpack_require__(260)
	);
	var ReactCSSTransitionGroupChild = React.createFactory(
	  __webpack_require__(265)
	);
	
	var ReactCSSTransitionGroup = React.createClass({
	  displayName: 'ReactCSSTransitionGroup',
	
	  propTypes: {
	    transitionName: React.PropTypes.string.isRequired,
	    transitionAppear: React.PropTypes.bool,
	    transitionEnter: React.PropTypes.bool,
	    transitionLeave: React.PropTypes.bool
	  },
	
	  getDefaultProps: function() {
	    return {
	      transitionAppear: false,
	      transitionEnter: true,
	      transitionLeave: true
	    };
	  },
	
	  _wrapChild: function(child) {
	    // We need to provide this childFactory so that
	    // ReactCSSTransitionGroupChild can receive updates to name, enter, and
	    // leave while it is leaving.
	    return ReactCSSTransitionGroupChild(
	      {
	        name: this.props.transitionName,
	        appear: this.props.transitionAppear,
	        enter: this.props.transitionEnter,
	        leave: this.props.transitionLeave
	      },
	      child
	    );
	  },
	
	  render: function() {
	    return (
	      ReactTransitionGroup(
	        assign({}, this.props, {childFactory: this._wrapChild})
	      )
	    );
	  }
	});
	
	module.exports = ReactCSSTransitionGroup;


/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactTransitionGroup
	 */
	
	'use strict';
	
	var React = __webpack_require__(24);
	var ReactTransitionChildMapping = __webpack_require__(261);
	
	var assign = __webpack_require__(34);
	var cloneWithProps = __webpack_require__(262);
	var emptyFunction = __webpack_require__(37);
	
	var ReactTransitionGroup = React.createClass({
	  displayName: 'ReactTransitionGroup',
	
	  propTypes: {
	    component: React.PropTypes.any,
	    childFactory: React.PropTypes.func
	  },
	
	  getDefaultProps: function() {
	    return {
	      component: 'span',
	      childFactory: emptyFunction.thatReturnsArgument
	    };
	  },
	
	  getInitialState: function() {
	    return {
	      children: ReactTransitionChildMapping.getChildMapping(this.props.children)
	    };
	  },
	
	  componentWillMount: function() {
	    this.currentlyTransitioningKeys = {};
	    this.keysToEnter = [];
	    this.keysToLeave = [];
	  },
	
	  componentDidMount: function() {
	    var initialChildMapping = this.state.children;
	    for (var key in initialChildMapping) {
	      if (initialChildMapping[key]) {
	        this.performAppear(key);
	      }
	    }
	  },
	
	  componentWillReceiveProps: function(nextProps) {
	    var nextChildMapping = ReactTransitionChildMapping.getChildMapping(
	      nextProps.children
	    );
	    var prevChildMapping = this.state.children;
	
	    this.setState({
	      children: ReactTransitionChildMapping.mergeChildMappings(
	        prevChildMapping,
	        nextChildMapping
	      )
	    });
	
	    var key;
	
	    for (key in nextChildMapping) {
	      var hasPrev = prevChildMapping && prevChildMapping.hasOwnProperty(key);
	      if (nextChildMapping[key] && !hasPrev &&
	          !this.currentlyTransitioningKeys[key]) {
	        this.keysToEnter.push(key);
	      }
	    }
	
	    for (key in prevChildMapping) {
	      var hasNext = nextChildMapping && nextChildMapping.hasOwnProperty(key);
	      if (prevChildMapping[key] && !hasNext &&
	          !this.currentlyTransitioningKeys[key]) {
	        this.keysToLeave.push(key);
	      }
	    }
	
	    // If we want to someday check for reordering, we could do it here.
	  },
	
	  componentDidUpdate: function() {
	    var keysToEnter = this.keysToEnter;
	    this.keysToEnter = [];
	    keysToEnter.forEach(this.performEnter);
	
	    var keysToLeave = this.keysToLeave;
	    this.keysToLeave = [];
	    keysToLeave.forEach(this.performLeave);
	  },
	
	  performAppear: function(key) {
	    this.currentlyTransitioningKeys[key] = true;
	
	    var component = this.refs[key];
	
	    if (component.componentWillAppear) {
	      component.componentWillAppear(
	        this._handleDoneAppearing.bind(this, key)
	      );
	    } else {
	      this._handleDoneAppearing(key);
	    }
	  },
	
	  _handleDoneAppearing: function(key) {
	    var component = this.refs[key];
	    if (component.componentDidAppear) {
	      component.componentDidAppear();
	    }
	
	    delete this.currentlyTransitioningKeys[key];
	
	    var currentChildMapping = ReactTransitionChildMapping.getChildMapping(
	      this.props.children
	    );
	
	    if (!currentChildMapping || !currentChildMapping.hasOwnProperty(key)) {
	      // This was removed before it had fully appeared. Remove it.
	      this.performLeave(key);
	    }
	  },
	
	  performEnter: function(key) {
	    this.currentlyTransitioningKeys[key] = true;
	
	    var component = this.refs[key];
	
	    if (component.componentWillEnter) {
	      component.componentWillEnter(
	        this._handleDoneEntering.bind(this, key)
	      );
	    } else {
	      this._handleDoneEntering(key);
	    }
	  },
	
	  _handleDoneEntering: function(key) {
	    var component = this.refs[key];
	    if (component.componentDidEnter) {
	      component.componentDidEnter();
	    }
	
	    delete this.currentlyTransitioningKeys[key];
	
	    var currentChildMapping = ReactTransitionChildMapping.getChildMapping(
	      this.props.children
	    );
	
	    if (!currentChildMapping || !currentChildMapping.hasOwnProperty(key)) {
	      // This was removed before it had fully entered. Remove it.
	      this.performLeave(key);
	    }
	  },
	
	  performLeave: function(key) {
	    this.currentlyTransitioningKeys[key] = true;
	
	    var component = this.refs[key];
	    if (component.componentWillLeave) {
	      component.componentWillLeave(this._handleDoneLeaving.bind(this, key));
	    } else {
	      // Note that this is somewhat dangerous b/c it calls setState()
	      // again, effectively mutating the component before all the work
	      // is done.
	      this._handleDoneLeaving(key);
	    }
	  },
	
	  _handleDoneLeaving: function(key) {
	    var component = this.refs[key];
	
	    if (component.componentDidLeave) {
	      component.componentDidLeave();
	    }
	
	    delete this.currentlyTransitioningKeys[key];
	
	    var currentChildMapping = ReactTransitionChildMapping.getChildMapping(
	      this.props.children
	    );
	
	    if (currentChildMapping && currentChildMapping.hasOwnProperty(key)) {
	      // This entered again before it fully left. Add it again.
	      this.performEnter(key);
	    } else {
	      var newChildren = assign({}, this.state.children);
	      delete newChildren[key];
	      this.setState({children: newChildren});
	    }
	  },
	
	  render: function() {
	    // TODO: we could get rid of the need for the wrapper node
	    // by cloning a single child
	    var childrenToRender = [];
	    for (var key in this.state.children) {
	      var child = this.state.children[key];
	      if (child) {
	        // You may need to apply reactive updates to a child as it is leaving.
	        // The normal React way to do it won't work since the child will have
	        // already been removed. In case you need this behavior you can provide
	        // a childFactory function to wrap every child, even the ones that are
	        // leaving.
	        childrenToRender.push(cloneWithProps(
	          this.props.childFactory(child),
	          {ref: key, key: key}
	        ));
	      }
	    }
	    return React.createElement(
	      this.props.component,
	      this.props,
	      childrenToRender
	    );
	  }
	});
	
	module.exports = ReactTransitionGroup;


/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks static-only
	 * @providesModule ReactTransitionChildMapping
	 */
	
	'use strict';
	
	var ReactChildren = __webpack_require__(29);
	var ReactFragment = __webpack_require__(31);
	
	var ReactTransitionChildMapping = {
	  /**
	   * Given `this.props.children`, return an object mapping key to child. Just
	   * simple syntactic sugar around ReactChildren.map().
	   *
	   * @param {*} children `this.props.children`
	   * @return {object} Mapping of key to child
	   */
	  getChildMapping: function(children) {
	    if (!children) {
	      return children;
	    }
	    return ReactFragment.extract(ReactChildren.map(children, function(child) {
	      return child;
	    }));
	  },
	
	  /**
	   * When you're adding or removing children some may be added or removed in the
	   * same render pass. We want to show *both* since we want to simultaneously
	   * animate elements in and out. This function takes a previous set of keys
	   * and a new set of keys and merges them with its best guess of the correct
	   * ordering. In the future we may expose some of the utilities in
	   * ReactMultiChild to make this easy, but for now React itself does not
	   * directly have this concept of the union of prevChildren and nextChildren
	   * so we implement it here.
	   *
	   * @param {object} prev prev children as returned from
	   * `ReactTransitionChildMapping.getChildMapping()`.
	   * @param {object} next next children as returned from
	   * `ReactTransitionChildMapping.getChildMapping()`.
	   * @return {object} a key set that contains all keys in `prev` and all keys
	   * in `next` in a reasonable order.
	   */
	  mergeChildMappings: function(prev, next) {
	    prev = prev || {};
	    next = next || {};
	
	    function getValueForKey(key) {
	      if (next.hasOwnProperty(key)) {
	        return next[key];
	      } else {
	        return prev[key];
	      }
	    }
	
	    // For each key of `next`, the list of keys to insert before that key in
	    // the combined list
	    var nextKeysPending = {};
	
	    var pendingKeys = [];
	    for (var prevKey in prev) {
	      if (next.hasOwnProperty(prevKey)) {
	        if (pendingKeys.length) {
	          nextKeysPending[prevKey] = pendingKeys;
	          pendingKeys = [];
	        }
	      } else {
	        pendingKeys.push(prevKey);
	      }
	    }
	
	    var i;
	    var childMapping = {};
	    for (var nextKey in next) {
	      if (nextKeysPending.hasOwnProperty(nextKey)) {
	        for (i = 0; i < nextKeysPending[nextKey].length; i++) {
	          var pendingNextKey = nextKeysPending[nextKey][i];
	          childMapping[nextKeysPending[nextKey][i]] = getValueForKey(
	            pendingNextKey
	          );
	        }
	      }
	      childMapping[nextKey] = getValueForKey(nextKey);
	    }
	
	    // Finally, add the keys which didn't appear before any key in `next`
	    for (i = 0; i < pendingKeys.length; i++) {
	      childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
	    }
	
	    return childMapping;
	  }
	};
	
	module.exports = ReactTransitionChildMapping;


/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks static-only
	 * @providesModule cloneWithProps
	 */
	
	'use strict';
	
	var ReactElement = __webpack_require__(32);
	var ReactPropTransferer = __webpack_require__(263);
	
	var keyOf = __webpack_require__(60);
	var warning = __webpack_require__(36);
	
	var CHILDREN_PROP = keyOf({children: null});
	
	/**
	 * Sometimes you want to change the props of a child passed to you. Usually
	 * this is to add a CSS class.
	 *
	 * @param {ReactElement} child child element you'd like to clone
	 * @param {object} props props you'd like to modify. className and style will be
	 * merged automatically.
	 * @return {ReactElement} a clone of child with props merged in.
	 */
	function cloneWithProps(child, props) {
	  if (false) {
	    ("production" !== process.env.NODE_ENV ? warning(
	      !child.ref,
	      'You are calling cloneWithProps() on a child with a ref. This is ' +
	      'dangerous because you\'re creating a new child which will not be ' +
	      'added as a ref to its parent.'
	    ) : null);
	  }
	
	  var newProps = ReactPropTransferer.mergeProps(props, child.props);
	
	  // Use `child.props.children` if it is provided.
	  if (!newProps.hasOwnProperty(CHILDREN_PROP) &&
	      child.props.hasOwnProperty(CHILDREN_PROP)) {
	    newProps.children = child.props.children;
	  }
	
	  // The current API doesn't retain _owner and _context, which is why this
	  // doesn't use ReactElement.cloneAndReplaceProps.
	  return ReactElement.createElement(child.type, newProps);
	}
	
	module.exports = cloneWithProps;


/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactPropTransferer
	 */
	
	'use strict';
	
	var assign = __webpack_require__(34);
	var emptyFunction = __webpack_require__(37);
	var joinClasses = __webpack_require__(264);
	
	/**
	 * Creates a transfer strategy that will merge prop values using the supplied
	 * `mergeStrategy`. If a prop was previously unset, this just sets it.
	 *
	 * @param {function} mergeStrategy
	 * @return {function}
	 */
	function createTransferStrategy(mergeStrategy) {
	  return function(props, key, value) {
	    if (!props.hasOwnProperty(key)) {
	      props[key] = value;
	    } else {
	      props[key] = mergeStrategy(props[key], value);
	    }
	  };
	}
	
	var transferStrategyMerge = createTransferStrategy(function(a, b) {
	  // `merge` overrides the first object's (`props[key]` above) keys using the
	  // second object's (`value`) keys. An object's style's existing `propA` would
	  // get overridden. Flip the order here.
	  return assign({}, b, a);
	});
	
	/**
	 * Transfer strategies dictate how props are transferred by `transferPropsTo`.
	 * NOTE: if you add any more exceptions to this list you should be sure to
	 * update `cloneWithProps()` accordingly.
	 */
	var TransferStrategies = {
	  /**
	   * Never transfer `children`.
	   */
	  children: emptyFunction,
	  /**
	   * Transfer the `className` prop by merging them.
	   */
	  className: createTransferStrategy(joinClasses),
	  /**
	   * Transfer the `style` prop (which is an object) by merging them.
	   */
	  style: transferStrategyMerge
	};
	
	/**
	 * Mutates the first argument by transferring the properties from the second
	 * argument.
	 *
	 * @param {object} props
	 * @param {object} newProps
	 * @return {object}
	 */
	function transferInto(props, newProps) {
	  for (var thisKey in newProps) {
	    if (!newProps.hasOwnProperty(thisKey)) {
	      continue;
	    }
	
	    var transferStrategy = TransferStrategies[thisKey];
	
	    if (transferStrategy && TransferStrategies.hasOwnProperty(thisKey)) {
	      transferStrategy(props, thisKey, newProps[thisKey]);
	    } else if (!props.hasOwnProperty(thisKey)) {
	      props[thisKey] = newProps[thisKey];
	    }
	  }
	  return props;
	}
	
	/**
	 * ReactPropTransferer are capable of transferring props to another component
	 * using a `transferPropsTo` method.
	 *
	 * @class ReactPropTransferer
	 */
	var ReactPropTransferer = {
	
	  /**
	   * Merge two props objects using TransferStrategies.
	   *
	   * @param {object} oldProps original props (they take precedence)
	   * @param {object} newProps new props to merge in
	   * @return {object} a new object containing both sets of props merged.
	   */
	  mergeProps: function(oldProps, newProps) {
	    return transferInto(assign({}, oldProps), newProps);
	  }
	
	};
	
	module.exports = ReactPropTransferer;


/***/ }),
/* 264 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule joinClasses
	 * @typechecks static-only
	 */
	
	'use strict';
	
	/**
	 * Combines multiple className strings into one.
	 * http://jsperf.com/joinclasses-args-vs-array
	 *
	 * @param {...?string} classes
	 * @return {string}
	 */
	function joinClasses(className/*, ... */) {
	  if (!className) {
	    className = '';
	  }
	  var nextClass;
	  var argLength = arguments.length;
	  if (argLength > 1) {
	    for (var ii = 1; ii < argLength; ii++) {
	      nextClass = arguments[ii];
	      if (nextClass) {
	        className = (className ? className + ' ' : '') + nextClass;
	      }
	    }
	  }
	  return className;
	}
	
	module.exports = joinClasses;


/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 * @providesModule ReactCSSTransitionGroupChild
	 */
	
	'use strict';
	
	var React = __webpack_require__(24);
	
	var CSSCore = __webpack_require__(266);
	var ReactTransitionEvents = __webpack_require__(267);
	
	var onlyChild = __webpack_require__(173);
	var warning = __webpack_require__(36);
	
	// We don't remove the element from the DOM until we receive an animationend or
	// transitionend event. If the user screws up and forgets to add an animation
	// their node will be stuck in the DOM forever, so we detect if an animation
	// does not start and if it doesn't, we just call the end listener immediately.
	var TICK = 17;
	var NO_EVENT_TIMEOUT = 5000;
	
	var noEventListener = null;
	
	
	if (false) {
	  noEventListener = function() {
	    ("production" !== process.env.NODE_ENV ? warning(
	      false,
	      'transition(): tried to perform an animation without ' +
	      'an animationend or transitionend event after timeout (' +
	      '%sms). You should either disable this ' +
	      'transition in JS or add a CSS animation/transition.',
	      NO_EVENT_TIMEOUT
	    ) : null);
	  };
	}
	
	var ReactCSSTransitionGroupChild = React.createClass({
	  displayName: 'ReactCSSTransitionGroupChild',
	
	  transition: function(animationType, finishCallback) {
	    var node = this.getDOMNode();
	    var className = this.props.name + '-' + animationType;
	    var activeClassName = className + '-active';
	    var noEventTimeout = null;
	
	    var endListener = function(e) {
	      if (e && e.target !== node) {
	        return;
	      }
	      if (false) {
	        clearTimeout(noEventTimeout);
	      }
	
	      CSSCore.removeClass(node, className);
	      CSSCore.removeClass(node, activeClassName);
	
	      ReactTransitionEvents.removeEndEventListener(node, endListener);
	
	      // Usually this optional callback is used for informing an owner of
	      // a leave animation and telling it to remove the child.
	      if (finishCallback) {
	        finishCallback();
	      }
	    };
	
	    ReactTransitionEvents.addEndEventListener(node, endListener);
	
	    CSSCore.addClass(node, className);
	
	    // Need to do this to actually trigger a transition.
	    this.queueClass(activeClassName);
	
	    if (false) {
	      noEventTimeout = setTimeout(noEventListener, NO_EVENT_TIMEOUT);
	    }
	  },
	
	  queueClass: function(className) {
	    this.classNameQueue.push(className);
	
	    if (!this.timeout) {
	      this.timeout = setTimeout(this.flushClassNameQueue, TICK);
	    }
	  },
	
	  flushClassNameQueue: function() {
	    if (this.isMounted()) {
	      this.classNameQueue.forEach(
	        CSSCore.addClass.bind(CSSCore, this.getDOMNode())
	      );
	    }
	    this.classNameQueue.length = 0;
	    this.timeout = null;
	  },
	
	  componentWillMount: function() {
	    this.classNameQueue = [];
	  },
	
	  componentWillUnmount: function() {
	    if (this.timeout) {
	      clearTimeout(this.timeout);
	    }
	  },
	
	  componentWillAppear: function(done) {
	    if (this.props.appear) {
	      this.transition('appear', done);
	    } else {
	      done();
	    }
	  },
	
	  componentWillEnter: function(done) {
	    if (this.props.enter) {
	      this.transition('enter', done);
	    } else {
	      done();
	    }
	  },
	
	  componentWillLeave: function(done) {
	    if (this.props.leave) {
	      this.transition('leave', done);
	    } else {
	      done();
	    }
	  },
	
	  render: function() {
	    return onlyChild(this.props.children);
	  }
	});
	
	module.exports = ReactCSSTransitionGroupChild;


/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule CSSCore
	 * @typechecks
	 */
	
	var invariant = __webpack_require__(28);
	
	/**
	 * The CSSCore module specifies the API (and implements most of the methods)
	 * that should be used when dealing with the display of elements (via their
	 * CSS classes and visibility on screen. It is an API focused on mutating the
	 * display and not reading it as no logical state should be encoded in the
	 * display of elements.
	 */
	
	var CSSCore = {
	
	  /**
	   * Adds the class passed in to the element if it doesn't already have it.
	   *
	   * @param {DOMElement} element the element to set the class on
	   * @param {string} className the CSS className
	   * @return {DOMElement} the element passed in
	   */
	  addClass: function(element, className) {
	    ( false ? invariant(
	      !/\s/.test(className),
	      'CSSCore.addClass takes only a single class name. "%s" contains ' +
	      'multiple classes.', className
	    ) : invariant(!/\s/.test(className)));
	
	    if (className) {
	      if (element.classList) {
	        element.classList.add(className);
	      } else if (!CSSCore.hasClass(element, className)) {
	        element.className = element.className + ' ' + className;
	      }
	    }
	    return element;
	  },
	
	  /**
	   * Removes the class passed in from the element
	   *
	   * @param {DOMElement} element the element to set the class on
	   * @param {string} className the CSS className
	   * @return {DOMElement} the element passed in
	   */
	  removeClass: function(element, className) {
	    ( false ? invariant(
	      !/\s/.test(className),
	      'CSSCore.removeClass takes only a single class name. "%s" contains ' +
	      'multiple classes.', className
	    ) : invariant(!/\s/.test(className)));
	
	    if (className) {
	      if (element.classList) {
	        element.classList.remove(className);
	      } else if (CSSCore.hasClass(element, className)) {
	        element.className = element.className
	          .replace(new RegExp('(^|\\s)' + className + '(?:\\s|$)', 'g'), '$1')
	          .replace(/\s+/g, ' ') // multiple spaces to one
	          .replace(/^\s*|\s*$/g, ''); // trim the ends
	      }
	    }
	    return element;
	  },
	
	  /**
	   * Helper to add or remove a class from an element based on a condition.
	   *
	   * @param {DOMElement} element the element to set the class on
	   * @param {string} className the CSS className
	   * @param {*} bool condition to whether to add or remove the class
	   * @return {DOMElement} the element passed in
	   */
	  conditionClass: function(element, className, bool) {
	    return (bool ? CSSCore.addClass : CSSCore.removeClass)(element, className);
	  },
	
	  /**
	   * Tests whether the element has the class specified.
	   *
	   * @param {DOMNode|DOMWindow} element the element to set the class on
	   * @param {string} className the CSS className
	   * @return {boolean} true if the element has the class, false if not
	   */
	  hasClass: function(element, className) {
	    ( false ? invariant(
	      !/\s/.test(className),
	      'CSS.hasClass takes only a single class name.'
	    ) : invariant(!/\s/.test(className)));
	    if (element.classList) {
	      return !!className && element.classList.contains(className);
	    }
	    return (' ' + element.className + ' ').indexOf(' ' + className + ' ') > -1;
	  }
	
	};
	
	module.exports = CSSCore;


/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactTransitionEvents
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(72);
	
	/**
	 * EVENT_NAME_MAP is used to determine which event fired when a
	 * transition/animation ends, based on the style property used to
	 * define that event.
	 */
	var EVENT_NAME_MAP = {
	  transitionend: {
	    'transition': 'transitionend',
	    'WebkitTransition': 'webkitTransitionEnd',
	    'MozTransition': 'mozTransitionEnd',
	    'OTransition': 'oTransitionEnd',
	    'msTransition': 'MSTransitionEnd'
	  },
	
	  animationend: {
	    'animation': 'animationend',
	    'WebkitAnimation': 'webkitAnimationEnd',
	    'MozAnimation': 'mozAnimationEnd',
	    'OAnimation': 'oAnimationEnd',
	    'msAnimation': 'MSAnimationEnd'
	  }
	};
	
	var endEvents = [];
	
	function detectEvents() {
	  var testEl = document.createElement('div');
	  var style = testEl.style;
	
	  // On some platforms, in particular some releases of Android 4.x,
	  // the un-prefixed "animation" and "transition" properties are defined on the
	  // style object but the events that fire will still be prefixed, so we need
	  // to check if the un-prefixed events are useable, and if not remove them
	  // from the map
	  if (!('AnimationEvent' in window)) {
	    delete EVENT_NAME_MAP.animationend.animation;
	  }
	
	  if (!('TransitionEvent' in window)) {
	    delete EVENT_NAME_MAP.transitionend.transition;
	  }
	
	  for (var baseEventName in EVENT_NAME_MAP) {
	    var baseEvents = EVENT_NAME_MAP[baseEventName];
	    for (var styleName in baseEvents) {
	      if (styleName in style) {
	        endEvents.push(baseEvents[styleName]);
	        break;
	      }
	    }
	  }
	}
	
	if (ExecutionEnvironment.canUseDOM) {
	  detectEvents();
	}
	
	// We use the raw {add|remove}EventListener() call because EventListener
	// does not know how to remove event listeners and we really should
	// clean up. Also, these events are not triggered in older browsers
	// so we should be A-OK here.
	
	function addEventListener(node, eventName, eventListener) {
	  node.addEventListener(eventName, eventListener, false);
	}
	
	function removeEventListener(node, eventName, eventListener) {
	  node.removeEventListener(eventName, eventListener, false);
	}
	
	var ReactTransitionEvents = {
	  addEndEventListener: function(node, eventListener) {
	    if (endEvents.length === 0) {
	      // If CSS transitions are not supported, trigger an "end animation"
	      // event immediately.
	      window.setTimeout(eventListener, 0);
	      return;
	    }
	    endEvents.forEach(function(endEvent) {
	      addEventListener(node, endEvent, eventListener);
	    });
	  },
	
	  removeEndEventListener: function(node, eventListener) {
	    if (endEvents.length === 0) {
	      return;
	    }
	    endEvents.forEach(function(endEvent) {
	      removeEventListener(node, endEvent, eventListener);
	    });
	  }
	};
	
	module.exports = ReactTransitionEvents;


/***/ }),
/* 268 */
/***/ (function(module, exports) {

	/**
	 * DOM search and manipulation
	 */
	
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = {
	
	  /**
	   * Test whether `parent` contains or equals to `child`
	   * @param {HTMLElement} parent
	   * @param {HTMLElement} child
	   * @returns {boolean}
	   */
	  contains: function contains(parent, child) {
	
	    do {
	      if (parent === child) return true;
	      child = child.parentNode;
	    } while (child);
	
	    return false;
	  }
	};
	module.exports = exports['default'];

/***/ }),
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Created by AshZhang on 15/9/25.
	 */
	
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	__webpack_require__(270);
	
	var _react = __webpack_require__(23);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _IconIconJsx = __webpack_require__(253);
	
	var _IconIconJsx2 = _interopRequireDefault(_IconIconJsx);
	
	var Tab = (function (_Component) {
	  _inherits(Tab, _Component);
	
	  function Tab(props) {
	    _classCallCheck(this, Tab);
	
	    _get(Object.getPrototypeOf(Tab.prototype), 'constructor', this).call(this, props);
	
	    this.state = {
	      items: this.props.items
	    };
	  }
	
	  _createClass(Tab, [{
	    key: 'render',
	    value: function render() {
	      var _this = this;
	
	      var items = this.state.items;
	      var _props = this.props;
	      var bottom = _props.bottom;
	      var onActivate = _props.onActivate;
	      var tabClass = 'tab clearfix tab-count-' + items.length + (bottom ? ' tab-bottom' : '');
	      var style = {
	        width: 100 / items.length + '%'
	      };
	
	      this.onActivate = onActivate;
	
	      // Default active
	      if (!items.some(function (item) {
	        return item.active;
	      }) || items.filter(function (item) {
	        return item.active;
	      })[0] && location.hash.indexOf(items.filter(function (item) {
	        return item.active;
	      })[0].name) === -1) {
	        items.forEach(function (item) {
	          item.active = location.hash.indexOf(item.name) !== -1;
	        });
	
	        if (!items.some(function (item) {
	          return item.active;
	        })) {
	          items[0].active = true;
	        }
	      }
	
	      var tabItems = items.map(function (item, index) {
	        var className = 'tab-item' + (item.active ? ' active' : '');
	
	        return _react2['default'].createElement(
	          'a',
	          { className: className, key: index,
	            href: '#/' + item.name,
	            style: style,
	            onTouchTap: _this.activateTab.bind(_this, index) },
	          item.icon ? _react2['default'].createElement(_IconIconJsx2['default'], { name: item.icon, className: 'tab-icon' }) : null,
	          item.text,
	          item.notification ? _react2['default'].createElement('span', { className: 'tab-notification' }) : null
	        );
	      });
	
	      return _react2['default'].createElement(
	        'nav',
	        { className: tabClass },
	        tabItems,
	        bottom ? null : _react2['default'].createElement('div', { className: 'tab-active-line', style: { width: 100 / items.length + '%' } })
	      );
	    }
	
	    /**
	     * Activate a tab by index
	     * @param {number} index
	     */
	  }, {
	    key: 'activateTab',
	    value: function activateTab(index) {
	      var oldActiveItem = undefined,
	          activeItem = undefined;
	
	      this.state.items.forEach(function (item, itemIndex) {
	        if (item.active) {
	          oldActiveItem = item;
	        }
	
	        item.active = itemIndex === index;
	
	        if (item.active) {
	          activeItem = item;
	        }
	      });
	
	      if (oldActiveItem !== activeItem && typeof this.onActivate === 'function') {
	        this.onActivate.call(this, activeItem.name, index);
	      }
	
	      this.setState({
	        items: this.state.items
	      });
	    }
	  }]);
	
	  return Tab;
	})(_react.Component);
	
	exports['default'] = Tab;
	module.exports = exports['default'];

/***/ }),
/* 270 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 271 */,
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Created by AshZhang on 15/10/13.
	 */
	
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	__webpack_require__(273);
	
	var _react = __webpack_require__(23);
	
	var _react2 = _interopRequireDefault(_react);
	
	var SideNav = (function (_Component) {
	  _inherits(SideNav, _Component);
	
	  function SideNav(props) {
	    _classCallCheck(this, SideNav);
	
	    _get(Object.getPrototypeOf(SideNav.prototype), 'constructor', this).call(this, props);
	    this.state = {
	      opened: false
	    };
	    this.close = this.close.bind(this);
	  }
	
	  _createClass(SideNav, [{
	    key: 'render',
	    value: function render() {
	      var _this = this;
	
	      var _props$data = this.props.data;
	      var data = _props$data === undefined ? [] : _props$data;
	      var opened = this.state.opened;
	      var navClass = 'side-nav' + (opened ? ' opened' : '');
	
	      return _react2['default'].createElement(
	        'div',
	        null,
	        _react2['default'].createElement(
	          'nav',
	          { className: navClass },
	          data.map(function (item, index) {
	            return _react2['default'].createElement(
	              'a',
	              { className: 'side-nav-item', key: index,
	                href: item.link ? '#/' + item.link : null,
	                onClick: _this.onTouchTap.bind(_this, item.onTouchTap) },
	              item.text
	            );
	          })
	        ),
	        opened ? _react2['default'].createElement('div', { className: 'side-nav-cover', onTouchEnd: this.close }) : null
	      );
	    }
	
	    /**
	     * Open the nav
	     */
	  }, {
	    key: 'open',
	    value: function open() {
	      this.setState({
	        opened: true
	      });
	      document.body.classList.add('side-nav-opened');
	    }
	
	    /**
	     * Close the nav
	     */
	  }, {
	    key: 'close',
	    value: function close() {
	      var _this2 = this;
	
	      setTimeout(function () {
	        _this2.setState({
	          opened: false
	        });
	        document.body.classList.remove('side-nav-opened');
	      }, 300);
	    }
	
	    /**
	     * When a menu item is touched
	     * @param {Function} callback
	     */
	  }, {
	    key: 'onTouchTap',
	    value: function onTouchTap(callback) {
	      this.close();
	
	      if (typeof callback === 'function') {
	        callback();
	      }
	    }
	  }]);
	
	  return SideNav;
	})(_react.Component);
	
	exports['default'] = SideNav;
	module.exports = exports['default'];

/***/ }),
/* 273 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 274 */,
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Login page
	 */
	
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	__webpack_require__(276);
	
	var _objectAssign = __webpack_require__(279);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	var _react = __webpack_require__(23);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _fluxUtils = __webpack_require__(228);
	
	var _dispatcherDispatcher = __webpack_require__(223);
	
	var _commonLang = __webpack_require__(245);
	
	var _componentsButtonButtonJsx = __webpack_require__(250);
	
	var _componentsButtonButtonJsx2 = _interopRequireDefault(_componentsButtonButtonJsx);
	
	var _componentsFormFormJsx = __webpack_require__(280);
	
	var _componentsFormFormJsx2 = _interopRequireDefault(_componentsFormFormJsx);
	
	var _componentsFormControlFormControlJsx = __webpack_require__(291);
	
	var _componentsFormControlFormControlJsx2 = _interopRequireDefault(_componentsFormControlFormControlJsx);
	
	var _componentsPageOpenerPageOpenerJsx = __webpack_require__(294);
	
	var _componentsPageOpenerPageOpenerJsx2 = _interopRequireDefault(_componentsPageOpenerPageOpenerJsx);
	
	var _componentsTextInputTextInputJsx = __webpack_require__(283);
	
	var _componentsTextInputTextInputJsx2 = _interopRequireDefault(_componentsTextInputTextInputJsx);
	
	var _componentsAlertErrorBoxJsx = __webpack_require__(297);
	
	var _componentsAlertErrorBoxJsx2 = _interopRequireDefault(_componentsAlertErrorBoxJsx);
	
	var _ForgotStep1Jsx = __webpack_require__(300);
	
	var _ForgotStep1Jsx2 = _interopRequireDefault(_ForgotStep1Jsx);
	
	var _storesLoginStore = __webpack_require__(301);
	
	var _storesLoginStore2 = _interopRequireDefault(_storesLoginStore);
	
	var _storesUserStore = __webpack_require__(303);
	
	var _storesUserStore2 = _interopRequireDefault(_storesUserStore);
	
	var _dataUtilsUserDataUtils = __webpack_require__(302);
	
	var _dataUtilsUserDataUtils2 = _interopRequireDefault(_dataUtilsUserDataUtils);
	
	var _dataUtilsRepairClockInDataUtils = __webpack_require__(304);
	
	var _dataUtilsRepairClockInDataUtils2 = _interopRequireDefault(_dataUtilsRepairClockInDataUtils);
	
	var loginForm = [{
	  type: 'text',
	  id: 'company',
	  name: 'company',
	  icon: 'home',
	  placeholder: (0, _commonLang.getItem)('COMPANY'),
	  required: true
	}, {
	  type: 'text',
	  id: 'username',
	  name: 'username',
	  icon: 'user',
	  placeholder: (0, _commonLang.getItem)('USERNAME'),
	  required: true
	}, {
	  type: 'password',
	  id: 'password',
	  name: 'password',
	  icon: 'lock',
	  placeholder: (0, _commonLang.getItem)('PASSWORD'),
	  required: true
	}, {
	  type: 'checkbox',
	  id: 'remember',
	  name: 'remember',
	  placeholder: (0, _commonLang.getItem)('REMEMBER')
	}],
	    loginSubmit = {
	  text: (0, _commonLang.getItem)('LOGIN')
	},
	    resetForm = [{
	  type: 'password',
	  id: 'newPwd',
	  name: 'newPwd',
	  label: (0, _commonLang.getItem)('NEW_PWD'),
	  tips: (0, _commonLang.getItem)('AT_LEAST_6'),
	  required: true,
	  minLength: 6
	}, {
	  type: 'password',
	  id: 'repeatPwd',
	  name: 'repeatPwd',
	  label: (0, _commonLang.getItem)('REPEAT_PWD'),
	  tips: (0, _commonLang.getItem)('SAME_PWD'),
	  required: true,
	  minLength: 6
	}, {
	  type: 'hidden',
	  id: 'type',
	  name: 'type',
	  label: '',
	  tips: '',
	  value: 1
	}],
	    resetSubmit = {
	  text: (0, _commonLang.getItem)('RESET_PWD')
	};
	
	var Login = (function (_Component) {
	  _inherits(Login, _Component);
	
	  function Login(props) {
	    _classCallCheck(this, Login);
	
	    _get(Object.getPrototypeOf(Login.prototype), 'constructor', this).call(this, props);
	
	    this.login = this.login.bind(this);
	    this.openForgotPage = this.openForgotPage.bind(this);
	
	    //UserDataUtils.loginTests({username:'111'});
	  }
	
	  _createClass(Login, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var form = _react2['default'].findDOMNode(this.refs.loginForm),
	          logo = _react2['default'].findDOMNode(this.refs.logo),
	          inputs = [].slice.call(form.querySelectorAll('input'));
	
	      for (var i = 0; i < inputs.length; i += 1) {
	
	        inputs[i].addEventListener('focus', function () {
	          logo.classList.add('form-focus');
	        }, false);
	
	        inputs[i].addEventListener('blur', function (e) {
	          if (!e.relatedTarget || e.relatedTarget.nodeName !== 'BUTTON') {
	            logo.classList.remove('form-focus');
	          }
	        }, false);
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      if (this.state.loginStatus && this.state.loginStatus.indexOf('failed') > -1) {
	        this.refs.loginForm.setState({
	          submitting: false
	        });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state;
	      var captchaPass = _state.captchaPass;
	      var captchaTimer = _state.captchaTimer;
	      var reset = _state.reset;
	      var resetPass = _state.resetPass;
	      var savedLogin = _state.savedLogin;
	      var _state$accountType = _state.accountType;
	      var accountType = _state$accountType === undefined ? 1 : _state$accountType;
	
	      loginForm[0].defaultValue = savedLogin.company || '';
	      loginForm[1].defaultValue = savedLogin.username || '';
	      loginForm[3].defaultChecked = !!savedLogin.remember;
	
	      //set accountvalue
	      resetForm.map(function (item) {
	        if (item.id == 'type') {
	          ///console.log(resetForm);
	          item.value = accountType;
	        }
	      });
	
	      // var form = document.getElementById('changeEmpPasswordForm');
	      // var type = document.getElementById('changeEmpPasswordType');
	      // if (!type) {
	
	      // } else {
	      //   type.value = accountType;
	      // }
	
	      //Test api
	      return _react2['default'].createElement(
	        'div',
	        { className: 'login' },
	        _react2['default'].createElement('div', { className: 'login-logo', ref: 'logo' }),
	        _react2['default'].createElement(_componentsFormFormJsx2['default'], { className: 'login-form',
	          ref: 'loginForm',
	          controls: loginForm,
	          submitButton: loginSubmit,
	          onSubmit: this.login }),
	        _react2['default'].createElement(_componentsButtonButtonJsx2['default'], { className: 'login-forgot',
	          text: (0, _commonLang.getItem)('FORGOT_PWD'),
	          onClick: this.openForgotPage }),
	        _react2['default'].createElement(
	          'div',
	          { className: 'login-copyright' },
	          (0, _commonLang.getItem)('COPYRIGHT')
	        ),
	        _react2['default'].createElement(
	          _componentsPageOpenerPageOpenerJsx2['default'],
	          { ref: 'forgotPage', className: captchaPass && '' },
	          _react2['default'].createElement(_ForgotStep1Jsx2['default'], { captchaTimer: captchaTimer,
	            reset: reset })
	        ),
	        _react2['default'].createElement(
	          _componentsPageOpenerPageOpenerJsx2['default'],
	          { className: captchaPass && !resetPass ? 'opened' : '',
	            ref: 'resetPage', closed: this.closeResetPass },
	          _react2['default'].createElement(_componentsFormFormJsx2['default'], { className: 'login-reset-form',
	            id: 'changeEmpPasswordForm',
	            ref: 'resetPwdForm',
	            action: '/change-emp-password',
	            controls: resetForm,
	            submitButton: resetSubmit,
	            beforeSubmit: this.checkPwd,
	            afterSubmit: this.assureResetPwd })
	        )
	      );
	    }
	
	    //
	    //关闭重置密码回调
	  }, {
	    key: 'closeResetPass',
	    value: function closeResetPass() {
	      (0, _dispatcherDispatcher.dispatch)({ type: 'reset-check-captcha' });
	    }
	
	    // Login
	    // ---------------------------
	
	  }, {
	    key: 'login',
	    value: function login() {
	
	      _react2['default'].findDOMNode(this.refs.logo).classList.remove('form-focus');
	      // Remember me
	      (0, _dispatcherDispatcher.dispatch)({
	        type: 'toggle-remember',
	        data: {
	          remember: document.getElementById('remember').checked ? 1 : 0,
	          company: document.getElementById('company').value,
	          username: document.getElementById('username').value
	        }
	      });
	
	      // Login
	      (0, _dispatcherDispatcher.dispatch)({
	        type: 'login',
	        data: new FormData(_react2['default'].findDOMNode(this.refs.loginForm))
	      });
	    }
	
	    // Forgot password
	    // ---------------------------
	
	    /**
	     * Open `forgot password` page
	     * @param e
	     */
	  }, {
	    key: 'openForgotPage',
	    value: function openForgotPage(e) {
	      this.refs.forgotPage.open(e);
	    }
	
	    /**
	     * Check password and repeat password are the same
	     */
	  }, {
	    key: 'checkPwd',
	    value: function checkPwd() {
	      var pwd = document.getElementById('newPwd').value,
	          rpt = document.getElementById('repeatPwd').value;
	
	      if (pwd !== rpt) {
	        alert((0, _commonLang.getItem)('SAME_PWD'));
	        return false;
	      }
	    }
	
	    /**
	     * Password reset success
	     */
	  }, {
	    key: 'assureResetPwd',
	    value: function assureResetPwd() {
	      alert((0, _commonLang.getItem)('PWD_RESET_SUCCESS'));
	      (0, _dispatcherDispatcher.dispatch)({
	        type: 'reset-password-success'
	      });
	    }
	  }], [{
	    key: 'getStores',
	    value: function getStores() {
	      return [_storesLoginStore2['default'], _storesUserStore2['default']];
	    }
	  }, {
	    key: 'calculateState',
	    value: function calculateState() {
	      return (0, _objectAssign2['default'])({}, _storesLoginStore2['default'].getState(), _storesUserStore2['default'].getState());
	    }
	  }]);
	
	  return Login;
	})(_react.Component);
	
	exports['default'] = _fluxUtils.Container.create(Login);
	module.exports = exports['default'];

/***/ }),
/* 276 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Created by AshZhang on 15/9/29.
	 */
	
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	__webpack_require__(281);
	
	var _react = __webpack_require__(23);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _commonUtilsAjax = __webpack_require__(222);
	
	var _commonUtilsAjax2 = _interopRequireDefault(_commonUtilsAjax);
	
	var _ButtonButtonJsx = __webpack_require__(250);
	
	var _ButtonButtonJsx2 = _interopRequireDefault(_ButtonButtonJsx);
	
	var _TextInputTextInputJsx = __webpack_require__(283);
	
	var _TextInputTextInputJsx2 = _interopRequireDefault(_TextInputTextInputJsx);
	
	var _SelectSelectJsx = __webpack_require__(287);
	
	var _SelectSelectJsx2 = _interopRequireDefault(_SelectSelectJsx);
	
	var _CheckboxCheckboxJsx = __webpack_require__(288);
	
	var _CheckboxCheckboxJsx2 = _interopRequireDefault(_CheckboxCheckboxJsx);
	
	var _FormControlFormControlJsx = __webpack_require__(291);
	
	var _FormControlFormControlJsx2 = _interopRequireDefault(_FormControlFormControlJsx);
	
	var Form = (function (_Component) {
	  _inherits(Form, _Component);
	
	  function Form(props) {
	    _classCallCheck(this, Form);
	
	    _get(Object.getPrototypeOf(Form.prototype), 'constructor', this).call(this, props);
	    this.onSubmit = this.onSubmit.bind(this);
	    this.isValid = this.isValid.bind(this);
	
	    this.state = {
	      disabled: true,
	      submitting: false
	    };
	  }
	
	  _createClass(Form, [{
	    key: 'render',
	    value: function render() {
	      var _this = this;
	
	      var _props = this.props;
	      var submitButton = _props.submitButton;
	      var _props$controls = _props.controls;
	      var controls = _props$controls === undefined ? [] : _props$controls;
	      var onSubmit = _props.onSubmit;
	      var attrs = _objectWithoutProperties(_props, ['submitButton', 'controls', 'onSubmit']);
	      var controlElems = controls.map(function (control, index) {
	        var Control = undefined;
	
	        if (!control.id) {
	          control.id = control.name;
	        }
	
	        switch (control.type) {
	          case 'hidden':
	          case 'text':
	          case 'tel':
	          case 'password':
	          case 'date':
	          case 'datetime-local':
	          case 'file':
	            Control = _TextInputTextInputJsx2['default'];
	            // control.onChange = ((e)=>{
	            //   console.log(e.target.value);
	            //   //control.defaultValue = e.target.value;
	            //   this.setState({f:0});
	            // });
	            break;
	          case 'select':
	            Control = _SelectSelectJsx2['default'];
	            if (control.options && control.options[0] && control.options[0].text) {
	              control.options.unshift({
	                value: '',
	                text: ''
	              });
	            }
	            break;
	          case 'checkbox':
	            Control = _CheckboxCheckboxJsx2['default'];
	            break;
	        }
	        //alert(control.onChange);
	        return _react2['default'].createElement(
	          _FormControlFormControlJsx2['default'],
	          _extends({ key: index }, control),
	          _react2['default'].createElement(Control, _extends({}, control, { ref: control.id || control.name, onChange: control.onChange != undefined ? control.onChange : _this.isValid }))
	        );
	      });
	
	      return _react2['default'].createElement(
	        'form',
	        _extends({}, attrs, { onSubmit: this.onSubmit, noValidate: true }),
	        controlElems,
	        _react2['default'].createElement(
	          'div',
	          { className: 'form-submit' },
	          submitButton && _react2['default'].createElement(_ButtonButtonJsx2['default'], _extends({ type: 'submit' }, submitButton, {
	            disabled: this.state.disabled,
	            submitting: this.state.submitting }))
	        )
	      );
	    }
	
	    //默认显示file选中的内容
	  }, {
	    key: 'fileOnChange',
	    value: function fileOnChange() {}
	
	    /**
	     * Test if the form is valid
	     * @returns {boolean}
	     */
	  }, {
	    key: 'isValid',
	    value: function isValid() {
	      var _this2 = this;
	
	      var valid = true;
	
	      Object.keys(this.refs).forEach(function (refName) {
	        valid = _this2.refs[refName].isValid() && valid;
	      });
	
	      this.setState({
	        disabled: !valid
	      });
	
	      return valid;
	    }
	
	    /**
	     * Submit the form only if it's valid
	     * @param e
	     */
	  }, {
	    key: 'onSubmit',
	    value: function onSubmit(e) {
	      var _this3 = this;
	
	      e.preventDefault();
	
	      if (this.isValid()) {
	        this.setState({
	          disabled: true,
	          submitting: true
	        });
	
	        if (typeof this.props.onSubmit === 'function') {
	          this.props.onSubmit.call(this, e);
	        } else {
	          var formData = new FormData(_react2['default'].findDOMNode(this));
	          var beforeResult = null;
	
	          // If `.beforeSubmit()` returns false, don't post the form
	          if (typeof this.props.beforeSubmit === 'function') {
	            beforeResult = this.props.beforeSubmit.call(this);
	
	            if (beforeResult === false) {
	              return this.setState({
	                disabled: false,
	                submitting: false
	              });
	            }
	          }
	
	          // .afterSubmit(res)
	          //console.log(this.props.action);
	          _commonUtilsAjax2['default'].post(this.props.action, formData).then(function (res) {
	
	            _this3.setState({
	              disabled: false,
	              submitting: false
	            });
	            //console.log(res);
	            if (res != undefined) {
	              if (typeof _this3.props.afterSubmit === 'function') {
	                _this3.props.afterSubmit.call(_this3, res);
	              }
	            }
	          })['catch'](function (e) {
	            _this3.setState({
	              disabled: false,
	              submitting: false
	            });
	          });
	        }
	      }
	    }
	  }]);
	
	  return Form;
	})(_react.Component);
	
	exports['default'] = Form;
	module.exports = exports['default'];

/***/ }),
/* 281 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 282 */,
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Created by AshZhang on 15/9/28.
	 */
	
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	__webpack_require__(284);
	
	var _react = __webpack_require__(23);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mixinsFormValidationMixin = __webpack_require__(286);
	
	var _mixinsFormValidationMixin2 = _interopRequireDefault(_mixinsFormValidationMixin);
	
	var _IconIconJsx = __webpack_require__(253);
	
	var _IconIconJsx2 = _interopRequireDefault(_IconIconJsx);
	
	var TextInput = (function (_Component) {
	  _inherits(TextInput, _Component);
	
	  function TextInput(props) {
	    _classCallCheck(this, _TextInput);
	
	    _get(Object.getPrototypeOf(_TextInput.prototype), 'constructor', this).call(this, props);
	    this.onBlur = this.onBlur.bind(this);
	  }
	
	  _createClass(TextInput, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props;
	      var _props$type = _props.type;
	      var type = _props$type === undefined ? 'text' : _props$type;
	      var icon = _props.icon;
	
	      var attrs = _objectWithoutProperties(_props, ['type', 'icon']);
	
	      var input = _react2['default'].createElement('input', _extends({ type: type }, attrs, { onBlur: this.onBlur }));
	
	      return icon ? _react2['default'].createElement(
	        'div',
	        { className: 'text-input-with-icon' },
	        _react2['default'].createElement(_IconIconJsx2['default'], { name: icon, className: 'text-input-icon' }),
	        input
	      ) : input;
	    }
	  }]);
	
	  var _TextInput = TextInput;
	  TextInput = (0, _mixinsFormValidationMixin2['default'])(TextInput) || TextInput;
	  return TextInput;
	})(_react.Component);
	
	exports['default'] = TextInput;
	module.exports = exports['default'];

/***/ }),
/* 284 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 285 */,
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Created by AshZhang on 15/9/29.
	 */
	
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(23);
	
	var _react2 = _interopRequireDefault(_react);
	
	function getInput(node) {
	  var inputTypes = ['INPUT', 'SELECT', 'TEXTAREA'];
	
	  if (inputTypes.indexOf(node.nodeName) > -1) {
	    return node;
	  } else {
	    return node.querySelector('input, select, textarea');
	  }
	}
	
	exports['default'] = function (target) {
	
	  /**
	   * Validate the control
	   * @returns {boolean}
	   */
	  target.prototype.isValid = function () {
	    var input = getInput(_react2['default'].findDOMNode(this));
	    var valid = true;
	
	    if (!input) return valid;
	
	    var value = input.value;
	
	    if (this.props.required && !value) {
	      valid = false;
	    }
	
	    if (value) {
	      if (this.props.maxLength && value.length > this.props.maxLength) {
	        valid = false;
	      }
	
	      if (this.props.minLength && value.length < this.props.minLength) {
	        valid = false;
	      }
	
	      if (this.props.max && +value > +this.props.max) {
	        valid = false;
	      }
	
	      if (this.props.min && +value < +this.props.min) {
	        valid = false;
	      }
	    }
	
	    // Triggers `onValid` and `onInvalid`
	    if (valid) {
	      if (typeof this.props.onValid === 'function') {
	        this.props.onValid.call(this, value);
	      }
	    } else {
	      if (typeof this.props.onInvalid === 'function') {
	        this.props.onInvalid.call(this, value);
	      }
	    }
	
	    return valid;
	  };
	
	  /**
	   * Validate on blur
	   */
	  target.prototype.onBlur = function (e) {
	    this.isValid();
	
	    if (typeof this.props.onBlur === 'function') {
	      this.props.onBlur.call(this, e);
	    }
	  };
	};
	
	module.exports = exports['default'];

/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Created by AshZhang on 15/9/28.
	 */
	
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(23);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mixinsFormValidationMixin = __webpack_require__(286);
	
	var _mixinsFormValidationMixin2 = _interopRequireDefault(_mixinsFormValidationMixin);
	
	var Select = (function (_Component) {
	  _inherits(Select, _Component);
	
	  function Select(props) {
	    _classCallCheck(this, _Select);
	
	    _get(Object.getPrototypeOf(_Select.prototype), 'constructor', this).call(this, props);
	    this.onBlur = this.onBlur.bind(this);
	  }
	
	  _createClass(Select, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props;
	      var _props$options = _props.options;
	      var options = _props$options === undefined ? [] : _props$options;
	      var placeholder = _props.placeholder;
	
	      var attr = _objectWithoutProperties(_props, ['options', 'placeholder']);
	
	      return _react2['default'].createElement(
	        'select',
	        _extends({}, attr, { onBlur: this.onBlur }),
	        placeholder ? _react2['default'].createElement(
	          'option',
	          { value: '' },
	          placeholder
	        ) : null,
	        options.map(function (_ref, index) {
	          var text = _ref.text;
	          var value = _ref.value;
	          var name = _ref.name;
	
	          return _react2['default'].createElement(
	            'option',
	            { value: name || value, key: index },
	            text
	          );
	        })
	      );
	    }
	  }]);
	
	  var _Select = Select;
	  Select = (0, _mixinsFormValidationMixin2['default'])(Select) || Select;
	  return Select;
	})(_react.Component);
	
	exports['default'] = Select;
	module.exports = exports['default'];

/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Created by AshZhang on 15/9/28.
	 */
	
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	__webpack_require__(289);
	
	var _react = __webpack_require__(23);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mixinsFormValidationMixin = __webpack_require__(286);
	
	var _mixinsFormValidationMixin2 = _interopRequireDefault(_mixinsFormValidationMixin);
	
	var Checkbox = (function (_Component) {
	  _inherits(Checkbox, _Component);
	
	  function Checkbox(props) {
	    _classCallCheck(this, _Checkbox);
	
	    _get(Object.getPrototypeOf(_Checkbox.prototype), 'constructor', this).call(this, props);
	    this.onBlur = this.onBlur.bind(this);
	  }
	
	  _createClass(Checkbox, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props;
	      var placeholder = _props.placeholder;
	
	      var attrs = _objectWithoutProperties(_props, ['placeholder']);
	
	      return _react2['default'].createElement(
	        'label',
	        { className: 'checkbox' },
	        _react2['default'].createElement('input', _extends({ type: 'checkbox' }, attrs, { onBlur: this.onBlur })),
	        _react2['default'].createElement(
	          'span',
	          { className: 'checkbox-text' },
	          placeholder
	        )
	      );
	    }
	  }]);
	
	  var _Checkbox = Checkbox;
	  Checkbox = (0, _mixinsFormValidationMixin2['default'])(Checkbox) || Checkbox;
	  return Checkbox;
	})(_react.Component);
	
	exports['default'] = Checkbox;
	module.exports = exports['default'];

/***/ }),
/* 289 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 290 */,
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Created by AshZhang on 15/9/28.
	 */
	
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	__webpack_require__(292);
	
	var _react = __webpack_require__(23);
	
	var _react2 = _interopRequireDefault(_react);
	
	var FormControl = (function (_Component) {
	  _inherits(FormControl, _Component);
	
	  function FormControl(props) {
	    _classCallCheck(this, FormControl);
	
	    _get(Object.getPrototypeOf(FormControl.prototype), 'constructor', this).call(this, props);
	    this.onValid = this.onValid.bind(this);
	    this.onInvalid = this.onInvalid.bind(this);
	  }
	
	  _createClass(FormControl, [{
	    key: 'render',
	    value: function render() {
	      var _this = this;
	
	      var _props = this.props;
	      var label = _props.label;
	      var tips = _props.tips;
	      var className = _props.className;
	      var half = _props.half;
	
	      var controlClass = 'form-control' + (half ? ' form-control-half' : '') + (className ? ' ' + className : '');
	
	      var children = _react2['default'].Children.map(this.props.children, function (child) {
	        if (child.props.defaultValue !== void 0) {
	          controlClass += ' form-has-data';
	        }
	
	        if (child.props.isline === false) {
	          controlClass += ' form-control-half';
	        }
	
	        return _react2['default'].cloneElement(child, {
	          onValid: _this.onValid,
	          onInvalid: _this.onInvalid,
	          onFocus: _this.onFocus.bind(_this, child.props.onFocus),
	          onBlur: _this.onBlur.bind(_this, child.props.onBlur),
	          onChange: _this.onChange.bind(_this, child.props.onChange)
	        });
	      });
	
	      var tipEl = tips ? _react2['default'].createElement(
	        'span',
	        { className: 'form-tips' },
	        '(',
	        tips,
	        ')'
	      ) : null;
	
	      var labelEl = label ? _react2['default'].createElement(
	        'div',
	        { className: 'form-label' },
	        label,
	        tipEl
	      ) : null;
	
	      return _react2['default'].createElement(
	        'div',
	        { className: controlClass, style: { display: this.props.type === 'hidden' ? 'none' : 'block' } },
	        this.props.type === 'file' ? _react2['default'].createElement(
	          'div',
	          null,
	          this.props.defaultValue
	        ) : null,
	        labelEl,
	        children
	      );
	    }
	
	    /**
	     * `.form-valid` class
	     */
	  }, {
	    key: 'onValid',
	    value: function onValid() {
	      var control = _react2['default'].findDOMNode(this);
	
	      control.classList.remove('form-invalid');
	      control.classList.add('form-valid');
	    }
	
	    /**
	     * `.form-invalid` class
	     */
	  }, {
	    key: 'onInvalid',
	    value: function onInvalid() {
	      var control = _react2['default'].findDOMNode(this);
	
	      control.classList.remove('form-valid');
	      control.classList.add('form-invalid');
	    }
	
	    /**
	     * `.form-focus` class
	     */
	  }, {
	    key: 'onFocus',
	    value: function onFocus(cb, e) {
	      _react2['default'].findDOMNode(this).classList.add('form-focus');
	      cb && cb.call(null, e);
	    }
	
	    /**
	     * Check data
	     */
	  }, {
	    key: 'onChange',
	    value: function onChange(cb, e) {
	      var value = e.target.value,
	          classList = _react2['default'].findDOMNode(this).classList;
	
	      if (value) {
	        classList.add('form-has-data');
	      } else {
	        classList.remove('form-has-data');
	      }
	
	      cb && cb.call(null, e);
	    }
	
	    /**
	     * remove `.form-focus` class
	     */
	  }, {
	    key: 'onBlur',
	    value: function onBlur(cb, e) {
	      _react2['default'].findDOMNode(this).classList.remove('form-focus');
	      cb && cb.call(null, e);
	    }
	  }]);
	
	  return FormControl;
	})(_react.Component);
	
	exports['default'] = FormControl;
	module.exports = exports['default'];

/***/ }),
/* 292 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 293 */,
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Created by AshZhang on 15/10/3.
	 */
	
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	__webpack_require__(295);
	
	var _react = __webpack_require__(23);
	
	var _react2 = _interopRequireDefault(_react);
	
	var PageOpener = (function (_Component) {
	  _inherits(PageOpener, _Component);
	
	  function PageOpener(props) {
	    _classCallCheck(this, PageOpener);
	
	    _get(Object.getPrototypeOf(PageOpener.prototype), 'constructor', this).call(this, props);
	    this.close = this.close.bind(this);
	  }
	
	  _createClass(PageOpener, [{
	    key: 'render',
	    value: function render() {
	      var _props$className = this.props.className;
	      var className = _props$className === undefined ? '' : _props$className;
	
	      return _react2['default'].createElement(
	        'div',
	        { className: 'page-opener ' + className },
	        _react2['default'].createElement('i', { className: 'icon-icomoon icon-cdp-close page-closer', onTouchTap: this.close }),
	        this.props.children
	      );
	    }
	
	    /**
	     * Opens a page from certain origin
	     * @param e
	     */
	  }, {
	    key: 'open',
	    value: function open(e) {
	      var pX = e.clientX / window.innerWidth * 100 + '%',
	          pY = e.clientY / window.innerHeight * 100 + '%',
	          to = pX + ' ' + pY,
	          page = _react2['default'].findDOMNode(this);
	
	      page.style.transformOrigin = to;
	      page.style.webkitTransformOrigin = to;
	
	      page.classList.add('opened');
	      document.body.style.height = '100%';
	      document.body.style.overflow = 'hidden';
	    }
	
	    /**
	     * Close a page
	     */
	  }, {
	    key: 'close',
	    value: function close() {
	      _react2['default'].findDOMNode(this).classList.remove('opened');
	      document.body.style.height = '';
	      document.body.style.overflow = '';
	      //console.log(this.props.closed);
	
	      if (this.props.closed) {
	        this.props.closed();
	      }
	    }
	  }]);
	
	  return PageOpener;
	})(_react.Component);
	
	exports['default'] = PageOpener;
	module.exports = exports['default'];

/***/ }),
/* 295 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 296 */,
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(23);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(298);
	
	var ErrorBox = (function (_Component) {
	  _inherits(ErrorBox, _Component);
	
	  function ErrorBox(props) {
	    _classCallCheck(this, ErrorBox);
	
	    _get(Object.getPrototypeOf(ErrorBox.prototype), 'constructor', this).call(this, props);
	
	    this.state = {
	      message: ''
	    };
	    this.state.message = props.message || '';
	  }
	
	  _createClass(ErrorBox, [{
	    key: 'render',
	    value: function render() {
	      return _react2['default'].createElement(
	        'div',
	        { className: 'alert alert-error ' + (this.state.message != '' ? '' : 'hide'), ref: 'box' },
	        this.state.message
	      );
	    }
	  }]);
	
	  return ErrorBox;
	})(_react.Component);
	
	exports['default'] = ErrorBox;
	module.exports = exports['default'];

/***/ }),
/* 298 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 299 */,
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * 首页-》忘记密码
	 */
	
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(23);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _dispatcherDispatcher = __webpack_require__(223);
	
	var _commonLang = __webpack_require__(245);
	
	var _componentsFormControlFormControlJsx = __webpack_require__(291);
	
	var _componentsFormControlFormControlJsx2 = _interopRequireDefault(_componentsFormControlFormControlJsx);
	
	var _componentsTextInputTextInputJsx = __webpack_require__(283);
	
	var _componentsTextInputTextInputJsx2 = _interopRequireDefault(_componentsTextInputTextInputJsx);
	
	var _componentsButtonButtonJsx = __webpack_require__(250);
	
	var _componentsButtonButtonJsx2 = _interopRequireDefault(_componentsButtonButtonJsx);
	
	var _componentsAlertErrorBoxJsx = __webpack_require__(297);
	
	var _componentsAlertErrorBoxJsx2 = _interopRequireDefault(_componentsAlertErrorBoxJsx);
	
	var ForgotStep1 = (function (_Component) {
	  _inherits(ForgotStep1, _Component);
	
	  function ForgotStep1(props) {
	    _classCallCheck(this, ForgotStep1);
	
	    _get(Object.getPrototypeOf(ForgotStep1.prototype), 'constructor', this).call(this, props);
	    this.state = { accountType: 'phone', reset: false, captchaTimer: null };
	    this.getCaptcha = this.getCaptcha.bind(this);
	    this.validateMobile = this.validateMobile.bind(this);
	    this.validateEmail = this.validateEmail.bind(this);
	    this.validateNext = this.validateNext.bind(this);
	    this.checkCaptcha = this.checkCaptcha.bind(this);
	    this.chooseAccountType = this.chooseAccountType.bind(this);
	  }
	
	  _createClass(ForgotStep1, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props;
	      var _props$captchaTimer = _props.captchaTimer;
	      var captchaTimer = _props$captchaTimer === undefined ? 0 : _props$captchaTimer;
	      var reset = _props.reset;
	      var getCaptchaText = captchaTimer ? captchaTimer + ' ' + (0, _commonLang.getItem)('RETRY_CAPTCHA') : (0, _commonLang.getItem)('GET_CAPTCHA');
	      var captchaDisabled = !!captchaTimer && !reset;
	      this.state.captchaTimer = captchaTimer;
	      //console.log(captchaTimer);
	      //console.log(this.state.captchaTimer);
	      return _react2['default'].createElement(
	        'div',
	        { className: 'login-forgot-page' },
	        _react2['default'].createElement(
	          'form',
	          { ref: 'captchaForm', className: 'login-forgot-form' },
	          _react2['default'].createElement('input', { type: 'hidden', ref: 'type', name: 'type', id: 'type' }),
	          _react2['default'].createElement(
	            'div',
	            { className: 'form-control form-control-radio' },
	            _react2['default'].createElement('input', { type: 'radio', ref: 'accountTypePhone', name: 'accountType', defaultChecked: true, onChange: this.chooseAccountType, value: 'phone' }),
	            '手机 ',
	            _react2['default'].createElement('input', { type: 'radio', ref: 'accountTypeEmail', name: 'accountType', onChange: this.chooseAccountType, value: 'email' }),
	            '邮箱'
	          ),
	          _react2['default'].createElement(
	            _componentsFormControlFormControlJsx2['default'],
	            { label: (0, _commonLang.getItem)('COMPANY'), tips: (0, _commonLang.getItem)('REQUIRED') },
	            _react2['default'].createElement(_componentsTextInputTextInputJsx2['default'], { ref: 'companyCode', id: 'companyCode', name: 'companyCode',
	              type: 'text', required: true,
	              onChange: this.validateMobile })
	          ),
	          _react2['default'].createElement(
	            _componentsFormControlFormControlJsx2['default'],
	            { label: (0, _commonLang.getItem)('MOBILE'), tips: (0, _commonLang.getItem)('REQUIRED'), type: this.state.accountType == 'phone' ? 'block' : 'hidden' },
	            _react2['default'].createElement(_componentsTextInputTextInputJsx2['default'], { ref: 'phone', id: 'phone', name: 'phone',
	              type: 'tel', required: true,
	              onChange: this.validateMobile, onBlur: this.validateMobile })
	          ),
	          _react2['default'].createElement(
	            _componentsFormControlFormControlJsx2['default'],
	            { label: (0, _commonLang.getItem)('EMAIL'), tips: (0, _commonLang.getItem)('REQUIRED'), type: 'hidden', type: this.state.accountType == 'email' ? 'block' : 'hidden' },
	            _react2['default'].createElement(_componentsTextInputTextInputJsx2['default'], { ref: 'email', id: 'email', name: 'email',
	              type: 'email', required: true,
	              onChange: this.validateMobile, onBlur: this.validateEmail })
	          ),
	          _react2['default'].createElement(
	            _componentsFormControlFormControlJsx2['default'],
	            { label: (0, _commonLang.getItem)('CAPTCHA'), tips: (0, _commonLang.getItem)('REQUIRED') },
	            _react2['default'].createElement(_componentsTextInputTextInputJsx2['default'], { id: 'captcha', name: 'captcha', ref: 'captcha', required: true, onChange: this.validateNext })
	          ),
	          _react2['default'].createElement(_componentsButtonButtonJsx2['default'], { ref: 'getCaptcha',
	            className: 'login-get-captcha', text: getCaptchaText, link: true,
	            onTouchTap: captchaDisabled ? function () {} : this.getCaptcha }),
	          _react2['default'].createElement('input', { type: 'hidden', ref: 'accountType' })
	        ),
	        _react2['default'].createElement(_componentsAlertErrorBoxJsx2['default'], { ref: 'errorBox' }),
	        _react2['default'].createElement(_componentsButtonButtonJsx2['default'], { ref: 'next',
	          className: 'login-reset-pwd', text: (0, _commonLang.getItem)('NEXT'),
	          onTouchTap: this.checkCaptcha, disabled: true })
	      );
	    }
	
	    /**
	     * choose account type (phone or email)
	     * 
	     * @memberof event
	     */
	  }, {
	    key: 'chooseAccountType',
	    value: function chooseAccountType(e) {
	      if (e.target.value == 'phone') {
	        _react2['default'].findDOMNode(this.refs.accountTypePhone).checked = 'checked';
	        _react2['default'].findDOMNode(this.refs.email).value = '1@1.com'; //test
	        this.setState({ accountType: 'phone' });
	      } else {
	        var email = _react2['default'].findDOMNode(this.refs.accountTypeEmail);
	        email.checked = 'checked';
	        _react2['default'].findDOMNode(this.refs.phone).value = '15800000000'; //test
	        this.setState({ accountType: 'email' });
	      }
	    }
	
	    /**
	     *  验证邮箱
	     */
	  }, {
	    key: 'validateEmail',
	    value: function validateEmail() {
	      var item = _react2['default'].findDOMNode(this.refs.email).value;
	      var matchEmail = /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})$/;
	      var emailValid = matchEmail.test(item);
	
	      if (!emailValid) {
	        this.refs.errorBox.setState({ message: '邮箱格式有误' });
	        return false;
	      }
	      this.refs.errorBox.setState({ message: '' });
	      return true;
	    }
	
	    /**
	    * 验证手机号
	    */
	
	  }, {
	    key: 'validateMobile',
	    value: function validateMobile() {
	      var item = _react2['default'].findDOMNode(this.refs.phone).value;
	
	      var mobileValid = true;
	      var emailValid = true;
	      //check mobile
	      if (item.length < 11) {
	        mobileValid = false;
	      }
	
	      if (!mobileValid) {
	        this.refs.errorBox.setState({ message: '手机号格式有误' });
	        return false;
	      }
	      this.refs.errorBox.setState({ message: '' });
	      return true;
	    }
	
	    /**
	     * Get captcha
	     */
	  }, {
	    key: 'getCaptcha',
	    value: function getCaptcha() {
	      //const { captchaTimer = 100 } = this.props;
	      //alert(this.refs.errorBox)
	      //console.log(this.props.captchaTimer);
	      //console.log(this.state.captchaTimer);
	      // if(this.state.captchaTimer == undefined)
	      //     this.state.captchaTimer = 1;
	      //console.log(captchaTimer);
	      if (this.props.captchaTimer == null || this.props.captchaTimer == 0) {
	        //if (captchaTimer != 100) {
	        if (this.state.accountType == 'phone') {
	          if (this.validateMobile()) {
	            (0, _dispatcherDispatcher.dispatch)({
	              type: 'get-captcha',
	              data: {
	                type: this.state.accountType,
	                email: _react2['default'].findDOMNode(this.refs.email).value,
	                phone: _react2['default'].findDOMNode(this.refs.phone).value,
	                companyCode: _react2['default'].findDOMNode(this.refs.companyCode).value
	              }
	            });
	          }
	        } else {
	          if (this.validateEmail()) {
	            (0, _dispatcherDispatcher.dispatch)({
	              type: 'get-captcha',
	              data: {
	                type: this.state.accountType,
	                email: _react2['default'].findDOMNode(this.refs.email).value,
	                phone: _react2['default'].findDOMNode(this.refs.phone).value,
	                companyCode: _react2['default'].findDOMNode(this.refs.companyCode).value
	              }
	            });
	          }
	        }
	        //}
	        //console.log('能');
	      } else {
	          //console.log('不能');
	        }
	    }
	
	    /**
	     * Check if can go to next step
	     * @param e
	     */
	  }, {
	    key: 'validateNext',
	    value: function validateNext(e) {
	      var captcha = e.target.value,
	          valid = this.validateMobile() && captcha && captcha.length;
	
	      _react2['default'].findDOMNode(this.refs.next).disabled = !valid;
	
	      return valid;
	    }
	
	    /**
	     * Check captcha before resetting password
	     */
	  }, {
	    key: 'checkCaptcha',
	    value: function checkCaptcha() {
	      if (_react2['default'].findDOMNode(this.refs.captcha).value == '') {
	        this.refs.errorBox.setState({ message: 'Please enter the verification code' });
	      } else {
	        this.refs.errorBox.setState({ message: '' });
	        _react2['default'].findDOMNode(this.refs.type).value = this.state.accountType;
	        if (this.state.accountType == 'phone') {
	          _react2['default'].findDOMNode(this.refs.type).value = 1;
	        } else {
	          _react2['default'].findDOMNode(this.refs.type).value = 2;
	        }
	
	        var form = new FormData(_react2['default'].findDOMNode(this.refs.captchaForm));
	        form.accountType = _react2['default'].findDOMNode(this.refs.type).value;
	        (0, _dispatcherDispatcher.dispatch)({
	          type: 'check-captcha',
	          data: form
	        });
	      }
	    }
	  }]);
	
	  return ForgotStep1;
	})(_react.Component);
	
	exports['default'] = ForgotStep1;
	module.exports = exports['default'];

/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Login store
	 */
	
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _fluxUtils = __webpack_require__(228);
	
	var _dispatcherDispatcher = __webpack_require__(223);
	
	var _dispatcherDispatcher2 = _interopRequireDefault(_dispatcherDispatcher);
	
	var _objectAssign = __webpack_require__(279);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	var _dataUtilsUserDataUtils = __webpack_require__(302);
	
	var _dataUtilsUserDataUtils2 = _interopRequireDefault(_dataUtilsUserDataUtils);
	
	var LoginStore = (function (_ReduceStore) {
	  _inherits(LoginStore, _ReduceStore);
	
	  function LoginStore() {
	    _classCallCheck(this, LoginStore);
	
	    _get(Object.getPrototypeOf(LoginStore.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(LoginStore, [{
	    key: 'getInitialState',
	    value: function getInitialState() {
	      return {
	        captchaTimer: null,
	        reset: null
	      };
	    }
	  }, {
	    key: 'reduce',
	    value: function reduce(state, action) {
	      switch (action.type) {
	        case 'login':
	          _dataUtilsUserDataUtils2['default'].login(action.data);
	          break;
	        case 'login-fail':
	          return (0, _objectAssign2['default'])({}, state, {
	            loginStatus: 'failed' + Date.now()
	          });
	        case 'logout':
	          _dataUtilsUserDataUtils2['default'].logout();
	          break;
	        case 'login-tests-success':
	          //alert(JSON.stringify(action.data));
	          break;
	        case 'get-captcha':
	          _dataUtilsUserDataUtils2['default'].getCaptcha(action.data);
	          break;
	        case 'get-captcha-countdown':
	          return (0, _objectAssign2['default'])({}, state, {
	            captchaTimer: action.data,
	            reset: false,
	            resetPass: false
	          });
	        case 'get-captcha-fail':
	          return (0, _objectAssign2['default'])({}, state, {
	            captchaTimer: null,
	            reset: false,
	            resetPass: false
	          });
	        case 'get-captcha-success':
	          return (0, _objectAssign2['default'])({}, state, {
	            captchaTimer: action.data,
	            reset: true,
	            resetPass: true
	          });
	        case 'check-captcha':
	          _dataUtilsUserDataUtils2['default'].checkCaptcha(action.data);
	          break;
	        case 'check-captcha-success':
	          return (0, _objectAssign2['default'])({}, state, {
	            captchaPass: true,
	            resetPass: false,
	            accountType: action.data.type
	          });
	        case 'reset-check-captcha':
	          return (0, _objectAssign2['default'])({}, state, {
	            captchaPass: false,
	            resetPass: false,
	            accountType: 1
	          });
	        case 'reset-password-success':
	          return (0, _objectAssign2['default'])({}, state, {
	            //resetPass: true
	            captchaPass: false,
	            resetPass: false
	          });
	        default:
	      }
	
	      return state;
	    }
	  }]);
	
	  return LoginStore;
	})(_fluxUtils.ReduceStore);
	
	exports['default'] = new LoginStore(_dispatcherDispatcher2['default']);
	module.exports = exports['default'];

/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * User data utils
	 */
	
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _dispatcherDispatcher = __webpack_require__(223);
	
	var _dispatcherDispatcher2 = _interopRequireDefault(_dispatcherDispatcher);
	
	var _commonUtilsAjax = __webpack_require__(222);
	
	var _commonUtilsAjax2 = _interopRequireDefault(_commonUtilsAjax);
	
	var _commonUtilsCookies = __webpack_require__(246);
	
	var _commonUtilsCookies2 = _interopRequireDefault(_commonUtilsCookies);
	
	var _commonLang = __webpack_require__(245);
	
	var _commonLang2 = _interopRequireDefault(_commonLang);
	
	exports['default'] = {
	
	  readCookie: function readCookie() {
	    var result = {};
	
	    _commonUtilsCookies2['default'].keys().forEach(function (key) {
	      result[key] = _commonUtilsCookies2['default'].getItem(key);
	    });
	
	    return result;
	  },
	
	  /**
	   * @params {Object} data
	   */
	  toggleRemember: function toggleRemember(data) {
	
	    if (data.remember) {
	      Object.keys(data).forEach(function (key) {
	        //1 month
	        _commonUtilsCookies2['default'].setItem(key, data[key], 2592000);
	      });
	    } else {
	      Object.keys(data).forEach(function (key) {
	        _commonUtilsCookies2['default'].removeItem(key);
	      });
	    }
	  },
	  /**
	   * for tests
	   * 
	   * @param {any} data 
	   */
	  loginTests: function loginTests(data) {
	    _commonUtilsAjax2['default'].get('/login-tests', data).then(function (res) {
	      (0, _dispatcherDispatcher.dispatch)({
	        type: 'login-tests-success',
	        data: res
	      });
	    });
	  },
	
	  login: function login(data) {
	    _commonUtilsAjax2['default'].post('/login', data).then(function (res) {
	      _commonUtilsCookies2['default'].setItem('loggedIn', 1);
	      (0, _dispatcherDispatcher.dispatch)({
	        type: 'login-success',
	        data: res
	      });
	    })['catch'](function (e) {
	      (0, _dispatcherDispatcher.dispatch)({
	        type: 'login-fail',
	        data: e
	      });
	    });
	  },
	
	  logout: function logout() {
	    _commonUtilsAjax2['default'].get('/logout').then(function () {
	      _commonUtilsCookies2['default'].removeItem('loggedIn');
	
	      (0, _dispatcherDispatcher.dispatch)({
	        type: 'logout-success'
	      });
	    })['catch'](function (e) {
	      (0, _dispatcherDispatcher.dispatch)({
	        type: 'logout-fail',
	        error: e
	      });
	    });
	  },
	
	  setLang: function setLang(code) {
	    _commonUtilsAjax2['default'].post('/change-lang', {
	      langCode: code
	    }).then(function () {
	      _commonLang2['default'].setLang(code);
	      (0, _dispatcherDispatcher.dispatch)({
	        type: 'set-language-success',
	        data: code
	      });
	    });
	  },
	
	  // Forgot password type 1: 手机验证,2:邮箱验证
	  // ---------------------------
	
	  /**
	   * Get captcha for a mobile
	   */
	  getCaptcha: function getCaptcha(data) {
	    var timer = 61,
	        timeout = undefined;
	
	    function countDown() {
	      timer -= 1;
	
	      (0, _dispatcherDispatcher.dispatch)({
	        type: 'get-captcha-countdown',
	        data: timer
	      });
	
	      if (timer === 0) {
	        return clearTimeout(timeout);
	      }
	
	      timeout = setTimeout(countDown, 1000);
	    }
	
	    setTimeout(countDown, 0);
	
	    if (data.type == 'phone') {
	      _commonUtilsAjax2['default'].post('/validation-no', {
	        type: 1,
	        companyCode: data.companyCode,
	        phone: data.phone,
	        captcha: data.captcha
	      }).then(function (res) {
	        //alert(JSON.stringify(res));
	        if (res.res == false) {
	          alert(res.error);
	          (0, _dispatcherDispatcher.dispatch)({
	            type: 'get-captcha-fail'
	          });
	        } else {
	          (0, _dispatcherDispatcher.dispatch)({ type: 'get-captcha-success' });
	        }
	      })['catch'](function () {
	        //alert('ex');
	        clearTimeout(timeout);
	        (0, _dispatcherDispatcher.dispatch)({
	          type: 'get-captcha-fail'
	        });
	      });
	    } else {
	      // console.log('/validation-email');
	      // console.log({
	      //     type: 2,
	      //     companyCode: data.companyCode,
	      //     email: data.email,
	      //     captcha: data.captcha
	      //   });
	      _commonUtilsAjax2['default'].post('/validation-email', {
	        type: 2,
	        companyCode: data.companyCode,
	        email: data.email,
	        captcha: data.captcha
	      }).then(function (res) {
	        if (res.res == false) {
	          alert(res.error);
	          (0, _dispatcherDispatcher.dispatch)({
	            type: 'get-captcha-fail'
	          });
	        } else {
	          (0, _dispatcherDispatcher.dispatch)({ type: 'get-captcha-success' });
	        }
	      })['catch'](function (e) {
	        clearTimeout(timeout);
	        (0, _dispatcherDispatcher.dispatch)({
	          type: 'get-captcha-fail'
	        });
	      });
	    }
	  },
	
	  /**
	   * Check captcha
	   * formdata
	   * type 1=手机验证、2=邮箱验证（多加了个类型区别手机号邮箱）
	   */
	  checkCaptcha: function checkCaptcha(formData) {
	    //console.log(formData.accountType);
	    _commonUtilsAjax2['default'].post('/forget-password', formData).then(function (res) {
	      //console.log(res);
	      if (res.res == false) {
	        alert(res.error);
	      } else {
	        (0, _dispatcherDispatcher.dispatch)({
	          type: 'check-captcha-success',
	          data: { type: formData.accountType }
	        });
	      }
	    });
	  },
	
	  // Home
	  // ---------------------------
	
	  /**
	   * Get user identity and custom menu
	   */
	  getUserMenu: function getUserMenu() {
	    _commonUtilsAjax2['default'].get('/user-menu').then(function (res) {
	      (0, _dispatcherDispatcher.dispatch)({
	        type: 'get-user-menu-success',
	        data: res
	      });
	    });
	  },
	
	  // Confirm
	  // ---------------------------
	
	  confirmMobile: function confirmMobile() {
	    (0, _commonUtilsAjax.ajaxDispatch)({
	      action: 'confirm-mobile',
	      url: '/user-confirm',
	      method: 'get'
	    });
	  },
	
	  // Init Password
	  // ---------------------------
	
	  initPassword: function initPassword() {
	    (0, _commonUtilsAjax.ajaxDispatch)({
	      action: 'init-password',
	      url: '/init-change-password',
	      method: 'post'
	    });
	  }
	};
	module.exports = exports['default'];

/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Home store
	 */
	
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _fluxUtils = __webpack_require__(228);
	
	var _dispatcherDispatcher = __webpack_require__(223);
	
	var _dispatcherDispatcher2 = _interopRequireDefault(_dispatcherDispatcher);
	
	var _objectAssign = __webpack_require__(279);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	var _commonLang = __webpack_require__(245);
	
	var _commonLang2 = _interopRequireDefault(_commonLang);
	
	var _dataUtilsUserDataUtils = __webpack_require__(302);
	
	var _dataUtilsUserDataUtils2 = _interopRequireDefault(_dataUtilsUserDataUtils);
	
	var UserStore = (function (_ReduceStore) {
	  _inherits(UserStore, _ReduceStore);
	
	  function UserStore() {
	    _classCallCheck(this, UserStore);
	
	    _get(Object.getPrototypeOf(UserStore.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(UserStore, [{
	    key: 'getInitialState',
	    value: function getInitialState() {
	      var userCookie = _dataUtilsUserDataUtils2['default'].readCookie();
	      return {
	        loggedIn: userCookie.loggedIn,
	        lang: _commonLang2['default'].getLang(),
	        langList: localStorage.langList ? JSON.parse(localStorage.langList) : [],
	        savedLogin: userCookie,
	        basicInfo: userCookie,
	
	        // 0 - undefined
	        // 1 - employee
	        // 2 - manager
	        identity: 0,
	
	        menu: {}
	      };
	    }
	  }, {
	    key: 'reduce',
	    value: function reduce(state, action) {
	      action.data || (action.data = {});
	
	      switch (action.type) {
	        case 'login-success':
	          var data = (0, _objectAssign2['default'])({}, state, {
	            loggedIn: true,
	            basicInfo: (0, _objectAssign2['default'])(_dataUtilsUserDataUtils2['default'].readCookie(), action.data.userInfo),
	            companyCode: action.data.userInfo.companyCode,
	            langList: action.data.lang,
	            lang: action.data.lang[0].langCode
	          });
	          localStorage.mobile = action.data.userInfo.phone;
	          if (!action.data.userInfo.userFlag) localStorage.needConfirmMobile = 1;
	          if (!action.data.userInfo.userInitFlag) localStorage.needResetPassword = 1;
	          localStorage.langList = JSON.stringify(action.data.lang);
	          localStorage.companyCode = JSON.stringify(action.data.userInfo.companyCode);
	          _dataUtilsUserDataUtils2['default'].getUserMenu();
	          return data;
	        case 'login-success-confirm-mobile':
	          console.log(localStorage);
	          return data;
	        case 'login-failed':
	        case 'logout-success':
	          return (0, _objectAssign2['default'])({}, state, {
	            loggedIn: false,
	            basicInfo: {}
	          });
	        case 'toggle-remember':
	          _dataUtilsUserDataUtils2['default'].toggleRemember(action.data);
	          return (0, _objectAssign2['default'])({}, state, {
	            loggedIn: false,
	            basicInfo: {},
	            savedLogin: action.data.remember ? action.data : {}
	          });
	        case 'set-language':
	          _dataUtilsUserDataUtils2['default'].setLang(action.data);
	          break;
	        case 'set-language-success':
	          location.reload();
	          return (0, _objectAssign2['default'])({}, state, {
	            lang: action.data
	          });
	        case 'get-user-menu':
	          _dataUtilsUserDataUtils2['default'].getUserMenu();
	          break;
	        case 'get-user-menu-success':
	          var menu = action.data.menu;
	          return (0, _objectAssign2['default'])({}, state, action.data, {
	            isMrg: menu && menu.ess && menu.ess.length && menu.mss && menu.mss.length
	          });
	        case 'confirm-mobile-success':
	          localStorage.needConfirmMobile = 0;
	          return (0, _objectAssign2['default'])({}, state, {
	            basicInfo: (0, _objectAssign2['default'])({}, state.basicInfo, {
	              userFlag: 1
	            })
	          });
	        case 'init-password-success':
	          localStorage.needResetPassword = 0;
	          return (0, _objectAssign2['default'])({}, state, {
	            basicInfo: (0, _objectAssign2['default'])({}, state.basicInfo, {
	              userInitFlag: 1
	            })
	          });
	        case 'goback-confirm-mobile':
	          return (0, _objectAssign2['default'])({}, state, {
	            editting: false
	          });
	        default:
	      }
	
	      return state;
	    }
	  }]);
	
	  return UserStore;
	})(_fluxUtils.ReduceStore);
	
	exports['default'] = new UserStore(_dispatcherDispatcher2['default']);
	module.exports = exports['default'];

/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
		value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _dispatcherDispatcher = __webpack_require__(223);
	
	var _dispatcherDispatcher2 = _interopRequireDefault(_dispatcherDispatcher);
	
	var _commonUtilsAjax = __webpack_require__(222);
	
	var _commonUtilsAjax2 = _interopRequireDefault(_commonUtilsAjax);
	
	exports['default'] = {
		//
		//测试未使用
		getEmpRciList: function getEmpRciList(data) {
			(0, _commonUtilsAjax.ajaxDispatch)({
				action: 'get-emp-rci-list',
				url: '/ess-rci-list',
				method: 'get',
				data: data
			});
		},
		//
		//ess获取补打卡的异常数据
		getEmpRciExList: function getEmpRciExList(period) {
			//[{"att_exe_perid":"1126","att_exe_empid":"64656","att_exe_date":"2017-07-18 00:00:00.0","att_exe_typid":"1000","att_exe_typname":"常日班","att_exe_resid":"4","att_exe_resdesc":"未打卡","att_exe_ctime":"2017-07-18 08:30:00.0","att_exe_gtime":"2017-07-18 17:00:00.0","att_exe_actime":null,"att_exe_agtime":null,"att_exe_lv":null,"att_exe_le":null,"comp_lvcode":"10001000"}]
			if (period == 0) period = '';
			//console.log('/ess-exce-timeclock?period='+period);
			_commonUtilsAjax2['default'].get('/ess-exce-timeclock?period=' + period).then(function (res) {
				//console.log(res);
				(0, _dispatcherDispatcher.dispatch)({
					type: 'get-emp-rci-exlist',
					data: res
				});
			})['catch'](function (res) {
				console.log(res);
				(0, _dispatcherDispatcher.dispatch)({
					type: 'get-emp-rci-exlist',
					data: []
				});
			});
		},
		//
		//ess获取补打卡的异常单条数据信息
		getEmpRciExDetail: function getEmpRciExDetail(id) {
			console.log('/ess-att-exception-get?id=' + id);
			_commonUtilsAjax2['default'].get('/ess-att-exception-get?id=' + id).then(function (res) {
				console.log(res);
				(0, _dispatcherDispatcher.dispatch)({
					type: 'get-emp-rci-exlist-detail',
					data: res
				});
			})['catch'](function (res) {
				console.log(res);
			});
		},
		//获取异常数据的区间列表
		getEmpRciPeriodList: function getEmpRciPeriodList() {
			//[{"pla_per_id":"1117","pla_per_code":"201610"},{"pla_per_id":"1117","pla_per_code":"201610"}]
			//console.log('/get-period-list');
			_commonUtilsAjax2['default'].get('/get-period-list').then(function (res) {
				//console.log(JSON.stringify(res));
				res.map(function (item, index) {
					var year = item.pla_per_code.substring(0, 4);
					item.pla_per_code = item.pla_per_code.replace(year, '');
					item.pla_per_code = year + '-' + item.pla_per_code;
				});
				(0, _dispatcherDispatcher.dispatch)({
					type: 'get-emp-rci-period-list',
					data: res
				});
			})['catch'](function (res) {
				console.log(res);
			});
		},
		//核算数据根据周期ID
		checkRciExList: function checkRciExList(pid) {
			//console.log('/ess-calc-exce-timeclock?period='+pid);
			_commonUtilsAjax2['default'].get('/ess-calc-exce-timeclock?period=' + pid).then(function (res) {
				if (res.res == true) {
					alert('success');
					(0, _dispatcherDispatcher.dispatch)({
						type: 'check-rci-ex-list-success',
						data: pid
					});
				} else {
					alert(res.error);
				}
			})['catch'](function (res) {
				console.log(res);
			});
		},
		//获取补打卡的表单
		getRciApplyForm: function getRciApplyForm() {
			(0, _dispatcherDispatcher.dispatch)({
				type: 'get-rci-form'
			});
			_commonUtilsAjax2['default'].get('/ess-repair-timeclock-form').then(function (form) {
				//console.log(form);
				_commonUtilsAjax2['default'].getScript(form.JS_CONFIG_FILE).then(function () {
					(0, _dispatcherDispatcher.dispatch)({
						type: 'get-rci-form-success',
						data: form
					});
				});
			});
		},
		/**
	  * Get edit info
	  * @param id
	  */
		getRciEditApplyForm: function getRciEditApplyForm(id) {
			(0, _dispatcherDispatcher.dispatch)({
				type: 'get-rci-form'
			});
	
			_commonUtilsAjax2['default'].get('/ess-repair-timeclock-get', {
				id: id
			}).then(function (res) {
				//console.log(res);
				(0, _dispatcherDispatcher.dispatch)({
					type: 'get-rci-form-success',
					data: res
				});
			});
		},
		//
		//ess补打卡提交申请
		empRciApplyInsert: function empRciApplyInsert(formData, url) {
			// dispatch({
			// 	type: 'insert-rci-form'
			// });
			//console.log(url);
			// ajax.post(url, formData)
			// 	.then((res) => {
			// 		//console.log(JSON.stringify(res));
			// 		console.log(res);
			// 		// dispatch({
			// 		// 	type: 'get-emp-rci-period-list',
			// 		// 	data: res
			// 		// });
			// 	})
			// 	.catch((res) => {
			// 		console.log(res);
			// 	});
	
			(0, _commonUtilsAjax.ajaxDispatch)({
				action: 'insert-rci-form',
				url: url,
				method: 'post',
				data: formData
			})['catch'](function (e) {
				console.log(e);
			});
		},
		//
		//ess补打卡申请列表
		empRciApplyList: function empRciApplyList(data) {
			(0, _commonUtilsAjax.ajaxDispatch)({
				action: 'get-emp-rci-list',
				url: '/ess-repair-timeclock-list',
				method: 'get',
				data: data
			});
		},
		//获取单条补打卡信息
		empRciApplyGet: function empRciApplyGet(id) {
			(0, _commonUtilsAjax.ajaxDispatch)({
				action: 'get-emp-rci-record',
				url: '/ess-repair-timeclock-get',
				method: 'get',
				data: {
					id: id
				}
			});
		},
		//获取单条补打卡的信息，字段名+值
		empRciApplyRecord: function empRciApplyRecord(id) {
			(0, _commonUtilsAjax.ajaxDispatch)({
				action: 'get-emp-rci-record',
				url: '/ess-tc-detail',
				method: 'get',
				data: {
					id: id
				}
			});
		},
		//mss获取未审批的申请列表
		mssRciPendingRecords: function mssRciPendingRecords(query) {
			//console.log('/mss-timeclock-todolist');
			(0, _commonUtilsAjax.ajaxDispatch)({
				action: 'get-rci-pending-records',
				url: '/mss-timeclock-todolist',
				method: 'get',
				data: query
			});
		},
		//
		//MSS补打卡申请单审核【通过、拒绝】
		mssApproveRecord: function mssApproveRecord(data) {
			console.log(data);
			(0, _commonUtilsAjax.ajaxDispatch)({
				action: 'approve-rci-pending-record',
				url: '/mss-tc-approve',
				method: 'post',
				data: data
			});
		},
		getFilter: function getFilter(companyCode) {
			_commonUtilsAjax2['default'].get('/custom/config/' + companyCode + '_LV_STATE.json').then(function (res) {
				(0, _dispatcherDispatcher.dispatch)({
					type: 'get-rci-filter-success',
					data: res && res.items
				});
			});
		}
	};
	module.exports = exports['default'];

/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Created by AshZhang on 15/12/18.
	 */
	
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(23);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _fluxUtils = __webpack_require__(228);
	
	var _dispatcherDispatcher = __webpack_require__(223);
	
	var _commonLang = __webpack_require__(245);
	
	var _commonLang2 = _interopRequireDefault(_commonLang);
	
	var _dataUtilsUserDataUtils = __webpack_require__(302);
	
	var _dataUtilsUserDataUtils2 = _interopRequireDefault(_dataUtilsUserDataUtils);
	
	var _componentsButtonButtonJsx = __webpack_require__(250);
	
	var _componentsButtonButtonJsx2 = _interopRequireDefault(_componentsButtonButtonJsx);
	
	var _componentsFormControlFormControlJsx = __webpack_require__(291);
	
	var _componentsFormControlFormControlJsx2 = _interopRequireDefault(_componentsFormControlFormControlJsx);
	
	var _componentsTextInputTextInputJsx = __webpack_require__(283);
	
	var _componentsTextInputTextInputJsx2 = _interopRequireDefault(_componentsTextInputTextInputJsx);
	
	var _ConfigChangeMobileJsx = __webpack_require__(306);
	
	var _ConfigChangeMobileJsx2 = _interopRequireDefault(_ConfigChangeMobileJsx);
	
	var _storesUserStore = __webpack_require__(303);
	
	var _storesUserStore2 = _interopRequireDefault(_storesUserStore);
	
	var ConfirmMobile = (function (_Component) {
	  _inherits(ConfirmMobile, _Component);
	
	  _createClass(ConfirmMobile, null, [{
	    key: 'getStores',
	    value: function getStores() {
	      return [_storesUserStore2['default']];
	    }
	  }, {
	    key: 'calculateState',
	    value: function calculateState() {
	      return _storesUserStore2['default'].getState();
	    }
	  }]);
	
	  function ConfirmMobile(props) {
	    _classCallCheck(this, ConfirmMobile);
	
	    _get(Object.getPrototypeOf(ConfirmMobile.prototype), 'constructor', this).call(this, props);
	    this.edit = this.edit.bind(this);
	    this.state = {};
	  }
	
	  _createClass(ConfirmMobile, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {}
	  }, {
	    key: 'edit',
	    value: function edit() {
	      this.setState({
	        editting: true
	      });
	    }
	  }, {
	    key: 'confirm',
	    value: function confirm() {
	      _dataUtilsUserDataUtils2['default'].confirmMobile();
	    }
	  }, {
	    key: 'logout',
	    value: function logout() {
	      (0, _dispatcherDispatcher.dispatch)({
	        type: 'logout'
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var props = this.props;
	      var phone = undefined,
	          editting = undefined;
	
	      if (!props.phone) {
	        phone = localStorage.confirmMobilePhone;
	      } else {
	        phone = props.phone;
	      }
	
	      //alert(phone+' '+editting);
	      //alert(phone && !editting);
	      return phone && !this.state.editting ? _react2['default'].createElement(
	        'div',
	        { className: 'side-gap', style: { paddingTop: '2rem' } },
	        _react2['default'].createElement(
	          'form',
	          null,
	          _react2['default'].createElement(
	            'div',
	            { className: 'col-2-3' },
	            _react2['default'].createElement(
	              _componentsFormControlFormControlJsx2['default'],
	              { label: (0, _commonLang.getItem)('MOBILE') },
	              _react2['default'].createElement(_componentsTextInputTextInputJsx2['default'], { ref: 'mobile', id: 'mobile', name: 'mobile',
	                type: 'tel', defaultValue: phone, disabled: true })
	            )
	          ),
	          _react2['default'].createElement(
	            'div',
	            { className: 'col-1-3' },
	            _react2['default'].createElement(_componentsButtonButtonJsx2['default'], { text: (0, _commonLang.getItem)('EDIT'),
	              style: { position: 'relative', top: '1.3rem' },
	              link: true,
	              onTouchTap: this.edit })
	          )
	        ),
	        _react2['default'].createElement(_componentsButtonButtonJsx2['default'], { text: (0, _commonLang.getItem)('OK'),
	          onTouchTap: this.confirm }),
	        _react2['default'].createElement(_componentsButtonButtonJsx2['default'], { text: (0, _commonLang.getItem)('CANCEL'),
	          className: 'gap-t',
	          link: true,
	          onTouchTap: this.logout })
	      ) : _react2['default'].createElement(_ConfigChangeMobileJsx2['default'], { fromChangeMobile: '1' });
	    }
	  }]);
	
	  return ConfirmMobile;
	})(_react.Component);
	
	exports['default'] = _fluxUtils.Container.create(ConfirmMobile);
	module.exports = exports['default'];

/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * 修改手机号页
	 * 
	 */
	
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(23);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _fluxUtils = __webpack_require__(228);
	
	var _commonLang = __webpack_require__(245);
	
	var _commonUtilsAjax = __webpack_require__(222);
	
	var _commonUtilsAjax2 = _interopRequireDefault(_commonUtilsAjax);
	
	var _dispatcherDispatcher = __webpack_require__(223);
	
	var _componentsHeaderHeaderJsx = __webpack_require__(247);
	
	var _componentsHeaderHeaderJsx2 = _interopRequireDefault(_componentsHeaderHeaderJsx);
	
	var _componentsFormFormJsx = __webpack_require__(280);
	
	var _componentsFormFormJsx2 = _interopRequireDefault(_componentsFormFormJsx);
	
	var _componentsButtonButtonJsx = __webpack_require__(250);
	
	var _componentsButtonButtonJsx2 = _interopRequireDefault(_componentsButtonButtonJsx);
	
	var _ConfirmMobileConfirmMobile = __webpack_require__(305);
	
	var _ConfirmMobileConfirmMobile2 = _interopRequireDefault(_ConfirmMobileConfirmMobile);
	
	var _storesUserStore = __webpack_require__(303);
	
	var _storesUserStore2 = _interopRequireDefault(_storesUserStore);
	
	var changeMobileControls = [{
	  type: 'password',
	  id: 'password',
	  name: 'password',
	  label: (0, _commonLang.getItem)('PASSWORD'),
	  required: true
	}, {
	  type: 'tel',
	  id: 'mobile',
	  name: 'mobile',
	  label: (0, _commonLang.getItem)('NEW_MOBILE'),
	  minLength: 11,
	  maxLength: 11,
	  required: true,
	  tips: (0, _commonLang.getItem)('MOBILE_TIP')
	}, {
	  type: 'tel',
	  id: 'captcha',
	  name: 'captcha',
	  label: (0, _commonLang.getItem)('CAPTCHA'),
	  minLength: 6,
	  maxLength: 6,
	  required: true,
	  tips: (0, _commonLang.getItem)('REQUIRED')
	}];
	
	var submitButton = {
	  text: (0, _commonLang.getItem)('CHANGE_MOBILE')
	};
	
	var ChangeMobile = (function (_Component) {
	  _inherits(ChangeMobile, _Component);
	
	  _createClass(ChangeMobile, null, [{
	    key: 'getStores',
	    value: function getStores() {
	      return [_storesUserStore2['default']];
	    }
	  }, {
	    key: 'calculateState',
	    value: function calculateState() {
	      return _storesUserStore2['default'].getState();
	    }
	  }]);
	
	  function ChangeMobile(props) {
	    _classCallCheck(this, ChangeMobile);
	
	    _get(Object.getPrototypeOf(ChangeMobile.prototype), 'constructor', this).call(this, props);
	    this.getCaptcha = this.getCaptcha.bind(this);
	    this.state = {
	      captchaTimer: 0
	    };
	  }
	
	  _createClass(ChangeMobile, [{
	    key: 'render',
	    value: function render() {
	      var _state = this.state;
	      var captchaTimer = _state.captchaTimer;
	      var goback = _state.goback;
	      var getCaptchaText = captchaTimer ? captchaTimer + ' ' + (0, _commonLang.getItem)('RETRY_CAPTCHA') : (0, _commonLang.getItem)('GET_CAPTCHA');
	      var captchaDisabled = !!captchaTimer;
	      //console.log(captchaDisabled);
	      if (localStorage.mobile) {
	        changeMobileControls[1].defaultValue = localStorage.mobile;
	      }
	
	      var props = this.props;
	      this.state = { fromChangeMobile: props.fromChangeMobile };
	      return _react2['default'].createElement(
	        'div',
	        { style: { position: 'relative' } },
	        localStorage.mobile ? props.fromChangeMobile ? _react2['default'].createElement(_componentsHeaderHeaderJsx2['default'], { back: true, title: (0, _commonLang.getItem)('CHANGE_MOBILE'), callback: this.goback.bind(this) }) : _react2['default'].createElement(_componentsHeaderHeaderJsx2['default'], { back: true, title: (0, _commonLang.getItem)('CHANGE_MOBILE') }) : _react2['default'].createElement(_componentsHeaderHeaderJsx2['default'], { back: true, title: (0, _commonLang.getItem)('CHANGE_MOBILE'), callback: this.goLogout.bind(this) }),
	        _react2['default'].createElement(_componentsFormFormJsx2['default'], { action: '/change-mobile',
	          controls: changeMobileControls,
	          submitButton: submitButton,
	          className: 'side-gap gap-t-lg',
	          afterSubmit: this.getResult }),
	        _react2['default'].createElement(_componentsButtonButtonJsx2['default'], { ref: 'getCaptcha',
	          className: 'login-get-captcha',
	          style: { bottom: 'auto', top: '15.75rem' },
	          text: getCaptchaText, link: true,
	          onTouchTap: captchaDisabled ? function () {} : this.getCaptcha })
	      );
	    }
	  }, {
	    key: 'goback',
	    value: function goback() {
	      //alert('goback');
	      //alert(this.state.fromChangeMobile);
	      // this.setState({editting:false});
	      // this.setState({confirmMobilePhone: '158000448791'});
	      localStorage.confirmMobilePhone = localStorage.mobile;
	      localStorage.confirmMobileEditting = false;
	      location.reload();
	    }
	  }, {
	    key: 'goLogout',
	    value: function goLogout() {
	      (0, _dispatcherDispatcher.dispatch)({ type: 'logout' });
	    }
	  }, {
	    key: 'getCaptcha',
	    value: function getCaptcha() {
	
	      var timer = 61,
	          timeout = undefined,
	          mobile = document.getElementById('mobile').value,
	          self = this;
	
	      if (!/^\d{11}$/.test(mobile)) return;
	
	      function countDown() {
	        timer -= 1;
	
	        self.setState({
	          captchaTimer: timer
	        });
	
	        if (timer === 0) {
	          return clearTimeout(timeout);
	        }
	
	        timeout = setTimeout(countDown, 1000);
	      }
	
	      setTimeout(countDown, 0);
	
	      _commonUtilsAjax2['default'].post('/validation-no', {
	        type: 0,
	        phone: mobile
	      }).then(function (res) {
	        console.log(res);
	      })['catch'](function () {
	        clearTimeout(timeout);
	        self.setState({
	          captchaTime: 0
	        });
	      });
	    }
	
	    /**
	     * Get change mobile result
	     */
	  }, {
	    key: 'getResult',
	    value: function getResult() {
	      localStorage.needConfirmMobile = 0;
	      localStorage.mobile = document.getElementById('mobile').value;
	      alert((0, _commonLang.getItem)('EDIT_SUCCESS'));
	
	      if (location.hash.indexOf('change-mobile') > -1) {
	        history.back();
	      } else {
	        location.reload();
	      }
	    }
	  }]);
	
	  return ChangeMobile;
	})(_react.Component);
	
	exports['default'] = _fluxUtils.Container.create(ChangeMobile);
	module.exports = exports['default'];
	/* <a href='#' onClick={::this.goback}>b</a> */

/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * 重置密码页
	 */
	
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(23);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _dispatcherDispatcher = __webpack_require__(223);
	
	var _commonLang = __webpack_require__(245);
	
	var _commonLang2 = _interopRequireDefault(_commonLang);
	
	var _componentsFormFormJsx = __webpack_require__(280);
	
	var _componentsFormFormJsx2 = _interopRequireDefault(_componentsFormFormJsx);
	
	var _dataUtilsUserDataUtils = __webpack_require__(302);
	
	var _dataUtilsUserDataUtils2 = _interopRequireDefault(_dataUtilsUserDataUtils);
	
	var formData = [{
	  type: 'password',
	  id: 'newPwd',
	  name: 'newPwd',
	  label: (0, _commonLang.getItem)('NEW_PWD'),
	  tips: (0, _commonLang.getItem)('AT_LEAST_6'),
	  required: true,
	  minLength: 6
	}, {
	  type: 'password',
	  id: 'repeatPwd',
	  name: 'repeatPwd',
	  label: (0, _commonLang.getItem)('REPEAT_PWD'),
	  tips: (0, _commonLang.getItem)('SAME_PWD'),
	  required: true,
	  minLength: 6
	}],
	    resetSubmit = {
	  text: (0, _commonLang.getItem)('RESET_PWD')
	};
	
	var ConfirmMobile = (function (_Component) {
	  _inherits(ConfirmMobile, _Component);
	
	  function ConfirmMobile() {
	    _classCallCheck(this, ConfirmMobile);
	
	    _get(Object.getPrototypeOf(ConfirmMobile.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(ConfirmMobile, [{
	    key: 'confirm',
	    value: function confirm() {
	      (0, _dispatcherDispatcher.dispatch)({
	        type: 'init-password-success'
	      });
	    }
	
	    /**
	     * Check password and repeat password are the same
	     */
	  }, {
	    key: 'checkPwd',
	    value: function checkPwd() {
	      var pwd = document.getElementById('newPwd').value,
	          rpt = document.getElementById('repeatPwd').value;
	
	      if (pwd !== rpt) {
	        alert((0, _commonLang.getItem)('SAME_PWD'));
	        return false;
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2['default'].createElement(
	        'div',
	        { className: 'side-gap', style: { paddingTop: '2rem' } },
	        _react2['default'].createElement(_componentsFormFormJsx2['default'], { className: 'login-reset-form',
	          action: '/init-change-password',
	          controls: formData,
	          submitButton: resetSubmit,
	          beforeSubmit: this.checkPwd,
	          afterSubmit: this.confirm })
	      );
	    }
	  }]);
	
	  return ConfirmMobile;
	})(_react.Component);
	
	exports['default'] = ConfirmMobile;
	module.exports = exports['default'];

/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Employee Container
	 */
	
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(23);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _fluxUtils = __webpack_require__(228);
	
	var _objectAssign = __webpack_require__(279);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	var _homeMenuSettings = __webpack_require__(309);
	
	var _homeMenuSettings2 = _interopRequireDefault(_homeMenuSettings);
	
	var _componentsActionMenuActionMenuJsx = __webpack_require__(310);
	
	var _componentsActionMenuActionMenuJsx2 = _interopRequireDefault(_componentsActionMenuActionMenuJsx);
	
	var _storesUserStore = __webpack_require__(303);
	
	var _storesUserStore2 = _interopRequireDefault(_storesUserStore);
	
	var Employee = (function (_Component) {
	  _inherits(Employee, _Component);
	
	  function Employee() {
	    _classCallCheck(this, Employee);
	
	    _get(Object.getPrototypeOf(Employee.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(Employee, [{
	    key: 'render',
	    value: function render() {
	
	      return _react2['default'].createElement(_componentsActionMenuActionMenuJsx2['default'], { items: this.state.menu });
	    }
	  }], [{
	    key: 'getStores',
	    value: function getStores() {
	
	      return [_storesUserStore2['default']];
	    }
	  }, {
	    key: 'calculateState',
	    value: function calculateState() {
	      var empMenu = _storesUserStore2['default'].getState().menu.ess || [];
	      return {
	        menu: empMenu.map(function (item) {
	          return (0, _objectAssign2['default'])(item, _homeMenuSettings2['default'][item.name]);
	        })
	      };
	    }
	  }]);
	
	  return Employee;
	})(_react.Component);
	
	exports['default'] = _fluxUtils.Container.create(Employee);
	module.exports = exports['default'];

/***/ }),
/* 309 */
/***/ (function(module, exports) {

	/**
	 * Created by AshZhang on 15/10/7.
	 */
	
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = {
	
	  baseMessage: {
	    style: 1,
	    link: 'profile',
	    icon: 'user'
	  },
	  myPay: {
	    style: 2,
	    link: 'my-salary',
	    icon: 'money'
	  },
	  myVacation: {
	    style: 3,
	    link: 'my-leave',
	    icon: 'plane'
	  },
	  myOvertime: {
	    style: 4,
	    link: 'my-ot',
	    icon: 'clock'
	  },
	  CDPLife: {
	    style: 4,
	    link: 'my-ot',
	    icon: 'money'
	  },
	  myAttException: {
	    style: 4,
	    link: 'my-rci',
	    icon: 'attr icons-hammer'
	  },
	  leaveManagement: {
	    style: 5,
	    link: 'leave-mgr',
	    icon: 'plane'
	  },
	  overtimeManagement: {
	    style: 6,
	    link: 'ot-mgr',
	    icon: 'clock'
	  },
	  teamMessage: {
	    style: 7,
	    link: 'team-profile',
	    icon: 'users'
	  },
	  attExceptionManagement: {
	    style: 6,
	    link: 'rci-mgr',
	    icon: 'attr icons-hammer'
	  }
	
	};
	module.exports = exports['default'];

/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Created by AshZhang on 15/9/26.
	 */
	
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	__webpack_require__(311);
	
	var _react = __webpack_require__(23);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _IconIconJsx = __webpack_require__(253);
	
	var _IconIconJsx2 = _interopRequireDefault(_IconIconJsx);
	
	var ActionMenu = (function (_Component) {
	  _inherits(ActionMenu, _Component);
	
	  function ActionMenu() {
	    _classCallCheck(this, ActionMenu);
	
	    _get(Object.getPrototypeOf(ActionMenu.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(ActionMenu, [{
	    key: 'render',
	    value: function render() {
	      var items = this.props.items;
	      var menuItems = items.map(function (item, index) {
	        var style = item.style || 1,
	            className = 'action-menu-item action-menu-style-' + style + ' clearfix';
	        return _react2['default'].createElement(
	          'a',
	          { key: index,
	            href: item.url || '#/' + item.link,
	            className: className,
	            target: item.url ? '_blank' : '_self' },
	          _react2['default'].createElement(
	            'i',
	            { className: 'icon-fontello icon-' + item.icon + ' action-menu-icon' },
	            item.notification ? _react2['default'].createElement(
	              'span',
	              { className: 'action-menu-label' },
	              item.notification
	            ) : null
	          ),
	          _react2['default'].createElement(
	            'div',
	            { className: 'action-menu-text' },
	            item.text
	          ),
	          _react2['default'].createElement(
	            'div',
	            { className: 'action-menu-desc' },
	            item.content
	          )
	        );
	      });
	
	      return _react2['default'].createElement(
	        'nav',
	        { className: 'action-menu clearfix' },
	        menuItems
	      );
	    }
	  }]);
	
	  return ActionMenu;
	})(_react.Component);
	
	exports['default'] = ActionMenu;
	module.exports = exports['default'];

/***/ }),
/* 311 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 312 */,
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Manager Container
	 */
	
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(23);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _fluxUtils = __webpack_require__(228);
	
	var _objectAssign = __webpack_require__(279);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	var _commonLang = __webpack_require__(245);
	
	var _homeMenuSettings = __webpack_require__(309);
	
	var _homeMenuSettings2 = _interopRequireDefault(_homeMenuSettings);
	
	var _componentsActionMenuActionMenuJsx = __webpack_require__(310);
	
	var _componentsActionMenuActionMenuJsx2 = _interopRequireDefault(_componentsActionMenuActionMenuJsx);
	
	var _storesUserStore = __webpack_require__(303);
	
	var _storesUserStore2 = _interopRequireDefault(_storesUserStore);
	
	var Manager = (function (_Component) {
	  _inherits(Manager, _Component);
	
	  function Manager() {
	    _classCallCheck(this, Manager);
	
	    _get(Object.getPrototypeOf(Manager.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(Manager, [{
	    key: 'render',
	    value: function render() {
	      return _react2['default'].createElement(_componentsActionMenuActionMenuJsx2['default'], { items: this.state.menu });
	    }
	  }], [{
	    key: 'getStores',
	    value: function getStores() {
	      return [_storesUserStore2['default']];
	    }
	  }, {
	    key: 'calculateState',
	    value: function calculateState() {
	      var empMenu = _storesUserStore2['default'].getState().menu.mss || [];
	
	      return {
	        menu: empMenu.map(function (item) {
	          return (0, _objectAssign2['default'])(item, _homeMenuSettings2['default'][item.name]);
	        })
	      };
	    }
	  }]);
	
	  return Manager;
	})(_react.Component);
	
	exports['default'] = _fluxUtils.Container.create(Manager);
	module.exports = exports['default'];

/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Profile container
	 */
	
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(23);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _fluxUtils = __webpack_require__(228);
	
	var _dispatcherDispatcher = __webpack_require__(223);
	
	var _dispatcherDispatcher2 = _interopRequireDefault(_dispatcherDispatcher);
	
	var _objectAssign = __webpack_require__(279);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	var _commonLang = __webpack_require__(245);
	
	var _componentsHeaderHeaderJsx = __webpack_require__(247);
	
	var _componentsHeaderHeaderJsx2 = _interopRequireDefault(_componentsHeaderHeaderJsx);
	
	var _componentsLoaderLoaderJsx = __webpack_require__(315);
	
	var _componentsLoaderLoaderJsx2 = _interopRequireDefault(_componentsLoaderLoaderJsx);
	
	var _componentsUserInfoUserInfoJsx = __webpack_require__(318);
	
	var _componentsUserInfoUserInfoJsx2 = _interopRequireDefault(_componentsUserInfoUserInfoJsx);
	
	var _componentsInfoCardInfoCardJsx = __webpack_require__(322);
	
	var _componentsInfoCardInfoCardJsx2 = _interopRequireDefault(_componentsInfoCardInfoCardJsx);
	
	var _componentsTopActionTopActionJsx = __webpack_require__(325);
	
	var _componentsTopActionTopActionJsx2 = _interopRequireDefault(_componentsTopActionTopActionJsx);
	
	var _storesProfileStore = __webpack_require__(328);
	
	var _storesProfileStore2 = _interopRequireDefault(_storesProfileStore);
	
	var _storesUserStore = __webpack_require__(303);
	
	var _storesUserStore2 = _interopRequireDefault(_storesUserStore);
	
	var Profile = (function (_Component) {
	  _inherits(Profile, _Component);
	
	  function Profile(props) {
	    _classCallCheck(this, Profile);
	
	    _get(Object.getPrototypeOf(Profile.prototype), 'constructor', this).call(this, props);
	    this.getProfileCategories(this.props.params.id);
	  }
	
	  _createClass(Profile, [{
	    key: 'render',
	    value: function render() {
	      var _this = this;
	
	      var _state = this.state;
	      var basicInfo = _state.basicInfo;
	      var empId = _state.empId;
	      var _state$infoList = _state.infoList;
	      var infoList = _state$infoList === undefined ? [] : _state$infoList;
	      var status = _state.status;
	      var _state$picInfo = _state.picInfo;
	      var picInfo = _state$picInfo === undefined ? {} : _state$picInfo;
	      var menu = _state.menu;
	
	      var baseMenu = (menu.ess || []).filter(function (item) {
	        return item.name === 'baseMessage';
	      });
	
	      var listElements = infoList.map(function (list) {
	
	        return _react2['default'].createElement(
	          'div',
	          { key: list.cmdId },
	          _react2['default'].createElement(
	            'h2',
	            { className: 'info-card-heading gap-t gap-b',
	              onTouchTap: _this.loadCategory.bind(null, list) },
	            list.pla_lan,
	            list.items ? null : _react2['default'].createElement('i', { className: 'icon-icomoon icon-cdp-down-arrow pull-right' })
	          ),
	          list.status ? _react2['default'].createElement(
	            _componentsLoaderLoaderJsx2['default'],
	            { status: list.status, style: { minHeight: 0 } },
	            list.items && list.items.map(function (card, index) {
	              return _react2['default'].createElement(_componentsInfoCardInfoCardJsx2['default'], { items: card, key: index });
	            })
	          ) : null,
	          _react2['default'].createElement('hr', { className: 'gap-t-lg gap-b-lg' })
	        );
	      });
	
	      return _react2['default'].createElement(
	        'div',
	        null,
	        _react2['default'].createElement(_componentsHeaderHeaderJsx2['default'], { back: true, title: baseMenu && baseMenu[0] && baseMenu[0].text }),
	        _react2['default'].createElement(
	          _componentsLoaderLoaderJsx2['default'],
	          { status: status, className: 'side-gap pad-b' },
	          picInfo ? _react2['default'].createElement(_componentsUserInfoUserInfoJsx2['default'], { className: 'gap-t-lg gap-b-lg', userInfo: picInfo }) : null,
	          listElements
	        ),
	        _react2['default'].createElement(_componentsTopActionTopActionJsx2['default'], null)
	      );
	    }
	
	    /**
	     * Get profile category list
	     * @param id
	     */
	  }, {
	    key: 'getProfileCategories',
	    value: function getProfileCategories(id) {
	      (0, _dispatcherDispatcher.dispatch)({
	        type: 'get-profile-categories',
	        data: id
	      });
	    }
	
	    /**
	     * Load a list of info items
	     * @param list
	     */
	  }, {
	    key: 'loadCategory',
	    value: function loadCategory(list) {
	
	      if (!list.items && list.status !== 'loading') {
	        (0, _dispatcherDispatcher.dispatch)({
	          type: 'get-profile-category-detail',
	          data: list.cmdId
	        });
	      }
	    }
	
	    /**
	     * Get an employees profile
	     * @param {number} [id]
	     */
	  }, {
	    key: 'getProfile',
	    value: function getProfile(id) {
	      (0, _dispatcherDispatcher.dispatch)({
	        type: 'get-profile',
	        data: id
	      });
	    }
	  }], [{
	    key: 'getStores',
	    value: function getStores() {
	      return [_storesProfileStore2['default'], _storesUserStore2['default']];
	    }
	  }, {
	    key: 'calculateState',
	    value: function calculateState() {
	      return (0, _objectAssign2['default'])({}, _storesProfileStore2['default'].getState(), _storesUserStore2['default'].getState());
	    }
	  }]);
	
	  return Profile;
	})(_react.Component);
	
	exports['default'] = _fluxUtils.Container.create(Profile);
	module.exports = exports['default'];

/***/ }),
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Created by AshZhang on 15/10/8.
	 */
	
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	__webpack_require__(316);
	
	var _react = __webpack_require__(23);
	
	var _react2 = _interopRequireDefault(_react);
	
	var Loader = (function (_Component) {
	  _inherits(Loader, _Component);
	
	  function Loader() {
	    _classCallCheck(this, Loader);
	
	    _get(Object.getPrototypeOf(Loader.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(Loader, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props;
	      var status = _props.status;
	      var className = _props.className;
	      var props = _objectWithoutProperties(_props, ['status', 'className']);
	      var loaderClass = 'loader ' + status + ' ' + (className || '');
	
	      return _react2['default'].createElement(
	        'div',
	        _extends({ className: loaderClass }, props),
	        status === 'loaded' ? this.props.children : status === 'loading' ? _react2['default'].createElement('i', { className: 'fa fa-spinner fa-pulse text-primary' }) : _react2['default'].createElement('i', { className: 'fa fa-meh-o' })
	      );
	    }
	  }]);
	
	  return Loader;
	})(_react.Component);
	
	exports['default'] = Loader;
	module.exports = exports['default'];

/***/ }),
/* 316 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 317 */,
/* 318 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Created by AshZhang on 15/9/28.
	 */
	
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	__webpack_require__(319);
	
	var _react = __webpack_require__(23);
	
	var _react2 = _interopRequireDefault(_react);
	
	var UserInfo = (function (_Component) {
	  _inherits(UserInfo, _Component);
	
	  function UserInfo() {
	    _classCallCheck(this, UserInfo);
	
	    _get(Object.getPrototypeOf(UserInfo.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(UserInfo, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props;
	      var _props$userInfo = _props.userInfo;
	      var userInfo = _props$userInfo === undefined ? {} : _props$userInfo;
	      var action = _props.action;
	      var simple = _props.simple;
	      var className = _props.className;
	      var onSelectUser = _props.onSelectUser;
	
	      userInfo.url && (userInfo.avatar = userInfo.url);
	
	      var userClass = 'user-info clearfix' + (className ? ' ' + className : '') + (simple ? ' user-info-simple' : '');
	
	      return _react2['default'].createElement(
	        'section',
	        { className: userClass,
	          onTouchTap: onSelectUser ? onSelectUser.bind(null, userInfo.id) : null },
	        _react2['default'].createElement(
	          'div',
	          { className: 'user-info-main clearfix' },
	          _react2['default'].createElement(
	            'div',
	            { className: 'user-info-name' },
	            userInfo.name || userInfo.firField
	          ),
	          _react2['default'].createElement(
	            'div',
	            { className: 'user-info-pos' },
	            userInfo.position || userInfo.secField
	          )
	        ),
	        action ? _react2['default'].createElement(
	          'a',
	          { className: 'user-info-action', href: action.link },
	          action.text
	        ) : null
	      );
	    }
	  }]);
	
	  return UserInfo;
	})(_react.Component);
	
	exports['default'] = UserInfo;
	module.exports = exports['default'];

/***/ }),
/* 319 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 320 */,
/* 321 */,
/* 322 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Created by AshZhang on 15/9/28.
	 */
	
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	__webpack_require__(323);
	
	var _react = __webpack_require__(23);
	
	var _react2 = _interopRequireDefault(_react);
	
	var InfoCard = (function (_Component) {
	  _inherits(InfoCard, _Component);
	
	  function InfoCard() {
	    _classCallCheck(this, InfoCard);
	
	    _get(Object.getPrototypeOf(InfoCard.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(InfoCard, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props;
	      var title = _props.title;
	      var _props$items = _props.items;
	      var items = _props$items === undefined ? [] : _props$items;
	
	      return _react2['default'].createElement(
	        'section',
	        { className: 'info-card' },
	        title ? _react2['default'].createElement(
	          'h1',
	          { className: 'info-card-title' },
	          title
	        ) : null,
	        _react2['default'].createElement(
	          'ul',
	          null,
	          items.map(function (item, index) {
	            return _react2['default'].createElement(
	              'li',
	              { className: 'info-card-item clearfix', key: index },
	              item.name || item.firField ? _react2['default'].createElement(
	                'span',
	                { className: 'info-card-name' },
	                item.name || item.firField
	              ) : null,
	              _react2['default'].createElement(
	                'span',
	                { className: 'info-card-value' },
	                item.value || item.secField
	              )
	            );
	          })
	        )
	      );
	    }
	  }]);
	
	  return InfoCard;
	})(_react.Component);
	
	exports['default'] = InfoCard;
	module.exports = exports['default'];

/***/ }),
/* 323 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 324 */,
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Created by AshZhang on 15/10/25.
	 */
	
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	__webpack_require__(326);
	
	var _react = __webpack_require__(23);
	
	var _react2 = _interopRequireDefault(_react);
	
	var TopAction = (function (_Component) {
	  _inherits(TopAction, _Component);
	
	  function TopAction(props) {
	    _classCallCheck(this, TopAction);
	
	    _get(Object.getPrototypeOf(TopAction.prototype), 'constructor', this).call(this, props);
	
	    this.state = {
	      visible: window.pageYOffset > 0
	    };
	
	    this._listenToScroll = this._listenToScroll.bind(this);
	  }
	
	  _createClass(TopAction, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      window.addEventListener('scroll', this._listenToScroll, false);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      window.removeEventListener('scroll', this._listenToScroll, false);
	    }
	
	    /**
	     * Scroll to the top of window
	     */
	  }, {
	    key: 'scrollTop',
	    value: function scrollTop() {
	      window.scroll(0, 0);
	    }
	
	    /**
	     * Only visible when the viewport has been scrolled down
	     * @private
	     */
	  }, {
	    key: '_listenToScroll',
	    value: function _listenToScroll() {
	      this.setState({
	        visible: window.pageYOffset > 0
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var visible = this.state.visible;
	
	      var visibilityStyle = {
	        display: visible ? 'block' : 'none'
	      };
	
	      return _react2['default'].createElement(
	        'span',
	        { className: 'top-action',
	          style: visibilityStyle,
	          onTouchTap: this.scrollTop.bind(this) },
	        _react2['default'].createElement('i', { className: 'icon-icomoon icon-cdp-up-arrow' })
	      );
	    }
	  }]);
	
	  return TopAction;
	})(_react.Component);
	
	exports['default'] = TopAction;
	module.exports = exports['default'];

/***/ }),
/* 326 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 327 */,
/* 328 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Home store
	 */
	
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _fluxUtils = __webpack_require__(228);
	
	var _dispatcherDispatcher = __webpack_require__(223);
	
	var _dispatcherDispatcher2 = _interopRequireDefault(_dispatcherDispatcher);
	
	var _objectAssign = __webpack_require__(279);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	var _dataUtilsProfileDataUtils = __webpack_require__(329);
	
	var _dataUtilsProfileDataUtils2 = _interopRequireDefault(_dataUtilsProfileDataUtils);
	
	var ProfileStore = (function (_ReduceStore) {
	  _inherits(ProfileStore, _ReduceStore);
	
	  function ProfileStore() {
	    _classCallCheck(this, ProfileStore);
	
	    _get(Object.getPrototypeOf(ProfileStore.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(ProfileStore, [{
	    key: 'getInitialState',
	    value: function getInitialState() {
	      return {
	        basicInfo: null,
	        //infoList: [],
	        //workExp: [],
	        infoList: [],
	        status: 'loading',
	        empId: null
	      };
	    }
	  }, {
	    key: 'reduce',
	    value: function reduce(state, action) {
	
	      switch (action.type) {
	        case 'get-profile':
	          _dataUtilsProfileDataUtils2['default'].getProfile(action.data);
	          return (0, _objectAssign2['default'])({}, state, {
	            status: 'loading'
	          });
	
	        case 'get-profile-categories':
	          _dataUtilsProfileDataUtils2['default'].getProfileCategories(action.data);
	          return (0, _objectAssign2['default'])({}, state, {
	            status: 'loading'
	          });
	
	        case 'get-profile-categories-success':
	          // Get first category by default
	          if (action.data && action.data.baseType && action.data.baseType.length) {
	            setTimeout(function () {
	              (0, _dispatcherDispatcher.dispatch)({
	                type: 'get-profile-category-detail',
	                data: action.data.baseType[0].cmdId
	              });
	            }, 0);
	          }
	          return (0, _objectAssign2['default'])({}, state, {
	            infoList: action.data.baseType,
	            picInfo: action.data.picInfo,
	            status: 'loaded'
	          });
	
	        case 'get-profile-category-detail':
	          _dataUtilsProfileDataUtils2['default'].getProfileByCategory(action.data);
	          return (0, _objectAssign2['default'])({}, state, {
	            infoList: state.infoList.map(function (category) {
	              if (category.cmdId === action.data) {
	                return (0, _objectAssign2['default'])({}, category, {
	                  status: 'loading'
	                });
	              } else {
	                return category;
	              }
	            })
	          });
	
	        case 'get-profile-category-detail-success':
	          return (0, _objectAssign2['default'])({}, state, {
	            infoList: state.infoList.map(function (category) {
	              if (category.cmdId === action.data.cmdId) {
	                return (0, _objectAssign2['default'])({}, category, {
	                  items: action.data.items,
	                  status: 'loaded'
	                });
	              } else {
	                return category;
	              }
	            })
	          });
	
	        case 'get-profile-success':
	          return (0, _objectAssign2['default'])({}, state, action.data, {
	            status: 'loaded'
	          });
	        default:
	      }
	
	      return state;
	    }
	  }]);
	
	  return ProfileStore;
	})(_fluxUtils.ReduceStore);
	
	exports['default'] = new ProfileStore(_dispatcherDispatcher2['default']);
	module.exports = exports['default'];

/***/ }),
/* 329 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Created by AshZhang on 15/10/8.
	 */
	
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _dispatcherDispatcher = __webpack_require__(223);
	
	var _dispatcherDispatcher2 = _interopRequireDefault(_dispatcherDispatcher);
	
	var _commonUtilsAjax = __webpack_require__(222);
	
	var _commonUtilsAjax2 = _interopRequireDefault(_commonUtilsAjax);
	
	exports['default'] = {
	
	  /**
	   * Get user profile
	   * @param {number} [id]
	   */
	  getProfile: function getProfile(id) {
	    var path = '/user-message' + (id === void 0 ? '' : '/' + id);
	
	    _commonUtilsAjax2['default'].get(path).then(function (res) {
	      (0, _dispatcherDispatcher.dispatch)({
	        type: 'get-profile-success',
	        data: res
	      });
	    });
	  },
	
	  /**
	   * Get user profile categories
	   * @param {number} [data]
	   */
	  getProfileCategories: function getProfileCategories(data) {
	    var id = data && Object.keys(data).length ? data : undefined,
	        path = '/user-message-info-type' + (id === void 0 ? '' : '/' + id);
	
	    _commonUtilsAjax2['default'].post('/user-message-info-type', { empId: id }).then(function (res) {
	      (0, _dispatcherDispatcher.dispatch)({
	        type: 'get-profile-categories-success',
	        data: res
	      });
	    });
	  },
	
	  /**
	   * Get a category detail
	   */
	  getProfileByCategory: function getProfileByCategory(cmdId) {
	    _commonUtilsAjax2['default'].post('/user-base-message-info', {
	      cmdId: cmdId
	    }).then(function (res) {
	      (0, _dispatcherDispatcher.dispatch)({
	        type: 'get-profile-category-detail-success',
	        data: {
	          cmdId: cmdId,
	          items: res.items
	        }
	      });
	    });
	  },
	
	  /**
	   * Get team member list (for managers)
	   * @param {Object} query
	   */
	  getTeamMembers: function getTeamMembers(query) {
	    _commonUtilsAjax2['default'].post('/team-info-page', query).then(function (res) {
	      (0, _dispatcherDispatcher.dispatch)({
	        type: 'get-team-members-success',
	        data: res
	      });
	    });
	  }
	};
	module.exports = exports['default'];

/***/ }),
/* 330 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Home page
	 */
	
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(23);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _fluxUtils = __webpack_require__(228);
	
	var _dispatcherDispatcher = __webpack_require__(223);
	
	var _dispatcherDispatcher2 = _interopRequireDefault(_dispatcherDispatcher);
	
	var _objectAssign = __webpack_require__(279);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	var _commonLang = __webpack_require__(245);
	
	var _componentsLoaderLoaderJsx = __webpack_require__(315);
	
	var _componentsLoaderLoaderJsx2 = _interopRequireDefault(_componentsLoaderLoaderJsx);
	
	var _componentsHeaderHeaderJsx = __webpack_require__(247);
	
	var _componentsHeaderHeaderJsx2 = _interopRequireDefault(_componentsHeaderHeaderJsx);
	
	var _componentsUserInfoUserInfoJsx = __webpack_require__(318);
	
	var _componentsUserInfoUserInfoJsx2 = _interopRequireDefault(_componentsUserInfoUserInfoJsx);
	
	var _componentsFormControlFormControlJsx = __webpack_require__(291);
	
	var _componentsFormControlFormControlJsx2 = _interopRequireDefault(_componentsFormControlFormControlJsx);
	
	var _componentsSelectSelectJsx = __webpack_require__(287);
	
	var _componentsSelectSelectJsx2 = _interopRequireDefault(_componentsSelectSelectJsx);
	
	var _componentsInfoCardInfoCardJsx = __webpack_require__(322);
	
	var _componentsInfoCardInfoCardJsx2 = _interopRequireDefault(_componentsInfoCardInfoCardJsx);
	
	var _componentsChartChartJsx = __webpack_require__(331);
	
	var _componentsChartChartJsx2 = _interopRequireDefault(_componentsChartChartJsx);
	
	var _componentsTopActionTopActionJsx = __webpack_require__(325);
	
	var _componentsTopActionTopActionJsx2 = _interopRequireDefault(_componentsTopActionTopActionJsx);
	
	var _storesSalaryStore = __webpack_require__(336);
	
	var _storesSalaryStore2 = _interopRequireDefault(_storesSalaryStore);
	
	var _storesUserStore = __webpack_require__(303);
	
	var _storesUserStore2 = _interopRequireDefault(_storesUserStore);
	
	var _dataUtilsSalaryDataUtils = __webpack_require__(337);
	
	var _dataUtilsSalaryDataUtils2 = _interopRequireDefault(_dataUtilsSalaryDataUtils);
	
	var defaultYear = new Date().getFullYear(),
	    defaultMonth = new Date().getMonth() + 1,
	    monthList = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].map(function (month) {
	  return {
	    text: month,
	    value: month
	  };
	});
	
	var Salary = (function (_Component) {
	  _inherits(Salary, _Component);
	
	  function Salary(props) {
	    _classCallCheck(this, Salary);
	
	    _get(Object.getPrototypeOf(Salary.prototype), 'constructor', this).call(this, props);
	    this.onDateChange = this.onDateChange.bind(this);
	    this.onAccChange = this.onAccChange.bind(this);
	    this.getSalary = this.getSalary.bind(this);
	    this.getAccountList = this.getAccountList.bind(this);
	
	    _dataUtilsSalaryDataUtils2['default'].getSalaryCalendar();
	  }
	
	  _createClass(Salary, [{
	    key: 'render',
	    value: function render() {
	      var _state = this.state;
	      var total = _state.total;
	      var picInfo = _state.picInfo;
	      var infoList = _state.infoList;
	      var _state$salaryCalendar = _state.salaryCalendar;
	      var salaryCalendar = _state$salaryCalendar === undefined ? {} : _state$salaryCalendar;
	      var accountList = _state.accountList;
	      var status = _state.status;
	      var chartData = _state.chartData;
	      var menu = _state.menu;
	
	      var yearList = (function (year) {
	        var list = [];
	
	        for (; year <= defaultYear; year += 1) {
	          list.unshift({
	            text: year,
	            value: year
	          });
	        }
	
	        return list;
	      })(salaryCalendar.minYear);
	
	      var newAccountList = accountList || this.getAccountList(salaryCalendar.payrollPeriodList, defaultYear, defaultMonth);
	
	      var payMenu = (menu.ess || []).filter(function (item) {
	        return item.name === 'myPay';
	      });
	
	      return _react2['default'].createElement(
	        'div',
	        { style: {
	            paddingBottom: '3rem'
	          } },
	        _react2['default'].createElement(_componentsHeaderHeaderJsx2['default'], { back: true, title: payMenu && payMenu[0] && payMenu[0].text }),
	        _react2['default'].createElement(_componentsUserInfoUserInfoJsx2['default'], { className: 'gap-t-lg gap-b-lg side-gap', userInfo: picInfo }),
	        _react2['default'].createElement(
	          'div',
	          { className: 'row gap-t' },
	          _react2['default'].createElement(
	            'div',
	            { className: 'col-1-4' },
	            _react2['default'].createElement(
	              _componentsFormControlFormControlJsx2['default'],
	              { label: (0, _commonLang.getItem)('YEAR') },
	              _react2['default'].createElement(_componentsSelectSelectJsx2['default'], { className: 'text-primary',
	                defaultValue: defaultYear,
	                options: yearList,
	                ref: 'year',
	                onChange: this.onDateChange })
	            )
	          ),
	          _react2['default'].createElement(
	            'div',
	            { className: 'col-1-4' },
	            _react2['default'].createElement(
	              _componentsFormControlFormControlJsx2['default'],
	              { label: (0, _commonLang.getItem)('MONTH') },
	              _react2['default'].createElement(_componentsSelectSelectJsx2['default'], { className: 'text-primary',
	                defaultValue: defaultMonth,
	                options: monthList,
	                ref: 'month',
	                onChange: this.onDateChange })
	            )
	          ),
	          _react2['default'].createElement(
	            'div',
	            { className: 'col-1-2', style: { display: newAccountList.length > 1 ? 'block' : 'none' }, ref: 'accNameHolder' },
	            _react2['default'].createElement(
	              _componentsFormControlFormControlJsx2['default'],
	              { label: '账套' },
	              _react2['default'].createElement(_componentsSelectSelectJsx2['default'], { className: 'text-primary',
	                options: newAccountList,
	                defaultValue: newAccountList[0] && newAccountList[0].value,
	                ref: 'accName', onChange: this.onAccChange })
	            )
	          )
	        ),
	        _react2['default'].createElement(
	          _componentsLoaderLoaderJsx2['default'],
	          { status: status, className: 'side-gap gap-t pad-b', style: { minHeight: 0 } },
	          infoList.length && chartData.length ? _react2['default'].createElement(
	            'div',
	            { className: 'gap-b' },
	            _react2['default'].createElement(_componentsChartChartJsx2['default'], { height: '200', data: chartData })
	          ) : null,
	          infoList.length ? infoList.map(function (card, index) {
	            return _react2['default'].createElement(_componentsInfoCardInfoCardJsx2['default'], { title: card.title, items: card.items, key: index });
	          }) : _react2['default'].createElement(
	            'p',
	            null,
	            salaryCalendar.pointInfo
	          )
	        ),
	        _react2['default'].createElement(_componentsTopActionTopActionJsx2['default'], null)
	      );
	    }
	
	    /**
	     * Re-fetch salary info when year and month changes
	     */
	  }, {
	    key: 'onDateChange',
	    value: function onDateChange() {
	      var accountList = this.getAccountList(this.state.salaryCalendar.payrollPeriodList, _react2['default'].findDOMNode(this.refs.year).value, _react2['default'].findDOMNode(this.refs.month).value);
	
	      if (accountList.length > 1) {
	        _react2['default'].findDOMNode(this.refs.accNameHolder).style.display = 'block';
	
	        (0, _dispatcherDispatcher.dispatch)({
	          type: 'change-account-list',
	          data: accountList
	        });
	      } else {
	        _react2['default'].findDOMNode(this.refs.accNameHolder).style.display = 'none';
	
	        if (!accountList.length) {
	          (0, _dispatcherDispatcher.dispatch)({
	            type: 'get-salary-success',
	            data: {
	              infoList: []
	            }
	          });
	        }
	      }
	
	      if (accountList[0]) {
	        this.getSalary(accountList[0].value);
	      }
	    }
	
	    /**
	     * Account name changes
	     */
	  }, {
	    key: 'onAccChange',
	    value: function onAccChange(e) {
	      this.getSalary(e.target.value);
	    }
	
	    /**
	     * Get salary data
	     */
	  }, {
	    key: 'getSalary',
	    value: function getSalary(accName) {
	      _dataUtilsSalaryDataUtils2['default'].getSalary({
	        year: _react2['default'].findDOMNode(this.refs.year).value,
	        month: _react2['default'].findDOMNode(this.refs.month).value,
	        accName: accName
	      });
	    }
	
	    /**
	     * Get account list by year and month
	     * @param data
	     * @param year
	     * @param month
	     * @returns {*|Array.<T>}
	     */
	  }, {
	    key: 'getAccountList',
	    value: function getAccountList(data, year, month) {
	      if (data === undefined) data = [];
	
	      var _this = this;
	
	      var accountList = data.filter(function (item) {
	        return item.payPerYear === +year && item.payPerMon === +month;
	      }).map(function (item) {
	        return {
	          text: item.payAccName,
	          value: item.payAccName
	        };
	      });
	
	      if (accountList.length) {
	        setTimeout(function () {
	          if (!_this.firstTime) {
	            _this.getSalary(accountList[0] && accountList[0].value);
	            _this.firstTime = true;
	          }
	        }, 0);
	      }
	
	      return accountList;
	    }
	  }], [{
	    key: 'getStores',
	    value: function getStores() {
	      return [_storesSalaryStore2['default'], _storesUserStore2['default']];
	    }
	  }, {
	    key: 'calculateState',
	    value: function calculateState() {
	      return (0, _objectAssign2['default'])({}, _storesSalaryStore2['default'].getState(), _storesUserStore2['default'].getState());
	    }
	  }]);
	
	  return Salary;
	})(_react.Component);
	
	exports['default'] = _fluxUtils.Container.create(Salary);
	module.exports = exports['default'];
	/*<div className='gap-t gap-b text-right'>
	 {getLang('ACTUAL_SALARY') + getLang('COLON')}
	 <span className='text-xl text-primary'>{total}</span>
	</div>*/

/***/ }),
/* 331 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Created by AshZhang on 15/9/28.
	 */
	
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	__webpack_require__(332);
	
	var _react = __webpack_require__(23);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bower_componentsChartJsChartMinJs = __webpack_require__(334);
	
	var _bower_componentsChartJsChartMinJs2 = _interopRequireDefault(_bower_componentsChartJsChartMinJs);
	
	var colorList = ['#5dc9e6', '#f773bd', '#fdbb7d', '#6dded5', '#a06081', '#7fca92', '#fb755c', '#bd8cc3', '#f875a7', '#8cbeb3', '#f0c868', '#9ad9de', '#f99bc0', '#a5cf85', '#fca793'];
	
	var Chart = (function (_Component) {
	  _inherits(Chart, _Component);
	
	  function Chart() {
	    _classCallCheck(this, Chart);
	
	    _get(Object.getPrototypeOf(Chart.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(Chart, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var ctx = _react2['default'].findDOMNode(this.refs.chart).getContext('2d');
	
	      this.props.data.forEach(function (item, index) {
	        item.color = colorList[index % colorList.length];
	      });
	
	      var myNewChart = new _bower_componentsChartJsChartMinJs2['default'](ctx).Pie(this.props.data, {
	        legendTemplate: '<ul class="chart-legend">' + '<% for (var i = 0; i < segments.length; i+=1) { %>' + '<li>' + '<span class="chart-label" style="background-color: <%= segments[i].fillColor %>"></span>' + '<% if (segments[i].label) { %><%= segments[i].label + ": " + segments[i].value %><% } %>' + '</li>' + '<% } %>' + '</ul>'
	      });
	
	      var legend = document.createElement('div');
	
	      legend.innerHTML = myNewChart.generateLegend();
	
	      _react2['default'].findDOMNode(this.refs.legend).appendChild(legend.firstChild);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var height = this.props.height;
	
	      return _react2['default'].createElement(
	        'div',
	        { className: 'row' },
	        _react2['default'].createElement(
	          'div',
	          { className: 'col-3-5' },
	          _react2['default'].createElement('canvas', { ref: 'chart', style: { width: '100%', height: height } })
	        ),
	        _react2['default'].createElement('div', { className: 'col-2-5', ref: 'legend' })
	      );
	    }
	  }]);
	
	  return Chart;
	})(_react.Component);
	
	exports['default'] = Chart;
	module.exports = exports['default'];

/***/ }),
/* 332 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 333 */,
/* 334 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * Chart.js
	 * http://chartjs.org/
	 * Version: 1.0.2
	 *
	 * Copyright 2015 Nick Downie
	 * Released under the MIT license
	 * https://github.com/nnnick/Chart.js/blob/master/LICENSE.md
	 */
	(function(){"use strict";var t=this,i=t.Chart,e=function(t){this.canvas=t.canvas,this.ctx=t;var i=function(t,i){return t["offset"+i]?t["offset"+i]:document.defaultView.getComputedStyle(t).getPropertyValue(i)},e=this.width=i(t.canvas,"Width"),n=this.height=i(t.canvas,"Height");t.canvas.width=e,t.canvas.height=n;var e=this.width=t.canvas.width,n=this.height=t.canvas.height;return this.aspectRatio=this.width/this.height,s.retinaScale(this),this};e.defaults={global:{animation:!0,animationSteps:60,animationEasing:"easeOutQuart",showScale:!0,scaleOverride:!1,scaleSteps:null,scaleStepWidth:null,scaleStartValue:null,scaleLineColor:"rgba(0,0,0,.1)",scaleLineWidth:1,scaleShowLabels:!0,scaleLabel:"<%=value%>",scaleIntegersOnly:!0,scaleBeginAtZero:!1,scaleFontFamily:"'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",scaleFontSize:12,scaleFontStyle:"normal",scaleFontColor:"#666",responsive:!1,maintainAspectRatio:!0,showTooltips:!0,customTooltips:!1,tooltipEvents:["mousemove","touchstart","touchmove","mouseout"],tooltipFillColor:"rgba(0,0,0,0.8)",tooltipFontFamily:"'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",tooltipFontSize:14,tooltipFontStyle:"normal",tooltipFontColor:"#fff",tooltipTitleFontFamily:"'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",tooltipTitleFontSize:14,tooltipTitleFontStyle:"bold",tooltipTitleFontColor:"#fff",tooltipYPadding:6,tooltipXPadding:6,tooltipCaretSize:8,tooltipCornerRadius:6,tooltipXOffset:10,tooltipTemplate:"<%if (label){%><%=label%>: <%}%><%= value %>",multiTooltipTemplate:"<%= value %>",multiTooltipKeyBackground:"#fff",onAnimationProgress:function(){},onAnimationComplete:function(){}}},e.types={};var s=e.helpers={},n=s.each=function(t,i,e){var s=Array.prototype.slice.call(arguments,3);if(t)if(t.length===+t.length){var n;for(n=0;n<t.length;n++)i.apply(e,[t[n],n].concat(s))}else for(var o in t)i.apply(e,[t[o],o].concat(s))},o=s.clone=function(t){var i={};return n(t,function(e,s){t.hasOwnProperty(s)&&(i[s]=e)}),i},a=s.extend=function(t){return n(Array.prototype.slice.call(arguments,1),function(i){n(i,function(e,s){i.hasOwnProperty(s)&&(t[s]=e)})}),t},h=s.merge=function(){var t=Array.prototype.slice.call(arguments,0);return t.unshift({}),a.apply(null,t)},l=s.indexOf=function(t,i){if(Array.prototype.indexOf)return t.indexOf(i);for(var e=0;e<t.length;e++)if(t[e]===i)return e;return-1},r=(s.where=function(t,i){var e=[];return s.each(t,function(t){i(t)&&e.push(t)}),e},s.findNextWhere=function(t,i,e){e||(e=-1);for(var s=e+1;s<t.length;s++){var n=t[s];if(i(n))return n}},s.findPreviousWhere=function(t,i,e){e||(e=t.length);for(var s=e-1;s>=0;s--){var n=t[s];if(i(n))return n}},s.inherits=function(t){var i=this,e=t&&t.hasOwnProperty("constructor")?t.constructor:function(){return i.apply(this,arguments)},s=function(){this.constructor=e};return s.prototype=i.prototype,e.prototype=new s,e.extend=r,t&&a(e.prototype,t),e.__super__=i.prototype,e}),c=s.noop=function(){},u=s.uid=function(){var t=0;return function(){return"chart-"+t++}}(),d=s.warn=function(t){window.console&&"function"==typeof window.console.warn&&console.warn(t)},p=s.amd="function"=="function"&&__webpack_require__(335),f=s.isNumber=function(t){return!isNaN(parseFloat(t))&&isFinite(t)},g=s.max=function(t){return Math.max.apply(Math,t)},m=s.min=function(t){return Math.min.apply(Math,t)},v=(s.cap=function(t,i,e){if(f(i)){if(t>i)return i}else if(f(e)&&e>t)return e;return t},s.getDecimalPlaces=function(t){return t%1!==0&&f(t)?t.toString().split(".")[1].length:0}),S=s.radians=function(t){return t*(Math.PI/180)},x=(s.getAngleFromPoint=function(t,i){var e=i.x-t.x,s=i.y-t.y,n=Math.sqrt(e*e+s*s),o=2*Math.PI+Math.atan2(s,e);return 0>e&&0>s&&(o+=2*Math.PI),{angle:o,distance:n}},s.aliasPixel=function(t){return t%2===0?0:.5}),y=(s.splineCurve=function(t,i,e,s){var n=Math.sqrt(Math.pow(i.x-t.x,2)+Math.pow(i.y-t.y,2)),o=Math.sqrt(Math.pow(e.x-i.x,2)+Math.pow(e.y-i.y,2)),a=s*n/(n+o),h=s*o/(n+o);return{inner:{x:i.x-a*(e.x-t.x),y:i.y-a*(e.y-t.y)},outer:{x:i.x+h*(e.x-t.x),y:i.y+h*(e.y-t.y)}}},s.calculateOrderOfMagnitude=function(t){return Math.floor(Math.log(t)/Math.LN10)}),C=(s.calculateScaleRange=function(t,i,e,s,n){var o=2,a=Math.floor(i/(1.5*e)),h=o>=a,l=g(t),r=m(t);l===r&&(l+=.5,r>=.5&&!s?r-=.5:l+=.5);for(var c=Math.abs(l-r),u=y(c),d=Math.ceil(l/(1*Math.pow(10,u)))*Math.pow(10,u),p=s?0:Math.floor(r/(1*Math.pow(10,u)))*Math.pow(10,u),f=d-p,v=Math.pow(10,u),S=Math.round(f/v);(S>a||a>2*S)&&!h;)if(S>a)v*=2,S=Math.round(f/v),S%1!==0&&(h=!0);else if(n&&u>=0){if(v/2%1!==0)break;v/=2,S=Math.round(f/v)}else v/=2,S=Math.round(f/v);return h&&(S=o,v=f/S),{steps:S,stepValue:v,min:p,max:p+S*v}},s.template=function(t,i){function e(t,i){var e=/\W/.test(t)?new Function("obj","var p=[],print=function(){p.push.apply(p,arguments);};with(obj){p.push('"+t.replace(/[\r\t\n]/g," ").split("<%").join("	").replace(/((^|%>)[^\t]*)'/g,"$1\r").replace(/\t=(.*?)%>/g,"',$1,'").split("	").join("');").split("%>").join("p.push('").split("\r").join("\\'")+"');}return p.join('');"):s[t]=s[t];return i?e(i):e}if(t instanceof Function)return t(i);var s={};return e(t,i)}),w=(s.generateLabels=function(t,i,e,s){var o=new Array(i);return labelTemplateString&&n(o,function(i,n){o[n]=C(t,{value:e+s*(n+1)})}),o},s.easingEffects={linear:function(t){return t},easeInQuad:function(t){return t*t},easeOutQuad:function(t){return-1*t*(t-2)},easeInOutQuad:function(t){return(t/=.5)<1?.5*t*t:-0.5*(--t*(t-2)-1)},easeInCubic:function(t){return t*t*t},easeOutCubic:function(t){return 1*((t=t/1-1)*t*t+1)},easeInOutCubic:function(t){return(t/=.5)<1?.5*t*t*t:.5*((t-=2)*t*t+2)},easeInQuart:function(t){return t*t*t*t},easeOutQuart:function(t){return-1*((t=t/1-1)*t*t*t-1)},easeInOutQuart:function(t){return(t/=.5)<1?.5*t*t*t*t:-0.5*((t-=2)*t*t*t-2)},easeInQuint:function(t){return 1*(t/=1)*t*t*t*t},easeOutQuint:function(t){return 1*((t=t/1-1)*t*t*t*t+1)},easeInOutQuint:function(t){return(t/=.5)<1?.5*t*t*t*t*t:.5*((t-=2)*t*t*t*t+2)},easeInSine:function(t){return-1*Math.cos(t/1*(Math.PI/2))+1},easeOutSine:function(t){return 1*Math.sin(t/1*(Math.PI/2))},easeInOutSine:function(t){return-0.5*(Math.cos(Math.PI*t/1)-1)},easeInExpo:function(t){return 0===t?1:1*Math.pow(2,10*(t/1-1))},easeOutExpo:function(t){return 1===t?1:1*(-Math.pow(2,-10*t/1)+1)},easeInOutExpo:function(t){return 0===t?0:1===t?1:(t/=.5)<1?.5*Math.pow(2,10*(t-1)):.5*(-Math.pow(2,-10*--t)+2)},easeInCirc:function(t){return t>=1?t:-1*(Math.sqrt(1-(t/=1)*t)-1)},easeOutCirc:function(t){return 1*Math.sqrt(1-(t=t/1-1)*t)},easeInOutCirc:function(t){return(t/=.5)<1?-0.5*(Math.sqrt(1-t*t)-1):.5*(Math.sqrt(1-(t-=2)*t)+1)},easeInElastic:function(t){var i=1.70158,e=0,s=1;return 0===t?0:1==(t/=1)?1:(e||(e=.3),s<Math.abs(1)?(s=1,i=e/4):i=e/(2*Math.PI)*Math.asin(1/s),-(s*Math.pow(2,10*(t-=1))*Math.sin(2*(1*t-i)*Math.PI/e)))},easeOutElastic:function(t){var i=1.70158,e=0,s=1;return 0===t?0:1==(t/=1)?1:(e||(e=.3),s<Math.abs(1)?(s=1,i=e/4):i=e/(2*Math.PI)*Math.asin(1/s),s*Math.pow(2,-10*t)*Math.sin(2*(1*t-i)*Math.PI/e)+1)},easeInOutElastic:function(t){var i=1.70158,e=0,s=1;return 0===t?0:2==(t/=.5)?1:(e||(e=.3*1.5),s<Math.abs(1)?(s=1,i=e/4):i=e/(2*Math.PI)*Math.asin(1/s),1>t?-.5*s*Math.pow(2,10*(t-=1))*Math.sin(2*(1*t-i)*Math.PI/e):s*Math.pow(2,-10*(t-=1))*Math.sin(2*(1*t-i)*Math.PI/e)*.5+1)},easeInBack:function(t){var i=1.70158;return 1*(t/=1)*t*((i+1)*t-i)},easeOutBack:function(t){var i=1.70158;return 1*((t=t/1-1)*t*((i+1)*t+i)+1)},easeInOutBack:function(t){var i=1.70158;return(t/=.5)<1?.5*t*t*(((i*=1.525)+1)*t-i):.5*((t-=2)*t*(((i*=1.525)+1)*t+i)+2)},easeInBounce:function(t){return 1-w.easeOutBounce(1-t)},easeOutBounce:function(t){return(t/=1)<1/2.75?7.5625*t*t:2/2.75>t?1*(7.5625*(t-=1.5/2.75)*t+.75):2.5/2.75>t?1*(7.5625*(t-=2.25/2.75)*t+.9375):1*(7.5625*(t-=2.625/2.75)*t+.984375)},easeInOutBounce:function(t){return.5>t?.5*w.easeInBounce(2*t):.5*w.easeOutBounce(2*t-1)+.5}}),b=s.requestAnimFrame=function(){return window.requestAnimationFrame||window.webkitRequestAnimationFrame||window.mozRequestAnimationFrame||window.oRequestAnimationFrame||window.msRequestAnimationFrame||function(t){return window.setTimeout(t,1e3/60)}}(),P=s.cancelAnimFrame=function(){return window.cancelAnimationFrame||window.webkitCancelAnimationFrame||window.mozCancelAnimationFrame||window.oCancelAnimationFrame||window.msCancelAnimationFrame||function(t){return window.clearTimeout(t,1e3/60)}}(),L=(s.animationLoop=function(t,i,e,s,n,o){var a=0,h=w[e]||w.linear,l=function(){a++;var e=a/i,r=h(e);t.call(o,r,e,a),s.call(o,r,e),i>a?o.animationFrame=b(l):n.apply(o)};b(l)},s.getRelativePosition=function(t){var i,e,s=t.originalEvent||t,n=t.currentTarget||t.srcElement,o=n.getBoundingClientRect();return s.touches?(i=s.touches[0].clientX-o.left,e=s.touches[0].clientY-o.top):(i=s.clientX-o.left,e=s.clientY-o.top),{x:i,y:e}},s.addEvent=function(t,i,e){t.addEventListener?t.addEventListener(i,e):t.attachEvent?t.attachEvent("on"+i,e):t["on"+i]=e}),k=s.removeEvent=function(t,i,e){t.removeEventListener?t.removeEventListener(i,e,!1):t.detachEvent?t.detachEvent("on"+i,e):t["on"+i]=c},F=(s.bindEvents=function(t,i,e){t.events||(t.events={}),n(i,function(i){t.events[i]=function(){e.apply(t,arguments)},L(t.chart.canvas,i,t.events[i])})},s.unbindEvents=function(t,i){n(i,function(i,e){k(t.chart.canvas,e,i)})}),R=s.getMaximumWidth=function(t){var i=t.parentNode;return i.clientWidth},T=s.getMaximumHeight=function(t){var i=t.parentNode;return i.clientHeight},A=(s.getMaximumSize=s.getMaximumWidth,s.retinaScale=function(t){var i=t.ctx,e=t.canvas.width,s=t.canvas.height;window.devicePixelRatio&&(i.canvas.style.width=e+"px",i.canvas.style.height=s+"px",i.canvas.height=s*window.devicePixelRatio,i.canvas.width=e*window.devicePixelRatio,i.scale(window.devicePixelRatio,window.devicePixelRatio))}),M=s.clear=function(t){t.ctx.clearRect(0,0,t.width,t.height)},W=s.fontString=function(t,i,e){return i+" "+t+"px "+e},z=s.longestText=function(t,i,e){t.font=i;var s=0;return n(e,function(i){var e=t.measureText(i).width;s=e>s?e:s}),s},B=s.drawRoundedRectangle=function(t,i,e,s,n,o){t.beginPath(),t.moveTo(i+o,e),t.lineTo(i+s-o,e),t.quadraticCurveTo(i+s,e,i+s,e+o),t.lineTo(i+s,e+n-o),t.quadraticCurveTo(i+s,e+n,i+s-o,e+n),t.lineTo(i+o,e+n),t.quadraticCurveTo(i,e+n,i,e+n-o),t.lineTo(i,e+o),t.quadraticCurveTo(i,e,i+o,e),t.closePath()};e.instances={},e.Type=function(t,i,s){this.options=i,this.chart=s,this.id=u(),e.instances[this.id]=this,i.responsive&&this.resize(),this.initialize.call(this,t)},a(e.Type.prototype,{initialize:function(){return this},clear:function(){return M(this.chart),this},stop:function(){return P(this.animationFrame),this},resize:function(t){this.stop();var i=this.chart.canvas,e=R(this.chart.canvas),s=this.options.maintainAspectRatio?e/this.chart.aspectRatio:T(this.chart.canvas);return i.width=this.chart.width=e,i.height=this.chart.height=s,A(this.chart),"function"==typeof t&&t.apply(this,Array.prototype.slice.call(arguments,1)),this},reflow:c,render:function(t){return t&&this.reflow(),this.options.animation&&!t?s.animationLoop(this.draw,this.options.animationSteps,this.options.animationEasing,this.options.onAnimationProgress,this.options.onAnimationComplete,this):(this.draw(),this.options.onAnimationComplete.call(this)),this},generateLegend:function(){return C(this.options.legendTemplate,this)},destroy:function(){this.clear(),F(this,this.events);var t=this.chart.canvas;t.width=this.chart.width,t.height=this.chart.height,t.style.removeProperty?(t.style.removeProperty("width"),t.style.removeProperty("height")):(t.style.removeAttribute("width"),t.style.removeAttribute("height")),delete e.instances[this.id]},showTooltip:function(t,i){"undefined"==typeof this.activeElements&&(this.activeElements=[]);var o=function(t){var i=!1;return t.length!==this.activeElements.length?i=!0:(n(t,function(t,e){t!==this.activeElements[e]&&(i=!0)},this),i)}.call(this,t);if(o||i){if(this.activeElements=t,this.draw(),this.options.customTooltips&&this.options.customTooltips(!1),t.length>0)if(this.datasets&&this.datasets.length>1){for(var a,h,r=this.datasets.length-1;r>=0&&(a=this.datasets[r].points||this.datasets[r].bars||this.datasets[r].segments,h=l(a,t[0]),-1===h);r--);var c=[],u=[],d=function(){var t,i,e,n,o,a=[],l=[],r=[];return s.each(this.datasets,function(i){t=i.points||i.bars||i.segments,t[h]&&t[h].hasValue()&&a.push(t[h])}),s.each(a,function(t){l.push(t.x),r.push(t.y),c.push(s.template(this.options.multiTooltipTemplate,t)),u.push({fill:t._saved.fillColor||t.fillColor,stroke:t._saved.strokeColor||t.strokeColor})},this),o=m(r),e=g(r),n=m(l),i=g(l),{x:n>this.chart.width/2?n:i,y:(o+e)/2}}.call(this,h);new e.MultiTooltip({x:d.x,y:d.y,xPadding:this.options.tooltipXPadding,yPadding:this.options.tooltipYPadding,xOffset:this.options.tooltipXOffset,fillColor:this.options.tooltipFillColor,textColor:this.options.tooltipFontColor,fontFamily:this.options.tooltipFontFamily,fontStyle:this.options.tooltipFontStyle,fontSize:this.options.tooltipFontSize,titleTextColor:this.options.tooltipTitleFontColor,titleFontFamily:this.options.tooltipTitleFontFamily,titleFontStyle:this.options.tooltipTitleFontStyle,titleFontSize:this.options.tooltipTitleFontSize,cornerRadius:this.options.tooltipCornerRadius,labels:c,legendColors:u,legendColorBackground:this.options.multiTooltipKeyBackground,title:t[0].label,chart:this.chart,ctx:this.chart.ctx,custom:this.options.customTooltips}).draw()}else n(t,function(t){var i=t.tooltipPosition();new e.Tooltip({x:Math.round(i.x),y:Math.round(i.y),xPadding:this.options.tooltipXPadding,yPadding:this.options.tooltipYPadding,fillColor:this.options.tooltipFillColor,textColor:this.options.tooltipFontColor,fontFamily:this.options.tooltipFontFamily,fontStyle:this.options.tooltipFontStyle,fontSize:this.options.tooltipFontSize,caretHeight:this.options.tooltipCaretSize,cornerRadius:this.options.tooltipCornerRadius,text:C(this.options.tooltipTemplate,t),chart:this.chart,custom:this.options.customTooltips}).draw()},this);return this}},toBase64Image:function(){return this.chart.canvas.toDataURL.apply(this.chart.canvas,arguments)}}),e.Type.extend=function(t){var i=this,s=function(){return i.apply(this,arguments)};if(s.prototype=o(i.prototype),a(s.prototype,t),s.extend=e.Type.extend,t.name||i.prototype.name){var n=t.name||i.prototype.name,l=e.defaults[i.prototype.name]?o(e.defaults[i.prototype.name]):{};e.defaults[n]=a(l,t.defaults),e.types[n]=s,e.prototype[n]=function(t,i){var o=h(e.defaults.global,e.defaults[n],i||{});return new s(t,o,this)}}else d("Name not provided for this chart, so it hasn't been registered");return i},e.Element=function(t){a(this,t),this.initialize.apply(this,arguments),this.save()},a(e.Element.prototype,{initialize:function(){},restore:function(t){return t?n(t,function(t){this[t]=this._saved[t]},this):a(this,this._saved),this},save:function(){return this._saved=o(this),delete this._saved._saved,this},update:function(t){return n(t,function(t,i){this._saved[i]=this[i],this[i]=t},this),this},transition:function(t,i){return n(t,function(t,e){this[e]=(t-this._saved[e])*i+this._saved[e]},this),this},tooltipPosition:function(){return{x:this.x,y:this.y}},hasValue:function(){return f(this.value)}}),e.Element.extend=r,e.Point=e.Element.extend({display:!0,inRange:function(t,i){var e=this.hitDetectionRadius+this.radius;return Math.pow(t-this.x,2)+Math.pow(i-this.y,2)<Math.pow(e,2)},draw:function(){if(this.display){var t=this.ctx;t.beginPath(),t.arc(this.x,this.y,this.radius,0,2*Math.PI),t.closePath(),t.strokeStyle=this.strokeColor,t.lineWidth=this.strokeWidth,t.fillStyle=this.fillColor,t.fill(),t.stroke()}}}),e.Arc=e.Element.extend({inRange:function(t,i){var e=s.getAngleFromPoint(this,{x:t,y:i}),n=e.angle>=this.startAngle&&e.angle<=this.endAngle,o=e.distance>=this.innerRadius&&e.distance<=this.outerRadius;return n&&o},tooltipPosition:function(){var t=this.startAngle+(this.endAngle-this.startAngle)/2,i=(this.outerRadius-this.innerRadius)/2+this.innerRadius;return{x:this.x+Math.cos(t)*i,y:this.y+Math.sin(t)*i}},draw:function(t){var i=this.ctx;i.beginPath(),i.arc(this.x,this.y,this.outerRadius,this.startAngle,this.endAngle),i.arc(this.x,this.y,this.innerRadius,this.endAngle,this.startAngle,!0),i.closePath(),i.strokeStyle=this.strokeColor,i.lineWidth=this.strokeWidth,i.fillStyle=this.fillColor,i.fill(),i.lineJoin="bevel",this.showStroke&&i.stroke()}}),e.Rectangle=e.Element.extend({draw:function(){var t=this.ctx,i=this.width/2,e=this.x-i,s=this.x+i,n=this.base-(this.base-this.y),o=this.strokeWidth/2;this.showStroke&&(e+=o,s-=o,n+=o),t.beginPath(),t.fillStyle=this.fillColor,t.strokeStyle=this.strokeColor,t.lineWidth=this.strokeWidth,t.moveTo(e,this.base),t.lineTo(e,n),t.lineTo(s,n),t.lineTo(s,this.base),t.fill(),this.showStroke&&t.stroke()},height:function(){return this.base-this.y},inRange:function(t,i){return t>=this.x-this.width/2&&t<=this.x+this.width/2&&i>=this.y&&i<=this.base}}),e.Tooltip=e.Element.extend({draw:function(){var t=this.chart.ctx;t.font=W(this.fontSize,this.fontStyle,this.fontFamily),this.xAlign="center",this.yAlign="above";var i=this.caretPadding=2,e=t.measureText(this.text).width+2*this.xPadding,s=this.fontSize+2*this.yPadding,n=s+this.caretHeight+i;this.x+e/2>this.chart.width?this.xAlign="left":this.x-e/2<0&&(this.xAlign="right"),this.y-n<0&&(this.yAlign="below");var o=this.x-e/2,a=this.y-n;if(t.fillStyle=this.fillColor,this.custom)this.custom(this);else{switch(this.yAlign){case"above":t.beginPath(),t.moveTo(this.x,this.y-i),t.lineTo(this.x+this.caretHeight,this.y-(i+this.caretHeight)),t.lineTo(this.x-this.caretHeight,this.y-(i+this.caretHeight)),t.closePath(),t.fill();break;case"below":a=this.y+i+this.caretHeight,t.beginPath(),t.moveTo(this.x,this.y+i),t.lineTo(this.x+this.caretHeight,this.y+i+this.caretHeight),t.lineTo(this.x-this.caretHeight,this.y+i+this.caretHeight),t.closePath(),t.fill()}switch(this.xAlign){case"left":o=this.x-e+(this.cornerRadius+this.caretHeight);break;case"right":o=this.x-(this.cornerRadius+this.caretHeight)}B(t,o,a,e,s,this.cornerRadius),t.fill(),t.fillStyle=this.textColor,t.textAlign="center",t.textBaseline="middle",t.fillText(this.text,o+e/2,a+s/2)}}}),e.MultiTooltip=e.Element.extend({initialize:function(){this.font=W(this.fontSize,this.fontStyle,this.fontFamily),this.titleFont=W(this.titleFontSize,this.titleFontStyle,this.titleFontFamily),this.height=this.labels.length*this.fontSize+(this.labels.length-1)*(this.fontSize/2)+2*this.yPadding+1.5*this.titleFontSize,this.ctx.font=this.titleFont;var t=this.ctx.measureText(this.title).width,i=z(this.ctx,this.font,this.labels)+this.fontSize+3,e=g([i,t]);this.width=e+2*this.xPadding;var s=this.height/2;this.y-s<0?this.y=s:this.y+s>this.chart.height&&(this.y=this.chart.height-s),this.x>this.chart.width/2?this.x-=this.xOffset+this.width:this.x+=this.xOffset},getLineHeight:function(t){var i=this.y-this.height/2+this.yPadding,e=t-1;return 0===t?i+this.titleFontSize/2:i+(1.5*this.fontSize*e+this.fontSize/2)+1.5*this.titleFontSize},draw:function(){if(this.custom)this.custom(this);else{B(this.ctx,this.x,this.y-this.height/2,this.width,this.height,this.cornerRadius);var t=this.ctx;t.fillStyle=this.fillColor,t.fill(),t.closePath(),t.textAlign="left",t.textBaseline="middle",t.fillStyle=this.titleTextColor,t.font=this.titleFont,t.fillText(this.title,this.x+this.xPadding,this.getLineHeight(0)),t.font=this.font,s.each(this.labels,function(i,e){t.fillStyle=this.textColor,t.fillText(i,this.x+this.xPadding+this.fontSize+3,this.getLineHeight(e+1)),t.fillStyle=this.legendColorBackground,t.fillRect(this.x+this.xPadding,this.getLineHeight(e+1)-this.fontSize/2,this.fontSize,this.fontSize),t.fillStyle=this.legendColors[e].fill,t.fillRect(this.x+this.xPadding,this.getLineHeight(e+1)-this.fontSize/2,this.fontSize,this.fontSize)},this)}}}),e.Scale=e.Element.extend({initialize:function(){this.fit()},buildYLabels:function(){this.yLabels=[];for(var t=v(this.stepValue),i=0;i<=this.steps;i++)this.yLabels.push(C(this.templateString,{value:(this.min+i*this.stepValue).toFixed(t)}));this.yLabelWidth=this.display&&this.showLabels?z(this.ctx,this.font,this.yLabels):0},addXLabel:function(t){this.xLabels.push(t),this.valuesCount++,this.fit()},removeXLabel:function(){this.xLabels.shift(),this.valuesCount--,this.fit()},fit:function(){this.startPoint=this.display?this.fontSize:0,this.endPoint=this.display?this.height-1.5*this.fontSize-5:this.height,this.startPoint+=this.padding,this.endPoint-=this.padding;var t,i=this.endPoint-this.startPoint;for(this.calculateYRange(i),this.buildYLabels(),this.calculateXLabelRotation();i>this.endPoint-this.startPoint;)i=this.endPoint-this.startPoint,t=this.yLabelWidth,this.calculateYRange(i),this.buildYLabels(),t<this.yLabelWidth&&this.calculateXLabelRotation()},calculateXLabelRotation:function(){this.ctx.font=this.font;var t,i,e=this.ctx.measureText(this.xLabels[0]).width,s=this.ctx.measureText(this.xLabels[this.xLabels.length-1]).width;if(this.xScalePaddingRight=s/2+3,this.xScalePaddingLeft=e/2>this.yLabelWidth+10?e/2:this.yLabelWidth+10,this.xLabelRotation=0,this.display){var n,o=z(this.ctx,this.font,this.xLabels);this.xLabelWidth=o;for(var a=Math.floor(this.calculateX(1)-this.calculateX(0))-6;this.xLabelWidth>a&&0===this.xLabelRotation||this.xLabelWidth>a&&this.xLabelRotation<=90&&this.xLabelRotation>0;)n=Math.cos(S(this.xLabelRotation)),t=n*e,i=n*s,t+this.fontSize/2>this.yLabelWidth+8&&(this.xScalePaddingLeft=t+this.fontSize/2),this.xScalePaddingRight=this.fontSize/2,this.xLabelRotation++,this.xLabelWidth=n*o;this.xLabelRotation>0&&(this.endPoint-=Math.sin(S(this.xLabelRotation))*o+3)}else this.xLabelWidth=0,this.xScalePaddingRight=this.padding,this.xScalePaddingLeft=this.padding},calculateYRange:c,drawingArea:function(){return this.startPoint-this.endPoint},calculateY:function(t){var i=this.drawingArea()/(this.min-this.max);return this.endPoint-i*(t-this.min)},calculateX:function(t){var i=(this.xLabelRotation>0,this.width-(this.xScalePaddingLeft+this.xScalePaddingRight)),e=i/Math.max(this.valuesCount-(this.offsetGridLines?0:1),1),s=e*t+this.xScalePaddingLeft;return this.offsetGridLines&&(s+=e/2),Math.round(s)},update:function(t){s.extend(this,t),this.fit()},draw:function(){var t=this.ctx,i=(this.endPoint-this.startPoint)/this.steps,e=Math.round(this.xScalePaddingLeft);this.display&&(t.fillStyle=this.textColor,t.font=this.font,n(this.yLabels,function(n,o){var a=this.endPoint-i*o,h=Math.round(a),l=this.showHorizontalLines;t.textAlign="right",t.textBaseline="middle",this.showLabels&&t.fillText(n,e-10,a),0!==o||l||(l=!0),l&&t.beginPath(),o>0?(t.lineWidth=this.gridLineWidth,t.strokeStyle=this.gridLineColor):(t.lineWidth=this.lineWidth,t.strokeStyle=this.lineColor),h+=s.aliasPixel(t.lineWidth),l&&(t.moveTo(e,h),t.lineTo(this.width,h),t.stroke(),t.closePath()),t.lineWidth=this.lineWidth,t.strokeStyle=this.lineColor,t.beginPath(),t.moveTo(e-5,h),t.lineTo(e,h),t.stroke(),t.closePath()},this),n(this.xLabels,function(i,e){var s=this.calculateX(e)+x(this.lineWidth),n=this.calculateX(e-(this.offsetGridLines?.5:0))+x(this.lineWidth),o=this.xLabelRotation>0,a=this.showVerticalLines;0!==e||a||(a=!0),a&&t.beginPath(),e>0?(t.lineWidth=this.gridLineWidth,t.strokeStyle=this.gridLineColor):(t.lineWidth=this.lineWidth,t.strokeStyle=this.lineColor),a&&(t.moveTo(n,this.endPoint),t.lineTo(n,this.startPoint-3),t.stroke(),t.closePath()),t.lineWidth=this.lineWidth,t.strokeStyle=this.lineColor,t.beginPath(),t.moveTo(n,this.endPoint),t.lineTo(n,this.endPoint+5),t.stroke(),t.closePath(),t.save(),t.translate(s,o?this.endPoint+12:this.endPoint+8),t.rotate(-1*S(this.xLabelRotation)),t.font=this.font,t.textAlign=o?"right":"center",t.textBaseline=o?"middle":"top",t.fillText(i,0,0),t.restore()},this))}}),e.RadialScale=e.Element.extend({initialize:function(){this.size=m([this.height,this.width]),this.drawingArea=this.display?this.size/2-(this.fontSize/2+this.backdropPaddingY):this.size/2},calculateCenterOffset:function(t){var i=this.drawingArea/(this.max-this.min);return(t-this.min)*i},update:function(){this.lineArc?this.drawingArea=this.display?this.size/2-(this.fontSize/2+this.backdropPaddingY):this.size/2:this.setScaleSize(),this.buildYLabels()},buildYLabels:function(){this.yLabels=[];for(var t=v(this.stepValue),i=0;i<=this.steps;i++)this.yLabels.push(C(this.templateString,{value:(this.min+i*this.stepValue).toFixed(t)}))},getCircumference:function(){return 2*Math.PI/this.valuesCount},setScaleSize:function(){var t,i,e,s,n,o,a,h,l,r,c,u,d=m([this.height/2-this.pointLabelFontSize-5,this.width/2]),p=this.width,g=0;for(this.ctx.font=W(this.pointLabelFontSize,this.pointLabelFontStyle,this.pointLabelFontFamily),i=0;i<this.valuesCount;i++)t=this.getPointPosition(i,d),e=this.ctx.measureText(C(this.templateString,{value:this.labels[i]})).width+5,0===i||i===this.valuesCount/2?(s=e/2,t.x+s>p&&(p=t.x+s,n=i),t.x-s<g&&(g=t.x-s,a=i)):i<this.valuesCount/2?t.x+e>p&&(p=t.x+e,n=i):i>this.valuesCount/2&&t.x-e<g&&(g=t.x-e,a=i);l=g,r=Math.ceil(p-this.width),o=this.getIndexAngle(n),h=this.getIndexAngle(a),c=r/Math.sin(o+Math.PI/2),u=l/Math.sin(h+Math.PI/2),c=f(c)?c:0,u=f(u)?u:0,this.drawingArea=d-(u+c)/2,this.setCenterPoint(u,c)},setCenterPoint:function(t,i){var e=this.width-i-this.drawingArea,s=t+this.drawingArea;this.xCenter=(s+e)/2,this.yCenter=this.height/2},getIndexAngle:function(t){var i=2*Math.PI/this.valuesCount;return t*i-Math.PI/2},getPointPosition:function(t,i){var e=this.getIndexAngle(t);return{x:Math.cos(e)*i+this.xCenter,y:Math.sin(e)*i+this.yCenter}},draw:function(){if(this.display){var t=this.ctx;if(n(this.yLabels,function(i,e){if(e>0){var s,n=e*(this.drawingArea/this.steps),o=this.yCenter-n;if(this.lineWidth>0)if(t.strokeStyle=this.lineColor,t.lineWidth=this.lineWidth,this.lineArc)t.beginPath(),t.arc(this.xCenter,this.yCenter,n,0,2*Math.PI),t.closePath(),t.stroke();else{t.beginPath();for(var a=0;a<this.valuesCount;a++)s=this.getPointPosition(a,this.calculateCenterOffset(this.min+e*this.stepValue)),0===a?t.moveTo(s.x,s.y):t.lineTo(s.x,s.y);t.closePath(),t.stroke()}if(this.showLabels){if(t.font=W(this.fontSize,this.fontStyle,this.fontFamily),this.showLabelBackdrop){var h=t.measureText(i).width;t.fillStyle=this.backdropColor,t.fillRect(this.xCenter-h/2-this.backdropPaddingX,o-this.fontSize/2-this.backdropPaddingY,h+2*this.backdropPaddingX,this.fontSize+2*this.backdropPaddingY)}t.textAlign="center",t.textBaseline="middle",t.fillStyle=this.fontColor,t.fillText(i,this.xCenter,o)}}},this),!this.lineArc){t.lineWidth=this.angleLineWidth,t.strokeStyle=this.angleLineColor;for(var i=this.valuesCount-1;i>=0;i--){if(this.angleLineWidth>0){var e=this.getPointPosition(i,this.calculateCenterOffset(this.max));t.beginPath(),t.moveTo(this.xCenter,this.yCenter),t.lineTo(e.x,e.y),t.stroke(),t.closePath()}var s=this.getPointPosition(i,this.calculateCenterOffset(this.max)+5);t.font=W(this.pointLabelFontSize,this.pointLabelFontStyle,this.pointLabelFontFamily),t.fillStyle=this.pointLabelFontColor;var o=this.labels.length,a=this.labels.length/2,h=a/2,l=h>i||i>o-h,r=i===h||i===o-h;t.textAlign=0===i?"center":i===a?"center":a>i?"left":"right",t.textBaseline=r?"middle":l?"bottom":"top",t.fillText(this.labels[i],s.x,s.y)}}}}}),s.addEvent(window,"resize",function(){var t;return function(){clearTimeout(t),t=setTimeout(function(){n(e.instances,function(t){t.options.responsive&&t.resize(t.render,!0)})},50)}}()),p?!(__WEBPACK_AMD_DEFINE_RESULT__ = function(){return e}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)):"object"==typeof module&&module.exports&&(module.exports=e),t.Chart=e,e.noConflict=function(){return t.Chart=i,e}}).call(this),function(){"use strict";var t=this,i=t.Chart,e=i.helpers,s={scaleBeginAtZero:!0,scaleShowGridLines:!0,scaleGridLineColor:"rgba(0,0,0,.05)",scaleGridLineWidth:1,scaleShowHorizontalLines:!0,scaleShowVerticalLines:!0,barShowStroke:!0,barStrokeWidth:2,barValueSpacing:5,barDatasetSpacing:1,legendTemplate:'<ul class="<%=name.toLowerCase()%>-legend"><% for (var i=0; i<datasets.length; i++){%><li><span style="background-color:<%=datasets[i].fillColor%>"></span><%if(datasets[i].label){%><%=datasets[i].label%><%}%></li><%}%></ul>'};i.Type.extend({name:"Bar",defaults:s,initialize:function(t){var s=this.options;this.ScaleClass=i.Scale.extend({offsetGridLines:!0,calculateBarX:function(t,i,e){var n=this.calculateBaseWidth(),o=this.calculateX(e)-n/2,a=this.calculateBarWidth(t);return o+a*i+i*s.barDatasetSpacing+a/2},calculateBaseWidth:function(){return this.calculateX(1)-this.calculateX(0)-2*s.barValueSpacing},calculateBarWidth:function(t){var i=this.calculateBaseWidth()-(t-1)*s.barDatasetSpacing;return i/t}}),this.datasets=[],this.options.showTooltips&&e.bindEvents(this,this.options.tooltipEvents,function(t){var i="mouseout"!==t.type?this.getBarsAtEvent(t):[];this.eachBars(function(t){t.restore(["fillColor","strokeColor"])}),e.each(i,function(t){t.fillColor=t.highlightFill,t.strokeColor=t.highlightStroke}),this.showTooltip(i)}),this.BarClass=i.Rectangle.extend({strokeWidth:this.options.barStrokeWidth,showStroke:this.options.barShowStroke,ctx:this.chart.ctx}),e.each(t.datasets,function(i){var s={label:i.label||null,fillColor:i.fillColor,strokeColor:i.strokeColor,bars:[]};this.datasets.push(s),e.each(i.data,function(e,n){s.bars.push(new this.BarClass({value:e,label:t.labels[n],datasetLabel:i.label,strokeColor:i.strokeColor,fillColor:i.fillColor,highlightFill:i.highlightFill||i.fillColor,highlightStroke:i.highlightStroke||i.strokeColor}))},this)},this),this.buildScale(t.labels),this.BarClass.prototype.base=this.scale.endPoint,this.eachBars(function(t,i,s){e.extend(t,{width:this.scale.calculateBarWidth(this.datasets.length),x:this.scale.calculateBarX(this.datasets.length,s,i),y:this.scale.endPoint}),t.save()},this),this.render()},update:function(){this.scale.update(),e.each(this.activeElements,function(t){t.restore(["fillColor","strokeColor"])}),this.eachBars(function(t){t.save()}),this.render()},eachBars:function(t){e.each(this.datasets,function(i,s){e.each(i.bars,t,this,s)},this)},getBarsAtEvent:function(t){for(var i,s=[],n=e.getRelativePosition(t),o=function(t){s.push(t.bars[i])},a=0;a<this.datasets.length;a++)for(i=0;i<this.datasets[a].bars.length;i++)if(this.datasets[a].bars[i].inRange(n.x,n.y))return e.each(this.datasets,o),s;return s},buildScale:function(t){var i=this,s=function(){var t=[];return i.eachBars(function(i){t.push(i.value)}),t},n={templateString:this.options.scaleLabel,height:this.chart.height,width:this.chart.width,ctx:this.chart.ctx,textColor:this.options.scaleFontColor,fontSize:this.options.scaleFontSize,fontStyle:this.options.scaleFontStyle,fontFamily:this.options.scaleFontFamily,valuesCount:t.length,beginAtZero:this.options.scaleBeginAtZero,integersOnly:this.options.scaleIntegersOnly,calculateYRange:function(t){var i=e.calculateScaleRange(s(),t,this.fontSize,this.beginAtZero,this.integersOnly);e.extend(this,i)},xLabels:t,font:e.fontString(this.options.scaleFontSize,this.options.scaleFontStyle,this.options.scaleFontFamily),lineWidth:this.options.scaleLineWidth,lineColor:this.options.scaleLineColor,showHorizontalLines:this.options.scaleShowHorizontalLines,showVerticalLines:this.options.scaleShowVerticalLines,gridLineWidth:this.options.scaleShowGridLines?this.options.scaleGridLineWidth:0,gridLineColor:this.options.scaleShowGridLines?this.options.scaleGridLineColor:"rgba(0,0,0,0)",padding:this.options.showScale?0:this.options.barShowStroke?this.options.barStrokeWidth:0,showLabels:this.options.scaleShowLabels,display:this.options.showScale};this.options.scaleOverride&&e.extend(n,{calculateYRange:e.noop,steps:this.options.scaleSteps,stepValue:this.options.scaleStepWidth,min:this.options.scaleStartValue,max:this.options.scaleStartValue+this.options.scaleSteps*this.options.scaleStepWidth}),this.scale=new this.ScaleClass(n)},addData:function(t,i){e.each(t,function(t,e){this.datasets[e].bars.push(new this.BarClass({value:t,label:i,x:this.scale.calculateBarX(this.datasets.length,e,this.scale.valuesCount+1),y:this.scale.endPoint,width:this.scale.calculateBarWidth(this.datasets.length),base:this.scale.endPoint,strokeColor:this.datasets[e].strokeColor,fillColor:this.datasets[e].fillColor}))
	},this),this.scale.addXLabel(i),this.update()},removeData:function(){this.scale.removeXLabel(),e.each(this.datasets,function(t){t.bars.shift()},this),this.update()},reflow:function(){e.extend(this.BarClass.prototype,{y:this.scale.endPoint,base:this.scale.endPoint});var t=e.extend({height:this.chart.height,width:this.chart.width});this.scale.update(t)},draw:function(t){var i=t||1;this.clear();this.chart.ctx;this.scale.draw(i),e.each(this.datasets,function(t,s){e.each(t.bars,function(t,e){t.hasValue()&&(t.base=this.scale.endPoint,t.transition({x:this.scale.calculateBarX(this.datasets.length,s,e),y:this.scale.calculateY(t.value),width:this.scale.calculateBarWidth(this.datasets.length)},i).draw())},this)},this)}})}.call(this),function(){"use strict";var t=this,i=t.Chart,e=i.helpers,s={segmentShowStroke:!0,segmentStrokeColor:"#fff",segmentStrokeWidth:2,percentageInnerCutout:50,animationSteps:100,animationEasing:"easeOutBounce",animateRotate:!0,animateScale:!1,legendTemplate:'<ul class="<%=name.toLowerCase()%>-legend"><% for (var i=0; i<segments.length; i++){%><li><span style="background-color:<%=segments[i].fillColor%>"></span><%if(segments[i].label){%><%=segments[i].label%><%}%></li><%}%></ul>'};i.Type.extend({name:"Doughnut",defaults:s,initialize:function(t){this.segments=[],this.outerRadius=(e.min([this.chart.width,this.chart.height])-this.options.segmentStrokeWidth/2)/2,this.SegmentArc=i.Arc.extend({ctx:this.chart.ctx,x:this.chart.width/2,y:this.chart.height/2}),this.options.showTooltips&&e.bindEvents(this,this.options.tooltipEvents,function(t){var i="mouseout"!==t.type?this.getSegmentsAtEvent(t):[];e.each(this.segments,function(t){t.restore(["fillColor"])}),e.each(i,function(t){t.fillColor=t.highlightColor}),this.showTooltip(i)}),this.calculateTotal(t),e.each(t,function(t,i){this.addData(t,i,!0)},this),this.render()},getSegmentsAtEvent:function(t){var i=[],s=e.getRelativePosition(t);return e.each(this.segments,function(t){t.inRange(s.x,s.y)&&i.push(t)},this),i},addData:function(t,i,e){var s=i||this.segments.length;this.segments.splice(s,0,new this.SegmentArc({value:t.value,outerRadius:this.options.animateScale?0:this.outerRadius,innerRadius:this.options.animateScale?0:this.outerRadius/100*this.options.percentageInnerCutout,fillColor:t.color,highlightColor:t.highlight||t.color,showStroke:this.options.segmentShowStroke,strokeWidth:this.options.segmentStrokeWidth,strokeColor:this.options.segmentStrokeColor,startAngle:1.5*Math.PI,circumference:this.options.animateRotate?0:this.calculateCircumference(t.value),label:t.label})),e||(this.reflow(),this.update())},calculateCircumference:function(t){return 2*Math.PI*(Math.abs(t)/this.total)},calculateTotal:function(t){this.total=0,e.each(t,function(t){this.total+=Math.abs(t.value)},this)},update:function(){this.calculateTotal(this.segments),e.each(this.activeElements,function(t){t.restore(["fillColor"])}),e.each(this.segments,function(t){t.save()}),this.render()},removeData:function(t){var i=e.isNumber(t)?t:this.segments.length-1;this.segments.splice(i,1),this.reflow(),this.update()},reflow:function(){e.extend(this.SegmentArc.prototype,{x:this.chart.width/2,y:this.chart.height/2}),this.outerRadius=(e.min([this.chart.width,this.chart.height])-this.options.segmentStrokeWidth/2)/2,e.each(this.segments,function(t){t.update({outerRadius:this.outerRadius,innerRadius:this.outerRadius/100*this.options.percentageInnerCutout})},this)},draw:function(t){var i=t?t:1;this.clear(),e.each(this.segments,function(t,e){t.transition({circumference:this.calculateCircumference(t.value),outerRadius:this.outerRadius,innerRadius:this.outerRadius/100*this.options.percentageInnerCutout},i),t.endAngle=t.startAngle+t.circumference,t.draw(),0===e&&(t.startAngle=1.5*Math.PI),e<this.segments.length-1&&(this.segments[e+1].startAngle=t.endAngle)},this)}}),i.types.Doughnut.extend({name:"Pie",defaults:e.merge(s,{percentageInnerCutout:0})})}.call(this),function(){"use strict";var t=this,i=t.Chart,e=i.helpers,s={scaleShowGridLines:!0,scaleGridLineColor:"rgba(0,0,0,.05)",scaleGridLineWidth:1,scaleShowHorizontalLines:!0,scaleShowVerticalLines:!0,bezierCurve:!0,bezierCurveTension:.4,pointDot:!0,pointDotRadius:4,pointDotStrokeWidth:1,pointHitDetectionRadius:20,datasetStroke:!0,datasetStrokeWidth:2,datasetFill:!0,legendTemplate:'<ul class="<%=name.toLowerCase()%>-legend"><% for (var i=0; i<datasets.length; i++){%><li><span style="background-color:<%=datasets[i].strokeColor%>"></span><%if(datasets[i].label){%><%=datasets[i].label%><%}%></li><%}%></ul>'};i.Type.extend({name:"Line",defaults:s,initialize:function(t){this.PointClass=i.Point.extend({strokeWidth:this.options.pointDotStrokeWidth,radius:this.options.pointDotRadius,display:this.options.pointDot,hitDetectionRadius:this.options.pointHitDetectionRadius,ctx:this.chart.ctx,inRange:function(t){return Math.pow(t-this.x,2)<Math.pow(this.radius+this.hitDetectionRadius,2)}}),this.datasets=[],this.options.showTooltips&&e.bindEvents(this,this.options.tooltipEvents,function(t){var i="mouseout"!==t.type?this.getPointsAtEvent(t):[];this.eachPoints(function(t){t.restore(["fillColor","strokeColor"])}),e.each(i,function(t){t.fillColor=t.highlightFill,t.strokeColor=t.highlightStroke}),this.showTooltip(i)}),e.each(t.datasets,function(i){var s={label:i.label||null,fillColor:i.fillColor,strokeColor:i.strokeColor,pointColor:i.pointColor,pointStrokeColor:i.pointStrokeColor,points:[]};this.datasets.push(s),e.each(i.data,function(e,n){s.points.push(new this.PointClass({value:e,label:t.labels[n],datasetLabel:i.label,strokeColor:i.pointStrokeColor,fillColor:i.pointColor,highlightFill:i.pointHighlightFill||i.pointColor,highlightStroke:i.pointHighlightStroke||i.pointStrokeColor}))},this),this.buildScale(t.labels),this.eachPoints(function(t,i){e.extend(t,{x:this.scale.calculateX(i),y:this.scale.endPoint}),t.save()},this)},this),this.render()},update:function(){this.scale.update(),e.each(this.activeElements,function(t){t.restore(["fillColor","strokeColor"])}),this.eachPoints(function(t){t.save()}),this.render()},eachPoints:function(t){e.each(this.datasets,function(i){e.each(i.points,t,this)},this)},getPointsAtEvent:function(t){var i=[],s=e.getRelativePosition(t);return e.each(this.datasets,function(t){e.each(t.points,function(t){t.inRange(s.x,s.y)&&i.push(t)})},this),i},buildScale:function(t){var s=this,n=function(){var t=[];return s.eachPoints(function(i){t.push(i.value)}),t},o={templateString:this.options.scaleLabel,height:this.chart.height,width:this.chart.width,ctx:this.chart.ctx,textColor:this.options.scaleFontColor,fontSize:this.options.scaleFontSize,fontStyle:this.options.scaleFontStyle,fontFamily:this.options.scaleFontFamily,valuesCount:t.length,beginAtZero:this.options.scaleBeginAtZero,integersOnly:this.options.scaleIntegersOnly,calculateYRange:function(t){var i=e.calculateScaleRange(n(),t,this.fontSize,this.beginAtZero,this.integersOnly);e.extend(this,i)},xLabels:t,font:e.fontString(this.options.scaleFontSize,this.options.scaleFontStyle,this.options.scaleFontFamily),lineWidth:this.options.scaleLineWidth,lineColor:this.options.scaleLineColor,showHorizontalLines:this.options.scaleShowHorizontalLines,showVerticalLines:this.options.scaleShowVerticalLines,gridLineWidth:this.options.scaleShowGridLines?this.options.scaleGridLineWidth:0,gridLineColor:this.options.scaleShowGridLines?this.options.scaleGridLineColor:"rgba(0,0,0,0)",padding:this.options.showScale?0:this.options.pointDotRadius+this.options.pointDotStrokeWidth,showLabels:this.options.scaleShowLabels,display:this.options.showScale};this.options.scaleOverride&&e.extend(o,{calculateYRange:e.noop,steps:this.options.scaleSteps,stepValue:this.options.scaleStepWidth,min:this.options.scaleStartValue,max:this.options.scaleStartValue+this.options.scaleSteps*this.options.scaleStepWidth}),this.scale=new i.Scale(o)},addData:function(t,i){e.each(t,function(t,e){this.datasets[e].points.push(new this.PointClass({value:t,label:i,x:this.scale.calculateX(this.scale.valuesCount+1),y:this.scale.endPoint,strokeColor:this.datasets[e].pointStrokeColor,fillColor:this.datasets[e].pointColor}))},this),this.scale.addXLabel(i),this.update()},removeData:function(){this.scale.removeXLabel(),e.each(this.datasets,function(t){t.points.shift()},this),this.update()},reflow:function(){var t=e.extend({height:this.chart.height,width:this.chart.width});this.scale.update(t)},draw:function(t){var i=t||1;this.clear();var s=this.chart.ctx,n=function(t){return null!==t.value},o=function(t,i,s){return e.findNextWhere(i,n,s)||t},a=function(t,i,s){return e.findPreviousWhere(i,n,s)||t};this.scale.draw(i),e.each(this.datasets,function(t){var h=e.where(t.points,n);e.each(t.points,function(t,e){t.hasValue()&&t.transition({y:this.scale.calculateY(t.value),x:this.scale.calculateX(e)},i)},this),this.options.bezierCurve&&e.each(h,function(t,i){var s=i>0&&i<h.length-1?this.options.bezierCurveTension:0;t.controlPoints=e.splineCurve(a(t,h,i),t,o(t,h,i),s),t.controlPoints.outer.y>this.scale.endPoint?t.controlPoints.outer.y=this.scale.endPoint:t.controlPoints.outer.y<this.scale.startPoint&&(t.controlPoints.outer.y=this.scale.startPoint),t.controlPoints.inner.y>this.scale.endPoint?t.controlPoints.inner.y=this.scale.endPoint:t.controlPoints.inner.y<this.scale.startPoint&&(t.controlPoints.inner.y=this.scale.startPoint)},this),s.lineWidth=this.options.datasetStrokeWidth,s.strokeStyle=t.strokeColor,s.beginPath(),e.each(h,function(t,i){if(0===i)s.moveTo(t.x,t.y);else if(this.options.bezierCurve){var e=a(t,h,i);s.bezierCurveTo(e.controlPoints.outer.x,e.controlPoints.outer.y,t.controlPoints.inner.x,t.controlPoints.inner.y,t.x,t.y)}else s.lineTo(t.x,t.y)},this),s.stroke(),this.options.datasetFill&&h.length>0&&(s.lineTo(h[h.length-1].x,this.scale.endPoint),s.lineTo(h[0].x,this.scale.endPoint),s.fillStyle=t.fillColor,s.closePath(),s.fill()),e.each(h,function(t){t.draw()})},this)}})}.call(this),function(){"use strict";var t=this,i=t.Chart,e=i.helpers,s={scaleShowLabelBackdrop:!0,scaleBackdropColor:"rgba(255,255,255,0.75)",scaleBeginAtZero:!0,scaleBackdropPaddingY:2,scaleBackdropPaddingX:2,scaleShowLine:!0,segmentShowStroke:!0,segmentStrokeColor:"#fff",segmentStrokeWidth:2,animationSteps:100,animationEasing:"easeOutBounce",animateRotate:!0,animateScale:!1,legendTemplate:'<ul class="<%=name.toLowerCase()%>-legend"><% for (var i=0; i<segments.length; i++){%><li><span style="background-color:<%=segments[i].fillColor%>"></span><%if(segments[i].label){%><%=segments[i].label%><%}%></li><%}%></ul>'};i.Type.extend({name:"PolarArea",defaults:s,initialize:function(t){this.segments=[],this.SegmentArc=i.Arc.extend({showStroke:this.options.segmentShowStroke,strokeWidth:this.options.segmentStrokeWidth,strokeColor:this.options.segmentStrokeColor,ctx:this.chart.ctx,innerRadius:0,x:this.chart.width/2,y:this.chart.height/2}),this.scale=new i.RadialScale({display:this.options.showScale,fontStyle:this.options.scaleFontStyle,fontSize:this.options.scaleFontSize,fontFamily:this.options.scaleFontFamily,fontColor:this.options.scaleFontColor,showLabels:this.options.scaleShowLabels,showLabelBackdrop:this.options.scaleShowLabelBackdrop,backdropColor:this.options.scaleBackdropColor,backdropPaddingY:this.options.scaleBackdropPaddingY,backdropPaddingX:this.options.scaleBackdropPaddingX,lineWidth:this.options.scaleShowLine?this.options.scaleLineWidth:0,lineColor:this.options.scaleLineColor,lineArc:!0,width:this.chart.width,height:this.chart.height,xCenter:this.chart.width/2,yCenter:this.chart.height/2,ctx:this.chart.ctx,templateString:this.options.scaleLabel,valuesCount:t.length}),this.updateScaleRange(t),this.scale.update(),e.each(t,function(t,i){this.addData(t,i,!0)},this),this.options.showTooltips&&e.bindEvents(this,this.options.tooltipEvents,function(t){var i="mouseout"!==t.type?this.getSegmentsAtEvent(t):[];e.each(this.segments,function(t){t.restore(["fillColor"])}),e.each(i,function(t){t.fillColor=t.highlightColor}),this.showTooltip(i)}),this.render()},getSegmentsAtEvent:function(t){var i=[],s=e.getRelativePosition(t);return e.each(this.segments,function(t){t.inRange(s.x,s.y)&&i.push(t)},this),i},addData:function(t,i,e){var s=i||this.segments.length;this.segments.splice(s,0,new this.SegmentArc({fillColor:t.color,highlightColor:t.highlight||t.color,label:t.label,value:t.value,outerRadius:this.options.animateScale?0:this.scale.calculateCenterOffset(t.value),circumference:this.options.animateRotate?0:this.scale.getCircumference(),startAngle:1.5*Math.PI})),e||(this.reflow(),this.update())},removeData:function(t){var i=e.isNumber(t)?t:this.segments.length-1;this.segments.splice(i,1),this.reflow(),this.update()},calculateTotal:function(t){this.total=0,e.each(t,function(t){this.total+=t.value},this),this.scale.valuesCount=this.segments.length},updateScaleRange:function(t){var i=[];e.each(t,function(t){i.push(t.value)});var s=this.options.scaleOverride?{steps:this.options.scaleSteps,stepValue:this.options.scaleStepWidth,min:this.options.scaleStartValue,max:this.options.scaleStartValue+this.options.scaleSteps*this.options.scaleStepWidth}:e.calculateScaleRange(i,e.min([this.chart.width,this.chart.height])/2,this.options.scaleFontSize,this.options.scaleBeginAtZero,this.options.scaleIntegersOnly);e.extend(this.scale,s,{size:e.min([this.chart.width,this.chart.height]),xCenter:this.chart.width/2,yCenter:this.chart.height/2})},update:function(){this.calculateTotal(this.segments),e.each(this.segments,function(t){t.save()}),this.reflow(),this.render()},reflow:function(){e.extend(this.SegmentArc.prototype,{x:this.chart.width/2,y:this.chart.height/2}),this.updateScaleRange(this.segments),this.scale.update(),e.extend(this.scale,{xCenter:this.chart.width/2,yCenter:this.chart.height/2}),e.each(this.segments,function(t){t.update({outerRadius:this.scale.calculateCenterOffset(t.value)})},this)},draw:function(t){var i=t||1;this.clear(),e.each(this.segments,function(t,e){t.transition({circumference:this.scale.getCircumference(),outerRadius:this.scale.calculateCenterOffset(t.value)},i),t.endAngle=t.startAngle+t.circumference,0===e&&(t.startAngle=1.5*Math.PI),e<this.segments.length-1&&(this.segments[e+1].startAngle=t.endAngle),t.draw()},this),this.scale.draw()}})}.call(this),function(){"use strict";var t=this,i=t.Chart,e=i.helpers;i.Type.extend({name:"Radar",defaults:{scaleShowLine:!0,angleShowLineOut:!0,scaleShowLabels:!1,scaleBeginAtZero:!0,angleLineColor:"rgba(0,0,0,.1)",angleLineWidth:1,pointLabelFontFamily:"'Arial'",pointLabelFontStyle:"normal",pointLabelFontSize:10,pointLabelFontColor:"#666",pointDot:!0,pointDotRadius:3,pointDotStrokeWidth:1,pointHitDetectionRadius:20,datasetStroke:!0,datasetStrokeWidth:2,datasetFill:!0,legendTemplate:'<ul class="<%=name.toLowerCase()%>-legend"><% for (var i=0; i<datasets.length; i++){%><li><span style="background-color:<%=datasets[i].strokeColor%>"></span><%if(datasets[i].label){%><%=datasets[i].label%><%}%></li><%}%></ul>'},initialize:function(t){this.PointClass=i.Point.extend({strokeWidth:this.options.pointDotStrokeWidth,radius:this.options.pointDotRadius,display:this.options.pointDot,hitDetectionRadius:this.options.pointHitDetectionRadius,ctx:this.chart.ctx}),this.datasets=[],this.buildScale(t),this.options.showTooltips&&e.bindEvents(this,this.options.tooltipEvents,function(t){var i="mouseout"!==t.type?this.getPointsAtEvent(t):[];this.eachPoints(function(t){t.restore(["fillColor","strokeColor"])}),e.each(i,function(t){t.fillColor=t.highlightFill,t.strokeColor=t.highlightStroke}),this.showTooltip(i)}),e.each(t.datasets,function(i){var s={label:i.label||null,fillColor:i.fillColor,strokeColor:i.strokeColor,pointColor:i.pointColor,pointStrokeColor:i.pointStrokeColor,points:[]};this.datasets.push(s),e.each(i.data,function(e,n){var o;this.scale.animation||(o=this.scale.getPointPosition(n,this.scale.calculateCenterOffset(e))),s.points.push(new this.PointClass({value:e,label:t.labels[n],datasetLabel:i.label,x:this.options.animation?this.scale.xCenter:o.x,y:this.options.animation?this.scale.yCenter:o.y,strokeColor:i.pointStrokeColor,fillColor:i.pointColor,highlightFill:i.pointHighlightFill||i.pointColor,highlightStroke:i.pointHighlightStroke||i.pointStrokeColor}))},this)},this),this.render()},eachPoints:function(t){e.each(this.datasets,function(i){e.each(i.points,t,this)},this)},getPointsAtEvent:function(t){var i=e.getRelativePosition(t),s=e.getAngleFromPoint({x:this.scale.xCenter,y:this.scale.yCenter},i),n=2*Math.PI/this.scale.valuesCount,o=Math.round((s.angle-1.5*Math.PI)/n),a=[];return(o>=this.scale.valuesCount||0>o)&&(o=0),s.distance<=this.scale.drawingArea&&e.each(this.datasets,function(t){a.push(t.points[o])}),a},buildScale:function(t){this.scale=new i.RadialScale({display:this.options.showScale,fontStyle:this.options.scaleFontStyle,fontSize:this.options.scaleFontSize,fontFamily:this.options.scaleFontFamily,fontColor:this.options.scaleFontColor,showLabels:this.options.scaleShowLabels,showLabelBackdrop:this.options.scaleShowLabelBackdrop,backdropColor:this.options.scaleBackdropColor,backdropPaddingY:this.options.scaleBackdropPaddingY,backdropPaddingX:this.options.scaleBackdropPaddingX,lineWidth:this.options.scaleShowLine?this.options.scaleLineWidth:0,lineColor:this.options.scaleLineColor,angleLineColor:this.options.angleLineColor,angleLineWidth:this.options.angleShowLineOut?this.options.angleLineWidth:0,pointLabelFontColor:this.options.pointLabelFontColor,pointLabelFontSize:this.options.pointLabelFontSize,pointLabelFontFamily:this.options.pointLabelFontFamily,pointLabelFontStyle:this.options.pointLabelFontStyle,height:this.chart.height,width:this.chart.width,xCenter:this.chart.width/2,yCenter:this.chart.height/2,ctx:this.chart.ctx,templateString:this.options.scaleLabel,labels:t.labels,valuesCount:t.datasets[0].data.length}),this.scale.setScaleSize(),this.updateScaleRange(t.datasets),this.scale.buildYLabels()},updateScaleRange:function(t){var i=function(){var i=[];return e.each(t,function(t){t.data?i=i.concat(t.data):e.each(t.points,function(t){i.push(t.value)})}),i}(),s=this.options.scaleOverride?{steps:this.options.scaleSteps,stepValue:this.options.scaleStepWidth,min:this.options.scaleStartValue,max:this.options.scaleStartValue+this.options.scaleSteps*this.options.scaleStepWidth}:e.calculateScaleRange(i,e.min([this.chart.width,this.chart.height])/2,this.options.scaleFontSize,this.options.scaleBeginAtZero,this.options.scaleIntegersOnly);e.extend(this.scale,s)},addData:function(t,i){this.scale.valuesCount++,e.each(t,function(t,e){var s=this.scale.getPointPosition(this.scale.valuesCount,this.scale.calculateCenterOffset(t));this.datasets[e].points.push(new this.PointClass({value:t,label:i,x:s.x,y:s.y,strokeColor:this.datasets[e].pointStrokeColor,fillColor:this.datasets[e].pointColor}))},this),this.scale.labels.push(i),this.reflow(),this.update()},removeData:function(){this.scale.valuesCount--,this.scale.labels.shift(),e.each(this.datasets,function(t){t.points.shift()},this),this.reflow(),this.update()},update:function(){this.eachPoints(function(t){t.save()}),this.reflow(),this.render()},reflow:function(){e.extend(this.scale,{width:this.chart.width,height:this.chart.height,size:e.min([this.chart.width,this.chart.height]),xCenter:this.chart.width/2,yCenter:this.chart.height/2}),this.updateScaleRange(this.datasets),this.scale.setScaleSize(),this.scale.buildYLabels()},draw:function(t){var i=t||1,s=this.chart.ctx;this.clear(),this.scale.draw(),e.each(this.datasets,function(t){e.each(t.points,function(t,e){t.hasValue()&&t.transition(this.scale.getPointPosition(e,this.scale.calculateCenterOffset(t.value)),i)},this),s.lineWidth=this.options.datasetStrokeWidth,s.strokeStyle=t.strokeColor,s.beginPath(),e.each(t.points,function(t,i){0===i?s.moveTo(t.x,t.y):s.lineTo(t.x,t.y)},this),s.closePath(),s.stroke(),s.fillStyle=t.fillColor,s.fill(),e.each(t.points,function(t){t.hasValue()&&t.draw()})},this)}})}.call(this);

/***/ }),
/* 335 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(__webpack_amd_options__) {module.exports = __webpack_amd_options__;
	
	/* WEBPACK VAR INJECTION */}.call(exports, {}))

/***/ }),
/* 336 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Home store
	 */
	
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _fluxUtils = __webpack_require__(228);
	
	var _dispatcherDispatcher = __webpack_require__(223);
	
	var _dispatcherDispatcher2 = _interopRequireDefault(_dispatcherDispatcher);
	
	var _objectAssign = __webpack_require__(279);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	var _dataUtilsSalaryDataUtils = __webpack_require__(337);
	
	var _dataUtilsSalaryDataUtils2 = _interopRequireDefault(_dataUtilsSalaryDataUtils);
	
	var SalaryStore = (function (_ReduceStore) {
	  _inherits(SalaryStore, _ReduceStore);
	
	  function SalaryStore() {
	    _classCallCheck(this, SalaryStore);
	
	    _get(Object.getPrototypeOf(SalaryStore.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(SalaryStore, [{
	    key: 'getInitialState',
	    value: function getInitialState() {
	      return {
	        basicInfo: {},
	        status: 'loading',
	        total: 0,
	        infoList: [],
	        chartData: [],
	        salaryCalendar: {
	          minYear: 2015,
	          payrollPeriodList: []
	        }
	      };
	    }
	  }, {
	    key: 'reduce',
	    value: function reduce(state, action) {
	      switch (action.type) {
	        case 'get-salary':
	          return (0, _objectAssign2['default'])({}, state, {
	            accountList: state.accountList,
	            status: 'loading'
	          });
	        case 'get-salary-success':
	          var chartData = (action.data.payCharts || []).map(function (item) {
	            item.label = item.payrollChartsName;
	            item.value = item.payrollTotal;
	            return item;
	          });
	
	          return (0, _objectAssign2['default'])({}, state, action.data, {
	            chartData: chartData,
	            accountList: state.accountList,
	            status: 'loaded'
	          });
	        case 'get-salary-fail':
	          return _extends({}, state, {
	            chartData: [],
	            status: 'loaded'
	          });
	        case 'get-salary-calendar':
	          return _extends({}, state, {
	            infoList: [],
	            chartData: []
	          });
	        case 'get-salary-calendar-success':
	          return (0, _objectAssign2['default'])({}, state, {
	            salaryCalendar: action.data.payrollData,
	            accountList: null,
	            picInfo: action.data.picInfo,
	            status: 'loaded'
	          });
	        case 'change-account-list':
	          return (0, _objectAssign2['default'])({}, state, {
	            accountList: action.data
	          });
	      }
	      return state;
	    }
	  }]);
	
	  return SalaryStore;
	})(_fluxUtils.ReduceStore);
	
	exports['default'] = new SalaryStore(_dispatcherDispatcher2['default']);
	module.exports = exports['default'];

/***/ }),
/* 337 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Created by AshZhang on 15/10/8.
	 */
	
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _dispatcherDispatcher = __webpack_require__(223);
	
	var _dispatcherDispatcher2 = _interopRequireDefault(_dispatcherDispatcher);
	
	var _commonUtilsAjax = __webpack_require__(222);
	
	var _commonUtilsAjax2 = _interopRequireDefault(_commonUtilsAjax);
	
	exports['default'] = {
	
	  /**
	   * Get user salary
	   * @param {number} year
	   * @param {number} month
	   * @param {string} accName
	   */
	  getSalary: function getSalary(_ref) {
	    var year = _ref.year;
	    var month = _ref.month;
	    var accName = _ref.accName;
	
	    (0, _commonUtilsAjax.ajaxDispatch)({
	      action: 'get-salary',
	      url: '/salary',
	      method: 'post',
	      data: {
	        salaryYear: year,
	        salaryMonth: month,
	        salaryCode: accName
	      }
	    });
	  },
	
	  /**
	   * Get salary calendar
	   */
	  getSalaryCalendar: function getSalaryCalendar() {
	    (0, _commonUtilsAjax.ajaxDispatch)({
	      action: 'get-salary-calendar',
	      url: '/calendar-salary',
	      method: 'get'
	    });
	  }
	};
	module.exports = exports['default'];

/***/ }),
/* 338 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * 个人中心 -》 修改密码
	 */
	
	'use strict';
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(23);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _fluxUtils = __webpack_require__(228);
	
	var _dispatcherDispatcher = __webpack_require__(223);
	
	var _commonLang = __webpack_require__(245);
	
	var _commonUtilsAjax = __webpack_require__(222);
	
	var _commonUtilsAjax2 = _interopRequireDefault(_commonUtilsAjax);
	
	var _componentsFormControlFormControlJsx = __webpack_require__(291);
	
	var _componentsFormControlFormControlJsx2 = _interopRequireDefault(_componentsFormControlFormControlJsx);
	
	var _componentsTextInputTextInputJsx = __webpack_require__(283);
	
	var _componentsTextInputTextInputJsx2 = _interopRequireDefault(_componentsTextInputTextInputJsx);
	
	var _componentsButtonButtonJsx = __webpack_require__(250);
	
	var _componentsButtonButtonJsx2 = _interopRequireDefault(_componentsButtonButtonJsx);
	
	var _componentsAlertErrorBoxJsx = __webpack_require__(297);
	
	var _componentsAlertErrorBoxJsx2 = _interopRequireDefault(_componentsAlertErrorBoxJsx);
	
	var _componentsHeaderHeaderJsx = __webpack_require__(247);
	
	var _componentsHeaderHeaderJsx2 = _interopRequireDefault(_componentsHeaderHeaderJsx);
	
	var _componentsFormFormJsx = __webpack_require__(280);
	
	var _componentsFormFormJsx2 = _interopRequireDefault(_componentsFormFormJsx);
	
	var _storesUserStore = __webpack_require__(303);
	
	var _storesUserStore2 = _interopRequireDefault(_storesUserStore);
	
	var _dataUtilsUserDataUtils = __webpack_require__(302);
	
	var _dataUtilsUserDataUtils2 = _interopRequireDefault(_dataUtilsUserDataUtils);
	
	var changePwdControls = [{
	  type: 'tel',
	  id: 'mobile',
	  name: 'mobile',
	  label: (0, _commonLang.getItem)('MOBILE'),
	  minLength: 11,
	  maxLength: 11,
	  required: true,
	  tips: (0, _commonLang.getItem)('MOBILE_TIP')
	}, {
	  type: 'tel',
	  id: 'captcha',
	  name: 'captcha',
	  label: (0, _commonLang.getItem)('CAPTCHA'),
	  minLength: 6,
	  maxLength: 6,
	  required: true,
	  tips: (0, _commonLang.getItem)('REQUIRED')
	}, {
	  type: 'password',
	  id: 'newPwd',
	  name: 'newPwd',
	  label: (0, _commonLang.getItem)('NEW_PWD'),
	  tips: (0, _commonLang.getItem)('AT_LEAST_6'),
	  required: true,
	  minLength: 6
	}, {
	  type: 'password',
	  id: 'repeatPwd',
	  name: 'repeatPwd',
	  label: (0, _commonLang.getItem)('REPEAT_PWD'),
	  tips: (0, _commonLang.getItem)('SAME_PWD'),
	  required: true,
	  minLength: 6
	}];
	
	var submitButton = {
	  text: (0, _commonLang.getItem)('CHANGE_PWD')
	};
	
	var ChangePwd = (function (_Component) {
	  _inherits(ChangePwd, _Component);
	
	  function ChangePwd(props) {
	    _classCallCheck(this, ChangePwd);
	
	    _get(Object.getPrototypeOf(ChangePwd.prototype), 'constructor', this).call(this, props);
	    this.state = {
	      captchaTimer: 0,
	      accountType: 'phone'
	    };
	    //console.log(localStorage.companyCode);
	
	    this.getCaptcha = this.getCaptcha.bind(this);
	    this.validateMobile = this.validateMobile.bind(this);
	    this.validateEmail = this.validateEmail.bind(this);
	    this.validateNext = this.validateNext.bind(this);
	    this.chooseAccountType = this.chooseAccountType.bind(this);
	    this.commit = this.commit.bind(this);
	  }
	
	  _createClass(ChangePwd, [{
	    key: 'render',
	    value: function render() {
	      var captchaTimer = this.state.captchaTimer;
	      var getCaptchaText = captchaTimer ? captchaTimer + ' ' + (0, _commonLang.getItem)('RETRY_CAPTCHA') : (0, _commonLang.getItem)('GET_CAPTCHA');
	      var captchaDisabled = !!captchaTimer;
	      //console.log(captchaDisabled);
	      //console.log(captchaTimer);
	      //console.log(captchaTimer);
	      return _react2['default'].createElement(
	        'div',
	        null,
	        _react2['default'].createElement(_componentsHeaderHeaderJsx2['default'], { back: true, title: (0, _commonLang.getItem)('CHANGE_PWD') }),
	        _react2['default'].createElement(
	          'div',
	          { className: 'login-forgot-page' },
	          _react2['default'].createElement(
	            'form',
	            { ref: 'changePasswordForm', className: 'login-forgot-form' },
	            _react2['default'].createElement(
	              'div',
	              { className: 'form-control form-control-radio' },
	              _react2['default'].createElement('input', { type: 'radio', ref: 'accountTypePhone', name: 'accountType', defaultChecked: true, onChange: this.chooseAccountType, value: 'phone' }),
	              '手机 ',
	              _react2['default'].createElement('input', { type: 'radio', ref: 'accountTypeEmail', name: 'accountType', onChange: this.chooseAccountType, value: 'email' }),
	              '邮箱'
	            ),
	            _react2['default'].createElement(
	              _componentsFormControlFormControlJsx2['default'],
	              { label: (0, _commonLang.getItem)('MOBILE'), tips: (0, _commonLang.getItem)('REQUIRED'), type: this.state.accountType == 'phone' ? 'block' : 'hidden' },
	              _react2['default'].createElement(_componentsTextInputTextInputJsx2['default'], { ref: 'phone', id: 'phone', name: 'phone',
	                type: 'tel', required: true,
	                onChange: this.validateMobile, onBlur: this.validateMobile })
	            ),
	            _react2['default'].createElement(
	              _componentsFormControlFormControlJsx2['default'],
	              { label: (0, _commonLang.getItem)('EMAIL'), tips: (0, _commonLang.getItem)('REQUIRED'), type: 'hidden', type: this.state.accountType == 'email' ? 'block' : 'hidden' },
	              _react2['default'].createElement(_componentsTextInputTextInputJsx2['default'], { ref: 'email', id: 'email', name: 'email',
	                type: 'email', required: true,
	                onChange: this.validateMobile, onBlur: this.validateEmail })
	            ),
	            _react2['default'].createElement(
	              _componentsFormControlFormControlJsx2['default'],
	              { label: (0, _commonLang.getItem)('CAPTCHA'), tips: (0, _commonLang.getItem)('REQUIRED') },
	              _react2['default'].createElement(_componentsTextInputTextInputJsx2['default'], { id: 'captcha', name: 'captcha', required: true, onChange: this.validateNext })
	            ),
	            _react2['default'].createElement(_componentsButtonButtonJsx2['default'], { ref: 'getCaptcha',
	              className: 'login-get-captcha', text: getCaptchaText, link: true,
	              style: { bottom: 'auto', top: '7.75rem' },
	              onTouchTap: captchaDisabled ? function () {} : this.getCaptcha }),
	            _react2['default'].createElement(
	              _componentsFormControlFormControlJsx2['default'],
	              { label: (0, _commonLang.getItem)('NEW_PWD'), tips: (0, _commonLang.getItem)('AT_LEAST_6') },
	              _react2['default'].createElement(_componentsTextInputTextInputJsx2['default'], { type: 'password', id: 'newPwd', name: 'newPwd', minLength: '6', required: true })
	            ),
	            _react2['default'].createElement(
	              _componentsFormControlFormControlJsx2['default'],
	              { label: (0, _commonLang.getItem)('REPEAT_PWD'), tips: (0, _commonLang.getItem)('SAME_PWD') },
	              _react2['default'].createElement(_componentsTextInputTextInputJsx2['default'], { type: 'password', id: 'repeatPwd', name: 'repeatPwd', minLength: '6', required: true })
	            ),
	            _react2['default'].createElement(_componentsAlertErrorBoxJsx2['default'], { ref: 'errorBox' }),
	            _react2['default'].createElement('input', { type: 'hidden', ref: 'accountType', id: 'type', name: 'type' }),
	            _react2['default'].createElement(_componentsButtonButtonJsx2['default'], { ref: 'next', className: 'login-reset-pwd', text: (0, _commonLang.getItem)('CHANGE_PWD'), disabled: true, onTouchTap: this.commit })
	          )
	        )
	      );
	    }
	
	    /**
	    * choose account type (phone or email)
	    * 
	    * @memberof event
	    */
	  }, {
	    key: 'chooseAccountType',
	    value: function chooseAccountType(e) {
	      if (e.target.value == 'phone') {
	        _react2['default'].findDOMNode(this.refs.accountTypePhone).checked = 'checked';
	        _react2['default'].findDOMNode(this.refs.email).value = '1@1.com'; //test
	        this.setState({ accountType: 'phone' });
	      } else {
	        var email = _react2['default'].findDOMNode(this.refs.accountTypeEmail);
	        email.checked = 'checked';
	        _react2['default'].findDOMNode(this.refs.phone).value = '15800000000'; //test
	        this.setState({ accountType: 'email' });
	      }
	    }
	
	    /**
	     *  验证邮箱
	     */
	  }, {
	    key: 'validateEmail',
	    value: function validateEmail() {
	      var item = _react2['default'].findDOMNode(this.refs.email).value;
	      var matchEmail = /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})$/;
	      var emailValid = matchEmail.test(item);
	
	      if (item == '') {
	        this.refs.errorBox.setState({ message: '邮箱格式有误' });
	        return false;
	      }
	      if (!emailValid) {
	        this.refs.errorBox.setState({ message: '邮箱格式有误' });
	        return false;
	      }
	      this.refs.errorBox.setState({ message: '' });
	      return true;
	    }
	
	    /**
	    * 验证手机号
	    */
	
	  }, {
	    key: 'validateMobile',
	    value: function validateMobile() {
	      var item = _react2['default'].findDOMNode(this.refs.phone).value;
	
	      var mobileValid = true;
	      var emailValid = true;
	      //check mobile
	      if (item.length < 11) {
	        mobileValid = false;
	      }
	
	      if (!mobileValid) {
	        this.refs.errorBox.setState({ message: '手机号格式有误' });
	        return false;
	      }
	      this.refs.errorBox.setState({ message: '' });
	      return true;
	    }
	
	    /**
	     * 获取验证码
	     * 
	    / */
	  }, {
	    key: 'getCaptcha',
	    value: function getCaptcha() {
	      var _this = this;
	
	      if (this.state.accountType == 'phone') {
	        if (this.validateMobile() == false) {
	          return;
	        }
	      } else {
	        if (this.validateEmail() == false) {
	          return;
	        }
	      }
	
	      var timer = 61,
	          timeout = undefined,
	          self = this;
	
	      function countDown() {
	        timer -= 1;
	
	        self.setState({
	          captchaTimer: timer
	        });
	
	        if (timer === 0) {
	          return clearTimeout(timeout);
	        }
	
	        timeout = setTimeout(countDown, 1000);
	      }
	
	      setTimeout(countDown, 0);
	      var accountType = this.state.accountType,
	          email = _react2['default'].findDOMNode(this.refs.email).value,
	          phone = _react2['default'].findDOMNode(this.refs.phone).value,
	          companyCode = localStorage.companyCode;
	
	      if (this.state.accountType == 'phone') {
	        if (this.validateMobile()) {
	          _commonUtilsAjax2['default'].post('/validation-no', {
	            type: 1,
	            companyCode: companyCode,
	            phone: phone,
	            captcha: ''
	          }).then(function (res) {
	            //alert(JSON.stringify(res));
	            if (res.res == false) {
	              alert(res.error);
	              (0, _dispatcherDispatcher.dispatch)({
	                type: 'get-captcha-fail'
	              });
	              _this.setState({ captchaTimer: 0 });
	            } else {
	              (0, _dispatcherDispatcher.dispatch)({ type: 'get-captcha-success' });
	            }
	          })['catch'](function () {
	            //alert('ex');
	            clearTimeout(timeout);
	            (0, _dispatcherDispatcher.dispatch)({
	              type: 'get-captcha-fail'
	            });
	            _this.setState({ captchaTimer: 0 });
	          });
	        }
	      } else {
	        if (this.validateEmail()) {
	          _commonUtilsAjax2['default'].post('/validation-email', {
	            type: 2,
	            companyCode: companyCode,
	            email: email,
	            captcha: ''
	          }).then(function (res) {
	            if (res.res == false) {
	              alert(res.error);
	              (0, _dispatcherDispatcher.dispatch)({
	                type: 'get-captcha-fail'
	              });
	              _this.setState({ captchaTimer: 0 });
	            } else {
	              (0, _dispatcherDispatcher.dispatch)({ type: 'get-captcha-success' });
	            }
	          })['catch'](function (e) {
	            clearTimeout(timeout);
	            (0, _dispatcherDispatcher.dispatch)({
	              type: 'get-captcha-fail'
	            });
	            _this.setState({ captchaTimer: 0 });
	          });
	        }
	      }
	    }
	
	    /**
	     * Check if can go to next step
	     * @param e
	     */
	  }, {
	    key: 'validateNext',
	    value: function validateNext(e) {
	      var captcha = e.target.value,
	          valid = this.validateMobile() && captcha && captcha.length;
	
	      _react2['default'].findDOMNode(this.refs.next).disabled = !valid;
	
	      return valid;
	    }
	
	    /**
	     * 
	     *  修改密码表单提交
	     */
	  }, {
	    key: 'commit',
	    value: function commit() {
	      var _this2 = this;
	
	      if (this.state.accountType == 'phone') {
	        if (this.validateMobile() == false) {
	          return;
	        }
	      } else {
	        if (this.validateEmail() == false) {
	          return;
	        }
	      }
	      if (document.getElementById('captcha').value == '') {
	        alert('Captcha is required');
	        return false;
	      }
	      if (document.getElementById('newPwd').value == '') {
	        alert((0, _commonLang.getItem)('NEW_PWD') + ' ' + (0, _commonLang.getItem)('AT_LEAST_6'));
	        return false;
	      }
	      if (document.getElementById('newPwd').value !== document.getElementById('repeatPwd').value) {
	        alert((0, _commonLang.getItem)('REPEAT_PWD') + ' ' + (0, _commonLang.getItem)('SAME_PWD'));
	        return false;
	      }
	
	      _react2['default'].findDOMNode(this.refs.accountType).value = this.state.accountType == 'phone' ? 1 : 2;
	
	      var form = _react2['default'].findDOMNode(this.refs.changePasswordForm);
	      var formData = new FormData(form);
	      //formData.append('type',)
	      // .afterSubmit(res)
	      _commonUtilsAjax2['default'].post('/change-password', formData).then(function (res) {
	        if (res.res == false) {
	          alert(res.error);
	        } else {
	          _this2.setState({
	            disabled: false,
	            submitting: false
	          });
	
	          alert((0, _commonLang.getItem)('EDIT_SUCCESS'));
	          history.back();
	        }
	      })['catch'](function (e) {
	        _this2.setState({
	          disabled: false,
	          submitting: false
	        });
	      });
	    }
	  }]);
	
	  return ChangePwd;
	})(_react.Component);
	
	exports['default'] = ChangePwd;
	module.exports = exports['default'];

/***/ }),
/* 339 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Home page
	 */
	
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x2, _x3, _x4) { var _again = true; _function: while (_again) { var object = _x2, property = _x3, receiver = _x4; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x2 = parent; _x3 = property; _x4 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(23);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _fluxUtils = __webpack_require__(228);
	
	var _dispatcherDispatcher = __webpack_require__(223);
	
	var _dispatcherDispatcher2 = _interopRequireDefault(_dispatcherDispatcher);
	
	var _commonLang = __webpack_require__(245);
	
	var _componentsHeaderHeaderJsx = __webpack_require__(247);
	
	var _componentsHeaderHeaderJsx2 = _interopRequireDefault(_componentsHeaderHeaderJsx);
	
	var _componentsPullLoaderPullLoaderJsx = __webpack_require__(340);
	
	var _componentsPullLoaderPullLoaderJsx2 = _interopRequireDefault(_componentsPullLoaderPullLoaderJsx);
	
	var _componentsSearchSearchJsx = __webpack_require__(343);
	
	var _componentsSearchSearchJsx2 = _interopRequireDefault(_componentsSearchSearchJsx);
	
	var _componentsSorterSorterJsx = __webpack_require__(346);
	
	var _componentsSorterSorterJsx2 = _interopRequireDefault(_componentsSorterSorterJsx);
	
	var _componentsUserListUserListJsx = __webpack_require__(349);
	
	var _componentsUserListUserListJsx2 = _interopRequireDefault(_componentsUserListUserListJsx);
	
	var _storesTeamProfileStore = __webpack_require__(352);
	
	var _storesTeamProfileStore2 = _interopRequireDefault(_storesTeamProfileStore);
	
	var sortItems = [{
	  text: (0, _commonLang.getItem)('NAME'),
	  name: 'name',
	  order: 'ASC'
	}, {
	  text: (0, _commonLang.getItem)('POSITION'),
	  name: 'position',
	  order: 'DESC'
	}];
	
	var TeamProfile = (function (_Component) {
	  _inherits(TeamProfile, _Component);
	
	  function TeamProfile(props) {
	    _classCallCheck(this, TeamProfile);
	
	    _get(Object.getPrototypeOf(TeamProfile.prototype), 'constructor', this).call(this, props);
	    this.search = this.search.bind(this);
	    this.selectUser = this.selectUser.bind(this);
	    this.sort = this.sort.bind(this);
	    this.getTeamMembers();
	  }
	
	  _createClass(TeamProfile, [{
	    key: 'render',
	    value: function render() {
	      var _state = this.state;
	      var status = _state.status;
	      var empList = _state.empList;
	
	      return _react2['default'].createElement(
	        'div',
	        null,
	        _react2['default'].createElement(
	          _componentsHeaderHeaderJsx2['default'],
	          { goBack: true, title: (0, _commonLang.getItem)('TEAM_PROFILE'), dropdown: true },
	          _react2['default'].createElement(_componentsSearchSearchJsx2['default'], { placeholder: (0, _commonLang.getItem)('ENTER_USER_SEARCH'), onSearch: this.search })
	        ),
	        _react2['default'].createElement(
	          _componentsPullLoaderPullLoaderJsx2['default'],
	          { status: status, className: 'pad-b', onLoad: this.loadMore },
	          _react2['default'].createElement(_componentsUserListUserListJsx2['default'], { userList: empList, onSelectUser: this.selectUser })
	        )
	      );
	    }
	
	    /**
	     * Get team members
	     * @param {Object} [query]
	     */
	  }, {
	    key: 'getTeamMembers',
	    value: function getTeamMembers() {
	      var query = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	      query.page = 1;
	      query.pageSize = 16;
	      query.loadMore = false;
	      (0, _dispatcherDispatcher.dispatch)({
	        type: 'get-team-members',
	        data: query
	      });
	    }
	
	    /**
	     * Load next page
	     */
	  }, {
	    key: 'loadMore',
	    value: function loadMore() {
	      (0, _dispatcherDispatcher.dispatch)({
	        type: 'get-team-members',
	        data: {
	          loadMore: true
	        }
	      });
	    }
	
	    /**
	     * Go to employee profile page
	     * @param id
	     */
	  }, {
	    key: 'selectUser',
	    value: function selectUser(id) {
	      location.hash = '/team-profile/profile/' + id;
	    }
	
	    /**
	     * Search employee
	     * @param {string} query
	     */
	  }, {
	    key: 'search',
	    value: function search(query) {
	      this.getTeamMembers({
	        search: query
	      });
	    }
	
	    /**
	     * Sort
	     * @param {string} name
	     * @param {string} order
	     */
	  }, {
	    key: 'sort',
	    value: function sort(name, order) {
	      this.getTeamMembers({
	        sort: name,
	        order: order
	      });
	    }
	  }], [{
	    key: 'getStores',
	    value: function getStores() {
	      return [_storesTeamProfileStore2['default']];
	    }
	  }, {
	    key: 'calculateState',
	    value: function calculateState() {
	      return _storesTeamProfileStore2['default'].getState();
	    }
	  }]);
	
	  return TeamProfile;
	})(_react.Component);
	
	exports['default'] = _fluxUtils.Container.create(TeamProfile);
	module.exports = exports['default'];
	/*<Sorter items={sortItems} defaultItem='name' onSort={this.sort} />*/

/***/ }),
/* 340 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Created by AshZhang on 15/10/9.
	 */
	
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	__webpack_require__(341);
	
	var _react = __webpack_require__(23);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _commonLang = __webpack_require__(245);
	
	var _commonLang2 = _interopRequireDefault(_commonLang);
	
	function load() {
	  var pullLoader = load.pullLoader;
	
	  if (pullLoader.props.status === 'no-more-data') return;
	
	  var pageHeight = document.body.clientHeight,
	      windowHeight = document.documentElement.clientHeight,
	      scrollY = window.scrollY;
	
	  if (windowHeight + scrollY >= pageHeight) {
	    if (typeof load.pullLoader.props.onLoad === 'function') {
	      load.pullLoader.props.onLoad.call(this);
	    }
	  }
	}
	
	var PullLoader = (function (_Component) {
	  _inherits(PullLoader, _Component);
	
	  function PullLoader(props) {
	    _classCallCheck(this, PullLoader);
	
	    _get(Object.getPrototypeOf(PullLoader.prototype), 'constructor', this).call(this, props);
	    load.pullLoader = this;
	  }
	
	  _createClass(PullLoader, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.continueLoading();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.stopLoading();
	    }
	  }, {
	    key: 'continueLoading',
	    value: function continueLoading() {
	      window.addEventListener('scroll', load, false);
	    }
	  }, {
	    key: 'stopLoading',
	    value: function stopLoading() {
	      window.removeEventListener('scroll', load, false);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props;
	      var status = _props.status;
	      var _props$className = _props.className;
	      var className = _props$className === undefined ? '' : _props$className;
	
	      var props = _objectWithoutProperties(_props, ['status', 'className']);
	
	      return _react2['default'].createElement(
	        'div',
	        _extends({ className: className }, props),
	        this.props.children,
	        _react2['default'].createElement(
	          'div',
	          { className: 'pull-loader ' + status },
	          status === 'loaded' ? (0, _commonLang.getItem)('PULL_TO_LOAD') : status === 'loading' ? _react2['default'].createElement('i', { className: 'fa fa-spinner fa-pulse text-primary' }) : _react2['default'].createElement(
	            'span',
	            null,
	            _react2['default'].createElement('i', { className: 'fa fa-meh-o' }),
	            ' ',
	            (0, _commonLang.getItem)('NO_MORE_DATA')
	          )
	        )
	      );
	    }
	  }]);
	
	  return PullLoader;
	})(_react.Component);
	
	exports['default'] = PullLoader;
	module.exports = exports['default'];

/***/ }),
/* 341 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 342 */,
/* 343 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Created by AshZhang on 15/9/29.
	 */
	
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	__webpack_require__(344);
	
	var _react = __webpack_require__(23);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactLibReactCSSTransitionGroup = __webpack_require__(259);
	
	var _reactLibReactCSSTransitionGroup2 = _interopRequireDefault(_reactLibReactCSSTransitionGroup);
	
	var _ButtonButtonJsx = __webpack_require__(250);
	
	var _ButtonButtonJsx2 = _interopRequireDefault(_ButtonButtonJsx);
	
	var _FormControlFormControlJsx = __webpack_require__(291);
	
	var _FormControlFormControlJsx2 = _interopRequireDefault(_FormControlFormControlJsx);
	
	var _TextInputTextInputJsx = __webpack_require__(283);
	
	var _TextInputTextInputJsx2 = _interopRequireDefault(_TextInputTextInputJsx);
	
	var Search = (function (_Component) {
	  _inherits(Search, _Component);
	
	  function Search(props) {
	    _classCallCheck(this, Search);
	
	    _get(Object.getPrototypeOf(Search.prototype), 'constructor', this).call(this, props);
	
	    this.state = {
	      opened: false
	    };
	
	    this.open = this.open.bind(this);
	    this.close = this.close.bind(this);
	    this.search = this.search.bind(this);
	    this.checkEnter = this.checkEnter.bind(this);
	  }
	
	  _createClass(Search, [{
	    key: 'render',
	    value: function render() {
	      var opened = this.state.opened;
	      var placeholder = this.props.placeholder;
	
	      return _react2['default'].createElement(
	        'div',
	        { className: 'search' },
	        !opened ? _react2['default'].createElement(_ButtonButtonJsx2['default'], { className: 'search-toggle', icon: 'search',
	          onTouchTap: this.open }) : null,
	        _react2['default'].createElement(
	          _reactLibReactCSSTransitionGroup2['default'],
	          { component: 'div', transitionName: 'search' },
	          opened ? _react2['default'].createElement(
	            _FormControlFormControlJsx2['default'],
	            { className: 'search-text' },
	            _react2['default'].createElement(_TextInputTextInputJsx2['default'], { ref: 'search', icon: 'search', placeholder: placeholder,
	              onBlur: this.search, onKeyDown: this.checkEnter }),
	            _react2['default'].createElement(_ButtonButtonJsx2['default'], { className: 'search-close', icon: 'times', onTouchTap: this.close })
	          ) : null
	        )
	      );
	    }
	
	    /**
	     * Toggle open status
	     */
	  }, {
	    key: 'open',
	    value: function open() {
	      this.setState({
	        opened: true
	      });
	    }
	
	    /**
	     * Close a search (search an empty string)
	     */
	  }, {
	    key: 'close',
	    value: function close() {
	      this.search({
	        target: {
	          value: ''
	        }
	      });
	      this.setState({
	        opened: false
	      });
	    }
	
	    /**
	     * Press enter to search
	     * @param e
	     */
	  }, {
	    key: 'checkEnter',
	    value: function checkEnter(e) {
	      if (e.key === 'Enter') {
	        this.search(e);
	      }
	    }
	
	    /**
	     * Search event
	     * @param {Event} e
	     */
	  }, {
	    key: 'search',
	    value: function search(e) {
	      if (typeof this.props.onSearch === 'function') {
	        this.props.onSearch.call(this, e.target.value);
	      }
	    }
	  }]);
	
	  return Search;
	})(_react.Component);
	
	exports['default'] = Search;
	module.exports = exports['default'];

/***/ }),
/* 344 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 345 */,
/* 346 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Created by AshZhang on 15/9/29.
	 */
	
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	__webpack_require__(347);
	
	var _react = __webpack_require__(23);
	
	var _react2 = _interopRequireDefault(_react);
	
	var Sorter = (function (_Component) {
	  _inherits(Sorter, _Component);
	
	  function Sorter(props) {
	    var _this = this;
	
	    _classCallCheck(this, Sorter);
	
	    _get(Object.getPrototypeOf(Sorter.prototype), 'constructor', this).call(this, props);
	
	    this.state = {
	      items: this.props.items || []
	    };
	
	    // Initialize default item
	    this.state.items.forEach(function (item) {
	      item.active = item.name === _this.props.defaultItem;
	    });
	  }
	
	  _createClass(Sorter, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var items = this.state.items;
	
	      return _react2['default'].createElement(
	        'ul',
	        { className: 'sorter' },
	        items.map(function (item, index) {
	          var className = 'sorter-item' + (item.active ? ' active' : '') + (item.order === 'ASC' ? ' asc' : ' desc');
	
	          return _react2['default'].createElement(
	            'li',
	            { className: className, key: index,
	              onTouchTap: _this2.onActivateSort.bind(_this2, index) },
	            _react2['default'].createElement(
	              'span',
	              { className: 'sorter-item-text' },
	              item.text
	            )
	          );
	        })
	      );
	    }
	
	    /**
	     * Activate sorter item by index
	     * @param {number} index
	     */
	  }, {
	    key: 'onActivateSort',
	    value: function onActivateSort(index) {
	      var items = this.state.items,
	          item = items[index];
	
	      if (item.active) {
	
	        // Switch order only if the item is active
	        item.order = item.order === 'ASC' ? 'DESC' : 'ASC';
	      } else {
	        items.forEach(function (item, itemIndex) {
	          item.active = itemIndex === index;
	        });
	      }
	
	      this.setState({ items: items });
	
	      if (typeof this.props.onSort === 'function') {
	        this.props.onSort.call(this, item.name, item.order);
	      }
	    }
	  }]);
	
	  return Sorter;
	})(_react.Component);
	
	exports['default'] = Sorter;
	module.exports = exports['default'];

/***/ }),
/* 347 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 348 */,
/* 349 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Created by AshZhang on 15/9/29.
	 */
	
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	__webpack_require__(350);
	
	var _react = __webpack_require__(23);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _UserInfoUserInfoJsx = __webpack_require__(318);
	
	var _UserInfoUserInfoJsx2 = _interopRequireDefault(_UserInfoUserInfoJsx);
	
	var UserList = (function (_Component) {
	  _inherits(UserList, _Component);
	
	  function UserList() {
	    _classCallCheck(this, UserList);
	
	    _get(Object.getPrototypeOf(UserList.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(UserList, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props;
	      var userList = _props.userList;
	      var onSelectUser = _props.onSelectUser;
	
	      return _react2['default'].createElement(
	        'div',
	        { className: 'user-list' },
	        userList.map(function (userInfo, index) {
	          return _react2['default'].createElement(_UserInfoUserInfoJsx2['default'], { key: index, userInfo: userInfo, simple: true, onSelectUser: onSelectUser });
	        })
	      );
	    }
	  }]);
	
	  return UserList;
	})(_react.Component);
	
	exports['default'] = UserList;
	module.exports = exports['default'];

/***/ }),
/* 350 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 351 */,
/* 352 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Home store
	 */
	
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _fluxUtils = __webpack_require__(228);
	
	var _dispatcherDispatcher = __webpack_require__(223);
	
	var _dispatcherDispatcher2 = _interopRequireDefault(_dispatcherDispatcher);
	
	var _objectAssign = __webpack_require__(279);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	var _dataUtilsProfileDataUtils = __webpack_require__(329);
	
	var _dataUtilsProfileDataUtils2 = _interopRequireDefault(_dataUtilsProfileDataUtils);
	
	var TeamProfileStore = (function (_ReduceStore) {
	  _inherits(TeamProfileStore, _ReduceStore);
	
	  function TeamProfileStore() {
	    _classCallCheck(this, TeamProfileStore);
	
	    _get(Object.getPrototypeOf(TeamProfileStore.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(TeamProfileStore, [{
	    key: 'getInitialState',
	    value: function getInitialState() {
	      return {
	        empList: [],
	        status: 'loading',
	        query: {
	          page: 1,
	          pageSize: 20,
	          sort: 'name',
	          order: 'ASC'
	        }
	      };
	    }
	  }, {
	    key: 'reduce',
	    value: function reduce(state, action) {
	
	      switch (action.type) {
	
	        case 'get-team-members':
	          var newQuery = (0, _objectAssign2['default'])(state.query, action.data);
	
	          if (action.data && action.data.loadMore) {
	            if (newQuery.status === 'loading') return state;
	
	            newQuery.page += 1;
	          }
	
	          _dataUtilsProfileDataUtils2['default'].getTeamMembers(newQuery);
	          return (0, _objectAssign2['default'])({}, state, {
	            query: newQuery,
	            status: 'loading'
	          });
	
	        case 'get-team-members-success':
	          var data = (action.data || []).map(function (item) {
	            return _extends({}, item, {
	              name: item.firField,
	              position: item.secField
	            });
	          });
	
	          return (0, _objectAssign2['default'])({}, state, {
	            empList: state.query.loadMore ? (state.empList || []).concat(data) : data,
	            status: data.length < state.query.pageSize ? 'no-more-data' : 'loaded'
	          });
	        default:
	      }
	
	      return state;
	    }
	  }]);
	
	  return TeamProfileStore;
	})(_fluxUtils.ReduceStore);
	
	exports['default'] = new TeamProfileStore(_dispatcherDispatcher2['default']);
	module.exports = exports['default'];

/***/ }),
/* 353 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Team Profile Emp Profile
	 */
	
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(23);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _fluxUtils = __webpack_require__(228);
	
	var _dispatcherDispatcher = __webpack_require__(223);
	
	var _dispatcherDispatcher2 = _interopRequireDefault(_dispatcherDispatcher);
	
	var _objectAssign = __webpack_require__(279);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	var _commonLang = __webpack_require__(245);
	
	var _componentsHeaderHeaderJsx = __webpack_require__(247);
	
	var _componentsHeaderHeaderJsx2 = _interopRequireDefault(_componentsHeaderHeaderJsx);
	
	var _componentsLoaderLoaderJsx = __webpack_require__(315);
	
	var _componentsLoaderLoaderJsx2 = _interopRequireDefault(_componentsLoaderLoaderJsx);
	
	var _componentsUserInfoUserInfoJsx = __webpack_require__(318);
	
	var _componentsUserInfoUserInfoJsx2 = _interopRequireDefault(_componentsUserInfoUserInfoJsx);
	
	var _componentsInfoCardInfoCardJsx = __webpack_require__(322);
	
	var _componentsInfoCardInfoCardJsx2 = _interopRequireDefault(_componentsInfoCardInfoCardJsx);
	
	var _componentsTopActionTopActionJsx = __webpack_require__(325);
	
	var _componentsTopActionTopActionJsx2 = _interopRequireDefault(_componentsTopActionTopActionJsx);
	
	var _storesProfileStore = __webpack_require__(328);
	
	var _storesProfileStore2 = _interopRequireDefault(_storesProfileStore);
	
	var _storesUserStore = __webpack_require__(303);
	
	var _storesUserStore2 = _interopRequireDefault(_storesUserStore);
	
	var TeamProfileEmpProfile = (function (_Component) {
	  _inherits(TeamProfileEmpProfile, _Component);
	
	  function TeamProfileEmpProfile(props) {
	    _classCallCheck(this, TeamProfileEmpProfile);
	
	    _get(Object.getPrototypeOf(TeamProfileEmpProfile.prototype), 'constructor', this).call(this, props);
	    this.getProfileCategories(this.props.params.id);
	  }
	
	  _createClass(TeamProfileEmpProfile, [{
	    key: 'render',
	    value: function render() {
	      var _this = this;
	
	      var _state = this.state;
	      var basicInfo = _state.basicInfo;
	      var _state$infoList = _state.infoList;
	      var infoList = _state$infoList === undefined ? [] : _state$infoList;
	      var status = _state.status;
	      var _state$picInfo = _state.picInfo;
	      var picInfo = _state$picInfo === undefined ? {} : _state$picInfo;
	      var menu = _state.menu;
	
	      var baseMenu = (menu.ess || []).filter(function (item) {
	        return item.name === 'baseMessage';
	      });
	
	      var listElements = infoList.map(function (list) {
	
	        return _react2['default'].createElement(
	          'div',
	          { key: list.cmdId },
	          _react2['default'].createElement(
	            'h2',
	            { className: 'info-card-heading gap-t gap-b',
	              onTouchTap: _this.loadCategory.bind(null, list) },
	            list.pla_lan,
	            list.items ? null : _react2['default'].createElement('i', { className: 'icon-icomoon icon-cdp-down-arrow pull-right' })
	          ),
	          list.status ? _react2['default'].createElement(
	            _componentsLoaderLoaderJsx2['default'],
	            { status: list.status, style: { minHeight: 0 } },
	            list.items && list.items.map(function (card, index) {
	              return _react2['default'].createElement(_componentsInfoCardInfoCardJsx2['default'], { items: card, key: index });
	            })
	          ) : null,
	          _react2['default'].createElement('hr', { className: 'gap-t-lg gap-b-lg' })
	        );
	      });
	
	      return _react2['default'].createElement(
	        'div',
	        null,
	        _react2['default'].createElement(_componentsHeaderHeaderJsx2['default'], { goBack: true, title: baseMenu && baseMenu[0] && baseMenu[0].text }),
	        _react2['default'].createElement(
	          _componentsLoaderLoaderJsx2['default'],
	          { status: status, className: 'side-gap pad-b' },
	          listElements
	        ),
	        _react2['default'].createElement(_componentsTopActionTopActionJsx2['default'], null)
	      );
	    }
	
	    /**
	     * Get profile category list
	     * @param id
	     */
	  }, {
	    key: 'getProfileCategories',
	    value: function getProfileCategories(id) {
	      (0, _dispatcherDispatcher.dispatch)({
	        type: 'get-profile-categories',
	        data: id
	      });
	    }
	
	    /**
	     * Load a list of info items
	     * @param list
	     */
	  }, {
	    key: 'loadCategory',
	    value: function loadCategory(list) {
	
	      if (!list.items && list.status !== 'loading') {
	        (0, _dispatcherDispatcher.dispatch)({
	          type: 'get-profile-category-detail',
	          data: list.cmdId
	        });
	      }
	    }
	
	    /**
	     * Get an employees profile
	     * @param {number} [id]
	     */
	  }, {
	    key: 'getProfile',
	    value: function getProfile(id) {
	      (0, _dispatcherDispatcher.dispatch)({
	        type: 'get-profile',
	        data: id
	      });
	    }
	  }], [{
	    key: 'getStores',
	    value: function getStores() {
	      return [_storesProfileStore2['default'], _storesUserStore2['default']];
	    }
	  }, {
	    key: 'calculateState',
	    value: function calculateState() {
	      return (0, _objectAssign2['default'])({}, _storesProfileStore2['default'].getState(), _storesUserStore2['default'].getState());
	    }
	  }]);
	
	  return TeamProfileEmpProfile;
	})(_react.Component);
	
	exports['default'] = _fluxUtils.Container.create(TeamProfileEmpProfile);
	module.exports = exports['default'];
	/*
	 picInfo
	   ? <UserInfo className='gap-t-lg gap-b-lg' userInfo={picInfo} />
	   :null
	*/

/***/ }),
/* 354 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Leave
	 */
	
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(23);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _fluxUtils = __webpack_require__(228);
	
	var _commonLang = __webpack_require__(245);
	
	var _componentsHeaderHeaderJsx = __webpack_require__(247);
	
	var _componentsHeaderHeaderJsx2 = _interopRequireDefault(_componentsHeaderHeaderJsx);
	
	var _componentsTabTabJsx = __webpack_require__(269);
	
	var _componentsTabTabJsx2 = _interopRequireDefault(_componentsTabTabJsx);
	
	var _storesLeaveStore = __webpack_require__(355);
	
	var _storesLeaveStore2 = _interopRequireDefault(_storesLeaveStore);
	
	var Leave = (function (_Component) {
	  _inherits(Leave, _Component);
	
	  function Leave() {
	    _classCallCheck(this, Leave);
	
	    _get(Object.getPrototypeOf(Leave.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(Leave, [{
	    key: 'render',
	    value: function render() {
	      var tabSettings = [{
	        text: (0, _commonLang.getItem)('LEAVE_QUOTA'),
	        name: 'my-leave/leave-quota',
	        icon: 'calendar'
	      }, {
	        text: (0, _commonLang.getItem)('MY_APPLY'),
	        name: 'my-leave/leave-list',
	        icon: 'plane'
	      }, {
	        text: (0, _commonLang.getItem)('LEAVE_SUMMARY'),
	        name: 'my-leave/leave-summary',
	        icon: 'pie-chart'
	      }];
	
	      return _react2['default'].createElement(
	        'div',
	        { className: 'bottom-gap' },
	        _react2['default'].createElement(_componentsTabTabJsx2['default'], { items: tabSettings, bottom: true }),
	        this.props.children
	      );
	    }
	  }], [{
	    key: 'getStores',
	    value: function getStores() {
	      return [_storesLeaveStore2['default']];
	    }
	  }, {
	    key: 'calculateState',
	    value: function calculateState() {
	      return _storesLeaveStore2['default'].getState();
	    }
	  }]);
	
	  return Leave;
	})(_react.Component);
	
	exports['default'] = _fluxUtils.Container.create(Leave);
	module.exports = exports['default'];

/***/ }),
/* 355 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Home store
	 */
	
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _fluxUtils = __webpack_require__(228);
	
	var _dispatcherDispatcher = __webpack_require__(223);
	
	var _dispatcherDispatcher2 = _interopRequireDefault(_dispatcherDispatcher);
	
	var _objectAssign = __webpack_require__(279);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	var _commonLang = __webpack_require__(245);
	
	var _dataUtilsLeaveDataUtils = __webpack_require__(356);
	
	var _dataUtilsLeaveDataUtils2 = _interopRequireDefault(_dataUtilsLeaveDataUtils);
	
	var LeaveStore = (function (_ReduceStore) {
	  _inherits(LeaveStore, _ReduceStore);
	
	  function LeaveStore() {
	    _classCallCheck(this, LeaveStore);
	
	    _get(Object.getPrototypeOf(LeaveStore.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(LeaveStore, [{
	    key: 'getInitialState',
	    value: function getInitialState() {
	      return {
	        leaveForm: [],
	        status: 'loading',
	        leaveValidation: null,
	        leaveTypes: [],
	        leaveEmpList: [],
	        leaveRecords: [],
	        leaveRecord: {},
	        selectedLeaveRecords: [],
	        mgrAjax: false,
	        query: {
	          page: 1
	        },
	        quota: [],
	        quotaTeamList: []
	      };
	    }
	  }, {
	    key: 'reduce',
	    value: function reduce(state, action) {
	      switch (action.type) {
	        case 'get-leave-quota':
	          return _extends({}, state, {
	            quota: [],
	            status: 'loading'
	          });
	        case 'get-leave-quota-success':
	          return _extends({}, state, {
	            quota: action.data || [],
	            status: 'loaded'
	          });
	        case 'get-lv-pending-records':
	          return _extends({}, state, {
	            pendingQuery: action.data,
	            status: 'loading'
	          });
	        case 'get-lv-pending-records-fail':
	          return _extends({}, state, {
	            status: 'loaded'
	          });
	        case 'get-lv-pending-records-success':
	          return _extends({}, state, {
	            pendingRecords: state.pendingQuery.page === 1 ? action.data : state.pendingRecords.concat(action.data),
	            status: 'loaded'
	          });
	        case 'get-quota-members':
	          return _extends({}, state, {
	            status: 'loading'
	          });
	        case 'get-quota-members-fail':
	          return _extends({}, state, {
	            status: 'loaded'
	          });
	        case 'get-quota-members-success':
	          var newList = (action.data.list || []).map(function (item) {
	            return _extends({}, item, {
	              name: item.firField,
	              position: item.secField
	            });
	          });
	          return _extends({}, state, {
	            quotaTeamList: action.data.loadMore ? (state.quotaTeamList || []).concat(newList) : newList,
	            status: 'loaded'
	          });
	        case 'get-leave-form':
	          return (0, _objectAssign2['default'])({}, state, {
	            status: 'loading'
	          });
	        case 'get-leave-form-success':
	          return (0, _objectAssign2['default'])({}, state, {
	            leaveForm: action.data.formConfig,
	            status: 'loaded',
	            leaveValidation: window.leaveValidation,
	            formPostback: true
	          });
	        case 'get-leave-types-success':
	          return (0, _objectAssign2['default'])({}, state, {
	            leaveTypes: action.data
	          });
	        case 'get-leave-filter-success':
	          return _extends({}, state, {
	            filter: {
	              items: action.data.map(function (item) {
	                return _extends({}, item, {
	                  text: item[(0, _commonLang.getLang)() + '_text'],
	                  name: item.value
	                });
	              })
	            }
	          });
	        case 'get-emp-leave-records':
	          var newQuery = (0, _objectAssign2['default'])(state.query, action.data);
	
	          if (action.data && action.data.loadMore) {
	            if (state.status === 'loading') return state;
	
	            newQuery.page += 1;
	          }
	
	          _dataUtilsLeaveDataUtils2['default'].getEmpLeaveRecords(newQuery);
	          return (0, _objectAssign2['default'])({}, state, {
	            status: 'loading',
	            query: newQuery
	          });
	        case 'get-mgr-leave-empList':
	          return _extends({}, state, {
	            status: 'loading'
	          });
	        case 'get-mgr-leave-empList-fail':
	          return _extends({}, state, {
	            status: 'loaded'
	          });
	        case 'get-mgr-leave-empList-success':
	          return (0, _objectAssign2['default'])({}, state, {
	            leaveEmpList: action.data.page !== 1 ? state.leaveEmpList.concat(action.data) : action.data,
	            status: action.data.length < 16 ? 'no-more-data' : 'loaded'
	          });
	        case 'form-submitting':
	          return _extends({}, state, {
	            formSubmitting: true
	          });
	        case 'form-submitting-fail':
	          return _extends({}, state, {
	            formSubmitting: false
	          });
	        case 'get-emp-leave-records-success':
	          var data = action.data;
	
	          return (0, _objectAssign2['default'])({}, state, {
	            leaveRecords: state.query.loadMore ? state.leaveRecords.concat(data) : data,
	            status: data.length < state.query.pageSize ? 'no-more-data' : 'loaded'
	          });
	        case 'get-mgr-leave-history-success':
	          return (0, _objectAssign2['default'])({}, state, {
	            status: 'loaded',
	            leaveRecords: state.query.page === 1 ? action.data : state.leaveRecords.concat(action.data)
	          });
	        case 'get-mgr-leave-history':
	          var newQueryHistory = (0, _objectAssign2['default'])(state.query, action.data);
	
	          return (0, _objectAssign2['default'])({}, state, {
	            status: 'loading',
	            query: newQueryHistory
	          });
	        case 'get-mgr-leave-history-fail':
	          return _extends({}, state, {
	            status: 'loaded'
	          });
	        case 'get-leave-record':
	          return (0, _objectAssign2['default'])({}, state, {
	            status: 'loading'
	          });
	        case 'get-leave-record-success':
	          return (0, _objectAssign2['default'])({}, state, {
	            leaveRecord: action.data,
	            status: 'loaded'
	          });
	        case 'get-leave-summary':
	          return (0, _objectAssign2['default'])({}, state, {
	            status: 'loading'
	          });
	        case 'get-leave-summary-success':
	          return (0, _objectAssign2['default'])({}, state, {
	            leaveSummary: action.data,
	            status: 'loaded'
	          });
	        case 'toggle-leave-record-selectable':
	          return (0, _objectAssign2['default'])({}, state, {
	            selectable: !state.selectable
	          });
	        case 'close-leave-record-selectable':
	          return (0, _objectAssign2['default'])({}, state, {
	            selectable: false
	          });
	        case 'toggle-leave-record-select-status':
	          if (action.data.isSelected && state.selectedLeaveRecords.indexOf(action.data.id) === -1) {
	            state.selectedLeaveRecords.push(action.data.id);
	          }
	          if (!action.data.isSelected && state.selectedLeaveRecords.indexOf(action.data.id) !== -1) {
	            state.selectedLeaveRecords = state.selectedLeaveRecords.filter(function (item) {
	              return item !== action.data.id;
	            });
	          }
	          return (0, _objectAssign2['default'])({}, state);
	        case 'approve-all-leaves':
	        case 'reject-all-leaves':
	          return (0, _objectAssign2['default'])({}, state, {
	            mgrAjax: true
	          });
	        case 'approve-all-leaves-success':
	        case 'reject-all-leaves-success':
	          location.reload();
	          return state;
	        case 'toggle-leave-record-select-all':
	          state.selectedLeaveRecords = [];
	          state.leaveRecords.forEach(function (item) {
	            if (item.status === 2) {
	              item.checked = action.data;
	              state.selectedLeaveRecords.push(item.id);
	            }
	          });
	          return (0, _objectAssign2['default'])({}, state);
	        case 'leave-record-approve-success':
	        case 'leave-record-reject-success':
	          history.back();
	          return state;
	        case 'leave-record-revoke':
	          return (0, _objectAssign2['default'])({}, state, {
	            status: 'loading'
	          });
	        case 'leave-record-revoke-success':
	          return (0, _objectAssign2['default'])({}, state, {
	            leaveRecord: action.data,
	            status: 'loaded'
	          });
	        case 'leave-record-revoke-fail':
	          return (0, _objectAssign2['default'])({}, state, {
	            status: 'loaded'
	          });
	        case 'get-leave-summary-filters':
	          return _extends({}, state, {
	            leaveEmpList: [],
	            configStatus: 'loading',
	            status: 'loaded'
	          });
	        case 'get-leave-summary-filters-fail':
	          return _extends({}, state, {
	            configStatus: 'loaded',
	            status: 'loaded'
	          });
	        case 'get-leave-summary-filters-success':
	          return (0, _objectAssign2['default'])({}, state, {
	            leaveSummaryConfig: action.data.formConfig,
	            configStatus: 'loaded',
	            status: 'loaded'
	          });
	      }
	
	      return state;
	    }
	  }]);
	
	  return LeaveStore;
	})(_fluxUtils.ReduceStore);
	
	exports['default'] = new LeaveStore(_dispatcherDispatcher2['default']);
	module.exports = exports['default'];

/***/ }),
/* 356 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Created by AshZhang on 15/10/8.
	 */
	
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _dispatcherDispatcher = __webpack_require__(223);
	
	var _dispatcherDispatcher2 = _interopRequireDefault(_dispatcherDispatcher);
	
	var _commonUtilsAjax = __webpack_require__(222);
	
	var _commonUtilsAjax2 = _interopRequireDefault(_commonUtilsAjax);
	
	exports['default'] = {
	
	  /**
	   * Get Leave Quota
	   */
	  getQuota: function getQuota(id) {
	    (0, _dispatcherDispatcher.dispatch)({
	      type: 'get-leave-quota'
	    });
	
	    var params = id ? {
	      empId: id
	    } : null;
	
	    _commonUtilsAjax2['default'].get('/user-quota', params).then(function (data) {
	      (0, _dispatcherDispatcher.dispatch)({
	        type: 'get-leave-quota-success',
	        data: data
	      });
	    });
	  },
	
	  /**
	   * Get Leave Quota
	   */
	  getQuotaMembers: function getQuotaMembers() {
	    var query = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	    (0, _dispatcherDispatcher.dispatch)({
	      type: 'get-quota-members'
	    });
	    console.log('/quota-team-member');
	    console.log(query);
	    _commonUtilsAjax2['default'].post('/quota-team-member', query).then(function (data) {
	      console.log(data);
	      (0, _dispatcherDispatcher.dispatch)({
	        type: 'get-quota-members-success',
	        data: {
	          list: data,
	          loadMore: query.loadMore
	        }
	      });
	    })['catch'](function () {
	      (0, _dispatcherDispatcher.dispatch)({
	        type: 'get-quota-members-fail'
	      });
	    });
	  },
	
	  /**
	   * Get leave form
	   */
	  getLeaveForm: function getLeaveForm() {
	    (0, _dispatcherDispatcher.dispatch)({
	      type: 'get-leave-form'
	    });
	
	    _commonUtilsAjax2['default'].get('/ess-lv-config').then(function (form) {
	      //console.log(form);
	      //console.log(new Date(form.formConfig[3].defaultvalue));
	      // if(form != undefined){
	      //   form.formConfig
	      // }
	      _commonUtilsAjax2['default'].getScript(form.JS_CONFIG_FILE).then(function () {
	
	        setTimeout(function () {
	          (0, _dispatcherDispatcher.dispatch)({
	            type: 'get-leave-form-success',
	            data: form
	          });
	        }, 200);
	      });
	    });
	  },
	
	  /**
	   * Get leave history employee list
	   * @param {Object} [params]
	   */
	  getLeaveEmpList: function getLeaveEmpList(params) {
	    _commonUtilsAjax2['default'].get('/lv-history-member', params).then(function (res) {
	      (0, _dispatcherDispatcher.dispatch)({
	        type: 'get-mgr-leave-empList-success',
	        data: res
	      });
	    });
	  },
	
	  /**
	   * Get edit info
	   * @param id
	   */
	  getLeaveEditRecord: function getLeaveEditRecord(id) {
	    (0, _dispatcherDispatcher.dispatch)({
	      type: 'get-leave-form'
	    });
	
	    _commonUtilsAjax2['default'].get('/ess-lv-edit-config', {
	      id: id
	    }).then(function (res) {
	      //console.log('/ess-lv-edit-config：');
	      //res.formConfig[2].defaultValue='1.jpg,2.jpg';
	      //res.formConfig[2].onChange = this.getLeaveSummaryEmpList(1,1);
	      //console.log(res);
	
	      _commonUtilsAjax2['default'].getScript(res.JS_CONFIG_FILE).then(function () {
	        (0, _dispatcherDispatcher.dispatch)({
	          type: 'get-leave-form-success',
	          data: res
	        });
	      });
	    });
	  },
	
	  /**
	   * Get leave history employee list
	   * @param {Object} [params]
	   * @param {Object} [page]
	   */
	  getLeaveSummaryEmpList: function getLeaveSummaryEmpList(params, page) {
	    (0, _dispatcherDispatcher.dispatch)({
	      type: 'get-mgr-leave-empList'
	    });
	
	    _commonUtilsAjax2['default'].post('/lv-team-summary', params).then(function (res) {
	      res.page = page;
	
	      (0, _dispatcherDispatcher.dispatch)({
	        type: 'get-mgr-leave-empList-success',
	        data: res
	      });
	    })['catch'](function () {
	      (0, _dispatcherDispatcher.dispatch)({
	        type: 'get-mgr-leave-empList-fail'
	      });
	    });
	  },
	
	  /**
	   * Get leave history employee list
	   * @param {Object} query
	   */
	  getPendingRecords: function getPendingRecords(query) {
	    (0, _commonUtilsAjax.ajaxDispatch)({
	      action: 'get-lv-pending-records',
	      url: '/mss-lv-todolist',
	      method: 'get',
	      data: query
	    });
	  },
	
	  /**
	   * Get leave types
	   */
	  getLeaveTypes: function getLeaveTypes() {
	    (0, _commonUtilsAjax.ajaxDispatch)({
	      action: 'get-leave-types',
	      url: '/leave-types',
	      method: 'get'
	    });
	  },
	
	  /**
	   * Get an employee's leave records
	   * @param {Object} [params]
	   */
	  getEmpLeaveRecords: function getEmpLeaveRecords(params) {
	    _commonUtilsAjax2['default'].get('/ess-lv-list', params).then(function (res) {
	      (0, _dispatcherDispatcher.dispatch)({
	        type: 'get-emp-leave-records-success',
	        data: res
	      });
	    })['catch'](function (e) {
	      (0, _dispatcherDispatcher.dispatch)({
	        type: 'get-emp-leave-records-success',
	        data: []
	      });
	    });
	  },
	
	  /**
	   * Get an employee's leave records
	   * @param {Object} [params]
	   */
	  getMgrLeaveHistory: function getMgrLeaveHistory(params) {
	    (0, _dispatcherDispatcher.dispatch)({
	      type: 'get-mgr-leave-history',
	      data: params
	    });
	
	    _commonUtilsAjax2['default'].get('/lv-approve-his', params).then(function (res) {
	      (0, _dispatcherDispatcher.dispatch)({
	        type: 'get-mgr-leave-history-success',
	        data: res
	      });
	    })['catch'](function () {
	      (0, _dispatcherDispatcher.dispatch)({
	        type: 'get-mgr-leave-history-fail'
	      });
	    });
	  },
	
	  /**
	   * Get a single leave record by id
	   */
	  getLeaveRecord: function getLeaveRecord(id) {
	
	    (0, _commonUtilsAjax.ajaxDispatch)({
	      action: 'get-leave-record',
	      url: '/ess-lv-detail/' + id,
	      method: 'get'
	    });
	  },
	
	  /**
	   * Get a single leave record by id
	   */
	  getApproveRecord: function getApproveRecord(id) {
	
	    (0, _commonUtilsAjax.ajaxDispatch)({
	      action: 'get-leave-record',
	      url: '/lv-approve-detail',
	      method: 'get',
	      data: { id: id }
	    });
	  },
	
	  /**
	   * 获取休假汇总
	   * @param id
	   * @param query
	   */
	  getLeaveSummary: function getLeaveSummary(id, query) {
	    if (query && id) {
	      query.append('id', id);
	    }
	
	    (0, _commonUtilsAjax.ajaxDispatch)({
	      action: 'get-leave-summary',
	      url: '/ess-lv-summary',
	      method: 'post',
	      data: query || (id ? { id: id } : {})
	    });
	  },
	
	  /**
	   * 获取汇总筛选表
	   */
	  getSummaryFilters: function getSummaryFilters(data) {
	    (0, _commonUtilsAjax.ajaxDispatch)({
	      action: 'get-leave-summary-filters',
	      url: '/filter-config-form',
	      method: 'get',
	      data: data
	    });
	  },
	
	  /**
	   * Approve all records
	   * @param {Array} records
	   */
	  approveAll: function approveAll(records) {
	
	    (0, _commonUtilsAjax.ajaxDispatch)({
	      action: 'approve-all-leaves',
	      url: '/approve-leave',
	      method: 'post',
	      data: records
	    });
	  },
	
	  /**
	   * Reject all records
	   * @param {Array} records
	   */
	  rejectAll: function rejectAll(records) {
	
	    (0, _commonUtilsAjax.ajaxDispatch)({
	      action: 'reject-all-leaves',
	      url: '/reject-leave',
	      method: 'post',
	      data: records
	    });
	  },
	
	  /**
	   * Reject a record
	   */
	  approveRecord: function approveRecord(_ref) {
	    var id = _ref.id;
	    var appOpinion = _ref.appOpinion;
	
	    (0, _commonUtilsAjax.ajaxDispatch)({
	      action: 'leave-record-approve',
	      url: '/mss-lv-approve',
	      method: 'post',
	      data: {
	        id: id,
	        appOpinion: appOpinion,
	        agreeOrNot: true
	      }
	    });
	  },
	
	  /**
	   * Reject a record
	   */
	  rejectRecord: function rejectRecord(_ref2) {
	    var id = _ref2.id;
	    var appOpinion = _ref2.appOpinion;
	
	    (0, _commonUtilsAjax.ajaxDispatch)({
	      action: 'leave-record-reject',
	      url: '/mss-lv-approve',
	      method: 'post',
	      data: {
	        id: id,
	        appOpinion: appOpinion,
	        agreeOrNot: false
	      }
	    });
	  },
	
	  /**
	   * Revoke a record
	   * @param data
	   */
	  revokeRecord: function revokeRecord(data) {
	
	    (0, _commonUtilsAjax.ajaxDispatch)({
	      action: 'leave-record-revoke',
	      url: '/lv-revoke',
	      method: 'post',
	      data: data
	    });
	  },
	
	  getFilter: function getFilter(companyCode) {
	    _commonUtilsAjax2['default'].get('/custom/config/' + companyCode.toUpperCase() + '_LV_STATE.json').then(function (res) {
	      //console.log('/custom/config/' + companyCode.toUpperCase() + '_LV_STATE.json');
	      //console.log(res);
	      (0, _dispatcherDispatcher.dispatch)({
	        type: 'get-leave-filter-success',
	        data: res && res.items || []
	      });
	    });
	  },
	
	  submitForm: function submitForm() {
	    (0, _dispatcherDispatcher.dispatch)({
	      type: 'form-submitting'
	    });
	  },
	
	  submitFormFail: function submitFormFail() {
	    (0, _dispatcherDispatcher.dispatch)({
	      type: 'form-submitting-fail'
	    });
	  }
	};
	module.exports = exports['default'];

/***/ }),
/* 357 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Home page
	 */
	
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(23);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _dispatcherDispatcher = __webpack_require__(223);
	
	var _dispatcherDispatcher2 = _interopRequireDefault(_dispatcherDispatcher);
	
	var _fluxUtils = __webpack_require__(228);
	
	var _commonLang = __webpack_require__(245);
	
	var _LeaveListJsx = __webpack_require__(358);
	
	var _LeaveListJsx2 = _interopRequireDefault(_LeaveListJsx);
	
	var _storesUserStore = __webpack_require__(303);
	
	var _storesUserStore2 = _interopRequireDefault(_storesUserStore);
	
	var _storesLeaveStore = __webpack_require__(355);
	
	var _storesLeaveStore2 = _interopRequireDefault(_storesLeaveStore);
	
	var LeaveListContainer = (function (_Component) {
	  _inherits(LeaveListContainer, _Component);
	
	  function LeaveListContainer() {
	    _classCallCheck(this, LeaveListContainer);
	
	    _get(Object.getPrototypeOf(LeaveListContainer.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(LeaveListContainer, [{
	    key: 'render',
	    value: function render() {
	      var mgr = location.hash.indexOf('mgr') !== -1;
	
	      return _react2['default'].createElement(_LeaveListJsx2['default'], _extends({}, this.state, { mgr: mgr, id: this.props.routeParams.id }));
	    }
	  }], [{
	    key: 'getStores',
	    value: function getStores() {
	      return [_storesLeaveStore2['default'], _storesUserStore2['default']];
	    }
	  }, {
	    key: 'calculateState',
	    value: function calculateState() {
	      return _extends({}, _storesLeaveStore2['default'].getState(), {
	        user: _storesUserStore2['default'].getState()
	      });
	    }
	  }]);
	
	  return LeaveListContainer;
	})(_react.Component);
	
	exports['default'] = _fluxUtils.Container.create(LeaveListContainer);
	module.exports = exports['default'];

/***/ }),
/* 358 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * 休假 - 我的申请列表
	 */
	
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x2, _x3, _x4) { var _again = true; _function: while (_again) { var object = _x2, property = _x3, receiver = _x4; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x2 = parent; _x3 = property; _x4 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(23);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _fluxUtils = __webpack_require__(228);
	
	var _dispatcherDispatcher = __webpack_require__(223);
	
	var _dispatcherDispatcher2 = _interopRequireDefault(_dispatcherDispatcher);
	
	var _commonUtilsAjax = __webpack_require__(222);
	
	var _commonUtilsAjax2 = _interopRequireDefault(_commonUtilsAjax);
	
	var _commonLang = __webpack_require__(245);
	
	var _reactLibReactCSSTransitionGroup = __webpack_require__(259);
	
	var _reactLibReactCSSTransitionGroup2 = _interopRequireDefault(_reactLibReactCSSTransitionGroup);
	
	var _componentsButtonButtonJsx = __webpack_require__(250);
	
	var _componentsButtonButtonJsx2 = _interopRequireDefault(_componentsButtonButtonJsx);
	
	var _componentsFormFormJsx = __webpack_require__(280);
	
	var _componentsFormFormJsx2 = _interopRequireDefault(_componentsFormFormJsx);
	
	var _componentsHeaderHeaderJsx = __webpack_require__(247);
	
	var _componentsHeaderHeaderJsx2 = _interopRequireDefault(_componentsHeaderHeaderJsx);
	
	var _componentsLoaderLoaderJsx = __webpack_require__(315);
	
	var _componentsLoaderLoaderJsx2 = _interopRequireDefault(_componentsLoaderLoaderJsx);
	
	var _componentsTabTabJsx = __webpack_require__(269);
	
	var _componentsTabTabJsx2 = _interopRequireDefault(_componentsTabTabJsx);
	
	var _componentsPageOpenerPageOpenerJsx = __webpack_require__(294);
	
	var _componentsPageOpenerPageOpenerJsx2 = _interopRequireDefault(_componentsPageOpenerPageOpenerJsx);
	
	var _componentsPullLoaderPullLoaderJsx = __webpack_require__(340);
	
	var _componentsPullLoaderPullLoaderJsx2 = _interopRequireDefault(_componentsPullLoaderPullLoaderJsx);
	
	var _componentsRecordListRecordListJsx = __webpack_require__(359);
	
	var _componentsRecordListRecordListJsx2 = _interopRequireDefault(_componentsRecordListRecordListJsx);
	
	var _componentsUserListUserListJsx = __webpack_require__(349);
	
	var _componentsUserListUserListJsx2 = _interopRequireDefault(_componentsUserListUserListJsx);
	
	var _storesLeaveStore = __webpack_require__(355);
	
	var _storesLeaveStore2 = _interopRequireDefault(_storesLeaveStore);
	
	var _dataUtilsLeaveDataUtils = __webpack_require__(356);
	
	var _dataUtilsLeaveDataUtils2 = _interopRequireDefault(_dataUtilsLeaveDataUtils);
	
	var LeaveList = (function (_Component) {
	  _inherits(LeaveList, _Component);
	
	  _createClass(LeaveList, null, [{
	    key: 'getStores',
	    value: function getStores() {
	      return [_storesLeaveStore2['default']];
	    }
	  }, {
	    key: 'calculateState',
	    value: function calculateState() {
	      return _storesLeaveStore2['default'].getState();
	    }
	  }]);
	
	  function LeaveList(props) {
	    _classCallCheck(this, LeaveList);
	
	    _get(Object.getPrototypeOf(LeaveList.prototype), 'constructor', this).call(this, props);
	    this.checkEdit = this.checkEdit.bind(this);
	    this.filter = this.filter.bind(this);
	    this.loadMore = this.loadMore.bind(this);
	    this.openApply = this.openApply.bind(this);
	    this.applyResponse = this.applyResponse.bind(this);
	    this.save = this.save.bind(this);
	    this.submitForm = this.submitForm.bind(this);
	  }
	
	  _createClass(LeaveList, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _props = this.props;
	      var defaultFilter = _props.defaultFilter;
	      var mgr = _props.mgr;
	
	      if (mgr) {
	        this._type = 'get-mgr-leave-history';
	      } else {
	        this._type = 'get-emp-leave-records';
	      }
	
	      this.getEmpLeaveRecords(defaultFilter);
	      _dataUtilsLeaveDataUtils2['default'].getFilter(JSON.parse(localStorage.getItem('companyCode')));
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      var filenameList = [];
	      var inputList = document.getElementsByTagName('input');
	      var files = [];
	      var fileDefaultValueCount = 0;
	      this.state.leaveForm.map(function (item) {
	        if (item.type == 'file' && item.defaultValue != null) {
	          fileDefaultValueCount++;
	        }
	      });
	
	      var formInput = undefined;
	      if (inputList.length > 0) {
	        for (var i = 0; i < inputList.length; i++) {
	          var input = inputList[i];
	          if (!formInput) {
	            formInput = input.parentNode;
	          }
	          if (input != null && input.type == 'file') {
	            //input.multiple = 'multiple';
	            if (files.length == 0) {
	              input.currentShow = 1;
	            }
	            //console.log(files.length+' '+fileDefaultValueCount);
	            if (fileDefaultValueCount == 0) {
	              if (files.length > 0) input.parentNode.style.display = 'none';
	            } else {
	              if (files.length >= fileDefaultValueCount) {
	                input.parentNode.style.display = 'none';
	              }
	            }
	            if (!document.getElementById('remove' + (files.length + 1))) {
	              (function () {
	                var del = document.createElement('a');
	                del.className = 'affixs-remove';
	                del.href = 'javascript:;';
	                del.text = 'Remove';
	                del.index = files.length + 1;
	                del.id = 'remove' + del.index;
	                del.onclick = function (e) {
	                  //Remove事件
	                  var affixs = document.getElementById('affixs');
	                  //console.log(affixs.value);
	                  if (affixs != undefined) {
	                    var value = affixs.value;
	                    if (value != '') {
	                      affixs.value = '';
	                      var list = value.split(',');
	                      for (var _i = 0; _i < list.length; _i++) {
	                        if (e.target.index - 1 == _i) {
	                          affixs.value += ' ,';
	                        } else {
	                          affixs.value += list[_i] + ',';
	                        }
	                      }
	                    }
	
	                    if (affixs.value != '') {
	                      affixs.value = affixs.value.substr(0, affixs.value.length - 1);
	                    }
	                    del.parentNode.firstChild.innerText = '';
	                  }
	                  //console.log(affixs.value);
	                };
	                input.parentNode.appendChild(del);
	              })();
	            }
	            if (files.length == 0) input.id = 'affix';else input.id = 'affix' + (files.length + 1);
	
	            input.index = files.length + 1;
	            files.push(input);
	
	            input.onchange = function (e) {
	              var filename = e.target.value.substr(e.target.value.lastIndexOf('\\') + 1);
	              var exists = false;
	              filenameList.map(function (item) {
	                console.log(item + ' ' + filename);
	                if (item == filename) {
	                  exists = true;
	                }
	              });
	
	              if (exists) {
	                alert('Duplicate file');
	                e.target.value = '';
	              } else {
	                filenameList.push(filename);
	                //console.log(filename);
	                var affixs = document.getElementById('affixs');
	                //console.log(affixs.value);
	                if (affixs != undefined) {
	                  var value = affixs.value;
	                  if (value != '') {
	                    affixs.value = '';
	                    var list = value.split(',');
	                    for (var _i2 = 0; _i2 < list.length; _i2++) {
	                      if (e.target.index - 1 == _i2) {
	                        affixs.value += ' ,';
	                      } else {
	                        affixs.value += list[_i2] + ',';
	                      }
	                    }
	                  }
	
	                  if (affixs.value != '') {
	                    affixs.value = affixs.value.substr(0, affixs.value.length - 1);
	                  }
	                }
	              }
	            };
	          }
	          //console.log(input);
	        }
	
	        //添加隐藏域名affixs
	        var affixs = '';
	        this.state.leaveForm.map(function (item) {
	          if (item.type == 'file' && item.defaultValue != null) {
	            affixs += item.defaultValue + ',';
	          }
	        });
	        if (affixs != '') {
	          affixs = affixs.substr(0, affixs.length - 1);
	        }
	        var inputAffixs = document.createElement('input');
	        inputAffixs.type = 'hidden';
	        inputAffixs.id = 'affixs';
	        inputAffixs.name = 'affixs';
	        inputAffixs.value = affixs;
	        formInput.appendChild(inputAffixs);
	
	        //console.log(formInput);
	        //console.log(document.getElementsByTagName('form')[0]);
	      }
	    }
	  }, {
	    key: 'checkEdit',
	    value: function checkEdit(item, e) {
	      if (item.stateCode === 0) {
	        e.preventDefault();
	
	        this._editId = item.id;
	        _dataUtilsLeaveDataUtils2['default'].getLeaveEditRecord(item.id);
	        this.openApply(e, true);
	      }
	    }
	  }, {
	    key: 'save',
	    value: function save() {
	      var _this = this;
	
	      //添加附件值到hidden
	      // var hidAffixs = document.createElement('input');
	      // hidAffixs.type='hidden';
	      // hidAffixs.id = 'affixs';
	      // hidAffixs.name = 'affixs';
	      // hidAffixs.ref = 'affixs';
	
	      // if(hidAffixs.value!='' && hidAffixs.value != undefined){
	      //     hidAffixs.value =hidAffixs.value.substr(0, hidAffixs.value.length - 1);
	      // }
	      // var domForm = document.getElementsByTagName('form')[0];
	      // domForm.appendChild(hidAffixs);
	      var form = this.refs.applyForm;
	
	      if (!form.isValid() || window.leaveValidation && !window.leaveValidation()) return;
	
	      var formData = new FormData(_react2['default'].findDOMNode(form));
	      this._submit = false;
	
	      formData.append('submit', this._submit);
	
	      if (this._editId) {
	        formData.append('id', this._editId);
	      }
	
	      formData.append('verify', true);
	
	      var affixs = '';
	      this.state.leaveForm.map(function (item) {
	        if (item.type == 'file' && item.defaultValue != null) {
	          affixs += item.defaultValue + ',';
	        }
	      });
	      if (affixs != '') {
	        affixs = affixs.substr(0, affixs.length - 1);
	        formData.append('affixs', affixs);
	        //console.log(affixs);
	      }
	
	      //LeaveDataUtils.submitForm();
	      console.log(form);
	      (0, _dispatcherDispatcher.dispatch)({
	        type: 'form-submitting'
	      });
	      _commonUtilsAjax2['default'].post(this.url, formData).then(function (res) {
	        _dataUtilsLeaveDataUtils2['default'].submitFormFail();
	        _this.applyResponse(res);
	      })['catch'](function () {
	        _dataUtilsLeaveDataUtils2['default'].submitFormFail();
	      });
	    }
	
	    /**
	     * 提交申请
	     */
	  }, {
	    key: 'submitForm',
	    value: function submitForm() {
	      var _this2 = this;
	
	      // if (!this.refs.applyForm.isValid()) return;
	      // if (window.leaveValidation) {
	      //   if (!window.leaveValidation()) {
	      //     return;
	      //   }
	      // }
	      //console.log(window.leaveValidation());
	      if (!this.refs.applyForm.isValid() || window.leaveValidation && !window.leaveValidation()) return;
	
	      //console.log(document.getElementById('vct_app_vtyid').value);
	      //console.log(document.getElementById('affix').value);
	      // console.log(window.leaveValidation());
	      // console.log(window.leaveValidation()=='false');
	      // console.log(window.leaveValidation()==false);
	      //    if(!window.leaveValidation()){ alert(1);return;}
	
	      var formData = new FormData(_react2['default'].findDOMNode(this.refs.applyForm));
	
	      this._submit = true;
	
	      formData.append('submit', this._submit);
	
	      if (this._editId) {
	        formData.append('id', this._editId);
	      }
	
	      formData.append('verify', true);
	
	      var affixs = '';
	      this.state.leaveForm.map(function (item) {
	        if (item.type == 'file' && item.defaultValue != null) {
	          affixs += item.defaultValue + ',';
	        }
	      });
	      if (affixs != '') {
	        affixs = affixs.substr(0, affixs.length - 1);
	        formData.append('affixs', affixs);
	        //console.log(affixs);
	      }
	
	      _dataUtilsLeaveDataUtils2['default'].submitForm();
	      //console.log(this.url);
	
	      // console.log('submitForm:');
	      // console.log(formData);
	      _commonUtilsAjax2['default'].post(this.url, formData).then(function (res) {
	        //console.log(res);
	        _dataUtilsLeaveDataUtils2['default'].submitFormFail();
	        _this2.applyResponse(res);
	      })['catch'](function () {
	        //console.log('error');
	        _dataUtilsLeaveDataUtils2['default'].submitFormFail();
	      });
	    }
	
	    /**
	     * Apply response
	     * @param res
	     */
	  }, {
	    key: 'applyResponse',
	    value: function applyResponse(res) {
	      var _this3 = this;
	
	      if (res && res.error || res == undefined) {
	        alert(res.error);
	        _dataUtilsLeaveDataUtils2['default'].submitFormFail();
	        return false;
	      } else if (res && res.confirm) {
	        if (confirm(res.confirm)) {
	          this._noVerify = true;
	
	          var formData = new FormData(_react2['default'].findDOMNode(this.refs.applyForm));
	
	          formData.append('submit', this._submit);
	
	          if (this._editId) {
	            formData.append('id', this._editId);
	          }
	
	          formData.append('verify', false);
	
	          _dataUtilsLeaveDataUtils2['default'].submitForm();
	
	          _commonUtilsAjax2['default'].post(this.url, formData).then(function (res) {
	            _this3.applyResponse(res);
	            _this3.getEmpLeaveRecords({
	              state: 'approving'
	            });
	          })['catch'](function () {
	            _dataUtilsLeaveDataUtils2['default'].submitFormFail();
	          });
	
	          this.getEmpLeaveRecords({
	            state: 'edit'
	          });
	          alert('success');
	          location.reload();
	          return;
	        }
	      } else {
	        alert('success');
	        location.reload();
	      }
	
	      // this._editId = null;
	
	      // this.refs.apply.close();
	      // this.refs.pullLoader.continueLoading();
	
	      // this.getEmpLeaveRecords({
	      //    state: 'edit'
	      // });
	    }
	
	    /**
	     * Open apply form
	     * @param e
	     * @param editMode
	     */
	  }, {
	    key: 'openApply',
	    value: function openApply(e, editMode) {
	      this.editMode = editMode === true;
	
	      this.refs.apply.open(e);
	      this.refs.pullLoader.stopLoading();
	
	      if (editMode === true) {
	        this.url = '/ess-edit-lv';
	        return;
	      } else {
	        this.url = '/ess-insert-lv';
	      }
	
	      _dataUtilsLeaveDataUtils2['default'].getLeaveForm();
	    }
	
	    /**
	     * Select / unselect all
	     */
	  }, {
	    key: 'toggleSelectAll',
	    value: function toggleSelectAll(e) {
	      var selected = e.target.checked;
	
	      [].slice.call(document.querySelectorAll('[type=checkbox]')).forEach(function (checkbox) {
	        checkbox.checked = selected;
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      var _props2 = this.props;
	      var leaveRecords = _props2.leaveRecords;
	      var status = _props2.status;
	      var leaveTypes = _props2.leaveTypes;
	      var mgr = _props2.mgr;
	      var selectable = _props2.selectable;
	      var toggleSelect = _props2.toggleSelect;
	      var filter = _props2.filter;
	      var leaveForm = _props2.leaveForm;
	      var formIsSubmitting = _props2.formIsSubmitting;
	      var formSubmitting = _props2.formSubmitting;
	      var formPostback = _props2.formPostback;
	
	      // if(leaveForm != ''){
	      //   leaveForm.map((item)=>{
	      //     if(item.type == 'file'){
	      //       item.onChange = this.fileOnChange;
	      //     }
	      //   });
	      // }
	      if (filter) {
	        filter.onClickItem = function (state) {
	          _this4.getEmpLeaveRecords({
	            state: state
	          });
	          if (state != 'edit') {
	            (0, _dispatcherDispatcher.dispatch)({
	              type: 'close-leave-record-selectable'
	            });
	          }
	        };
	      }
	
	      // if(formSubmitting){
	      //   location.reload();
	      // }
	
	      return _react2['default'].createElement(
	        'div',
	        null,
	        _react2['default'].createElement(_componentsHeaderHeaderJsx2['default'], {
	          back: true,
	          title: (0, _commonLang.getItem)('MY_APPLY'),
	          dropdown: filter,
	          callback: this.goback.bind(this)
	        }),
	        _react2['default'].createElement(
	          _componentsPullLoaderPullLoaderJsx2['default'],
	          { ref: 'pullLoader', status: status, onLoad: this.loadMore },
	          mgr ? _react2['default'].createElement(
	            'div',
	            { className: 'gap-t-lg' },
	            _react2['default'].createElement(_componentsUserListUserListJsx2['default'], { userList: leaveRecords, onSelectUser: this.selectUser })
	          ) : _react2['default'].createElement(_componentsRecordListRecordListJsx2['default'], { recordList: leaveRecords,
	            url: 'leave-record' + (mgr ? '-mgr' : ''),
	            onClickItem: this.checkEdit,
	            selectable: selectable && this.select,
	            toggleSelect: this.toggleSelect })
	        ),
	        this.enableSubmit ? _react2['default'].createElement(_componentsButtonButtonJsx2['default'], { icon: 'pencil', action: true, onClick: this.toggleEnterMode, style: { bottom: '8.5rem' } }) : null,
	        _react2['default'].createElement(_componentsButtonButtonJsx2['default'], { icon: 'plus', action: true, onClick: this.openApply }),
	        _react2['default'].createElement(
	          _componentsPageOpenerPageOpenerJsx2['default'],
	          { ref: 'apply' },
	          _react2['default'].createElement(
	            _componentsLoaderLoaderJsx2['default'],
	            { status: status },
	            _react2['default'].createElement(_componentsFormFormJsx2['default'], { className: 'side-gap pad-b', action: '/leave-apply', ref: 'applyForm',
	              controls: leaveForm }),
	            _react2['default'].createElement(
	              'div',
	              { className: 'row' },
	              _react2['default'].createElement(
	                'a',
	                { href: 'javascript:;', className: 'btnAddFix', onClick: this.addFix },
	                '+',
	                (0, _commonLang.getItem)('FORM_ADD_FIX')
	              ),
	              _react2['default'].createElement('br', null),
	              _react2['default'].createElement('br', null)
	            ),
	            _react2['default'].createElement(
	              'div',
	              { className: 'row' },
	              _react2['default'].createElement(
	                'div',
	                { className: 'col-1-2' },
	                _react2['default'].createElement(_componentsButtonButtonJsx2['default'], { type: 'button',
	                  text: (0, _commonLang.getItem)('SAVE'),
	                  disabled: formSubmitting,
	                  onClick: this.save })
	              ),
	              _react2['default'].createElement(
	                'div',
	                { className: 'col-1-2' },
	                _react2['default'].createElement(_componentsButtonButtonJsx2['default'], { type: 'button',
	                  text: (0, _commonLang.getItem)('SUBMIT'),
	                  disabled: formSubmitting,
	                  onClick: this.submitForm })
	              )
	            )
	          )
	        ),
	        _react2['default'].createElement(
	          _reactLibReactCSSTransitionGroup2['default'],
	          { component: 'div', transitionName: 'bottom-up' },
	          selectable ? _react2['default'].createElement(
	            'nav',
	            { className: 'tab tab-bottom leave-mgr-bottom' },
	            _react2['default'].createElement(
	              'label',
	              { className: 'leave-mgr-select-all' },
	              _react2['default'].createElement('input', { type: 'checkbox', value: '', onChange: this.toggleSelectAll })
	            ),
	            _react2['default'].createElement(
	              'div',
	              { className: 'row' },
	              _react2['default'].createElement(
	                'div',
	                { className: 'col-1-2' },
	                _react2['default'].createElement(_componentsButtonButtonJsx2['default'], { text: (0, _commonLang.getItem)('SUBMIT'), disabled: !this.enableSubmit, onTouchTap: this.submit })
	              ),
	              _react2['default'].createElement(
	                'div',
	                { className: 'col-1-2' },
	                _react2['default'].createElement(_componentsButtonButtonJsx2['default'], { text: (0, _commonLang.getItem)('DROP'), hollow: true, className: 'text-primary', onTouchTap: this.drop })
	              )
	            )
	          ) : null
	        ),
	        !selectable && _react2['default'].createElement(_componentsTabTabJsx2['default'], { items: [{
	            text: (0, _commonLang.getItem)('LEAVE_QUOTA'),
	            name: 'my-leave/leave-quota',
	            icon: 'calendar'
	          }, {
	            text: (0, _commonLang.getItem)('MY_APPLY'),
	            name: 'my-leave/leave-list',
	            icon: 'plane'
	          }, {
	            text: (0, _commonLang.getItem)('LEAVE_SUMMARY'),
	            name: 'my-leave/leave-summary',
	            icon: 'pie-chart'
	          }], bottom: true })
	      );
	    }
	  }, {
	    key: 'addFix',
	    value: function addFix() {
	      var inputList = document.getElementsByTagName('input');
	      var files = [];
	      var currentShow = 1;
	      if (inputList.length > 0) {
	        for (var i = 0; i < inputList.length; i++) {
	          var input = inputList[i];
	          if (input != null && input.type == 'file') {
	            input.multiple = 'multiple';
	            if (files.length == 0) {
	              input.currentShow += 1;
	              currentShow = input.currentShow;
	            }
	            //console.log(currentShow);
	            if (currentShow - 1 == files.length) {
	              input.parentNode.style.display = 'block';
	            }
	            files.push(input);
	          }
	          //console.log(input);
	        }
	      }
	    }
	  }, {
	    key: 'fileOnChange',
	    value: function fileOnChange(e) {}
	    //alert('change');
	
	    /**
	     * Get employees' leave records (parameters)
	     * @param params
	     */
	
	  }, {
	    key: 'getEmpLeaveRecords',
	    value: function getEmpLeaveRecords() {
	      var params = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	      params.page = 1;
	      params.loadMore = false;
	      params.state || (params.state = 'approving');
	
	      this.enableSubmit = params.state === 'edit';
	
	      (0, _dispatcherDispatcher.dispatch)({
	        type: this._type,
	        data: params
	      });
	    }
	  }, {
	    key: 'goback',
	    value: function goback() {
	      (0, _dispatcherDispatcher.dispatch)({
	        type: 'close-leave-record-selectable'
	      });
	      history.back();
	    }
	
	    /**
	     * Load next page
	     */
	  }, {
	    key: 'loadMore',
	    value: function loadMore() {
	      (0, _dispatcherDispatcher.dispatch)({
	        type: this._type,
	        data: {
	          loadMore: true
	        }
	      });
	    }
	
	    /**
	     * Update filter
	     * @param type
	     * @param choice
	     */
	  }, {
	    key: 'filter',
	    value: function filter(type, choice) {
	      this.getEmpLeaveRecords({ type: type, choice: choice });
	    }
	
	    /**
	     * Test if an item is selectable
	     * @param {Object} item
	     */
	  }, {
	    key: 'select',
	    value: function select(item) {
	      return true;
	    }
	  }, {
	    key: 'toggleSelect',
	    value: function toggleSelect(record) {}
	  }, {
	    key: 'toggleEnterMode',
	    value: function toggleEnterMode() {
	      (0, _dispatcherDispatcher.dispatch)({
	        type: 'toggle-leave-record-selectable'
	      });
	    }
	  }, {
	    key: 'submit',
	    value: function submit() {
	      var inputs = [].slice.call(document.querySelectorAll('[type=checkbox]')).filter(function (check) {
	        return check.checked;
	      }).map(function (check) {
	        return check.value;
	      });
	
	      _commonUtilsAjax2['default'].post('/ess-submit-lv', {
	        idList: inputs.join()
	      }).then(function () {
	        location.reload();
	      });
	    }
	  }, {
	    key: 'drop',
	    value: function drop() {
	      var inputs = [].slice.call(document.querySelectorAll('[type=checkbox]')).filter(function (check) {
	        return check.checked;
	      }).map(function (check) {
	        return check.value;
	      });
	
	      _commonUtilsAjax2['default'].post('/ess-drop-lv', {
	        idList: inputs.join()
	      }).then(function () {
	        location.reload();
	      });
	    }
	  }, {
	    key: 'selectUser',
	    value: function selectUser(id) {
	      location.hash = 'my-leave/leave-list/' + id;
	    }
	  }]);
	
	  return LeaveList;
	})(_react.Component);
	
	exports['default'] = _fluxUtils.Container.create(LeaveList);
	module.exports = exports['default'];
	/*<Filter items={filter} onFilter={this.filter}></Filter>*/

/***/ }),
/* 359 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Created by AshZhang on 15/10/10.
	 */
	
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	__webpack_require__(360);
	
	var _react = __webpack_require__(23);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _commonLang = __webpack_require__(245);
	
	var _commonLang2 = _interopRequireDefault(_commonLang);
	
	var statusText = [(0, _commonLang.getItem)('REJECTED'), (0, _commonLang.getItem)('APPROVED'), (0, _commonLang.getItem)('PENDING')];
	
	var RecordList = (function (_Component) {
	  _inherits(RecordList, _Component);
	
	  function RecordList() {
	    _classCallCheck(this, RecordList);
	
	    _get(Object.getPrototypeOf(RecordList.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(RecordList, [{
	    key: 'render',
	    value: function render() {
	      var _this = this;
	
	      var _props = this.props;
	      var url = _props.url;
	      var _props$recordList = _props.recordList;
	      var recordList = _props$recordList === undefined ? [] : _props$recordList;
	      var selectable = _props.selectable;
	      var href = _props.href;
	      var onClickItem = _props.onClickItem;
	
	      return _react2['default'].createElement(
	        'ul',
	        { className: 'record-list' + (selectable ? ' record-list-selectable' : '') },
	        (recordList.map ? recordList : []).map(function (record, index) {
	          return _react2['default'].createElement(
	            'li',
	            { key: index, className: record.userName ? 'with-name' : null },
	            selectable && selectable(record) ? _react2['default'].createElement(
	              'label',
	              { className: 'record-item-select' },
	              _react2['default'].createElement('input', { type: 'checkbox', defaultChecked: !!record.checked, onChange: _this.toggleSelect.bind(_this, record), value: record.id })
	            ) : null,
	            _react2['default'].createElement(
	              'a',
	              { className: 'record-item', onClick: onClickItem ? onClickItem.bind(_this, record) : null, href: href === null ? null : '#/' + url + '/' + record.id },
	              record.userName ? _react2['default'].createElement(
	                'span',
	                { className: 'record-item-name-bar' },
	                record.userName,
	                _react2['default'].createElement(
	                  'span',
	                  { className: 'text-lighter text-sm gap-l' },
	                  record.department
	                )
	              ) : null,
	              _react2['default'].createElement(
	                'span',
	                { className: 'record-item-name' },
	                record.Type
	              ),
	              _react2['default'].createElement(
	                'span',
	                { className: 'record-item-time' },
	                record.Start,
	                ' - ',
	                record.End
	              ),
	              _react2['default'].createElement(
	                'span',
	                { className: 'record-item-hours' },
	                record.hours
	              ),
	              _react2['default'].createElement(
	                'span',
	                { className: 'record-item-status record-item-status-' + record.status },
	                record.state
	              )
	            )
	          );
	        })
	      );
	    }
	
	    /**
	     * When an item's select status changes
	     * @param {Object} record
	     * @param {Event} e
	     */
	  }, {
	    key: 'toggleSelect',
	    value: function toggleSelect(record, e) {
	
	      if (typeof this.props.toggleSelect === 'function') {
	        this.props.toggleSelect(record, e.target.checked);
	      }
	    }
	  }]);
	
	  return RecordList;
	})(_react.Component);
	
	exports['default'] = RecordList;
	module.exports = exports['default'];

/***/ }),
/* 360 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 361 */,
/* 362 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Created by AshZhang on 15/10/15.
	 */
	
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(23);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _dispatcherDispatcher = __webpack_require__(223);
	
	var _dispatcherDispatcher2 = _interopRequireDefault(_dispatcherDispatcher);
	
	var _fluxUtils = __webpack_require__(228);
	
	var _commonLang = __webpack_require__(245);
	
	var _componentsHeaderHeaderJsx = __webpack_require__(247);
	
	var _componentsHeaderHeaderJsx2 = _interopRequireDefault(_componentsHeaderHeaderJsx);
	
	var _componentsLoaderLoaderJsx = __webpack_require__(315);
	
	var _componentsLoaderLoaderJsx2 = _interopRequireDefault(_componentsLoaderLoaderJsx);
	
	var _componentsUserInfoUserInfoJsx = __webpack_require__(318);
	
	var _componentsUserInfoUserInfoJsx2 = _interopRequireDefault(_componentsUserInfoUserInfoJsx);
	
	var _componentsInfoCardInfoCardJsx = __webpack_require__(322);
	
	var _componentsInfoCardInfoCardJsx2 = _interopRequireDefault(_componentsInfoCardInfoCardJsx);
	
	var _componentsFormControlFormControlJsx = __webpack_require__(291);
	
	var _componentsFormControlFormControlJsx2 = _interopRequireDefault(_componentsFormControlFormControlJsx);
	
	var _componentsTextInputTextInputJsx = __webpack_require__(283);
	
	var _componentsTextInputTextInputJsx2 = _interopRequireDefault(_componentsTextInputTextInputJsx);
	
	var _componentsButtonButtonJsx = __webpack_require__(250);
	
	var _componentsButtonButtonJsx2 = _interopRequireDefault(_componentsButtonButtonJsx);
	
	var _componentsConfirmButtonConfirmButtonJsx = __webpack_require__(363);
	
	var _componentsConfirmButtonConfirmButtonJsx2 = _interopRequireDefault(_componentsConfirmButtonConfirmButtonJsx);
	
	var _storesLeaveStore = __webpack_require__(355);
	
	var _storesLeaveStore2 = _interopRequireDefault(_storesLeaveStore);
	
	var _dataUtilsLeaveDataUtils = __webpack_require__(356);
	
	var _dataUtilsLeaveDataUtils2 = _interopRequireDefault(_dataUtilsLeaveDataUtils);
	
	var LeaveRecord = (function (_Component) {
	  _inherits(LeaveRecord, _Component);
	
	  function LeaveRecord(props) {
	    _classCallCheck(this, LeaveRecord);
	
	    _get(Object.getPrototypeOf(LeaveRecord.prototype), 'constructor', this).call(this, props);
	    this.revoke = this.revoke.bind(this);
	    this.approve = this.approve.bind(this);
	    this.reject = this.reject.bind(this);
	
	    if (this.props.route.name !== 'leave-record-mgr') {
	      this.getLeaveRecord();
	    }
	  }
	
	  _createClass(LeaveRecord, [{
	    key: 'render',
	    value: function render() {
	      var _state = this.state;
	      var status = _state.status;
	      var leaveRecord = _state.leaveRecord;
	      var appInfo = leaveRecord.appInfo;
	      var baseInfo = leaveRecord.baseInfo;
	      var _leaveRecord$onRevoke = leaveRecord.onRevoke;
	      var onRevoke = _leaveRecord$onRevoke === undefined ? false : _leaveRecord$onRevoke;
	      var mgr = this.props.route.name === 'leave-record-mgr';
	
	      return _react2['default'].createElement(
	        'div',
	        null,
	        _react2['default'].createElement(_componentsHeaderHeaderJsx2['default'], { goBack: true, title: (0, _commonLang.getItem)('MY_APPLY') }),
	        !mgr ? _react2['default'].createElement(
	          _componentsLoaderLoaderJsx2['default'],
	          { status: status, className: 'side-gap gap-t-lg pad-b' },
	          baseInfo ? _react2['default'].createElement(
	            'div',
	            null,
	            _react2['default'].createElement(
	              'h2',
	              { className: 'info-card-heading gap-b' },
	              baseInfo.title
	            ),
	            _react2['default'].createElement(_componentsInfoCardInfoCardJsx2['default'], { items: baseInfo.items })
	          ) : null,
	          appInfo ? _react2['default'].createElement(
	            'div',
	            null,
	            _react2['default'].createElement(
	              'h2',
	              { className: 'info-card-heading gap-b' },
	              appInfo.title
	            ),
	            appInfo.items.map(function (item, index) {
	              return _react2['default'].createElement(_componentsInfoCardInfoCardJsx2['default'], { items: item, key: index });
	            })
	          ) : null,
	          onRevoke ? _react2['default'].createElement(_componentsConfirmButtonConfirmButtonJsx2['default'], { text: (0, _commonLang.getItem)('REVOKE'), onTouchTap: this.revoke }) : null
	        ) : null,
	        mgr ? _react2['default'].createElement(
	          'div',
	          { className: 'gap-t' },
	          _react2['default'].createElement(
	            'div',
	            { className: 'row' },
	            _react2['default'].createElement(
	              'div',
	              { className: 'col-1-1' },
	              _react2['default'].createElement(
	                _componentsFormControlFormControlJsx2['default'],
	                { label: (0, _commonLang.getItem)('APPROVE_OPINION') },
	                _react2['default'].createElement(_componentsTextInputTextInputJsx2['default'], { ref: 'opinion' })
	              )
	            )
	          ),
	          _react2['default'].createElement(
	            'div',
	            { className: 'row' },
	            _react2['default'].createElement(
	              'div',
	              { className: 'col-1-2' },
	              _react2['default'].createElement(_componentsButtonButtonJsx2['default'], { text: (0, _commonLang.getItem)('APPROVE'), onTouchTap: this.approve })
	            ),
	            _react2['default'].createElement(
	              'div',
	              { className: 'col-1-2' },
	              _react2['default'].createElement(_componentsButtonButtonJsx2['default'], { hollow: true, className: 'text-primary', text: (0, _commonLang.getItem)('REJECT'), onTouchTap: this.reject })
	            )
	          )
	        ) : null
	      );
	    }
	
	    /**
	     * Get a single leave record
	     */
	  }, {
	    key: 'getLeaveRecord',
	    value: function getLeaveRecord() {
	      if (this.props.route.name === 'leave-record-mgr') {
	        _dataUtilsLeaveDataUtils2['default'].getApproveRecord(this.props.params.id);
	      } else {
	        _dataUtilsLeaveDataUtils2['default'].getLeaveRecord(this.props.params && this.props.params.id);
	      }
	    }
	
	    /**
	     * Revoke a record
	     */
	  }, {
	    key: 'revoke',
	    value: function revoke() {
	      _dataUtilsLeaveDataUtils2['default'].revokeRecord({
	        id: this.props.params.id,
	        onRevoke: this.state.leaveRecord.onRevoke
	      });
	    }
	
	    /**
	     * Approve a record
	     */
	  }, {
	    key: 'approve',
	    value: function approve() {
	      _dataUtilsLeaveDataUtils2['default'].approveRecord({
	        id: this.props.params.id,
	        appOpinion: _react2['default'].findDOMNode(this.refs.opinion).value
	      });
	    }
	
	    /**
	     * Reject a record
	     */
	  }, {
	    key: 'reject',
	    value: function reject() {
	      _dataUtilsLeaveDataUtils2['default'].rejectRecord({
	        id: this.props.params.id,
	        appOpinion: _react2['default'].findDOMNode(this.refs.opinion).value
	      });
	    }
	  }], [{
	    key: 'getStores',
	    value: function getStores() {
	      return [_storesLeaveStore2['default']];
	    }
	  }, {
	    key: 'calculateState',
	    value: function calculateState() {
	      var state = _storesLeaveStore2['default'].getState();
	
	      return {
	        status: state.status,
	        leaveRecord: state.leaveRecord,
	        mgrAjax: state.mgrAjax
	      };
	    }
	  }]);
	
	  return LeaveRecord;
	})(_react.Component);
	
	exports['default'] = _fluxUtils.Container.create(LeaveRecord);
	module.exports = exports['default'];

/***/ }),
/* 363 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Created by Sherry.Liu on 2016/10/31.
	 */
	
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(23);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(364);
	
	var _commonLang = __webpack_require__(245);
	
	var _ButtonButtonJsx = __webpack_require__(250);
	
	var _ButtonButtonJsx2 = _interopRequireDefault(_ButtonButtonJsx);
	
	var ConfirmButton = (function (_Component) {
	  _inherits(ConfirmButton, _Component);
	
	  function ConfirmButton(props) {
	    _classCallCheck(this, ConfirmButton);
	
	    _get(Object.getPrototypeOf(ConfirmButton.prototype), 'constructor', this).call(this, props);
	    this.state = {
	      isConfirm: false
	    };
	
	    this.toggleState = this.toggleState.bind(this);
	  }
	
	  _createClass(ConfirmButton, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props;
	      var text = _props.text;
	
	      var attr = _objectWithoutProperties(_props, ['text']);
	
	      var isConfirm = this.state.isConfirm;
	
	      return _react2['default'].createElement(
	        'div',
	        null,
	        isConfirm ? _react2['default'].createElement(
	          'div',
	          null,
	          _react2['default'].createElement(
	            'p',
	            { className: 'gap-t-lg gap-b-lg confirm-btn-text' },
	            (0, _commonLang.getItem)('CONFIRM_MSG'),
	            '？'
	          ),
	          _react2['default'].createElement(_ButtonButtonJsx2['default'], _extends({ className: 'gap-b', text: (0, _commonLang.getItem)('OK') }, attr)),
	          _react2['default'].createElement(_ButtonButtonJsx2['default'], { className: 'gap-b', hollow: true, text: (0, _commonLang.getItem)('CANCEL'), onTouchTap: this.toggleState })
	        ) : _react2['default'].createElement(_ButtonButtonJsx2['default'], { className: 'gap-t ', text: text, onTouchTap: this.toggleState })
	      );
	    }
	  }, {
	    key: 'toggleState',
	    value: function toggleState() {
	      var oldState = this.state.isConfirm;
	      this.setState({
	        isConfirm: !oldState
	      });
	    }
	  }]);
	
	  return ConfirmButton;
	})(_react.Component);
	
	exports['default'] = ConfirmButton;
	module.exports = exports['default'];

/***/ }),
/* 364 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 365 */,
/* 366 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Home page
	 */
	
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(23);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _fluxUtils = __webpack_require__(228);
	
	var _componentsHeaderHeaderJsx = __webpack_require__(247);
	
	var _componentsHeaderHeaderJsx2 = _interopRequireDefault(_componentsHeaderHeaderJsx);
	
	var _componentsInfoCardInfoCardJsx = __webpack_require__(322);
	
	var _componentsInfoCardInfoCardJsx2 = _interopRequireDefault(_componentsInfoCardInfoCardJsx);
	
	var _componentsLoaderLoaderJsx = __webpack_require__(315);
	
	var _componentsLoaderLoaderJsx2 = _interopRequireDefault(_componentsLoaderLoaderJsx);
	
	var _commonLang = __webpack_require__(245);
	
	var _storesLeaveStore = __webpack_require__(355);
	
	var _storesLeaveStore2 = _interopRequireDefault(_storesLeaveStore);
	
	var _dataUtilsLeaveDataUtils = __webpack_require__(356);
	
	var _dataUtilsLeaveDataUtils2 = _interopRequireDefault(_dataUtilsLeaveDataUtils);
	
	var LeaveQuota = (function (_Component) {
	  _inherits(LeaveQuota, _Component);
	
	  function LeaveQuota() {
	    _classCallCheck(this, LeaveQuota);
	
	    _get(Object.getPrototypeOf(LeaveQuota.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(LeaveQuota, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      _dataUtilsLeaveDataUtils2['default'].getQuota();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state;
	      var _state$quota = _state.quota;
	      var quota = _state$quota === undefined ? [] : _state$quota;
	      var status = _state.status;
	
	      return _react2['default'].createElement(
	        'div',
	        null,
	        _react2['default'].createElement(_componentsHeaderHeaderJsx2['default'], { back: true, title: (0, _commonLang.getItem)('LEAVE_QUOTA') }),
	        _react2['default'].createElement(
	          _componentsLoaderLoaderJsx2['default'],
	          { status: status, className: 'side-gap gap-t gap-b' },
	          (quota.map ? quota : []).map(function (card, index) {
	            return _react2['default'].createElement(
	              'div',
	              { className: 'gap-t', key: index },
	              _react2['default'].createElement(
	                'h2',
	                { className: 'info-card-heading gap-b' },
	                card.title
	              ),
	              _react2['default'].createElement(_componentsInfoCardInfoCardJsx2['default'], { items: card.items })
	            );
	          })
	        )
	      );
	    }
	  }], [{
	    key: 'getStores',
	    value: function getStores() {
	      return [_storesLeaveStore2['default']];
	    }
	  }, {
	    key: 'calculateState',
	    value: function calculateState() {
	      return _storesLeaveStore2['default'].getState();
	    }
	  }]);
	
	  return LeaveQuota;
	})(_react.Component);
	
	exports['default'] = _fluxUtils.Container.create(LeaveQuota);
	module.exports = exports['default'];

/***/ }),
/* 367 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Home page
	 */
	
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(23);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _fluxUtils = __webpack_require__(228);
	
	var _commonLang = __webpack_require__(245);
	
	var _storesLeaveStore = __webpack_require__(355);
	
	var _storesLeaveStore2 = _interopRequireDefault(_storesLeaveStore);
	
	var _dataUtilsLeaveDataUtils = __webpack_require__(356);
	
	var _dataUtilsLeaveDataUtils2 = _interopRequireDefault(_dataUtilsLeaveDataUtils);
	
	var _componentsFormFormJsx = __webpack_require__(280);
	
	var _componentsFormFormJsx2 = _interopRequireDefault(_componentsFormFormJsx);
	
	var _componentsHeaderHeaderJsx = __webpack_require__(247);
	
	var _componentsHeaderHeaderJsx2 = _interopRequireDefault(_componentsHeaderHeaderJsx);
	
	var _componentsInfoCardInfoCardJsx = __webpack_require__(322);
	
	var _componentsInfoCardInfoCardJsx2 = _interopRequireDefault(_componentsInfoCardInfoCardJsx);
	
	var _componentsLoaderLoaderJsx = __webpack_require__(315);
	
	var _componentsLoaderLoaderJsx2 = _interopRequireDefault(_componentsLoaderLoaderJsx);
	
	var LeaveQuota = (function (_Component) {
	  _inherits(LeaveQuota, _Component);
	
	  _createClass(LeaveQuota, null, [{
	    key: 'getStores',
	    value: function getStores() {
	      return [_storesLeaveStore2['default']];
	    }
	  }, {
	    key: 'calculateState',
	    value: function calculateState() {
	      return _storesLeaveStore2['default'].getState();
	    }
	  }]);
	
	  function LeaveQuota(props) {
	    _classCallCheck(this, LeaveQuota);
	
	    _get(Object.getPrototypeOf(LeaveQuota.prototype), 'constructor', this).call(this, props);
	    this.querySummary = this.querySummary.bind(this);
	  }
	
	  _createClass(LeaveQuota, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      _dataUtilsLeaveDataUtils2['default'].getSummaryFilters({
	        type: 'FILTER_LV_SUMMARY'
	      });
	    }
	  }, {
	    key: 'querySummary',
	    value: function querySummary() {
	      _dataUtilsLeaveDataUtils2['default'].getLeaveSummary(null, new FormData(_react2['default'].findDOMNode(this.refs.query)));
	      this.refs.query.setState({
	        submitting: false,
	        disabled: false
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state;
	      var leaveSummary = _state.leaveSummary;
	      var _state$status = _state.status;
	      var status = _state$status === undefined ? 'loading' : _state$status;
	      var _state$configStatus = _state.configStatus;
	      var configStatus = _state$configStatus === undefined ? 'loading' : _state$configStatus;
	      var _state$leaveSummaryConfig = _state.leaveSummaryConfig;
	      var leaveSummaryConfig = _state$leaveSummaryConfig === undefined ? [] : _state$leaveSummaryConfig;
	
	      console.log(status);
	
	      return _react2['default'].createElement(
	        'div',
	        null,
	        _react2['default'].createElement(_componentsHeaderHeaderJsx2['default'], { back: true, title: (0, _commonLang.getItem)('LEAVE_SUMMARY') }),
	        _react2['default'].createElement(
	          _componentsLoaderLoaderJsx2['default'],
	          { status: configStatus, className: 'side-gap gap-t' },
	          _react2['default'].createElement(_componentsFormFormJsx2['default'], { ref: 'query',
	            action: '/ess-lv-summary',
	            controls: leaveSummaryConfig,
	            submitButton: { text: (0, _commonLang.getItem)('SUBMIT') },
	            onSubmit: this.querySummary.bind(this) })
	        ),
	        _react2['default'].createElement(
	          'div',
	          { style: { minHeight: '100vh' } },
	          _react2['default'].createElement(
	            _componentsLoaderLoaderJsx2['default'],
	            { status: status,
	              className: 'side-gap gap-t-lg pad-t-lg pad-b',
	              style: { minHeight: 0 } },
	            Array.isArray(leaveSummary) && leaveSummary.map(function (item, index) {
	              return _react2['default'].createElement(_componentsInfoCardInfoCardJsx2['default'], { title: item.title, items: item.items, key: index });
	            })
	          )
	        )
	      );
	    }
	  }]);
	
	  return LeaveQuota;
	})(_react.Component);
	
	exports['default'] = _fluxUtils.Container.create(LeaveQuota);
	module.exports = exports['default'];

/***/ }),
/* 368 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Home page
	 */
	
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	__webpack_require__(369);
	
	var _react = __webpack_require__(23);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _commonLang = __webpack_require__(245);
	
	var _componentsTabTabJsx = __webpack_require__(269);
	
	var _componentsTabTabJsx2 = _interopRequireDefault(_componentsTabTabJsx);
	
	var tabSettings = [{
	  text: (0, _commonLang.getItem)('LEAVE_QUOTA'),
	  name: 'leave-mgr/quota',
	  icon: 'calendar'
	}, {
	  text: (0, _commonLang.getItem)('PENDING'),
	  name: 'leave-mgr/pending',
	  icon: 'plane'
	}, {
	  text: (0, _commonLang.getItem)('HISTORY'),
	  name: 'leave-mgr/history',
	  icon: 'book'
	}, {
	  text: (0, _commonLang.getItem)('LEAVE_SUMMARY'),
	  name: 'leave-mgr/summary',
	  icon: 'pie-chart'
	}];
	
	var LeaveMgr = (function (_Component) {
	  _inherits(LeaveMgr, _Component);
	
	  function LeaveMgr() {
	    _classCallCheck(this, LeaveMgr);
	
	    _get(Object.getPrototypeOf(LeaveMgr.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(LeaveMgr, [{
	    key: 'render',
	    value: function render() {
	      return _react2['default'].createElement(
	        'div',
	        { className: 'bottom-gap' },
	        _react2['default'].createElement(_componentsTabTabJsx2['default'], { items: tabSettings, bottom: true }),
	        this.props.children
	      );
	    }
	  }]);
	
	  return LeaveMgr;
	})(_react.Component);
	
	exports['default'] = LeaveMgr;
	module.exports = exports['default'];

/***/ }),
/* 369 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 370 */,
/* 371 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Home page
	 */
	
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x2, _x3, _x4) { var _again = true; _function: while (_again) { var object = _x2, property = _x3, receiver = _x4; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x2 = parent; _x3 = property; _x4 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(23);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _fluxUtils = __webpack_require__(228);
	
	var _commonLang = __webpack_require__(245);
	
	var _storesLeaveStore = __webpack_require__(355);
	
	var _storesLeaveStore2 = _interopRequireDefault(_storesLeaveStore);
	
	var _dataUtilsLeaveDataUtils = __webpack_require__(356);
	
	var _dataUtilsLeaveDataUtils2 = _interopRequireDefault(_dataUtilsLeaveDataUtils);
	
	var _componentsHeaderHeaderJsx = __webpack_require__(247);
	
	var _componentsHeaderHeaderJsx2 = _interopRequireDefault(_componentsHeaderHeaderJsx);
	
	var _componentsRecordListRecordListJsx = __webpack_require__(359);
	
	var _componentsRecordListRecordListJsx2 = _interopRequireDefault(_componentsRecordListRecordListJsx);
	
	var _componentsPullLoaderPullLoaderJsx = __webpack_require__(340);
	
	var _componentsPullLoaderPullLoaderJsx2 = _interopRequireDefault(_componentsPullLoaderPullLoaderJsx);
	
	var LeaveMgrQuota = (function (_Component) {
	  _inherits(LeaveMgrQuota, _Component);
	
	  function LeaveMgrQuota(props) {
	    _classCallCheck(this, LeaveMgrQuota);
	
	    _get(Object.getPrototypeOf(LeaveMgrQuota.prototype), 'constructor', this).call(this, props);
	
	    this.page = 1;
	    _dataUtilsLeaveDataUtils2['default'].getMgrLeaveHistory();
	
	    this.loadMore = this.loadMore.bind(this);
	  }
	
	  _createClass(LeaveMgrQuota, [{
	    key: 'render',
	    value: function render() {
	      var _state = this.state;
	      var leaveRecords = _state.leaveRecords;
	      var status = _state.status;
	
	      return _react2['default'].createElement(
	        'div',
	        null,
	        _react2['default'].createElement(_componentsHeaderHeaderJsx2['default'], { back: 'manager', title: (0, _commonLang.getItem)('HISTORY') }),
	        _react2['default'].createElement(
	          _componentsPullLoaderPullLoaderJsx2['default'],
	          { className: 'pad-b',
	            status: status,
	            onLoad: this.loadMore },
	          _react2['default'].createElement(_componentsRecordListRecordListJsx2['default'], { recordList: leaveRecords, href: null })
	        )
	      );
	    }
	  }, {
	    key: 'loadMore',
	    value: function loadMore() {
	      var query = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	      this.page += 1;
	
	      _dataUtilsLeaveDataUtils2['default'].getMgrLeaveHistory(_extends({}, query, {
	        page: this.page,
	        loadMore: true
	      }));
	    }
	  }], [{
	    key: 'getStores',
	    value: function getStores() {
	      return [_storesLeaveStore2['default']];
	    }
	  }, {
	    key: 'calculateState',
	    value: function calculateState() {
	      return _storesLeaveStore2['default'].getState();
	    }
	  }]);
	
	  return LeaveMgrQuota;
	})(_react.Component);
	
	exports['default'] = _fluxUtils.Container.create(LeaveMgrQuota);
	module.exports = exports['default'];

/***/ }),
/* 372 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Home page
	 */
	
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(23);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _fluxUtils = __webpack_require__(228);
	
	var _commonLang = __webpack_require__(245);
	
	var _componentsHeaderHeaderJsx = __webpack_require__(247);
	
	var _componentsHeaderHeaderJsx2 = _interopRequireDefault(_componentsHeaderHeaderJsx);
	
	var _componentsFormFormJsx = __webpack_require__(280);
	
	var _componentsFormFormJsx2 = _interopRequireDefault(_componentsFormFormJsx);
	
	var _componentsLoaderLoaderJsx = __webpack_require__(315);
	
	var _componentsLoaderLoaderJsx2 = _interopRequireDefault(_componentsLoaderLoaderJsx);
	
	var _componentsPullLoaderPullLoaderJsx = __webpack_require__(340);
	
	var _componentsPullLoaderPullLoaderJsx2 = _interopRequireDefault(_componentsPullLoaderPullLoaderJsx);
	
	var _componentsInfoCardInfoCardJsx = __webpack_require__(322);
	
	var _componentsInfoCardInfoCardJsx2 = _interopRequireDefault(_componentsInfoCardInfoCardJsx);
	
	var _storesLeaveStore = __webpack_require__(355);
	
	var _storesLeaveStore2 = _interopRequireDefault(_storesLeaveStore);
	
	var _dataUtilsLeaveDataUtils = __webpack_require__(356);
	
	var _dataUtilsLeaveDataUtils2 = _interopRequireDefault(_dataUtilsLeaveDataUtils);
	
	var LeaveMgrQuota = (function (_Component) {
	  _inherits(LeaveMgrQuota, _Component);
	
	  function LeaveMgrQuota() {
	    _classCallCheck(this, LeaveMgrQuota);
	
	    _get(Object.getPrototypeOf(LeaveMgrQuota.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(LeaveMgrQuota, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      _dataUtilsLeaveDataUtils2['default'].getSummaryFilters({
	        type: 'FILTER_LV_SUMMARY'
	      });
	    }
	  }, {
	    key: 'querySummary',
	    value: function querySummary(page) {
	      var form = new FormData(_react2['default'].findDOMNode(this.refs.query));
	
	      if (typeof page !== 'number' || isNaN(page)) page = 1;
	
	      form.append('page', page);
	
	      this.page = page;
	
	      _dataUtilsLeaveDataUtils2['default'].getLeaveSummaryEmpList(form, page);
	
	      this.refs.query.setState({
	        submitting: false,
	        disabled: false
	      });
	    }
	  }, {
	    key: 'loadMore',
	    value: function loadMore() {
	      this.querySummary(this.page + 1);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state;
	      var leaveEmpList = _state.leaveEmpList;
	      var _state$configStatus = _state.configStatus;
	      var configStatus = _state$configStatus === undefined ? 'loading' : _state$configStatus;
	      var _state$status = _state.status;
	      var status = _state$status === undefined ? 'loaded' : _state$status;
	      var _state$leaveSummaryConfig = _state.leaveSummaryConfig;
	      var leaveSummaryConfig = _state$leaveSummaryConfig === undefined ? [] : _state$leaveSummaryConfig;
	
	      return _react2['default'].createElement(
	        'div',
	        null,
	        _react2['default'].createElement(_componentsHeaderHeaderJsx2['default'], { back: 'manager', title: (0, _commonLang.getItem)('LEAVE_SUMMARY') }),
	        _react2['default'].createElement(
	          _componentsLoaderLoaderJsx2['default'],
	          { status: configStatus },
	          _react2['default'].createElement(_componentsFormFormJsx2['default'], { className: 'side-gap gap-t',
	            ref: 'query',
	            action: '/lv-team-summary',
	            controls: leaveSummaryConfig,
	            submitButton: { text: (0, _commonLang.getItem)('SUBMIT') },
	            onSubmit: this.querySummary.bind(this) })
	        ),
	        _react2['default'].createElement(
	          _componentsPullLoaderPullLoaderJsx2['default'],
	          { className: 'pad-b gap-t-lg pad-t-lg side-gap',
	            status: status,
	            style: { paddingBottom: 80 },
	            onLoad: this.loadMore.bind(this) },
	          Array.isArray(leaveEmpList) && leaveEmpList.map(function (item, index) {
	            return _react2['default'].createElement(
	              'div',
	              { key: index },
	              _react2['default'].createElement(
	                'div',
	                { className: 'summary-user-info' },
	                _react2['default'].createElement(
	                  'span',
	                  null,
	                  item.userInfo.items[0].firField
	                ),
	                _react2['default'].createElement(
	                  'span',
	                  { className: 'summary-user-pos' },
	                  item.userInfo.items[0].secField
	                )
	              ),
	              item.summaryInfo.items.map(function (item, index) {
	                return _react2['default'].createElement(_componentsInfoCardInfoCardJsx2['default'], { title: item.title, items: item.items, key: index });
	              })
	            );
	          })
	        )
	      );
	    }
	  }], [{
	    key: 'getStores',
	    value: function getStores() {
	      return [_storesLeaveStore2['default']];
	    }
	  }, {
	    key: 'calculateState',
	    value: function calculateState() {
	      return _storesLeaveStore2['default'].getState();
	    }
	  }]);
	
	  return LeaveMgrQuota;
	})(_react.Component);
	
	exports['default'] = _fluxUtils.Container.create(LeaveMgrQuota);
	module.exports = exports['default'];

/***/ }),
/* 373 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Home page
	 */
	
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(23);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _fluxUtils = __webpack_require__(228);
	
	var _commonLang = __webpack_require__(245);
	
	var _componentsHeaderHeaderJsx = __webpack_require__(247);
	
	var _componentsHeaderHeaderJsx2 = _interopRequireDefault(_componentsHeaderHeaderJsx);
	
	var _componentsLoaderLoaderJsx = __webpack_require__(315);
	
	var _componentsLoaderLoaderJsx2 = _interopRequireDefault(_componentsLoaderLoaderJsx);
	
	var _componentsRecordListRecordListJsx = __webpack_require__(359);
	
	var _componentsRecordListRecordListJsx2 = _interopRequireDefault(_componentsRecordListRecordListJsx);
	
	var _storesLeaveStore = __webpack_require__(355);
	
	var _storesLeaveStore2 = _interopRequireDefault(_storesLeaveStore);
	
	var _dataUtilsLeaveDataUtils = __webpack_require__(356);
	
	var _dataUtilsLeaveDataUtils2 = _interopRequireDefault(_dataUtilsLeaveDataUtils);
	
	var LeaveListContainer = (function (_Component) {
	  _inherits(LeaveListContainer, _Component);
	
	  _createClass(LeaveListContainer, null, [{
	    key: 'getStores',
	    value: function getStores() {
	      return [_storesLeaveStore2['default']];
	    }
	  }, {
	    key: 'calculateState',
	    value: function calculateState() {
	      return _storesLeaveStore2['default'].getState();
	    }
	  }]);
	
	  function LeaveListContainer(props) {
	    _classCallCheck(this, LeaveListContainer);
	
	    _get(Object.getPrototypeOf(LeaveListContainer.prototype), 'constructor', this).call(this, props);
	
	    _dataUtilsLeaveDataUtils2['default'].getApproveRecord(this.props.routeParams.id);
	  }
	
	  _createClass(LeaveListContainer, [{
	    key: 'render',
	    value: function render() {
	      var _state = this.state;
	      var _state$leaveRecord = _state.leaveRecord;
	      var leaveRecord = _state$leaveRecord === undefined ? [] : _state$leaveRecord;
	      var _state$status = _state.status;
	      var status = _state$status === undefined ? 'loading' : _state$status;
	
	      return _react2['default'].createElement(
	        'div',
	        null,
	        _react2['default'].createElement(_componentsHeaderHeaderJsx2['default'], { goBack: true, title: (0, _commonLang.getItem)('LEAVE_SUMMARY') }),
	        _react2['default'].createElement(
	          _componentsLoaderLoaderJsx2['default'],
	          { className: 'side-gap',
	            status: status },
	          _react2['default'].createElement(_componentsRecordListRecordListJsx2['default'], { recordList: leaveRecord })
	        )
	      );
	    }
	  }]);
	
	  return LeaveListContainer;
	})(_react.Component);
	
	exports['default'] = _fluxUtils.Container.create(LeaveListContainer);
	module.exports = exports['default'];

/***/ }),
/* 374 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * MSS - 假期配额页
	 */
	
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x3, _x4, _x5) { var _again = true; _function: while (_again) { var object = _x3, property = _x4, receiver = _x5; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x3 = parent; _x4 = property; _x5 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(23);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _fluxUtils = __webpack_require__(228);
	
	var _commonLang = __webpack_require__(245);
	
	var _storesLeaveStore = __webpack_require__(355);
	
	var _storesLeaveStore2 = _interopRequireDefault(_storesLeaveStore);
	
	var _dataUtilsLeaveDataUtils = __webpack_require__(356);
	
	var _dataUtilsLeaveDataUtils2 = _interopRequireDefault(_dataUtilsLeaveDataUtils);
	
	var _componentsHeaderHeaderJsx = __webpack_require__(247);
	
	var _componentsHeaderHeaderJsx2 = _interopRequireDefault(_componentsHeaderHeaderJsx);
	
	var _componentsUserListUserListJsx = __webpack_require__(349);
	
	var _componentsUserListUserListJsx2 = _interopRequireDefault(_componentsUserListUserListJsx);
	
	var _componentsPullLoaderPullLoaderJsx = __webpack_require__(340);
	
	var _componentsPullLoaderPullLoaderJsx2 = _interopRequireDefault(_componentsPullLoaderPullLoaderJsx);
	
	var LeaveMgrQuota = (function (_Component) {
	  _inherits(LeaveMgrQuota, _Component);
	
	  function LeaveMgrQuota(props) {
	    _classCallCheck(this, LeaveMgrQuota);
	
	    _get(Object.getPrototypeOf(LeaveMgrQuota.prototype), 'constructor', this).call(this, props);
	
	    this.getTeamMembers();
	    this.loadMore = this.loadMore.bind(this);
	  }
	
	  _createClass(LeaveMgrQuota, [{
	    key: 'render',
	    value: function render() {
	      var _state = this.state;
	      var quotaTeamList = _state.quotaTeamList;
	      var status = _state.status;
	
	      return _react2['default'].createElement(
	        'div',
	        null,
	        _react2['default'].createElement(_componentsHeaderHeaderJsx2['default'], { back: 'manager', title: (0, _commonLang.getItem)('LEAVE_QUOTA') }),
	        _react2['default'].createElement(
	          _componentsPullLoaderPullLoaderJsx2['default'],
	          { className: 'pad-b',
	            status: status,
	            onLoad: this.loadMore },
	          _react2['default'].createElement(_componentsUserListUserListJsx2['default'], { userList: quotaTeamList,
	            onSelectUser: this.selectUser })
	        )
	      );
	    }
	  }, {
	    key: 'getTeamMembers',
	    value: function getTeamMembers() {
	      var query = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	      query.page = 1;
	      query.loadMore = false;
	
	      this.page = query.page;
	
	      _dataUtilsLeaveDataUtils2['default'].getQuotaMembers(query);
	    }
	  }, {
	    key: 'loadMore',
	    value: function loadMore() {
	      var query = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	      this.page += 1;
	
	      _dataUtilsLeaveDataUtils2['default'].getQuotaMembers(_extends({}, query, {
	        page: this.page,
	        loadMore: true
	      }));
	    }
	  }, {
	    key: 'selectUser',
	    value: function selectUser(id) {
	      location.hash = '/leave-mgr/quota/' + id;
	    }
	  }], [{
	    key: 'getStores',
	    value: function getStores() {
	      return [_storesLeaveStore2['default']];
	    }
	  }, {
	    key: 'calculateState',
	    value: function calculateState() {
	      var state = _storesLeaveStore2['default'].getState();
	
	      return {
	        quotaTeamList: state.quotaTeamList,
	        status: state.status
	      };
	    }
	  }]);
	
	  return LeaveMgrQuota;
	})(_react.Component);
	
	exports['default'] = _fluxUtils.Container.create(LeaveMgrQuota);
	module.exports = exports['default'];

/***/ }),
/* 375 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Home page
	 */
	
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(23);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _fluxUtils = __webpack_require__(228);
	
	var _componentsHeaderHeaderJsx = __webpack_require__(247);
	
	var _componentsHeaderHeaderJsx2 = _interopRequireDefault(_componentsHeaderHeaderJsx);
	
	var _componentsInfoCardInfoCardJsx = __webpack_require__(322);
	
	var _componentsInfoCardInfoCardJsx2 = _interopRequireDefault(_componentsInfoCardInfoCardJsx);
	
	var _componentsLoaderLoaderJsx = __webpack_require__(315);
	
	var _componentsLoaderLoaderJsx2 = _interopRequireDefault(_componentsLoaderLoaderJsx);
	
	var _commonLang = __webpack_require__(245);
	
	var _storesLeaveStore = __webpack_require__(355);
	
	var _storesLeaveStore2 = _interopRequireDefault(_storesLeaveStore);
	
	var _dataUtilsLeaveDataUtils = __webpack_require__(356);
	
	var _dataUtilsLeaveDataUtils2 = _interopRequireDefault(_dataUtilsLeaveDataUtils);
	
	var LeaveQuota = (function (_Component) {
	  _inherits(LeaveQuota, _Component);
	
	  _createClass(LeaveQuota, null, [{
	    key: 'getStores',
	    value: function getStores() {
	      return [_storesLeaveStore2['default']];
	    }
	  }, {
	    key: 'calculateState',
	    value: function calculateState() {
	      return _storesLeaveStore2['default'].getState();
	    }
	  }]);
	
	  function LeaveQuota(props) {
	    _classCallCheck(this, LeaveQuota);
	
	    _get(Object.getPrototypeOf(LeaveQuota.prototype), 'constructor', this).call(this, props);
	    _dataUtilsLeaveDataUtils2['default'].getQuota(this.props.params.id);
	  }
	
	  _createClass(LeaveQuota, [{
	    key: 'render',
	    value: function render() {
	      var _state = this.state;
	      var _state$quota = _state.quota;
	      var quota = _state$quota === undefined ? [] : _state$quota;
	      var status = _state.status;
	
	      return _react2['default'].createElement(
	        'div',
	        null,
	        _react2['default'].createElement(_componentsHeaderHeaderJsx2['default'], { goBack: true, title: (0, _commonLang.getItem)('LEAVE_QUOTA') }),
	        _react2['default'].createElement(
	          'div',
	          { className: 'side-gap gap-t gap-b' },
	          _react2['default'].createElement(
	            _componentsLoaderLoaderJsx2['default'],
	            { status: status },
	            quota.map(function (card, index) {
	              return _react2['default'].createElement(
	                'div',
	                { className: 'gap-t', key: index },
	                _react2['default'].createElement(
	                  'h2',
	                  { className: 'info-card-heading gap-b' },
	                  card.title
	                ),
	                _react2['default'].createElement(_componentsInfoCardInfoCardJsx2['default'], { items: card.items })
	              );
	            })
	          )
	        )
	      );
	    }
	  }]);
	
	  return LeaveQuota;
	})(_react.Component);
	
	exports['default'] = _fluxUtils.Container.create(LeaveQuota);
	module.exports = exports['default'];

/***/ }),
/* 376 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Home page
	 */
	
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(23);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _dispatcherDispatcher = __webpack_require__(223);
	
	var _dispatcherDispatcher2 = _interopRequireDefault(_dispatcherDispatcher);
	
	var _fluxUtils = __webpack_require__(228);
	
	var _reactLibReactCSSTransitionGroup = __webpack_require__(259);
	
	var _reactLibReactCSSTransitionGroup2 = _interopRequireDefault(_reactLibReactCSSTransitionGroup);
	
	var _commonUtilsAjax = __webpack_require__(222);
	
	var _commonUtilsAjax2 = _interopRequireDefault(_commonUtilsAjax);
	
	var _commonLang = __webpack_require__(245);
	
	var _componentsButtonButtonJsx = __webpack_require__(250);
	
	var _componentsButtonButtonJsx2 = _interopRequireDefault(_componentsButtonButtonJsx);
	
	var _componentsHeaderHeaderJsx = __webpack_require__(247);
	
	var _componentsHeaderHeaderJsx2 = _interopRequireDefault(_componentsHeaderHeaderJsx);
	
	var _componentsPullLoaderPullLoaderJsx = __webpack_require__(340);
	
	var _componentsPullLoaderPullLoaderJsx2 = _interopRequireDefault(_componentsPullLoaderPullLoaderJsx);
	
	var _componentsRecordListRecordListJsx = __webpack_require__(359);
	
	var _componentsRecordListRecordListJsx2 = _interopRequireDefault(_componentsRecordListRecordListJsx);
	
	var _storesLeaveStore = __webpack_require__(355);
	
	var _storesLeaveStore2 = _interopRequireDefault(_storesLeaveStore);
	
	var _dataUtilsLeaveDataUtils = __webpack_require__(356);
	
	var _dataUtilsLeaveDataUtils2 = _interopRequireDefault(_dataUtilsLeaveDataUtils);
	
	var LeaveListContainer = (function (_Component) {
	  _inherits(LeaveListContainer, _Component);
	
	  _createClass(LeaveListContainer, null, [{
	    key: 'getStores',
	    value: function getStores() {
	      return [_storesLeaveStore2['default']];
	    }
	  }, {
	    key: 'calculateState',
	    value: function calculateState() {
	      return _storesLeaveStore2['default'].getState();
	    }
	  }]);
	
	  function LeaveListContainer(props) {
	    _classCallCheck(this, LeaveListContainer);
	
	    _get(Object.getPrototypeOf(LeaveListContainer.prototype), 'constructor', this).call(this, props);
	
	    _dataUtilsLeaveDataUtils2['default'].getPendingRecords({
	      page: 1
	    });
	
	    this.loadMore = this.loadMore.bind(this);
	  }
	
	  /**
	    * Approve all entries
	    */
	
	  _createClass(LeaveListContainer, [{
	    key: 'approve',
	    value: function approve(agreeOrNot) {
	      var inputs = [].slice.call(document.querySelectorAll('[type=checkbox]')).filter(function (check) {
	        return check.checked;
	      }).map(function (check) {
	        return check.value;
	      });
	
	      _commonUtilsAjax2['default'].post('/mss-lv-approve', {
	        idList: inputs.join(),
	        agreeOrNot: agreeOrNot
	      }).then(function () {
	        location.reload();
	      });
	    }
	
	    /**
	     * Load next page
	     */
	  }, {
	    key: 'loadMore',
	    value: function loadMore() {
	      _dataUtilsLeaveDataUtils2['default'].getPendingRecords({
	        page: this.state.pendingQuery.page + 1
	      });
	    }
	
	    /**
	     * Test if an item is selectable
	     * @param {Object} item
	     */
	  }, {
	    key: 'select',
	    value: function select(item) {
	      return true;
	    }
	
	    /**
	      * Make records selectable / unselectable
	      */
	  }, {
	    key: 'toggleSelectMode',
	    value: function toggleSelectMode() {
	      (0, _dispatcherDispatcher.dispatch)({
	        type: 'toggle-leave-record-selectable'
	      });
	    }
	
	    /**
	      * Select / unselect all
	      */
	  }, {
	    key: 'toggleSelectAll',
	    value: function toggleSelectAll(e) {
	      var selected = e.target.checked;
	
	      [].slice.call(document.querySelectorAll('[type=checkbox]')).forEach(function (checkbox) {
	        checkbox.checked = selected;
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state;
	      var pendingRecords = _state.pendingRecords;
	      var selectable = _state.selectable;
	      var status = _state.status;
	
	      return _react2['default'].createElement(
	        'div',
	        null,
	        _react2['default'].createElement(_componentsHeaderHeaderJsx2['default'], { back: 'manager', title: (0, _commonLang.getItem)('PENDING') }),
	        _react2['default'].createElement(
	          _componentsPullLoaderPullLoaderJsx2['default'],
	          { status: status, onLoad: this.loadMore },
	          _react2['default'].createElement(_componentsRecordListRecordListJsx2['default'], { recordList: pendingRecords,
	            selectable: selectable && this.select,
	            url: 'leave-record-mgr' })
	        ),
	        _react2['default'].createElement(_componentsButtonButtonJsx2['default'], { icon: 'pencil', action: true, onClick: this.toggleSelectMode }),
	        _react2['default'].createElement(
	          _reactLibReactCSSTransitionGroup2['default'],
	          { component: 'div', transitionName: 'bottom-up' },
	          selectable ? _react2['default'].createElement(
	            'nav',
	            { className: 'tab tab-bottom leave-mgr-bottom' },
	            _react2['default'].createElement(
	              'label',
	              { className: 'leave-mgr-select-all' },
	              _react2['default'].createElement('input', { type: 'checkbox', value: '', onChange: this.toggleSelectAll })
	            ),
	            _react2['default'].createElement(
	              'div',
	              { className: 'row' },
	              _react2['default'].createElement(
	                'div',
	                { className: 'col-1-2' },
	                _react2['default'].createElement(_componentsButtonButtonJsx2['default'], { text: (0, _commonLang.getItem)('APPROVE_ALL'),
	                  onTouchTap: this.approve.bind(null, true) })
	              ),
	              _react2['default'].createElement(
	                'div',
	                { className: 'col-1-2' },
	                _react2['default'].createElement(_componentsButtonButtonJsx2['default'], { text: (0, _commonLang.getItem)('REJECT_ALL'),
	                  hollow: true,
	                  className: 'text-primary',
	                  onTouchTap: this.approve.bind(null, false) })
	              )
	            )
	          ) : null
	        )
	      );
	    }
	  }]);
	
	  return LeaveListContainer;
	})(_react.Component);
	
	exports['default'] = _fluxUtils.Container.create(LeaveListContainer);
	module.exports = exports['default'];

/***/ }),
/* 377 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Overtime
	 */
	
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(23);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _fluxUtils = __webpack_require__(228);
	
	var _commonLang = __webpack_require__(245);
	
	var _componentsTabTabJsx = __webpack_require__(269);
	
	var _componentsTabTabJsx2 = _interopRequireDefault(_componentsTabTabJsx);
	
	var _storesOvertimeStore = __webpack_require__(378);
	
	var _storesOvertimeStore2 = _interopRequireDefault(_storesOvertimeStore);
	
	var tabSettings = [{
	  text: (0, _commonLang.getItem)('MY_APPLY'),
	  name: 'my-ot/list',
	  icon: 'clock-o'
	}, {
	  text: (0, _commonLang.getItem)('OT_SUMMARY'),
	  name: 'my-ot/summary',
	  icon: 'pie-chart'
	}];
	
	var Overtime = (function (_Component) {
	  _inherits(Overtime, _Component);
	
	  function Overtime() {
	    _classCallCheck(this, Overtime);
	
	    _get(Object.getPrototypeOf(Overtime.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(Overtime, [{
	    key: 'render',
	    value: function render() {
	      return _react2['default'].createElement(
	        'div',
	        { className: 'bottom-gap' },
	        this.props.children,
	        _react2['default'].createElement(_componentsTabTabJsx2['default'], { items: tabSettings, bottom: true })
	      );
	    }
	  }], [{
	    key: 'getStores',
	    value: function getStores() {
	      return [_storesOvertimeStore2['default']];
	    }
	  }, {
	    key: 'calculateState',
	    value: function calculateState() {
	      return _storesOvertimeStore2['default'].getState();
	    }
	  }]);
	
	  return Overtime;
	})(_react.Component);
	
	exports['default'] = _fluxUtils.Container.create(Overtime);
	module.exports = exports['default'];

/***/ }),
/* 378 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Created by AshZhang on 2016-4-5.
	 */
	
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _fluxUtils = __webpack_require__(228);
	
	var _dispatcherDispatcher = __webpack_require__(223);
	
	var _dispatcherDispatcher2 = _interopRequireDefault(_dispatcherDispatcher);
	
	var _commonLang = __webpack_require__(245);
	
	var OvertimeStore = (function (_ReduceStore) {
		_inherits(OvertimeStore, _ReduceStore);
	
		function OvertimeStore() {
			_classCallCheck(this, OvertimeStore);
	
			_get(Object.getPrototypeOf(OvertimeStore.prototype), 'constructor', this).apply(this, arguments);
		}
	
		_createClass(OvertimeStore, [{
			key: 'getInitialState',
			value: function getInitialState() {
				return {};
			}
		}, {
			key: 'reduce',
			value: function reduce(state, action) {
				switch (action.type) {
					case 'get-emp-ot-list':
						return _extends({}, state, {
							empOtListQuery: action.data,
							status: 'loading'
						});
					case 'get-emp-ot-list-fail':
						return _extends({}, state, {
							status: 'loaded'
						});
					case 'get-emp-ot-list-success':
						return _extends({}, state, {
							empOtList: state.empOtListQuery.page === 1 ? action.data : state.empOtList.concat(action.data),
							status: 'loaded'
						});
					case 'get-emp-ot-record':
						return _extends({}, state, {
							status: 'loading'
						});
					case 'get-emp-ot-record-fail':
						return _extends({}, state, {
							status: 'loaded'
						});
					case 'get-emp-ot-record-success':
						return _extends({}, state, {
							empOtRecord: action.data,
							status: 'loaded'
						});
					case 'get-emp-ot-summary':
						return _extends({}, state, {
							status: 'loading'
						});
					case 'get-emp-ot-summary-success':
						return _extends({}, state, {
							empOtSummary: action.data,
							status: 'loaded'
						});
					case 'get-ot-form':
						return _extends({}, state, {
							status: 'loading'
						});
					case 'get-ot-form-success':
						return _extends({}, state, {
							otForm: action.data.formConfig,
							status: 'loaded'
						});
					case 'insert-ot-form':
						return _extends({}, state, {
							submitting: true
						});
					case 'insert-ot-form-fail':
						//alert('insert-ot-form-fail');
						return _extends({}, state, {
							submitting: false,
							refreshList: false
						});
					case 'insert-ot-form-success':
						//alert('insert-ot-form-success');
						return _extends({}, state, {
							submitting: false,
							refreshList: action.type === 'insert-ot-form-success'
						});
					case 'get-ot-pending-records':
						return _extends({}, state, {
							pendingQuery: action.data,
							status: 'loading'
						});
					case 'get-ot-pending-records-fail':
						return _extends({}, state, {
							status: 'loaded'
						});
					case 'get-ot-pending-records-success':
						return _extends({}, state, {
							pendingRecords: state.pendingQuery.page === 1 ? action.data : state.pendingRecords.concat(action.data),
							status: 'loaded'
						});
					case 'revoke-ot-record':
						return _extends({}, state, {
							status: 'loading'
						});
					case 'revoke-ot-record-success':
						return _extends({}, state, {
							empOtRecord: action.data,
							status: 'loaded'
						});
					case 'revoke-ot-record-fail':
						return _extends({}, state, {
							status: 'loaded'
						});
					case 'approve-ot-pending-record-success':
						return history.back();
					case 'get-ot-history-list':
						return _extends({}, state, {
							otHistoryQuery: action.data,
							status: 'loading'
						});
					case 'get-ot-history-list-fail':
						return _extends({}, state, {
							status: 'loaded'
						});
					case 'get-ot-history-list-success':
						return _extends({}, state, {
							otHistoryList: state.otHistoryQuery.page === 1 ? action.data : state.otHistoryList.concat(action.data),
							status: 'loaded'
						});
					case 'get-ot-history-detail':
						return _extends({}, state, {
							status: 'loading'
						});
					case 'get-ot-history-detail-success':
						return _extends({}, state, {
							otHistoryDetail: action.data,
							status: 'loaded'
						});
					case 'get-ot-summary-list':
						return _extends({}, state, {
							summaryQuery: action.data,
							status: 'loading'
						});
					case 'get-ot-summary-list-fail':
						return _extends({}, state, {
							status: 'loaded'
						});
					case 'get-ot-summary-list-success':
						return _extends({}, state, {
							summaryList: action.data.page !== 1 ? state.summaryList.concat(action.data) : action.data,
							status: 'loaded'
						});
					case 'toggle-overtime-record-selectable':
						return _extends({}, state, {
							selectable: !state.selectable
						});
					case 'get-leave-summary-filters':
						return _extends({}, state, {
							summaryList: [],
							configStatus: 'loading',
							status: 'loaded'
						});
					case 'get-leave-summary-filters-fail':
						return _extends({}, state, {
							configStatus: 'loaded',
							status: 'loaded'
						});
					case 'get-leave-summary-filters-success':
						return _extends({}, state, {
							otSummaryConfig: action.data.formConfig,
							configStatus: 'loaded',
							status: 'loaded'
						});
					case 'get-ot-filter-success':
						return _extends({}, state, {
							filter: {
								items: (action.data.map ? action.data : []).map(function (item) {
									return _extends({}, item, {
										text: item[(0, _commonLang.getLang)() + '_text'],
										name: item.value
									});
								})
							}
						});
					default:
						return state;
				}
			}
		}]);
	
		return OvertimeStore;
	})(_fluxUtils.ReduceStore);
	
	exports['default'] = new OvertimeStore(_dispatcherDispatcher2['default']);
	module.exports = exports['default'];

/***/ }),
/* 379 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Overtime Employee List
	 */
	
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(23);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _fluxUtils = __webpack_require__(228);
	
	var _commonLang = __webpack_require__(245);
	
	var _componentsHeaderHeaderJsx = __webpack_require__(247);
	
	var _componentsHeaderHeaderJsx2 = _interopRequireDefault(_componentsHeaderHeaderJsx);
	
	var _componentsPullLoaderPullLoaderJsx = __webpack_require__(340);
	
	var _componentsPullLoaderPullLoaderJsx2 = _interopRequireDefault(_componentsPullLoaderPullLoaderJsx);
	
	var _componentsRecordListRecordListJsx = __webpack_require__(359);
	
	var _componentsRecordListRecordListJsx2 = _interopRequireDefault(_componentsRecordListRecordListJsx);
	
	var _componentsButtonButtonJsx = __webpack_require__(250);
	
	var _componentsButtonButtonJsx2 = _interopRequireDefault(_componentsButtonButtonJsx);
	
	var _componentsFormFormJsx = __webpack_require__(280);
	
	var _componentsFormFormJsx2 = _interopRequireDefault(_componentsFormFormJsx);
	
	var _componentsLoaderLoaderJsx = __webpack_require__(315);
	
	var _componentsLoaderLoaderJsx2 = _interopRequireDefault(_componentsLoaderLoaderJsx);
	
	var _componentsPageOpenerPageOpenerJsx = __webpack_require__(294);
	
	var _componentsPageOpenerPageOpenerJsx2 = _interopRequireDefault(_componentsPageOpenerPageOpenerJsx);
	
	var _storesOvertimeStore = __webpack_require__(378);
	
	var _storesOvertimeStore2 = _interopRequireDefault(_storesOvertimeStore);
	
	var _dataUtilsOvertimeDataUtils = __webpack_require__(380);
	
	var _dataUtilsOvertimeDataUtils2 = _interopRequireDefault(_dataUtilsOvertimeDataUtils);
	
	var OvertimeEmpList = (function (_Component) {
		_inherits(OvertimeEmpList, _Component);
	
		_createClass(OvertimeEmpList, null, [{
			key: 'getStores',
			value: function getStores() {
				return [_storesOvertimeStore2['default']];
			}
		}, {
			key: 'calculateState',
			value: function calculateState() {
				return _storesOvertimeStore2['default'].getState();
			}
		}]);
	
		function OvertimeEmpList(props) {
			_classCallCheck(this, OvertimeEmpList);
	
			_get(Object.getPrototypeOf(OvertimeEmpList.prototype), 'constructor', this).call(this, props);
	
			_dataUtilsOvertimeDataUtils2['default'].getEmpOtList({
				page: 1,
				state: 'approving'
			});
	
			_dataUtilsOvertimeDataUtils2['default'].getFilter(JSON.parse(localStorage.getItem('companyCode')));
		}
	
		_createClass(OvertimeEmpList, [{
			key: 'componentDidUpdate',
			value: function componentDidUpdate() {
				var inputList = document.getElementsByTagName('input');
				var files = [];
				if (inputList.length > 0) {
					for (var i = 0; i < inputList.length; i++) {
						var input = inputList[i];
						if (input != null && input.type == 'file') {
							input.multiple = 'multiple';
							if (files.length == 0) {
								input.currentShow = 1;
							}
							if (files.length > 0 && input.value == '') {
								input.parentNode.style.display = 'none';
							}
							files.push(input);
						}
						//console.log(input);
					}
				}
			}
	
			/**
	   * 加载更多
	   */
		}, {
			key: 'loadMore',
			value: function loadMore() {
				var currentQuery = this.state.empOtListQuery;
	
				_dataUtilsOvertimeDataUtils2['default'].getEmpOtList(_extends({}, currentQuery, {
					page: currentQuery.page + 1
				}));
			}
		}, {
			key: 'checkEdit',
			value: function checkEdit(item, e) {
				if (item.stateCode === 0) {
					e.preventDefault();
	
					this._editId = item.id;
					_dataUtilsOvertimeDataUtils2['default'].getOtEditRecord(item.id);
					this.openApply(e, true);
				}
			}
		}, {
			key: 'toggleSelect',
			value: function toggleSelect() {}
	
			/**
	   * Open apply form
	   * @param e
	   * @param editMode
	   */
		}, {
			key: 'openApply',
			value: function openApply(e, editMode) {
				this.refs.apply.open(e);
				this.refs.pullLoader.stopLoading();
	
				if (editMode === true) {
					this.url = '/ess-edit-ot';
					return;
				} else {
					this.url = '/ess-insert-ot';
				}
	
				_dataUtilsOvertimeDataUtils2['default'].getOtForm();
			}
	
			/**
	   * 新增表单
	   * - save: { submit: false}
	   * - submit: { submit: true }
	   * @param submitValue
	   */
		}, {
			key: 'insert',
			value: function insert(submitValue, e) {
				var formData = this.collectFormData(submitValue);
	
				if (!formData) return;
	
				_dataUtilsOvertimeDataUtils2['default'].insertOt(formData, this.url);
	
				e.preventDefault();
			}
	
			/**
	   * 若表单合法, 返回 formData
	   * 若不合法, 返回 false
	   * @param {boolean} submitValue
	   * @returns {boolean|*}
	   */
		}, {
			key: 'collectFormData',
			value: function collectFormData(submitValue) {
				var form = this.refs.applyForm,
				    formData = new FormData(_react2['default'].findDOMNode(form));
	
				if (!form.isValid() || window.leaveValidation && !window.leaveValidation()) return;
	
				formData.append('submit', submitValue);
	
				formData.append('verify', false);
	
				if (this._editId) {
					formData.append('id', this._editId);
				}
	
				return formData;
			}
	
			/**
	   * 关闭申请框, 并清除数据
	   */
		}, {
			key: 'closeFormAndRefreshList',
			value: function closeFormAndRefreshList() {
				var inputs = _react2['default'].findDOMNode(this.refs.applyForm).querySelectorAll('input, select, textarea');
	
				for (var i = 0; i < inputs.length; i += 1) {
					inputs[i].value = '';
				}
	
				this.refs.apply.close();
				this.refs.pullLoader.continueLoading();
			}
		}, {
			key: 'addFix',
			value: function addFix() {
				var inputList = document.getElementsByTagName('input');
				var files = [];
				var currentShow = 1;
				if (inputList.length > 0) {
					for (var i = 0; i < inputList.length; i++) {
						var input = inputList[i];
						if (input != null && input.type == 'file') {
							input.multiple = 'multiple';
							if (files.length == 0) {
								input.currentShow += 1;
								currentShow = input.currentShow;
							}
							//console.log(currentShow);
							if (currentShow - 1 == files.length) {
								input.parentNode.style.display = 'block';
							}
							files.push(input);
						}
						//console.log(input);
					}
				}
			}
		}, {
			key: 'render',
			value: function render() {
				var _state = this.state;
				var _state$empOtList = _state.empOtList;
				var empOtList = _state$empOtList === undefined ? [] : _state$empOtList;
				var selectable = _state.selectable;
				var _state$status = _state.status;
				var status = _state$status === undefined ? 'loading' : _state$status;
				var filter = _state.filter;
				var otForm = _state.otForm;
				var submitting = _state.submitting;
				var refreshList = _state.refreshList;
	
				if (filter) {
					filter.onClickItem = function (state) {
						_dataUtilsOvertimeDataUtils2['default'].getEmpOtList({
							page: 1,
							state: state
						});
					};
				}
	
				if (refreshList) {
					setTimeout(function () {
						location.reload();
					}, 0);
				}
				return _react2['default'].createElement(
					'div',
					null,
					_react2['default'].createElement(_componentsHeaderHeaderJsx2['default'], {
						back: true,
						title: (0, _commonLang.getItem)('MY_APPLY'),
						dropdown: filter
					}),
					_react2['default'].createElement(
						_componentsPullLoaderPullLoaderJsx2['default'],
						{ ref: 'pullLoader',
							status: status,
							onLoad: this.loadMore.bind(this) },
						_react2['default'].createElement(_componentsRecordListRecordListJsx2['default'], { recordList: empOtList,
							url: '/my-ot/record',
							onClickItem: this.checkEdit.bind(this),
							selectable: selectable && this.select.bind(this),
							toggleSelect: this.toggleSelect.bind(this) })
					),
					_react2['default'].createElement(_componentsButtonButtonJsx2['default'], { icon: 'plus', action: true, onClick: this.openApply.bind(this) }),
					_react2['default'].createElement(
						_componentsPageOpenerPageOpenerJsx2['default'],
						{ ref: 'apply' },
						_react2['default'].createElement(
							_componentsLoaderLoaderJsx2['default'],
							{ status: status },
							_react2['default'].createElement(_componentsFormFormJsx2['default'], { className: 'side-gap pad-b',
								controls: otForm,
								ref: 'applyForm' }),
							_react2['default'].createElement(
								'div',
								{ className: 'row' },
								_react2['default'].createElement(
									'a',
									{ href: 'javascript:;', className: 'btnAddFix', onClick: this.addFix },
									'+',
									(0, _commonLang.getItem)('FORM_ADD_FIX')
								),
								_react2['default'].createElement('br', null),
								_react2['default'].createElement('br', null)
							),
							_react2['default'].createElement(
								'div',
								{ className: 'row' },
								_react2['default'].createElement(
									'div',
									{ className: 'col-1-2' },
									_react2['default'].createElement(_componentsButtonButtonJsx2['default'], { type: 'button',
										disabled: submitting,
										text: (0, _commonLang.getItem)('SAVE'),
										onClick: this.insert.bind(this, false) })
								),
								_react2['default'].createElement(
									'div',
									{ className: 'col-1-2' },
									_react2['default'].createElement(_componentsButtonButtonJsx2['default'], { type: 'button',
										disabled: submitting,
										text: (0, _commonLang.getItem)('SUBMIT'),
										onClick: this.insert.bind(this, true) })
								)
							)
						)
					)
				);
			}
		}]);
	
		return OvertimeEmpList;
	})(_react.Component);
	
	exports['default'] = _fluxUtils.Container.create(OvertimeEmpList);
	module.exports = exports['default'];

/***/ }),
/* 380 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Created by AshZhang on 2016-4-5.
	 */
	
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
		value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _dispatcherDispatcher = __webpack_require__(223);
	
	var _commonUtilsAjax = __webpack_require__(222);
	
	var _commonUtilsAjax2 = _interopRequireDefault(_commonUtilsAjax);
	
	exports['default'] = {
	
		getEmpOtList: function getEmpOtList(data) {
			(0, _commonUtilsAjax.ajaxDispatch)({
				action: 'get-emp-ot-list',
				url: '/ess-ot-list',
				method: 'get',
				data: data
			});
		},
	
		getEmpOtRecord: function getEmpOtRecord(id) {
			(0, _commonUtilsAjax.ajaxDispatch)({
				action: 'get-emp-ot-record',
				url: '/ess-ot-detail',
				method: 'get',
				data: {
					id: id
				}
			});
		},
	
		/**
	  * Get edit info
	  * @param id
	  */
		getOtEditRecord: function getOtEditRecord(id) {
			(0, _dispatcherDispatcher.dispatch)({
				type: 'get-ot-form'
			});
	
			_commonUtilsAjax2['default'].get('/ess-ot-edit-config', {
				id: id
			}).then(function (res) {
				(0, _dispatcherDispatcher.dispatch)({
					type: 'get-ot-form-success',
					data: res
				});
			});
		},
	
		getOtForm: function getOtForm() {
			(0, _dispatcherDispatcher.dispatch)({
				type: 'get-ot-form'
			});
	
			_commonUtilsAjax2['default'].get('/ess-ot-config').then(function (form) {
	
				_commonUtilsAjax2['default'].getScript(form.JS_CONFIG_FILE).then(function () {
	
					(0, _dispatcherDispatcher.dispatch)({
						type: 'get-ot-form-success',
						data: form
					});
				});
			});
		},
	
		insertOt: function insertOt(formData, url) {
			(0, _commonUtilsAjax.ajaxDispatch)({
				action: 'insert-ot-form',
				url: url,
				method: 'post',
				data: formData
			})['catch'](function (e) {
				console.log(e);
			});
		},
	
		getEmpOtSummary: function getEmpOtSummary(id, query) {
			if (query && id) {
				query.append('id', id);
			}
	
			(0, _commonUtilsAjax.ajaxDispatch)({
				action: 'get-emp-ot-summary',
				url: '/ess-ot-summary',
				method: 'post',
				data: query || (id ? { id: id } : {})
			});
		},
	
		getPendingRecords: function getPendingRecords(query) {
			(0, _commonUtilsAjax.ajaxDispatch)({
				action: 'get-ot-pending-records',
				url: '/mss-ot-todolist',
				method: 'get',
				data: query
			});
		},
	
		approveRecord: function approveRecord(data) {
			(0, _commonUtilsAjax.ajaxDispatch)({
				action: 'approve-ot-pending-record',
				url: '/mss-ot-approve',
				method: 'post',
				data: data
			});
		},
	
		revokeRecord: function revokeRecord(data) {
			(0, _commonUtilsAjax.ajaxDispatch)({
				action: 'revoke-ot-record',
				url: '/ot-revoke',
				method: 'post',
				data: data
			});
		},
	
		getHistoryList: function getHistoryList(query) {
			(0, _commonUtilsAjax.ajaxDispatch)({
				action: 'get-ot-history-list',
				url: '/ot-approve-his',
				method: 'get',
				data: query
			});
		},
	
		getHistoryDetail: function getHistoryDetail(id) {
			(0, _commonUtilsAjax.ajaxDispatch)({
				action: 'get-ot-history-detail',
				url: '/ot-approve-otdetail',
				method: 'get',
				data: {
					id: id
				}
			});
		},
	
		getSummaryMembers: function getSummaryMembers(params, page) {
			(0, _dispatcherDispatcher.dispatch)({
				type: 'get-ot-summary-list'
			});
	
			_commonUtilsAjax2['default'].post('/ot-team-summary', params).then(function (res) {
				res.page = page;
	
				(0, _dispatcherDispatcher.dispatch)({
					type: 'get-ot-summary-list-success',
					data: res
				});
			})['catch'](function () {
				(0, _dispatcherDispatcher.dispatch)({
					type: 'get-ot-summary-list-fail'
				});
			});
		},
	
		getFilter: function getFilter(companyCode) {
			_commonUtilsAjax2['default'].get('/custom/config/' + companyCode + '_LV_STATE.json').then(function (res) {
				(0, _dispatcherDispatcher.dispatch)({
					type: 'get-ot-filter-success',
					data: res && res.items
				});
			});
		},
	
		submitForm: function submitForm() {
			(0, _dispatcherDispatcher.dispatch)({
				type: 'form-submitting'
			});
		}
	};
	module.exports = exports['default'];

/***/ }),
/* 381 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Created by AshZhang on 2016-4-5.
	 * 
	 */
	
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
		value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(23);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _fluxUtils = __webpack_require__(228);
	
	var _commonLang = __webpack_require__(245);
	
	var _componentsHeaderHeaderJsx = __webpack_require__(247);
	
	var _componentsHeaderHeaderJsx2 = _interopRequireDefault(_componentsHeaderHeaderJsx);
	
	var _componentsInfoCardInfoCardJsx = __webpack_require__(322);
	
	var _componentsInfoCardInfoCardJsx2 = _interopRequireDefault(_componentsInfoCardInfoCardJsx);
	
	var _componentsLoaderLoaderJsx = __webpack_require__(315);
	
	var _componentsLoaderLoaderJsx2 = _interopRequireDefault(_componentsLoaderLoaderJsx);
	
	var _componentsConfirmButtonConfirmButtonJsx = __webpack_require__(363);
	
	var _componentsConfirmButtonConfirmButtonJsx2 = _interopRequireDefault(_componentsConfirmButtonConfirmButtonJsx);
	
	var _storesOvertimeStore = __webpack_require__(378);
	
	var _storesOvertimeStore2 = _interopRequireDefault(_storesOvertimeStore);
	
	var _dataUtilsOvertimeDataUtils = __webpack_require__(380);
	
	var _dataUtilsOvertimeDataUtils2 = _interopRequireDefault(_dataUtilsOvertimeDataUtils);
	
	var OvertimeEmpRecord = (function (_Component) {
		_inherits(OvertimeEmpRecord, _Component);
	
		_createClass(OvertimeEmpRecord, null, [{
			key: 'getStores',
			value: function getStores() {
				return [_storesOvertimeStore2['default']];
			}
		}, {
			key: 'calculateState',
			value: function calculateState() {
				return _storesOvertimeStore2['default'].getState();
			}
		}]);
	
		function OvertimeEmpRecord(props) {
			_classCallCheck(this, OvertimeEmpRecord);
	
			_get(Object.getPrototypeOf(OvertimeEmpRecord.prototype), 'constructor', this).call(this, props);
			this.revoke = this.revoke.bind(this);
	
			_dataUtilsOvertimeDataUtils2['default'].getEmpOtRecord(this.props.routeParams.id);
		}
	
		_createClass(OvertimeEmpRecord, [{
			key: 'render',
			value: function render() {
				var _state = this.state;
				var _state$empOtRecord = _state.empOtRecord;
				var empOtRecord = _state$empOtRecord === undefined ? {} : _state$empOtRecord;
				var _state$status = _state.status;
				var status = _state$status === undefined ? 'loading' : _state$status;
				var baseInfo = empOtRecord.baseInfo;
				var appInfo = empOtRecord.appInfo;
				var _empOtRecord$onRevoke = empOtRecord.onRevoke;
				var onRevoke = _empOtRecord$onRevoke === undefined ? false : _empOtRecord$onRevoke;
	
				return _react2['default'].createElement(
					'div',
					null,
					_react2['default'].createElement(_componentsHeaderHeaderJsx2['default'], { goBack: true, title: (0, _commonLang.getItem)('MY_OT') }),
					_react2['default'].createElement(
						_componentsLoaderLoaderJsx2['default'],
						{ status: status, className: 'side-gap gap-t-lg pad-b' },
						baseInfo && _react2['default'].createElement(
							'div',
							null,
							_react2['default'].createElement(
								'h2',
								{ className: 'info-card-heading gap-b' },
								baseInfo.title
							),
							_react2['default'].createElement(_componentsInfoCardInfoCardJsx2['default'], { items: baseInfo.items })
						),
						appInfo && _react2['default'].createElement(
							'div',
							null,
							_react2['default'].createElement(
								'h2',
								{ className: 'info-card-heading gap-b' },
								appInfo.title
							),
							appInfo.items.map(function (item, index) {
								return _react2['default'].createElement(_componentsInfoCardInfoCardJsx2['default'], { items: item, key: index });
							})
						),
						onRevoke && _react2['default'].createElement(_componentsConfirmButtonConfirmButtonJsx2['default'], { text: (0, _commonLang.getItem)('REVOKE'), onTouchTap: this.revoke })
					)
				);
			}
	
			/**
	   * Revoke a record
	   */
		}, {
			key: 'revoke',
			value: function revoke() {
				_dataUtilsOvertimeDataUtils2['default'].revokeRecord({
					id: this.props.routeParams.id,
					onRevoke: this.state.empOtRecord.onRevoke
				});
			}
		}]);
	
		return OvertimeEmpRecord;
	})(_react.Component);
	
	exports['default'] = _fluxUtils.Container.create(OvertimeEmpRecord);
	module.exports = exports['default'];

/***/ }),
/* 382 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Created by AshZhang on 2016-4-5.
	 */
	
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(23);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _fluxUtils = __webpack_require__(228);
	
	var _commonLang = __webpack_require__(245);
	
	var _componentsHeaderHeaderJsx = __webpack_require__(247);
	
	var _componentsHeaderHeaderJsx2 = _interopRequireDefault(_componentsHeaderHeaderJsx);
	
	var _componentsInfoCardInfoCardJsx = __webpack_require__(322);
	
	var _componentsInfoCardInfoCardJsx2 = _interopRequireDefault(_componentsInfoCardInfoCardJsx);
	
	var _componentsLoaderLoaderJsx = __webpack_require__(315);
	
	var _componentsLoaderLoaderJsx2 = _interopRequireDefault(_componentsLoaderLoaderJsx);
	
	var _componentsFormFormJsx = __webpack_require__(280);
	
	var _componentsFormFormJsx2 = _interopRequireDefault(_componentsFormFormJsx);
	
	var _storesOvertimeStore = __webpack_require__(378);
	
	var _storesOvertimeStore2 = _interopRequireDefault(_storesOvertimeStore);
	
	var _dataUtilsLeaveDataUtils = __webpack_require__(356);
	
	var _dataUtilsLeaveDataUtils2 = _interopRequireDefault(_dataUtilsLeaveDataUtils);
	
	var _dataUtilsOvertimeDataUtils = __webpack_require__(380);
	
	var _dataUtilsOvertimeDataUtils2 = _interopRequireDefault(_dataUtilsOvertimeDataUtils);
	
	var OvertimeEmpSummary = (function (_Component) {
	  _inherits(OvertimeEmpSummary, _Component);
	
	  _createClass(OvertimeEmpSummary, null, [{
	    key: 'getStores',
	    value: function getStores() {
	      return [_storesOvertimeStore2['default']];
	    }
	  }, {
	    key: 'calculateState',
	    value: function calculateState() {
	      return _storesOvertimeStore2['default'].getState();
	    }
	  }]);
	
	  function OvertimeEmpSummary(props) {
	    _classCallCheck(this, OvertimeEmpSummary);
	
	    _get(Object.getPrototypeOf(OvertimeEmpSummary.prototype), 'constructor', this).call(this, props);
	
	    _dataUtilsLeaveDataUtils2['default'].getSummaryFilters({
	      type: 'FILTER_OT_SUMMARY'
	    });
	    // OvertimeDataUtils.getEmpOtSummary(this.props.routeParams.id);
	  }
	
	  _createClass(OvertimeEmpSummary, [{
	    key: 'querySummary',
	    value: function querySummary() {
	      _dataUtilsOvertimeDataUtils2['default'].getEmpOtSummary(this.props.params.id, new FormData(_react2['default'].findDOMNode(this.refs.query)));
	
	      this.refs.query.setState({
	        submitting: false,
	        disabled: false
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state;
	      var _state$empOtSummary = _state.empOtSummary;
	      var empOtSummary = _state$empOtSummary === undefined ? [] : _state$empOtSummary;
	      var _state$configStatus = _state.configStatus;
	      var configStatus = _state$configStatus === undefined ? 'loading' : _state$configStatus;
	      var _state$status = _state.status;
	      var status = _state$status === undefined ? 'loading' : _state$status;
	      var _state$otSummaryConfig = _state.otSummaryConfig;
	      var otSummaryConfig = _state$otSummaryConfig === undefined ? [] : _state$otSummaryConfig;
	
	      return _react2['default'].createElement(
	        'div',
	        null,
	        _react2['default'].createElement(_componentsHeaderHeaderJsx2['default'], { back: true, title: (0, _commonLang.getItem)('OT_SUMMARY') }),
	        _react2['default'].createElement(
	          _componentsLoaderLoaderJsx2['default'],
	          { status: configStatus, className: 'side-gap gap-t' },
	          _react2['default'].createElement(_componentsFormFormJsx2['default'], { ref: 'query',
	            action: '/ess-ot-summary',
	            controls: otSummaryConfig,
	            submitButton: { text: (0, _commonLang.getItem)('SUBMIT') },
	            onSubmit: this.querySummary.bind(this) })
	        ),
	        _react2['default'].createElement(
	          _componentsLoaderLoaderJsx2['default'],
	          { status: status,
	            className: 'side-gap gap-t-lg pad-t-lg pad-b',
	            style: { minHeight: 0 } },
	          empOtSummary.map(function (item, index) {
	            return _react2['default'].createElement(
	              'div',
	              { key: index },
	              _react2['default'].createElement(
	                'h2',
	                { className: 'info-card-heading gap-b' },
	                item.title
	              ),
	              _react2['default'].createElement(_componentsInfoCardInfoCardJsx2['default'], { items: item.items })
	            );
	          })
	        )
	      );
	    }
	  }]);
	
	  return OvertimeEmpSummary;
	})(_react.Component);
	
	exports['default'] = _fluxUtils.Container.create(OvertimeEmpSummary);
	module.exports = exports['default'];

/***/ }),
/* 383 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Home page
	 */
	
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(23);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _fluxUtils = __webpack_require__(228);
	
	var _componentsTabTabJsx = __webpack_require__(269);
	
	var _componentsTabTabJsx2 = _interopRequireDefault(_componentsTabTabJsx);
	
	var _commonLang = __webpack_require__(245);
	
	var _storesOvertimeStore = __webpack_require__(378);
	
	var _storesOvertimeStore2 = _interopRequireDefault(_storesOvertimeStore);
	
	var tabSettings = [{
	  text: (0, _commonLang.getItem)('PENDING'),
	  name: 'ot-mgr/pending',
	  icon: 'clock-o'
	}, {
	  text: (0, _commonLang.getItem)('HISTORY'),
	  name: 'ot-mgr/history',
	  icon: 'book'
	}, {
	  text: (0, _commonLang.getItem)('OT_SUMMARY'),
	  name: 'ot-mgr/summary',
	  icon: 'pie-chart'
	}];
	
	var OvertimeMgr = (function (_Component) {
	  _inherits(OvertimeMgr, _Component);
	
	  function OvertimeMgr() {
	    _classCallCheck(this, OvertimeMgr);
	
	    _get(Object.getPrototypeOf(OvertimeMgr.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(OvertimeMgr, [{
	    key: 'render',
	    value: function render() {
	      return _react2['default'].createElement(
	        'div',
	        null,
	        this.props.children,
	        _react2['default'].createElement(_componentsTabTabJsx2['default'], { items: tabSettings, bottom: true })
	      );
	    }
	  }], [{
	    key: 'getStores',
	    value: function getStores() {
	      return [_storesOvertimeStore2['default']];
	    }
	  }, {
	    key: 'calculateState',
	    value: function calculateState() {
	      return _storesOvertimeStore2['default'].getState();
	    }
	  }]);
	
	  return OvertimeMgr;
	})(_react.Component);
	
	exports['default'] = _fluxUtils.Container.create(OvertimeMgr);
	module.exports = exports['default'];

/***/ }),
/* 384 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Created by AshZhang on 2016-4-6.
	 */
	
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
		value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(23);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _fluxUtils = __webpack_require__(228);
	
	var _dispatcherDispatcher = __webpack_require__(223);
	
	var _dispatcherDispatcher2 = _interopRequireDefault(_dispatcherDispatcher);
	
	var _reactLibReactCSSTransitionGroup = __webpack_require__(259);
	
	var _reactLibReactCSSTransitionGroup2 = _interopRequireDefault(_reactLibReactCSSTransitionGroup);
	
	var _commonUtilsAjax = __webpack_require__(222);
	
	var _commonUtilsAjax2 = _interopRequireDefault(_commonUtilsAjax);
	
	var _commonLang = __webpack_require__(245);
	
	var _componentsButtonButtonJsx = __webpack_require__(250);
	
	var _componentsButtonButtonJsx2 = _interopRequireDefault(_componentsButtonButtonJsx);
	
	var _componentsHeaderHeaderJsx = __webpack_require__(247);
	
	var _componentsHeaderHeaderJsx2 = _interopRequireDefault(_componentsHeaderHeaderJsx);
	
	var _componentsPullLoaderPullLoaderJsx = __webpack_require__(340);
	
	var _componentsPullLoaderPullLoaderJsx2 = _interopRequireDefault(_componentsPullLoaderPullLoaderJsx);
	
	var _componentsRecordListRecordListJsx = __webpack_require__(359);
	
	var _componentsRecordListRecordListJsx2 = _interopRequireDefault(_componentsRecordListRecordListJsx);
	
	var _storesOvertimeStore = __webpack_require__(378);
	
	var _storesOvertimeStore2 = _interopRequireDefault(_storesOvertimeStore);
	
	var _dataUtilsOvertimeDataUtils = __webpack_require__(380);
	
	var _dataUtilsOvertimeDataUtils2 = _interopRequireDefault(_dataUtilsOvertimeDataUtils);
	
	var OvertimeMgrPending = (function (_Component) {
		_inherits(OvertimeMgrPending, _Component);
	
		_createClass(OvertimeMgrPending, null, [{
			key: 'getStores',
			value: function getStores() {
				return [_storesOvertimeStore2['default']];
			}
		}, {
			key: 'calculateState',
			value: function calculateState() {
				return _storesOvertimeStore2['default'].getState();
			}
		}]);
	
		function OvertimeMgrPending(props) {
			_classCallCheck(this, OvertimeMgrPending);
	
			_get(Object.getPrototypeOf(OvertimeMgrPending.prototype), 'constructor', this).call(this, props);
	
			_dataUtilsOvertimeDataUtils2['default'].getPendingRecords({
				page: 1
			});
		}
	
		/**
	  * Approve all entries
	  */
	
		_createClass(OvertimeMgrPending, [{
			key: 'approve',
			value: function approve(agreeOrNot) {
				var inputs = [].slice.call(document.querySelectorAll('[type=checkbox]')).filter(function (check) {
					return check.checked;
				}).map(function (check) {
					return check.value;
				});
	
				_commonUtilsAjax2['default'].post('/mss-ot-approve', {
					idList: inputs.join(),
					agreeOrNot: agreeOrNot
				}).then(function () {
					location.reload();
				});
			}
	
			/**
	   * Load more
	   */
		}, {
			key: 'loadMore',
			value: function loadMore() {
				_dataUtilsOvertimeDataUtils2['default'].getPendingRecords({
					page: this.state.pendingQuery.page + 1
				});
			}
	
			/**
	   * Test if an item is selectable
	   * @param {Object} item
	   */
		}, {
			key: 'select',
			value: function select(item) {
				return true;
			}
	
			/**
	   * Make records selectable / unselectable
	   */
		}, {
			key: 'toggleSelectMode',
			value: function toggleSelectMode() {
				(0, _dispatcherDispatcher.dispatch)({
					type: 'toggle-overtime-record-selectable'
				});
			}
	
			/**
	   * Select / unselect all
	   */
		}, {
			key: 'toggleSelectAll',
			value: function toggleSelectAll(e) {
				var selected = e.target.checked;
	
				[].slice.call(document.querySelectorAll('[type=checkbox]')).forEach(function (checkbox) {
					checkbox.checked = selected;
				});
			}
		}, {
			key: 'render',
			value: function render() {
				var _state = this.state;
				var _state$pendingRecords = _state.pendingRecords;
				var pendingRecords = _state$pendingRecords === undefined ? [] : _state$pendingRecords;
				var _state$status = _state.status;
				var status = _state$status === undefined ? 'loading' : _state$status;
				var selectable = _state.selectable;
	
				return _react2['default'].createElement(
					'div',
					null,
					_react2['default'].createElement(_componentsHeaderHeaderJsx2['default'], { back: 'manager', title: (0, _commonLang.getItem)('PENDING') }),
					_react2['default'].createElement(
						_componentsPullLoaderPullLoaderJsx2['default'],
						{ status: status,
							onLoad: this.loadMore.bind(this) },
						_react2['default'].createElement(_componentsRecordListRecordListJsx2['default'], { recordList: pendingRecords,
							selectable: selectable && this.select,
							url: 'ot-record-mgr' })
					),
					_react2['default'].createElement(_componentsButtonButtonJsx2['default'], { icon: 'pencil', action: true, onClick: this.toggleSelectMode }),
					_react2['default'].createElement(
						_reactLibReactCSSTransitionGroup2['default'],
						{ component: 'div', transitionName: 'bottom-up' },
						selectable ? _react2['default'].createElement(
							'nav',
							{ className: 'tab tab-bottom leave-mgr-bottom' },
							_react2['default'].createElement(
								'label',
								{ className: 'leave-mgr-select-all' },
								_react2['default'].createElement('input', { type: 'checkbox', value: '', onChange: this.toggleSelectAll })
							),
							_react2['default'].createElement(
								'div',
								{ className: 'row' },
								_react2['default'].createElement(
									'div',
									{ className: 'col-1-2' },
									_react2['default'].createElement(_componentsButtonButtonJsx2['default'], { text: (0, _commonLang.getItem)('APPROVE_ALL'),
										onTouchTap: this.approve.bind(null, true) })
								),
								_react2['default'].createElement(
									'div',
									{ className: 'col-1-2' },
									_react2['default'].createElement(_componentsButtonButtonJsx2['default'], { text: (0, _commonLang.getItem)('REJECT_ALL'),
										hollow: true,
										className: 'text-primary',
										onTouchTap: this.approve.bind(null, false) })
								)
							)
						) : null
					)
				);
			}
		}]);
	
		return OvertimeMgrPending;
	})(_react.Component);
	
	exports['default'] = _fluxUtils.Container.create(OvertimeMgrPending);
	module.exports = exports['default'];

/***/ }),
/* 385 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Created by AshZhang on 2016-4-6.
	 */
	
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
		value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(23);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _fluxUtils = __webpack_require__(228);
	
	var _commonLang = __webpack_require__(245);
	
	var _componentsButtonButtonJsx = __webpack_require__(250);
	
	var _componentsButtonButtonJsx2 = _interopRequireDefault(_componentsButtonButtonJsx);
	
	var _componentsFormControlFormControlJsx = __webpack_require__(291);
	
	var _componentsFormControlFormControlJsx2 = _interopRequireDefault(_componentsFormControlFormControlJsx);
	
	var _componentsHeaderHeaderJsx = __webpack_require__(247);
	
	var _componentsHeaderHeaderJsx2 = _interopRequireDefault(_componentsHeaderHeaderJsx);
	
	var _componentsInfoCardInfoCardJsx = __webpack_require__(322);
	
	var _componentsInfoCardInfoCardJsx2 = _interopRequireDefault(_componentsInfoCardInfoCardJsx);
	
	var _componentsLoaderLoaderJsx = __webpack_require__(315);
	
	var _componentsLoaderLoaderJsx2 = _interopRequireDefault(_componentsLoaderLoaderJsx);
	
	var _componentsTextInputTextInputJsx = __webpack_require__(283);
	
	var _componentsTextInputTextInputJsx2 = _interopRequireDefault(_componentsTextInputTextInputJsx);
	
	var _storesOvertimeStore = __webpack_require__(378);
	
	var _storesOvertimeStore2 = _interopRequireDefault(_storesOvertimeStore);
	
	var _dataUtilsOvertimeDataUtils = __webpack_require__(380);
	
	var _dataUtilsOvertimeDataUtils2 = _interopRequireDefault(_dataUtilsOvertimeDataUtils);
	
	var OvertimePendingRecord = (function (_Component) {
		_inherits(OvertimePendingRecord, _Component);
	
		_createClass(OvertimePendingRecord, null, [{
			key: 'getStores',
			value: function getStores() {
				return [_storesOvertimeStore2['default']];
			}
		}, {
			key: 'calculateState',
			value: function calculateState() {
				return _storesOvertimeStore2['default'].getState();
			}
		}]);
	
		function OvertimePendingRecord(props) {
			_classCallCheck(this, OvertimePendingRecord);
	
			_get(Object.getPrototypeOf(OvertimePendingRecord.prototype), 'constructor', this).call(this, props);
	
			// OvertimeDataUtils.getEmpOtRecord(this.props.routeParams.id);
		}
	
		/**
	  * Approve a record
	  * @param {boolean} agreeOrNot
	  */
	
		_createClass(OvertimePendingRecord, [{
			key: 'approve',
			value: function approve(agreeOrNot) {
				_dataUtilsOvertimeDataUtils2['default'].approveRecord({
					id: this.props.params.id,
					appOpinion: _react2['default'].findDOMNode(this.refs.opinion).value,
					agreeOrNot: agreeOrNot
				});
			}
		}, {
			key: 'render',
			value: function render() {
				var _state = this.state;
				var _state$empOtRecord = _state.empOtRecord;
				var empOtRecord = _state$empOtRecord === undefined ? {} : _state$empOtRecord;
				var _state$status = _state.status;
				var status = _state$status === undefined ? 'loading' : _state$status;
				var baseInfo = empOtRecord.baseInfo;
				var appInfo = empOtRecord.appInfo;
	
				return _react2['default'].createElement(
					'div',
					null,
					_react2['default'].createElement(_componentsHeaderHeaderJsx2['default'], { goBack: true, title: (0, _commonLang.getItem)('MY_OT') }),
					_react2['default'].createElement(
						'div',
						{ className: 'row gap-t' },
						_react2['default'].createElement(
							'div',
							{ className: 'col-1-1' },
							_react2['default'].createElement(
								_componentsFormControlFormControlJsx2['default'],
								{ label: (0, _commonLang.getItem)('APPROVE_OPINION') },
								_react2['default'].createElement(_componentsTextInputTextInputJsx2['default'], { ref: 'opinion' })
							)
						)
					),
					_react2['default'].createElement(
						'div',
						{ className: 'row' },
						_react2['default'].createElement(
							'div',
							{ className: 'col-1-2' },
							_react2['default'].createElement(_componentsButtonButtonJsx2['default'], { text: (0, _commonLang.getItem)('APPROVE'),
								onTouchTap: this.approve.bind(this, true) })
						),
						_react2['default'].createElement(
							'div',
							{ className: 'col-1-2' },
							_react2['default'].createElement(_componentsButtonButtonJsx2['default'], { hollow: true, className: 'text-primary',
								text: (0, _commonLang.getItem)('REJECT'),
								onTouchTap: this.approve.bind(this, false) })
						)
					)
				);
			}
		}]);
	
		return OvertimePendingRecord;
	})(_react.Component);
	
	exports['default'] = _fluxUtils.Container.create(OvertimePendingRecord);
	module.exports = exports['default'];
	/*<Loader status={status} className='side-gap pad-b'>
	{
		baseInfo &&
		<div>
			<h2 className="info-card-heading gap-b">{baseInfo.title}</h2>
			<InfoCard items={baseInfo.items} />
		</div>
	}
	{
		appInfo &&
		<div>
			<h2 className="info-card-heading gap-b">{appInfo.title}</h2>
			{
				appInfo.items.map((item, index) => {
					return <InfoCard items={item} key={index} />;
				})
			}
		</div>
	}
	</Loader>*/

/***/ }),
/* 386 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Created by AshZhang on 2016-4-6.
	 */
	
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
		value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(23);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _fluxUtils = __webpack_require__(228);
	
	var _commonLang = __webpack_require__(245);
	
	var _componentsHeaderHeaderJsx = __webpack_require__(247);
	
	var _componentsHeaderHeaderJsx2 = _interopRequireDefault(_componentsHeaderHeaderJsx);
	
	var _componentsFormFormJsx = __webpack_require__(280);
	
	var _componentsFormFormJsx2 = _interopRequireDefault(_componentsFormFormJsx);
	
	var _componentsLoaderLoaderJsx = __webpack_require__(315);
	
	var _componentsLoaderLoaderJsx2 = _interopRequireDefault(_componentsLoaderLoaderJsx);
	
	var _componentsPullLoaderPullLoaderJsx = __webpack_require__(340);
	
	var _componentsPullLoaderPullLoaderJsx2 = _interopRequireDefault(_componentsPullLoaderPullLoaderJsx);
	
	var _componentsInfoCardInfoCardJsx = __webpack_require__(322);
	
	var _componentsInfoCardInfoCardJsx2 = _interopRequireDefault(_componentsInfoCardInfoCardJsx);
	
	var _storesOvertimeStore = __webpack_require__(378);
	
	var _storesOvertimeStore2 = _interopRequireDefault(_storesOvertimeStore);
	
	var _dataUtilsOvertimeDataUtils = __webpack_require__(380);
	
	var _dataUtilsOvertimeDataUtils2 = _interopRequireDefault(_dataUtilsOvertimeDataUtils);
	
	var _dataUtilsLeaveDataUtils = __webpack_require__(356);
	
	var _dataUtilsLeaveDataUtils2 = _interopRequireDefault(_dataUtilsLeaveDataUtils);
	
	var OvertimeMgrSummary = (function (_Component) {
		_inherits(OvertimeMgrSummary, _Component);
	
		function OvertimeMgrSummary() {
			_classCallCheck(this, OvertimeMgrSummary);
	
			_get(Object.getPrototypeOf(OvertimeMgrSummary.prototype), 'constructor', this).apply(this, arguments);
		}
	
		_createClass(OvertimeMgrSummary, [{
			key: 'componentDidMount',
			value: function componentDidMount() {
				_dataUtilsLeaveDataUtils2['default'].getSummaryFilters({
					type: 'FILTER_OT_SUMMARY'
				});
			}
		}, {
			key: 'querySummary',
			value: function querySummary(page) {
				var form = new FormData(_react2['default'].findDOMNode(this.refs.query));
	
				if (typeof page !== 'number' || isNaN(page)) page = 1;
	
				form.append('page', page);
	
				this.page = page;
	
				_dataUtilsOvertimeDataUtils2['default'].getSummaryMembers(form, page);
	
				this.refs.query.setState({
					submitting: false,
					disabled: false
				});
			}
		}, {
			key: 'loadMore',
			value: function loadMore() {
				this.querySummary(this.page + 1);
			}
		}, {
			key: 'render',
			value: function render() {
				var _state = this.state;
				var _state$summaryList = _state.summaryList;
				var summaryList = _state$summaryList === undefined ? [] : _state$summaryList;
				var _state$configStatus = _state.configStatus;
				var configStatus = _state$configStatus === undefined ? 'loading' : _state$configStatus;
				var _state$status = _state.status;
				var status = _state$status === undefined ? 'loaded' : _state$status;
				var otSummaryConfig = _state.otSummaryConfig;
	
				return _react2['default'].createElement(
					'div',
					null,
					_react2['default'].createElement(_componentsHeaderHeaderJsx2['default'], { back: 'manager', title: (0, _commonLang.getItem)('OT_SUMMARY') }),
					_react2['default'].createElement(
						_componentsLoaderLoaderJsx2['default'],
						{ status: configStatus },
						_react2['default'].createElement(_componentsFormFormJsx2['default'], { className: 'side-gap gap-t',
							ref: 'query',
							action: '/ot-team-summary',
							controls: otSummaryConfig,
							submitButton: { text: (0, _commonLang.getItem)('SUBMIT') },
							onSubmit: this.querySummary.bind(this) })
					),
					_react2['default'].createElement(
						_componentsPullLoaderPullLoaderJsx2['default'],
						{ className: 'pad-b-lg gap-t-lg pad-t-lg side-gap',
							status: status,
							style: { paddingBottom: 80 },
							onLoad: this.loadMore.bind(this) },
						Array.isArray(summaryList) && summaryList.map(function (item, index) {
							return _react2['default'].createElement(
								'div',
								{ key: index },
								_react2['default'].createElement(
									'div',
									{ className: 'summary-user-info' },
									_react2['default'].createElement(
										'span',
										null,
										item.userInfo.items[0].firField
									),
									_react2['default'].createElement(
										'span',
										{ className: 'summary-user-pos' },
										item.userInfo.items[0].secField
									)
								),
								item.summaryInfo.items.map(function (item, index) {
									return _react2['default'].createElement(_componentsInfoCardInfoCardJsx2['default'], { title: item.title, items: item.items, key: index });
								})
							);
						})
					)
				);
			}
		}], [{
			key: 'getStores',
			value: function getStores() {
				return [_storesOvertimeStore2['default']];
			}
		}, {
			key: 'calculateState',
			value: function calculateState() {
				return _storesOvertimeStore2['default'].getState();
			}
		}]);
	
		return OvertimeMgrSummary;
	})(_react.Component);
	
	exports['default'] = _fluxUtils.Container.create(OvertimeMgrSummary);
	module.exports = exports['default'];

/***/ }),
/* 387 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Created by AshZhang on 2016-4-6.
	 */
	
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
		value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(23);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _fluxUtils = __webpack_require__(228);
	
	var _commonLang = __webpack_require__(245);
	
	var _componentsHeaderHeaderJsx = __webpack_require__(247);
	
	var _componentsHeaderHeaderJsx2 = _interopRequireDefault(_componentsHeaderHeaderJsx);
	
	var _componentsRecordListRecordListJsx = __webpack_require__(359);
	
	var _componentsRecordListRecordListJsx2 = _interopRequireDefault(_componentsRecordListRecordListJsx);
	
	var _componentsPullLoaderPullLoaderJsx = __webpack_require__(340);
	
	var _componentsPullLoaderPullLoaderJsx2 = _interopRequireDefault(_componentsPullLoaderPullLoaderJsx);
	
	var _storesOvertimeStore = __webpack_require__(378);
	
	var _storesOvertimeStore2 = _interopRequireDefault(_storesOvertimeStore);
	
	var _dataUtilsOvertimeDataUtils = __webpack_require__(380);
	
	var _dataUtilsOvertimeDataUtils2 = _interopRequireDefault(_dataUtilsOvertimeDataUtils);
	
	var OvertimeMgrHistory = (function (_Component) {
		_inherits(OvertimeMgrHistory, _Component);
	
		_createClass(OvertimeMgrHistory, null, [{
			key: 'getStores',
			value: function getStores() {
				return [_storesOvertimeStore2['default']];
			}
		}, {
			key: 'calculateState',
			value: function calculateState() {
				return _storesOvertimeStore2['default'].getState();
			}
		}]);
	
		function OvertimeMgrHistory(props) {
			_classCallCheck(this, OvertimeMgrHistory);
	
			_get(Object.getPrototypeOf(OvertimeMgrHistory.prototype), 'constructor', this).call(this, props);
	
			_dataUtilsOvertimeDataUtils2['default'].getHistoryList({
				page: 1
			});
		}
	
		_createClass(OvertimeMgrHistory, [{
			key: 'loadMore',
			value: function loadMore() {
				_dataUtilsOvertimeDataUtils2['default'].getHistoryList({
					page: this.state.otHistoryQuery.page + 1
				});
			}
		}, {
			key: 'render',
			value: function render() {
				var _state = this.state;
				var _state$otHistoryList = _state.otHistoryList;
				var otHistoryList = _state$otHistoryList === undefined ? [] : _state$otHistoryList;
				var _state$status = _state.status;
				var status = _state$status === undefined ? 'loading' : _state$status;
	
				return _react2['default'].createElement(
					'div',
					null,
					_react2['default'].createElement(_componentsHeaderHeaderJsx2['default'], { back: 'manager', title: (0, _commonLang.getItem)('HISTORY') }),
					_react2['default'].createElement(
						_componentsPullLoaderPullLoaderJsx2['default'],
						{ className: 'pad-b',
							status: status,
							onLoad: this.loadMore.bind(this) },
						_react2['default'].createElement(_componentsRecordListRecordListJsx2['default'], { recordList: otHistoryList, href: null })
					)
				);
			}
		}]);
	
		return OvertimeMgrHistory;
	})(_react.Component);
	
	exports['default'] = _fluxUtils.Container.create(OvertimeMgrHistory);
	module.exports = exports['default'];

/***/ }),
/* 388 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Created by AshZhang on 2016-4-6.
	 */
	
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
		value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(23);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _fluxUtils = __webpack_require__(228);
	
	var _componentsHeaderHeaderJsx = __webpack_require__(247);
	
	var _componentsHeaderHeaderJsx2 = _interopRequireDefault(_componentsHeaderHeaderJsx);
	
	var _componentsLoaderLoaderJsx = __webpack_require__(315);
	
	var _componentsLoaderLoaderJsx2 = _interopRequireDefault(_componentsLoaderLoaderJsx);
	
	var _componentsRecordListRecordListJsx = __webpack_require__(359);
	
	var _componentsRecordListRecordListJsx2 = _interopRequireDefault(_componentsRecordListRecordListJsx);
	
	var _commonLang = __webpack_require__(245);
	
	var _storesOvertimeStore = __webpack_require__(378);
	
	var _storesOvertimeStore2 = _interopRequireDefault(_storesOvertimeStore);
	
	var _dataUtilsOvertimeDataUtils = __webpack_require__(380);
	
	var _dataUtilsOvertimeDataUtils2 = _interopRequireDefault(_dataUtilsOvertimeDataUtils);
	
	var OvertimeHistoryDetail = (function (_Component) {
		_inherits(OvertimeHistoryDetail, _Component);
	
		_createClass(OvertimeHistoryDetail, null, [{
			key: 'getStores',
			value: function getStores() {
				return [_storesOvertimeStore2['default']];
			}
		}, {
			key: 'calculateState',
			value: function calculateState() {
				return _storesOvertimeStore2['default'].getState();
			}
		}]);
	
		function OvertimeHistoryDetail(props) {
			_classCallCheck(this, OvertimeHistoryDetail);
	
			_get(Object.getPrototypeOf(OvertimeHistoryDetail.prototype), 'constructor', this).call(this, props);
	
			_dataUtilsOvertimeDataUtils2['default'].getHistoryDetail(this.props.routeParams.id);
		}
	
		_createClass(OvertimeHistoryDetail, [{
			key: 'render',
			value: function render() {
				var _state = this.state;
				var _state$otHistoryDetail = _state.otHistoryDetail;
				var otHistoryDetail = _state$otHistoryDetail === undefined ? [] : _state$otHistoryDetail;
				var _state$status = _state.status;
				var status = _state$status === undefined ? 'loading' : _state$status;
	
				return _react2['default'].createElement(
					'div',
					null,
					_react2['default'].createElement(_componentsHeaderHeaderJsx2['default'], { goBack: true, title: (0, _commonLang.getItem)('OT_MGR') }),
					_react2['default'].createElement(
						_componentsLoaderLoaderJsx2['default'],
						{ className: 'side-gap',
							status: status },
						_react2['default'].createElement(_componentsRecordListRecordListJsx2['default'], { recordList: otHistoryDetail })
					)
				);
			}
		}]);
	
		return OvertimeHistoryDetail;
	})(_react.Component);
	
	exports['default'] = _fluxUtils.Container.create(OvertimeHistoryDetail);
	module.exports = exports['default'];

/***/ }),
/* 389 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(23);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _fluxUtils = __webpack_require__(228);
	
	var _commonLang = __webpack_require__(245);
	
	var _componentsTabTabJsx = __webpack_require__(269);
	
	var _componentsTabTabJsx2 = _interopRequireDefault(_componentsTabTabJsx);
	
	var _storesRepairClockInStoreJs = __webpack_require__(390);
	
	var _storesRepairClockInStoreJs2 = _interopRequireDefault(_storesRepairClockInStoreJs);
	
	var tabSettings = [{
	    text: (0, _commonLang.getItem)('MY_APPLY'),
	    name: 'my-rci/list',
	    icon: 'clock-o'
	}
	// {
	//   text: getLang('RCI_CHECK_DATA'),
	//   name: 'my-rci/checklist',
	//   icon: 'pie-chart'
	// }
	// ,
	// {
	//   text: getLang('RCI_VIEW_DATA'),
	//   name: 'my-rci/viewlist/0',
	//   icon: 'pie-chart'
	// }
	];
	
	var RepairClockIn = (function (_Component) {
	    _inherits(RepairClockIn, _Component);
	
	    function RepairClockIn() {
	        _classCallCheck(this, RepairClockIn);
	
	        _get(Object.getPrototypeOf(RepairClockIn.prototype), 'constructor', this).apply(this, arguments);
	    }
	
	    _createClass(RepairClockIn, [{
	        key: 'render',
	        value: function render() {
	            return _react2['default'].createElement(
	                'div',
	                { className: 'bottom-gap' },
	                this.props.children,
	                _react2['default'].createElement(_componentsTabTabJsx2['default'], { items: tabSettings, bottom: true })
	            );
	        }
	    }], [{
	        key: 'getStores',
	        value: function getStores() {
	            return [_storesRepairClockInStoreJs2['default']];
	        }
	    }, {
	        key: 'calculateState',
	        value: function calculateState() {
	            return _storesRepairClockInStoreJs2['default'].getState();
	        }
	    }]);
	
	    return RepairClockIn;
	})(_react.Component);
	
	exports['default'] = _fluxUtils.Container.create(RepairClockIn);
	module.exports = exports['default'];

/***/ }),
/* 390 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _fluxUtils = __webpack_require__(228);
	
	var _dispatcherDispatcher = __webpack_require__(223);
	
	var _dispatcherDispatcher2 = _interopRequireDefault(_dispatcherDispatcher);
	
	var _commonLang = __webpack_require__(245);
	
	var RepairClockInStore = (function (_ReduceStore) {
		_inherits(RepairClockInStore, _ReduceStore);
	
		function RepairClockInStore() {
			_classCallCheck(this, RepairClockInStore);
	
			_get(Object.getPrototypeOf(RepairClockInStore.prototype), 'constructor', this).apply(this, arguments);
		}
	
		_createClass(RepairClockInStore, [{
			key: 'getInitialState',
			value: function getInitialState() {
				return {};
			}
		}, {
			key: 'reduce',
			value: function reduce(state, action) {
				switch (action.type) {
					case 'get-emp-rci-exlist':
						return _extends({}, state, {
							rciList: action.data,
							status: 'loaded'
						});
					case 'get-emp-rci-exlist-detail':
						return _extends({}, state, {
							record: action.data,
							status: 'loaded'
						});
					case 'get-emp-rci-period-list':
						return _extends({}, state, {
							status: 'loaded',
							periodList: action.data
						});
					case 'get-rci-form':
						return _extends({}, state, {
							status: 'loading'
						});
					case 'get-rci-form-success':
						return _extends({}, state, {
							rciForm: action.data.formConfig,
							status: 'loaded'
						});
					case 'insert-rci-form':
						return _extends({}, state, {
							submitting: true
						});
					case 'insert-rci-form-fail':
					case 'insert-rci-form-success':
						return _extends({}, state, {
							submitting: false,
							refreshList: action.type === 'insert-rci-form-success'
						});
					case 'get-emp-rci-list':
						return _extends({}, state, {
							empRciListQuery: action.data,
							status: 'loading'
						});
					case 'get-emp-rci-list-fail':
						return _extends({}, state, {
							status: 'loaded'
						});
					case 'get-emp-rci-list-success':
						//console.log(action.data);
						return _extends({}, state, {
							empRciList: state.empRciListQuery.page === 1 ? action.data : state.empRciList.concat(action.data),
							status: 'loaded'
						});
					case 'get-emp-rci-record':
						return _extends({}, state, {
							status: 'loading'
						});
					case 'get-emp-rci-record-fail':
						return _extends({}, state, {
							status: 'loaded'
						});
					case 'get-emp-rci-record-success':
						return _extends({}, state, {
							empRciRecord: action.data,
							status: 'loaded'
						});
					case 'get-rci-pending-records':
						return _extends({}, state, {
							pendingQuery: action.data,
							status: 'loading'
						});
					case 'get-rci-pending-records-fail':
						return _extends({}, state, {
							status: 'loaded'
						});
					case 'get-rci-pending-records-success':
						return _extends({}, state, {
							pendingRecords: state.pendingQuery.page === 1 ? action.data : state.pendingRecords.concat(action.data),
							status: 'loaded'
						});
					//审批通过或拒绝
					case 'approve-rci-pending-record-success':
						return history.back();
					case 'check-rci-ex-list-success':
						return _extends({}, state, {
							pid: action.data
						});
					case 'close-rci-record-selectable':
						return _extends({}, state, {
							selectable: false
						});
					case 'get-rci-filter-success':
						return _extends({}, state, {
							filter: {
								items: (action.data.map ? action.data : []).map(function (item) {
									return _extends({}, item, {
										text: item[(0, _commonLang.getLang)() + '_text'],
										name: item.value
									});
								})
							}
						});
					default:
						return state;
				}
			}
		}]);
	
		return RepairClockInStore;
	})(_fluxUtils.ReduceStore);
	
	exports['default'] = new RepairClockInStore(_dispatcherDispatcher2['default']);
	module.exports = exports['default'];

/***/ }),
/* 391 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * 补打卡 - 我的申请
	 */
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(23);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _fluxUtils = __webpack_require__(228);
	
	var _dispatcherDispatcher = __webpack_require__(223);
	
	var _commonLang = __webpack_require__(245);
	
	var _componentsHeaderHeaderJsx = __webpack_require__(247);
	
	var _componentsHeaderHeaderJsx2 = _interopRequireDefault(_componentsHeaderHeaderJsx);
	
	var _componentsPullLoaderPullLoaderJsx = __webpack_require__(340);
	
	var _componentsPullLoaderPullLoaderJsx2 = _interopRequireDefault(_componentsPullLoaderPullLoaderJsx);
	
	var _componentsRecordListRecordListJsx = __webpack_require__(359);
	
	var _componentsRecordListRecordListJsx2 = _interopRequireDefault(_componentsRecordListRecordListJsx);
	
	var _componentsFormControlFormControlJsx = __webpack_require__(291);
	
	var _componentsFormControlFormControlJsx2 = _interopRequireDefault(_componentsFormControlFormControlJsx);
	
	var _componentsTextInputTextInputJsx = __webpack_require__(283);
	
	var _componentsTextInputTextInputJsx2 = _interopRequireDefault(_componentsTextInputTextInputJsx);
	
	var _componentsButtonButtonJsx = __webpack_require__(250);
	
	var _componentsButtonButtonJsx2 = _interopRequireDefault(_componentsButtonButtonJsx);
	
	var _componentsFormFormJsx = __webpack_require__(280);
	
	var _componentsFormFormJsx2 = _interopRequireDefault(_componentsFormFormJsx);
	
	var _componentsLoaderLoaderJsx = __webpack_require__(315);
	
	var _componentsLoaderLoaderJsx2 = _interopRequireDefault(_componentsLoaderLoaderJsx);
	
	var _componentsPageOpenerPageOpenerJsx = __webpack_require__(294);
	
	var _componentsPageOpenerPageOpenerJsx2 = _interopRequireDefault(_componentsPageOpenerPageOpenerJsx);
	
	var _storesRepairClockInStore = __webpack_require__(390);
	
	var _storesRepairClockInStore2 = _interopRequireDefault(_storesRepairClockInStore);
	
	var _dataUtilsRepairClockInDataUtils = __webpack_require__(304);
	
	var _dataUtilsRepairClockInDataUtils2 = _interopRequireDefault(_dataUtilsRepairClockInDataUtils);
	
	var _dataUtilsLeaveDataUtils = __webpack_require__(356);
	
	var _dataUtilsLeaveDataUtils2 = _interopRequireDefault(_dataUtilsLeaveDataUtils);
	
	var RepairClockInList = (function (_Component) {
		_inherits(RepairClockInList, _Component);
	
		_createClass(RepairClockInList, null, [{
			key: 'getStores',
			value: function getStores() {
				return [_storesRepairClockInStore2['default']];
			}
		}, {
			key: 'calculateState',
			value: function calculateState() {
				return _storesRepairClockInStore2['default'].getState();
			}
		}]);
	
		function RepairClockInList(props) {
			_classCallCheck(this, RepairClockInList);
	
			_get(Object.getPrototypeOf(RepairClockInList.prototype), 'constructor', this).call(this, props);
			// RepairClockInDataUtils.getEmpRciList({
			// 	page: 1,
			// 	state: 'approving'
			// });
			// RepairClockInDataUtils.empRciApplyList({
			// 	page: 1,
			// 	state: 'approving'
			// });
			//RepairClockInDataUtils.getRciEditApplyForm(1004);
	
			//获取右上角筛选列表
			_dataUtilsRepairClockInDataUtils2['default'].getFilter(JSON.parse(localStorage.getItem('companyCode')));
		}
	
		_createClass(RepairClockInList, [{
			key: 'render',
			value: function render() {
				var _this = this;
	
				var _state = this.state;
				var _state$submitting = _state.submitting;
				var submitting = _state$submitting === undefined ? false : _state$submitting;
				var selectTable = _state.selectTable;
				var rciForm = _state.rciForm;
				var refreshList = _state.refreshList;
				var _state$empRciList = _state.empRciList;
				var empRciList = _state$empRciList === undefined ? [] : _state$empRciList;
				var _state$status = _state.status;
				var status = _state$status === undefined ? 'loaded' : _state$status;
				var filter = _state.filter;
	
				if (filter) {
					filter.onClickItem = function (state) {
						_dataUtilsRepairClockInDataUtils2['default'].empRciApplyList({
							page: 1,
							state: state
						});
						if (state != 'edit') {
							(0, _dispatcherDispatcher.dispatch)({
								type: 'close-rci-record-selectable'
							});
						}
					};
				}
	
				if (refreshList) {
					setTimeout(function () {
						location.reload();
					}, 0);
				}
				//console.log(empRciList);
				return _react2['default'].createElement(
					'div',
					null,
					_react2['default'].createElement(_componentsHeaderHeaderJsx2['default'], {
						back: true,
						title: (0, _commonLang.getItem)('MY_APPLY'),
						dropdown: filter
					}),
					_react2['default'].createElement(
						_componentsPullLoaderPullLoaderJsx2['default'],
						{ ref: 'pullLoader', status: status, onLoad: this.loadMore.bind(this) },
						_react2['default'].createElement(
							'ul',
							{ className: 'record-list' + (selectTable ? ' record-list-selectable' : '') },
							empRciList.map(function (record, index) {
								return _react2['default'].createElement(
									'li',
									null,
									_react2['default'].createElement(
										'a',
										{ className: 'record-item record-item-plus', href: '#/my-rci/record/' + record.app_001_id, onClick: _this.checkEdit.bind(_this, record) },
										_react2['default'].createElement(
											'span',
											{ className: 'record-item-name' },
											' ',
											record.app_001_c001v
										),
										_react2['default'].createElement(
											'span',
											{ className: 'record-item-time' },
											record.app_001_sdate,
											' - ',
											record.app_001_edate
										),
										_react2['default'].createElement(
											'span',
											{ className: 'record-item-status' },
											record.app_statev
										)
									)
								);
							})
						)
					),
					_react2['default'].createElement(_componentsButtonButtonJsx2['default'], { icon: 'plus', action: true, onClick: this.openApply.bind(this) }),
					_react2['default'].createElement(
						_componentsPageOpenerPageOpenerJsx2['default'],
						{ ref: 'apply' },
						_react2['default'].createElement(
							_componentsLoaderLoaderJsx2['default'],
							{ status: status },
							_react2['default'].createElement(_componentsFormFormJsx2['default'], { className: 'side-gap pad-b',
								controls: rciForm,
								ref: 'applyForm' }),
							_react2['default'].createElement(
								'div',
								{ className: 'row' },
								_react2['default'].createElement(
									'div',
									{ className: 'col-1-2' },
									_react2['default'].createElement(_componentsButtonButtonJsx2['default'], { type: 'button',
										disabled: submitting,
										text: (0, _commonLang.getItem)('SAVE'), onClick: this.insert.bind(this, false) })
								),
								_react2['default'].createElement(
									'div',
									{ className: 'col-1-2' },
									_react2['default'].createElement(_componentsButtonButtonJsx2['default'], { type: 'button',
										disabled: submitting,
										text: (0, _commonLang.getItem)('SUBMIT'), onClick: this.insert.bind(this, true) })
								)
							)
						)
					)
				);
			}
	
			/**
	   * 加载更多
	   */
		}, {
			key: 'loadMore',
			value: function loadMore() {
				//alert(1);
				var currentQuery = this.state.empRciListQuery;
	
				_dataUtilsRepairClockInDataUtils2['default'].empRciApplyList(_extends({}, currentQuery, {
					page: currentQuery.page + 1
				}));
			}
		}, {
			key: 'checkEdit',
			value: function checkEdit(item, e) {
				//什么情况下，才可以编辑0或1
				//目前是先写1
				if (parseInt(item.app_state) === 0) {
					e.preventDefault();
	
					this._editId = item.app_001_id;
					_dataUtilsRepairClockInDataUtils2['default'].getRciEditApplyForm(item.app_001_id);
					this.openApply(e, true);
				}
			}
	
			/**
	   * 通过配置获取并打开表单
	   * 
	   * @param {any} e 
	   * @param {any} editMode 
	   * @returns 
	   * 
	   * @memberof RepairClockInList
	   */
		}, {
			key: 'openApply',
			value: function openApply(e, editMode) {
				this.refs.apply.open(e);
				this.refs.pullLoader.stopLoading();
	
				if (editMode === true) {
					this.url = '/ess-edit-repair-timeclock';
					return;
				} else {
					this.url = '/ess-insert-repair-timeclock';
				}
	
				_dataUtilsRepairClockInDataUtils2['default'].getRciApplyForm();
			}
	
			/**
	   * 新增表单
	   * - save: { submit: false}
	   * - submit: { submit: true }
	   * @param submitValue
	   */
		}, {
			key: 'insert',
			value: function insert(submitValue, e) {
				var formData = this.collectFormData(submitValue);
	
				if (!formData) return;
	
				_dataUtilsRepairClockInDataUtils2['default'].empRciApplyInsert(formData, this.url);
	
				e.preventDefault();
			}
	
			/**
	   * 若表单合法, 返回 formData
	   * 若不合法, 返回 false
	   * @param {boolean} submitValue
	   * @returns {boolean|*}
	   */
		}, {
			key: 'collectFormData',
			value: function collectFormData(submitValue) {
				var form = this.refs.applyForm,
				    formData = new FormData(_react2['default'].findDOMNode(form));
	
				if (!form.isValid() || window.leaveValidation && !window.leaveValidation()) return;
	
				formData.append('submit', submitValue);
	
				formData.append('verify', false);
	
				if (this._editId) {
					formData.append('id', this._editId);
				}
	
				return formData;
			}
	
			/**
	   * 关闭申请框, 并清除数据
	   */
			// 	closeFormAndRefreshList() {
			// 		const inputs = React.findDOMNode(this.refs.applyForm).querySelectorAll('input, select, textarea');
	
			// 		for (let i = 0; i < inputs.length; i += 1) {
			// 			inputs[i].value = '';
			// 		}
	
			// 		this.refs.apply.close();
			//     	this.refs.pullLoader.continueLoading();
			//    }
		}]);
	
		return RepairClockInList;
	})(_react.Component);
	
	exports['default'] = _fluxUtils.Container.create(RepairClockInList);
	module.exports = exports['default'];
	/*<div className='login-forgot-page'>
	<FormControl label={'理由'} tips={getLang('REQUIRED')}>
		<TextInput ref='tbReason' id='tbReason' name='tbReason'
			type='text' required />
	</FormControl>
	<FormControl label={'开始时间'} tips={getLang('REQUIRED')}>
		<TextInput ref='tbStartTime' id='tbStartTime' name='tbStartTime'
			type='datetime' required />
	</FormControl>
	<FormControl label={'结束时间'} tips={getLang('REQUIRED')}>
		<TextInput ref='tbEndTime' id='tbEndTime' name='tbEndTime'
			type='datetime' required />
	</FormControl>
	</div>*/

/***/ }),
/* 392 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
		value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(23);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _fluxUtils = __webpack_require__(228);
	
	var _commonLang = __webpack_require__(245);
	
	var _componentsHeaderHeaderJsx = __webpack_require__(247);
	
	var _componentsHeaderHeaderJsx2 = _interopRequireDefault(_componentsHeaderHeaderJsx);
	
	var _componentsInfoCardInfoCardJsx = __webpack_require__(322);
	
	var _componentsInfoCardInfoCardJsx2 = _interopRequireDefault(_componentsInfoCardInfoCardJsx);
	
	var _componentsLoaderLoaderJsx = __webpack_require__(315);
	
	var _componentsLoaderLoaderJsx2 = _interopRequireDefault(_componentsLoaderLoaderJsx);
	
	var _componentsConfirmButtonConfirmButtonJsx = __webpack_require__(363);
	
	var _componentsConfirmButtonConfirmButtonJsx2 = _interopRequireDefault(_componentsConfirmButtonConfirmButtonJsx);
	
	var _storesRepairClockInStore = __webpack_require__(390);
	
	var _storesRepairClockInStore2 = _interopRequireDefault(_storesRepairClockInStore);
	
	var _dataUtilsRepairClockInDataUtils = __webpack_require__(304);
	
	var _dataUtilsRepairClockInDataUtils2 = _interopRequireDefault(_dataUtilsRepairClockInDataUtils);
	
	var RepairClockInEmpRecord = (function (_Component) {
		_inherits(RepairClockInEmpRecord, _Component);
	
		_createClass(RepairClockInEmpRecord, null, [{
			key: 'getStores',
			value: function getStores() {
				return [_storesRepairClockInStore2['default']];
			}
		}, {
			key: 'calculateState',
			value: function calculateState() {
				return _storesRepairClockInStore2['default'].getState();
			}
		}]);
	
		function RepairClockInEmpRecord(props) {
			_classCallCheck(this, RepairClockInEmpRecord);
	
			_get(Object.getPrototypeOf(RepairClockInEmpRecord.prototype), 'constructor', this).call(this, props);
	
			_dataUtilsRepairClockInDataUtils2['default'].empRciApplyRecord(this.props.routeParams.id);
		}
	
		_createClass(RepairClockInEmpRecord, [{
			key: 'render',
			value: function render() {
				var _state = this.state;
				var _state$empRciRecord = _state.empRciRecord;
				var empRciRecord = _state$empRciRecord === undefined ? {} : _state$empRciRecord;
				var _state$status = _state.status;
				var status = _state$status === undefined ? 'loading' : _state$status;
				var _empRciRecord$baseInfo = empRciRecord.baseInfo;
				var baseInfo = _empRciRecord$baseInfo === undefined ? { title: '' } : _empRciRecord$baseInfo;
				var _empRciRecord$appInfo = empRciRecord.appInfo;
				var appInfo = _empRciRecord$appInfo === undefined ? { title: '' } : _empRciRecord$appInfo;
	
				var appItems = [];
				if (appInfo != undefined && appInfo.items != undefined) {
					appItems = appInfo.items[0];
				}
				//console.log(appInfo.items);
	
				return _react2['default'].createElement(
					'div',
					null,
					_react2['default'].createElement(_componentsHeaderHeaderJsx2['default'], { goBack: true, title: (0, _commonLang.getItem)('MY_RCI') }),
					_react2['default'].createElement(
						'div',
						null,
						_react2['default'].createElement(
							'h2',
							{ className: 'info-card-heading gap-b' },
							baseInfo.title
						),
						_react2['default'].createElement(_componentsInfoCardInfoCardJsx2['default'], { items: baseInfo.items })
					),
					_react2['default'].createElement(
						'div',
						null,
						_react2['default'].createElement(
							'h2',
							{ className: 'info-card-heading gap-b' },
							appInfo.title
						),
						_react2['default'].createElement(_componentsInfoCardInfoCardJsx2['default'], { items: appItems })
					)
				);
			}
		}]);
	
		return RepairClockInEmpRecord;
	})(_react.Component);
	
	exports['default'] = _fluxUtils.Container.create(RepairClockInEmpRecord);
	module.exports = exports['default'];
	/*<ConfirmButton text={getLang('REVOKE')} onTouchTap={this.revoke} />*/

/***/ }),
/* 393 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
		value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(23);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _fluxUtils = __webpack_require__(228);
	
	var _dispatcherDispatcher = __webpack_require__(223);
	
	var _commonLang = __webpack_require__(245);
	
	var _componentsHeaderHeaderJsx = __webpack_require__(247);
	
	var _componentsHeaderHeaderJsx2 = _interopRequireDefault(_componentsHeaderHeaderJsx);
	
	var _componentsPullLoaderPullLoaderJsx = __webpack_require__(340);
	
	var _componentsPullLoaderPullLoaderJsx2 = _interopRequireDefault(_componentsPullLoaderPullLoaderJsx);
	
	var _componentsRecordListRecordListJsx = __webpack_require__(359);
	
	var _componentsRecordListRecordListJsx2 = _interopRequireDefault(_componentsRecordListRecordListJsx);
	
	var _componentsFormControlFormControlJsx = __webpack_require__(291);
	
	var _componentsFormControlFormControlJsx2 = _interopRequireDefault(_componentsFormControlFormControlJsx);
	
	var _componentsTextInputTextInputJsx = __webpack_require__(283);
	
	var _componentsTextInputTextInputJsx2 = _interopRequireDefault(_componentsTextInputTextInputJsx);
	
	var _componentsButtonButtonJsx = __webpack_require__(250);
	
	var _componentsButtonButtonJsx2 = _interopRequireDefault(_componentsButtonButtonJsx);
	
	var _componentsFormFormJsx = __webpack_require__(280);
	
	var _componentsFormFormJsx2 = _interopRequireDefault(_componentsFormFormJsx);
	
	var _componentsLoaderLoaderJsx = __webpack_require__(315);
	
	var _componentsLoaderLoaderJsx2 = _interopRequireDefault(_componentsLoaderLoaderJsx);
	
	var _componentsPageOpenerPageOpenerJsx = __webpack_require__(294);
	
	var _componentsPageOpenerPageOpenerJsx2 = _interopRequireDefault(_componentsPageOpenerPageOpenerJsx);
	
	var _storesRepairClockInStore = __webpack_require__(390);
	
	var _storesRepairClockInStore2 = _interopRequireDefault(_storesRepairClockInStore);
	
	var _dataUtilsRepairClockInDataUtils = __webpack_require__(304);
	
	var _dataUtilsRepairClockInDataUtils2 = _interopRequireDefault(_dataUtilsRepairClockInDataUtils);
	
	var RepairClockInCheckList = (function (_Component) {
		_inherits(RepairClockInCheckList, _Component);
	
		_createClass(RepairClockInCheckList, null, [{
			key: 'getStores',
			value: function getStores() {
				return [_storesRepairClockInStore2['default']];
			}
		}, {
			key: 'calculateState',
			value: function calculateState() {
				return _storesRepairClockInStore2['default'].getState();
			}
		}]);
	
		function RepairClockInCheckList(props) {
			_classCallCheck(this, RepairClockInCheckList);
	
			_get(Object.getPrototypeOf(RepairClockInCheckList.prototype), 'constructor', this).call(this, props);
			_dataUtilsRepairClockInDataUtils2['default'].getEmpRciPeriodList();
		}
	
		_createClass(RepairClockInCheckList, [{
			key: 'render',
			value: function render() {
				var _this = this;
	
				var _state = //审核通过回调的PID
				this.state;
				var selectTable = _state.selectTable;
				var _state$periodList = _state.periodList;
				var periodList = _state$periodList === undefined ? [] : _state$periodList;
				var _state$submitting = _state.submitting;
				var submitting = _state$submitting === undefined ? false : _state$submitting;
				var _state$status = _state.status;
				var status = _state$status === undefined ? 'loading' : _state$status;
				var _state$pid = _state.pid;
				var pid = _state$pid === undefined ? 0 : _state$pid;
	
				//核算成功后跳转到对应列表
				if (pid > 0) {
					window.location.href = '#/my-rci/viewlist/' + pid;
				}
				return _react2['default'].createElement(
					'div',
					null,
					_react2['default'].createElement(_componentsHeaderHeaderJsx2['default'], {
						back: true,
						title: (0, _commonLang.getItem)('RCI_CHECK_DATA')
					}),
					_react2['default'].createElement(_componentsPullLoaderPullLoaderJsx2['default'], { ref: 'pullLoader', status: status }),
					_react2['default'].createElement(
						'ul',
						{ className: 'record-list' + (selectTable ? ' record-list-selectable' : '') },
						periodList.map(function (item, index) {
							return _react2['default'].createElement(
								'li',
								null,
								_react2['default'].createElement(
									'a',
									{ href: 'javascript:;', className: 'record-item', onClick: _this.check.bind(_this, item.pla_per_id) },
									_react2['default'].createElement(
										'span',
										{ className: 'record-item-name' },
										item.pla_per_code
									),
									_react2['default'].createElement(
										'span',
										{ className: 'record-item-hours record-choose' },
										'核算'
									)
								)
							);
						})
					)
				);
			}
		}, {
			key: 'check',
			value: function check(pid, e) {
				if (confirm((0, _commonLang.getItem)('RCI_AUS_CHECK'))) {
					_dataUtilsRepairClockInDataUtils2['default'].checkRciExList(pid);
				}
			}
		}]);
	
		return RepairClockInCheckList;
	})(_react.Component);
	
	exports['default'] = _fluxUtils.Container.create(RepairClockInCheckList);
	module.exports = exports['default'];
	/*<span className='record-item-time'>123</span>*/ /*<span className={'record-item-status record-item-status-'}>123</span>*/

/***/ }),
/* 394 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * 补打卡异常数据单页信息
	 */
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	__webpack_require__(395);
	
	var _react = __webpack_require__(23);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _fluxUtils = __webpack_require__(228);
	
	var _commonLang = __webpack_require__(245);
	
	var _componentsHeaderHeaderJsx = __webpack_require__(247);
	
	var _componentsHeaderHeaderJsx2 = _interopRequireDefault(_componentsHeaderHeaderJsx);
	
	var _componentsInfoCardInfoCardJsx = __webpack_require__(322);
	
	var _componentsInfoCardInfoCardJsx2 = _interopRequireDefault(_componentsInfoCardInfoCardJsx);
	
	var _componentsLoaderLoaderJsx = __webpack_require__(315);
	
	var _componentsLoaderLoaderJsx2 = _interopRequireDefault(_componentsLoaderLoaderJsx);
	
	var _componentsConfirmButtonConfirmButtonJsx = __webpack_require__(363);
	
	var _componentsConfirmButtonConfirmButtonJsx2 = _interopRequireDefault(_componentsConfirmButtonConfirmButtonJsx);
	
	var _componentsFormControlFormControlJsx = __webpack_require__(291);
	
	var _componentsFormControlFormControlJsx2 = _interopRequireDefault(_componentsFormControlFormControlJsx);
	
	var _componentsTextInputTextInputJsx = __webpack_require__(283);
	
	var _componentsTextInputTextInputJsx2 = _interopRequireDefault(_componentsTextInputTextInputJsx);
	
	var _componentsAlertErrorBoxJsx = __webpack_require__(297);
	
	var _componentsAlertErrorBoxJsx2 = _interopRequireDefault(_componentsAlertErrorBoxJsx);
	
	var _storesRepairClockInStore = __webpack_require__(390);
	
	var _storesRepairClockInStore2 = _interopRequireDefault(_storesRepairClockInStore);
	
	var _dataUtilsRepairClockInDataUtils = __webpack_require__(304);
	
	var _dataUtilsRepairClockInDataUtils2 = _interopRequireDefault(_dataUtilsRepairClockInDataUtils);
	
	var RepairClockInEmpCheckRecord = (function (_Component) {
	    _inherits(RepairClockInEmpCheckRecord, _Component);
	
	    _createClass(RepairClockInEmpCheckRecord, null, [{
	        key: 'getStores',
	        value: function getStores() {
	            return [_storesRepairClockInStore2['default']];
	        }
	    }, {
	        key: 'calculateState',
	        value: function calculateState() {
	            return _storesRepairClockInStore2['default'].getState();
	        }
	    }]);
	
	    function RepairClockInEmpCheckRecord(props) {
	        _classCallCheck(this, RepairClockInEmpCheckRecord);
	
	        _get(Object.getPrototypeOf(RepairClockInEmpCheckRecord.prototype), 'constructor', this).call(this, props);
	        this.commitApply = this.commitApply.bind(this);
	        var id = this.props.routeParams.id;
	        _dataUtilsRepairClockInDataUtils2['default'].getEmpRciExDetail(id);
	    }
	
	    _createClass(RepairClockInEmpCheckRecord, [{
	        key: 'render',
	        value: function render() {
	            var _state = this.state;
	            var _state$record = _state.record;
	            var record = _state$record === undefined ? {
	                names: [],
	                rows: []
	            } : _state$record;
	            var _state$status = _state.status;
	            var status = _state$status === undefined ? 'loading' : _state$status;
	
	            var info = {
	                'title': '单据信息',
	                'items': []
	            };
	
	            record.names.map(function (item, index) {
	                info.items.push({
	                    firField: item,
	                    secField: record.values[index]
	                });
	            });
	
	            return _react2['default'].createElement(
	                'div',
	                null,
	                _react2['default'].createElement(_componentsHeaderHeaderJsx2['default'], { goBack: true, title: '核算数据（异常）' }),
	                _react2['default'].createElement(_componentsLoaderLoaderJsx2['default'], { status: status }),
	                _react2['default'].createElement(
	                    'div',
	                    null,
	                    _react2['default'].createElement(
	                        'h2',
	                        { className: 'info-card-heading gap-b' },
	                        info.title
	                    ),
	                    _react2['default'].createElement(_componentsInfoCardInfoCardJsx2['default'], { items: info.items })
	                ),
	                _react2['default'].createElement(
	                    'div',
	                    null,
	                    _react2['default'].createElement('textarea', { placeholder: '原因 / 备注', className: 'input-rci-reason', ref: 'txtReason' }),
	                    _react2['default'].createElement(_componentsAlertErrorBoxJsx2['default'], { ref: 'errorBox' }),
	                    _react2['default'].createElement(_componentsConfirmButtonConfirmButtonJsx2['default'], { text: (0, _commonLang.getItem)('COMMIT_APPLY'), onTouchTap: this.commitApply })
	                )
	            );
	        }
	
	        /**
	         * 提交申请
	         */
	    }, {
	        key: 'commitApply',
	        value: function commitApply() {
	            var $reason = _react2['default'].findDOMNode(this.refs.txtReason);
	
	            if ($reason.value == '') {
	                this.refs.errorBox.setState({ message: '请输入原因或备注' });
	                return;
	            } else {}
	            //提交申请并跳转
	            //alert('执行跳转');
	            //window.location.hash = '#/my-rci/';
	
	            // OvertimeDataUtils.revokeRecord({
	            // 	id: this.props.routeParams.id,
	            // 	onRevoke: this.state.empOtRecord.onRevoke
	            // });
	        }
	    }]);
	
	    return RepairClockInEmpCheckRecord;
	})(_react.Component);
	
	exports['default'] = _fluxUtils.Container.create(RepairClockInEmpCheckRecord);
	module.exports = exports['default'];

/***/ }),
/* 395 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 396 */,
/* 397 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
		value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(23);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _fluxUtils = __webpack_require__(228);
	
	var _dispatcherDispatcher = __webpack_require__(223);
	
	var _commonLang = __webpack_require__(245);
	
	var _componentsHeaderHeaderJsx = __webpack_require__(247);
	
	var _componentsHeaderHeaderJsx2 = _interopRequireDefault(_componentsHeaderHeaderJsx);
	
	var _componentsPullLoaderPullLoaderJsx = __webpack_require__(340);
	
	var _componentsPullLoaderPullLoaderJsx2 = _interopRequireDefault(_componentsPullLoaderPullLoaderJsx);
	
	var _componentsRecordListRecordListJsx = __webpack_require__(359);
	
	var _componentsRecordListRecordListJsx2 = _interopRequireDefault(_componentsRecordListRecordListJsx);
	
	var _componentsFormControlFormControlJsx = __webpack_require__(291);
	
	var _componentsFormControlFormControlJsx2 = _interopRequireDefault(_componentsFormControlFormControlJsx);
	
	var _componentsTextInputTextInputJsx = __webpack_require__(283);
	
	var _componentsTextInputTextInputJsx2 = _interopRequireDefault(_componentsTextInputTextInputJsx);
	
	var _componentsButtonButtonJsx = __webpack_require__(250);
	
	var _componentsButtonButtonJsx2 = _interopRequireDefault(_componentsButtonButtonJsx);
	
	var _componentsFormFormJsx = __webpack_require__(280);
	
	var _componentsFormFormJsx2 = _interopRequireDefault(_componentsFormFormJsx);
	
	var _componentsLoaderLoaderJsx = __webpack_require__(315);
	
	var _componentsLoaderLoaderJsx2 = _interopRequireDefault(_componentsLoaderLoaderJsx);
	
	var _componentsPageOpenerPageOpenerJsx = __webpack_require__(294);
	
	var _componentsPageOpenerPageOpenerJsx2 = _interopRequireDefault(_componentsPageOpenerPageOpenerJsx);
	
	var _storesRepairClockInStore = __webpack_require__(390);
	
	var _storesRepairClockInStore2 = _interopRequireDefault(_storesRepairClockInStore);
	
	var _dataUtilsRepairClockInDataUtils = __webpack_require__(304);
	
	var _dataUtilsRepairClockInDataUtils2 = _interopRequireDefault(_dataUtilsRepairClockInDataUtils);
	
	var RepairClockInViewList = (function (_Component) {
		_inherits(RepairClockInViewList, _Component);
	
		_createClass(RepairClockInViewList, null, [{
			key: 'getStores',
			value: function getStores() {
				return [_storesRepairClockInStore2['default']];
			}
		}, {
			key: 'calculateState',
			value: function calculateState() {
				return _storesRepairClockInStore2['default'].getState();
			}
		}]);
	
		function RepairClockInViewList(props) {
			_classCallCheck(this, RepairClockInViewList);
	
			_get(Object.getPrototypeOf(RepairClockInViewList.prototype), 'constructor', this).call(this, props);
			var periodId = this.props.routeParams.id;
			//console.log(periodId);
			_dataUtilsRepairClockInDataUtils2['default'].getEmpRciExList(periodId);
			_dataUtilsRepairClockInDataUtils2['default'].getEmpRciPeriodList();
		}
	
		_createClass(RepairClockInViewList, [{
			key: 'render',
			value: function render() {
				var _this = this;
	
				var _state = this.state;
				var selectTable = _state.selectTable;
				var _state$rciList = _state.rciList;
				var rciList = _state$rciList === undefined ? [] : _state$rciList;
				var _state$periodList = _state.periodList;
				var periodList = _state$periodList === undefined ? [] : _state$periodList;
				var _state$submitting = _state.submitting;
				var submitting = _state$submitting === undefined ? false : _state$submitting;
				var _state$status = _state.status;
				var status = _state$status === undefined ? 'loading' : _state$status;
	
				//console.log(rciList);
	
				return _react2['default'].createElement(
					'div',
					null,
					_react2['default'].createElement(_componentsHeaderHeaderJsx2['default'], {
						back: true,
						title: (0, _commonLang.getItem)('RCI_VIEW_DATA')
					}),
					_react2['default'].createElement(_componentsPullLoaderPullLoaderJsx2['default'], { ref: 'pullLoader', status: status }),
					_react2['default'].createElement(
						'ul',
						{ className: 'record-list' + (selectTable ? ' record-list-selectable' : '') },
						rciList.map(function (item, index) {
							return _react2['default'].createElement(
								'li',
								null,
								_react2['default'].createElement(
									'a',
									{ href: '#/my-rci/viewrecord/' + item.att_exe_id, className: 'record-item' },
									_react2['default'].createElement(
										'span',
										{ className: 'record-item-name' },
										item.att_exe_typname,
										' - ',
										item.att_exe_resdesc
									),
									_react2['default'].createElement(
										'span',
										{ className: 'record-item-time' },
										item.att_exe_ctime
									),
									_react2['default'].createElement(
										'span',
										{ className: 'record-item-status' },
										item.att_exe_gtime
									)
								)
							);
						})
					),
					_react2['default'].createElement(_componentsButtonButtonJsx2['default'], { icon: 'search', action: true, onClick: this.openSearchDialog.bind(this) }),
					_react2['default'].createElement(
						_componentsPageOpenerPageOpenerJsx2['default'],
						{ ref: 'openSearch' },
						_react2['default'].createElement(
							_componentsLoaderLoaderJsx2['default'],
							{ status: status },
							_react2['default'].createElement(
								'ul',
								{ className: 'record-list' + (selectTable ? ' record-list-selectable' : '') },
								periodList.map(function (item, index) {
									return _react2['default'].createElement(
										'li',
										null,
										_react2['default'].createElement(
											'a',
											{ href: 'javascript:;', className: 'record-item', onClick: _this.closeSearchDialog.bind(_this, item.pla_per_id) },
											_react2['default'].createElement(
												'span',
												{ className: 'record-item-name' },
												item.pla_per_code
											),
											_react2['default'].createElement(
												'span',
												{ className: 'record-item-hours record-choose' },
												'选择'
											)
										)
									);
								})
							)
						)
					)
				);
			}
	
			/**
	   * 打开筛选对话框
	   * 
	   */
		}, {
			key: 'openSearchDialog',
			value: function openSearchDialog(e) {
				this.refs.openSearch.open(e);
				this.refs.pullLoader.stopLoading();
			}
	
			/**
	   * 关闭及渲染当前页
	   * 
	   */
		}, {
			key: 'closeSearchDialog',
			value: function closeSearchDialog(pid, e) {
				this.refs.openSearch.close(e);
				this.refs.pullLoader.stopLoading();
				_dataUtilsRepairClockInDataUtils2['default'].getEmpRciExList(pid);
				_dataUtilsRepairClockInDataUtils2['default'].getEmpRciPeriodList();
			}
		}]);
	
		return RepairClockInViewList;
	})(_react.Component);
	
	exports['default'] = _fluxUtils.Container.create(RepairClockInViewList);
	module.exports = exports['default'];

/***/ }),
/* 398 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * 补打卡异常数据单页信息
	 */
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	__webpack_require__(395);
	
	var _react = __webpack_require__(23);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _fluxUtils = __webpack_require__(228);
	
	var _commonLang = __webpack_require__(245);
	
	var _componentsHeaderHeaderJsx = __webpack_require__(247);
	
	var _componentsHeaderHeaderJsx2 = _interopRequireDefault(_componentsHeaderHeaderJsx);
	
	var _componentsInfoCardInfoCardJsx = __webpack_require__(322);
	
	var _componentsInfoCardInfoCardJsx2 = _interopRequireDefault(_componentsInfoCardInfoCardJsx);
	
	var _componentsLoaderLoaderJsx = __webpack_require__(315);
	
	var _componentsLoaderLoaderJsx2 = _interopRequireDefault(_componentsLoaderLoaderJsx);
	
	var _componentsConfirmButtonConfirmButtonJsx = __webpack_require__(363);
	
	var _componentsConfirmButtonConfirmButtonJsx2 = _interopRequireDefault(_componentsConfirmButtonConfirmButtonJsx);
	
	var _componentsFormControlFormControlJsx = __webpack_require__(291);
	
	var _componentsFormControlFormControlJsx2 = _interopRequireDefault(_componentsFormControlFormControlJsx);
	
	var _componentsTextInputTextInputJsx = __webpack_require__(283);
	
	var _componentsTextInputTextInputJsx2 = _interopRequireDefault(_componentsTextInputTextInputJsx);
	
	var _componentsAlertErrorBoxJsx = __webpack_require__(297);
	
	var _componentsAlertErrorBoxJsx2 = _interopRequireDefault(_componentsAlertErrorBoxJsx);
	
	var _componentsButtonButtonJsx = __webpack_require__(250);
	
	var _componentsButtonButtonJsx2 = _interopRequireDefault(_componentsButtonButtonJsx);
	
	var _componentsFormFormJsx = __webpack_require__(280);
	
	var _componentsFormFormJsx2 = _interopRequireDefault(_componentsFormFormJsx);
	
	var _componentsPageOpenerPageOpenerJsx = __webpack_require__(294);
	
	var _componentsPageOpenerPageOpenerJsx2 = _interopRequireDefault(_componentsPageOpenerPageOpenerJsx);
	
	var _storesRepairClockInStore = __webpack_require__(390);
	
	var _storesRepairClockInStore2 = _interopRequireDefault(_storesRepairClockInStore);
	
	var _dataUtilsRepairClockInDataUtils = __webpack_require__(304);
	
	var _dataUtilsRepairClockInDataUtils2 = _interopRequireDefault(_dataUtilsRepairClockInDataUtils);
	
	var RepairClockInEmpViewRecord = (function (_Component) {
	  _inherits(RepairClockInEmpViewRecord, _Component);
	
	  _createClass(RepairClockInEmpViewRecord, null, [{
	    key: 'getStores',
	    value: function getStores() {
	      return [_storesRepairClockInStore2['default']];
	    }
	  }, {
	    key: 'calculateState',
	    value: function calculateState() {
	      return _storesRepairClockInStore2['default'].getState();
	    }
	  }]);
	
	  function RepairClockInEmpViewRecord(props) {
	    _classCallCheck(this, RepairClockInEmpViewRecord);
	
	    _get(Object.getPrototypeOf(RepairClockInEmpViewRecord.prototype), 'constructor', this).call(this, props);
	    this.commitApply = this.commitApply.bind(this);
	    var id = this.props.routeParams.id;
	    _dataUtilsRepairClockInDataUtils2['default'].getEmpRciExDetail(id);
	  }
	
	  _createClass(RepairClockInEmpViewRecord, [{
	    key: 'render',
	    value: function render() {
	      var _state = this.state;
	      var _state$submitting = _state.submitting;
	      var submitting = _state$submitting === undefined ? false : _state$submitting;
	      var _state$record = _state.record;
	      var record = _state$record === undefined ? {} : _state$record;
	      var _state$status = _state.status;
	      var status = _state$status === undefined ? 'loading' : _state$status;
	      var rciForm = _state.rciForm;
	      var refreshList = _state.refreshList;
	
	      var info = {
	        'title': (0, _commonLang.getItem)('RCI_VIEW_INFO'),
	        'items': []
	      };
	
	      //添加成功
	      if (refreshList) {
	        window.location.href = '#/my-rci/list';
	      }
	
	      //自定义列表
	      // info.items.push({
	      //     firField: getLang('RCI_INFO_TYPENAME'),
	      //     secField: record.att_exe_typname
	      // });
	      // info.items.push({
	      //     firField: getLang('RCI_INFO_CTIME'),
	      //     secField: record.att_exe_ctime
	      // });
	      // info.items.push({
	      //     firField: getLang('RCI_INFO_ETIME'),
	      //     secField: record.att_exe_gtime
	      // });
	      // info.items.push({
	      //     firField: getLang('RCI_INFO_EXEDESC'),
	      //     secField: record.att_exe_resdesc
	      // });
	      // info.items.push({
	      //     firField: getLang('RCI_INFO_LV'),
	      //     secField: record.att_exe_lv
	      // });
	      // info.items.push({
	      //     firField: getLang('RCI_INFO_LE'),
	      //     secField: record.att_exe_le
	      // });
	
	      return _react2['default'].createElement(
	        'div',
	        null,
	        _react2['default'].createElement(_componentsHeaderHeaderJsx2['default'], { goBack: true, title: (0, _commonLang.getItem)('RCI_VIEW_DATA') }),
	        _react2['default'].createElement(_componentsLoaderLoaderJsx2['default'], { status: status }),
	        _react2['default'].createElement(
	          'div',
	          null,
	          _react2['default'].createElement(
	            'h2',
	            { className: 'info-card-heading gap-b' },
	            info.title
	          ),
	          _react2['default'].createElement(_componentsInfoCardInfoCardJsx2['default'], { items: record.appInfo })
	        ),
	        _react2['default'].createElement(
	          'div',
	          null,
	          _react2['default'].createElement(_componentsButtonButtonJsx2['default'], { type: 'button', text: (0, _commonLang.getItem)('COMMIT_APPLY'), onClick: this.commitApply })
	        ),
	        _react2['default'].createElement(
	          _componentsPageOpenerPageOpenerJsx2['default'],
	          { ref: 'apply' },
	          _react2['default'].createElement(
	            _componentsLoaderLoaderJsx2['default'],
	            { status: status },
	            _react2['default'].createElement(_componentsFormFormJsx2['default'], { className: 'side-gap pad-b',
	              controls: rciForm,
	              ref: 'applyForm' }),
	            _react2['default'].createElement(
	              'div',
	              { className: 'row' },
	              _react2['default'].createElement(
	                'div',
	                { className: 'col-1-2' },
	                _react2['default'].createElement(_componentsButtonButtonJsx2['default'], { type: 'button',
	                  disabled: submitting,
	                  text: (0, _commonLang.getItem)('SAVE'), onClick: this.insert.bind(this, false) })
	              ),
	              _react2['default'].createElement(
	                'div',
	                { className: 'col-1-2' },
	                _react2['default'].createElement(_componentsButtonButtonJsx2['default'], { type: 'button',
	                  disabled: submitting,
	                  text: (0, _commonLang.getItem)('SUBMIT'), onClick: this.insert.bind(this, true) })
	              )
	            )
	          )
	        )
	      );
	    }
	
	    /**
	     * 提交申请
	     */
	  }, {
	    key: 'commitApply',
	    value: function commitApply(e) {
	      this.refs.apply.open(e);
	      this.url = '/ess-insert-repair-timeclock';
	
	      _dataUtilsRepairClockInDataUtils2['default'].getRciApplyForm();
	
	      //let $reason = React.findDOMNode(this.refs.txtReason);
	      // if($reason.value == ''){
	      //     this.refs.errorBox.setState({message:'请输入原因或备注'});
	      //     return;
	      // }else{
	      //提交申请并跳转
	      //alert('执行跳转');
	      //window.location.hash = '#/my-rci/';
	      //}
	
	      // OvertimeDataUtils.revokeRecord({
	      // 	id: this.props.routeParams.id,
	      // 	onRevoke: this.state.empOtRecord.onRevoke
	      // });
	    }
	
	    /**
	    * 新增表单
	    * - save: { submit: false}
	    * - submit: { submit: true }
	    * @param submitValue
	    */
	  }, {
	    key: 'insert',
	    value: function insert(submitValue, e) {
	      var formData = this.collectFormData(submitValue);
	
	      if (!formData) return;
	
	      _dataUtilsRepairClockInDataUtils2['default'].empRciApplyInsert(formData, this.url);
	
	      e.preventDefault();
	    }
	
	    /**
	    * 若表单合法, 返回 formData
	    * 若不合法, 返回 false
	    * @param {boolean} submitValue
	    * @returns {boolean|*}
	    */
	  }, {
	    key: 'collectFormData',
	    value: function collectFormData(submitValue) {
	      var form = this.refs.applyForm,
	          formData = new FormData(_react2['default'].findDOMNode(form));
	
	      if (!form.isValid() || window.leaveValidation && !window.leaveValidation()) return;
	
	      formData.append('submit', submitValue);
	
	      formData.append('verify', false);
	
	      if (this._editId) {
	        formData.append('id', this._editId);
	      }
	
	      return formData;
	    }
	  }]);
	
	  return RepairClockInEmpViewRecord;
	})(_react.Component);
	
	exports['default'] = _fluxUtils.Container.create(RepairClockInEmpViewRecord);
	module.exports = exports['default'];
	/*<textarea placeholder={getLang('RCI_REASON_REMARK')} className='input-rci-reason' ref='txtReason' />
	<ErrorBox ref='errorBox' />*/

/***/ }),
/* 399 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(23);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _fluxUtils = __webpack_require__(228);
	
	var _commonLang = __webpack_require__(245);
	
	var _componentsTabTabJsx = __webpack_require__(269);
	
	var _componentsTabTabJsx2 = _interopRequireDefault(_componentsTabTabJsx);
	
	var _storesRepairClockInStoreJs = __webpack_require__(390);
	
	var _storesRepairClockInStoreJs2 = _interopRequireDefault(_storesRepairClockInStoreJs);
	
	var tabSettings = [{
	    text: (0, _commonLang.getItem)('PENDING'),
	    name: 'rci-mgr/pending',
	    icon: 'clock-o'
	} //,
	// {
	//   text: getLang('HISTORY'),
	//   name: 'rci-mgr/history',
	//   icon: 'pie-chart'
	// }
	];
	
	var RepairClockInMgr = (function (_Component) {
	    _inherits(RepairClockInMgr, _Component);
	
	    function RepairClockInMgr() {
	        _classCallCheck(this, RepairClockInMgr);
	
	        _get(Object.getPrototypeOf(RepairClockInMgr.prototype), 'constructor', this).apply(this, arguments);
	    }
	
	    _createClass(RepairClockInMgr, [{
	        key: 'render',
	        value: function render() {
	            return _react2['default'].createElement(
	                'div',
	                { className: 'bottom-gap' },
	                this.props.children,
	                _react2['default'].createElement(_componentsTabTabJsx2['default'], { items: tabSettings, bottom: true })
	            );
	        }
	    }], [{
	        key: 'getStores',
	        value: function getStores() {
	            return [_storesRepairClockInStoreJs2['default']];
	        }
	    }, {
	        key: 'calculateState',
	        value: function calculateState() {
	            return _storesRepairClockInStoreJs2['default'].getState();
	        }
	    }]);
	
	    return RepairClockInMgr;
	})(_react.Component);
	
	exports['default'] = _fluxUtils.Container.create(RepairClockInMgr);
	module.exports = exports['default'];

/***/ }),
/* 400 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(23);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _fluxUtils = __webpack_require__(228);
	
	var _dispatcherDispatcher = __webpack_require__(223);
	
	var _commonLang = __webpack_require__(245);
	
	var _componentsHeaderHeaderJsx = __webpack_require__(247);
	
	var _componentsHeaderHeaderJsx2 = _interopRequireDefault(_componentsHeaderHeaderJsx);
	
	var _componentsPullLoaderPullLoaderJsx = __webpack_require__(340);
	
	var _componentsPullLoaderPullLoaderJsx2 = _interopRequireDefault(_componentsPullLoaderPullLoaderJsx);
	
	var _componentsRecordListRecordListJsx = __webpack_require__(359);
	
	var _componentsRecordListRecordListJsx2 = _interopRequireDefault(_componentsRecordListRecordListJsx);
	
	var _componentsFormControlFormControlJsx = __webpack_require__(291);
	
	var _componentsFormControlFormControlJsx2 = _interopRequireDefault(_componentsFormControlFormControlJsx);
	
	var _componentsTextInputTextInputJsx = __webpack_require__(283);
	
	var _componentsTextInputTextInputJsx2 = _interopRequireDefault(_componentsTextInputTextInputJsx);
	
	var _componentsButtonButtonJsx = __webpack_require__(250);
	
	var _componentsButtonButtonJsx2 = _interopRequireDefault(_componentsButtonButtonJsx);
	
	var _componentsFormFormJsx = __webpack_require__(280);
	
	var _componentsFormFormJsx2 = _interopRequireDefault(_componentsFormFormJsx);
	
	var _componentsLoaderLoaderJsx = __webpack_require__(315);
	
	var _componentsLoaderLoaderJsx2 = _interopRequireDefault(_componentsLoaderLoaderJsx);
	
	var _componentsPageOpenerPageOpenerJsx = __webpack_require__(294);
	
	var _componentsPageOpenerPageOpenerJsx2 = _interopRequireDefault(_componentsPageOpenerPageOpenerJsx);
	
	var _storesRepairClockInStore = __webpack_require__(390);
	
	var _storesRepairClockInStore2 = _interopRequireDefault(_storesRepairClockInStore);
	
	var _dataUtilsRepairClockInDataUtils = __webpack_require__(304);
	
	var _dataUtilsRepairClockInDataUtils2 = _interopRequireDefault(_dataUtilsRepairClockInDataUtils);
	
	var RepairClockInMgrPending = (function (_Component) {
		_inherits(RepairClockInMgrPending, _Component);
	
		_createClass(RepairClockInMgrPending, null, [{
			key: 'getStores',
			value: function getStores() {
				return [_storesRepairClockInStore2['default']];
			}
		}, {
			key: 'calculateState',
			value: function calculateState() {
				return _storesRepairClockInStore2['default'].getState();
			}
		}]);
	
		function RepairClockInMgrPending(props) {
			_classCallCheck(this, RepairClockInMgrPending);
	
			_get(Object.getPrototypeOf(RepairClockInMgrPending.prototype), 'constructor', this).call(this, props);
			_dataUtilsRepairClockInDataUtils2['default'].mssRciPendingRecords({
				page: 1
			});
		}
	
		_createClass(RepairClockInMgrPending, [{
			key: 'render',
			value: function render() {
				var _state = this.state;
				var _state$submitting = _state.submitting;
				var submitting = _state$submitting === undefined ? false : _state$submitting;
				var selectTable = _state.selectTable;
				var refreshList = _state.refreshList;
				var _state$pendingRecords = _state.pendingRecords;
				var pendingRecords = _state$pendingRecords === undefined ? [] : _state$pendingRecords;
				var _state$status = _state.status;
				var status = _state$status === undefined ? 'loading' : _state$status;
	
				return _react2['default'].createElement(
					'div',
					null,
					_react2['default'].createElement(_componentsHeaderHeaderJsx2['default'], {
						back: true,
						title: (0, _commonLang.getItem)('PENDING')
					}),
					_react2['default'].createElement(
						_componentsPullLoaderPullLoaderJsx2['default'],
						{ ref: 'pullLoader', status: status, onLoad: this.loadMore.bind(this) },
						_react2['default'].createElement(
							'ul',
							{ className: 'record-list' + (selectTable ? ' record-list-selectable' : '') },
							pendingRecords.map(function (record, index) {
								return _react2['default'].createElement(
									'li',
									null,
									_react2['default'].createElement(
										'a',
										{ className: 'record-item', href: '#/rci-record-mgr/' + record.app_001_id },
										_react2['default'].createElement(
											'span',
											{ className: 'record-item-name' },
											record.empName,
											' - ',
											record.app_001_c001v
										),
										_react2['default'].createElement(
											'span',
											{ className: 'record-item-time' },
											record.app_001_sdate,
											' - ',
											record.app_001_edate
										),
										_react2['default'].createElement(
											'span',
											{ className: 'record-item-status' },
											record.app_statev
										)
									)
								);
							})
						)
					)
				);
			}
	
			/**
	   * 加载更多
	   */
		}, {
			key: 'loadMore',
			value: function loadMore() {
				//alert(1);
				var currentQuery = this.state.pendingQuery;
	
				_dataUtilsRepairClockInDataUtils2['default'].mssRciPendingRecords(_extends({}, currentQuery, {
					page: currentQuery.page + 1
				}));
			}
		}]);
	
		return RepairClockInMgrPending;
	})(_react.Component);
	
	exports['default'] = _fluxUtils.Container.create(RepairClockInMgrPending);
	module.exports = exports['default'];
	/*<Button icon='plus' action onClick={::this.openApply} />
		<PageOpener ref='apply'>
	<Loader status={'loaded'}>
		<div className='login-forgot-page'>
				<FormControl label={'理由'} tips={getLang('REQUIRED')}>
					<TextInput ref='tbReason' id='tbReason' name='tbReason'
							type='text' required />
				</FormControl>
				<FormControl label={'开始时间'} tips={getLang('REQUIRED')}>
					<TextInput ref='tbStartTime' id='tbStartTime' name='tbStartTime'
							type='datetime' required />
				</FormControl>
				<FormControl label={'结束时间'} tips={getLang('REQUIRED')}>
					<TextInput ref='tbEndTime' id='tbEndTime' name='tbEndTime'
							type='datetime' required />
				</FormControl>
		</div>
		<div className="row">
			<div className="col-1-2">
				<Button type='button'
								disabled={submitting}
								text={getLang('SAVE')}/>
			</div>
			<div className="col-1-2">
				<Button type='button'
								disabled={submitting}
								text={getLang('SUBMIT')}/>
			</div>
		</div>
	</Loader>
	</PageOpener>*/

/***/ }),
/* 401 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * MSS补打卡 - 未审批点击的审核内页
	 */
	
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
		value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(23);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _fluxUtils = __webpack_require__(228);
	
	var _commonLang = __webpack_require__(245);
	
	var _componentsButtonButtonJsx = __webpack_require__(250);
	
	var _componentsButtonButtonJsx2 = _interopRequireDefault(_componentsButtonButtonJsx);
	
	var _componentsFormControlFormControlJsx = __webpack_require__(291);
	
	var _componentsFormControlFormControlJsx2 = _interopRequireDefault(_componentsFormControlFormControlJsx);
	
	var _componentsHeaderHeaderJsx = __webpack_require__(247);
	
	var _componentsHeaderHeaderJsx2 = _interopRequireDefault(_componentsHeaderHeaderJsx);
	
	var _componentsInfoCardInfoCardJsx = __webpack_require__(322);
	
	var _componentsInfoCardInfoCardJsx2 = _interopRequireDefault(_componentsInfoCardInfoCardJsx);
	
	var _componentsLoaderLoaderJsx = __webpack_require__(315);
	
	var _componentsLoaderLoaderJsx2 = _interopRequireDefault(_componentsLoaderLoaderJsx);
	
	var _componentsTextInputTextInputJsx = __webpack_require__(283);
	
	var _componentsTextInputTextInputJsx2 = _interopRequireDefault(_componentsTextInputTextInputJsx);
	
	var _storesRepairClockInStore = __webpack_require__(390);
	
	var _storesRepairClockInStore2 = _interopRequireDefault(_storesRepairClockInStore);
	
	var _dataUtilsRepairClockInDataUtils = __webpack_require__(304);
	
	var _dataUtilsRepairClockInDataUtils2 = _interopRequireDefault(_dataUtilsRepairClockInDataUtils);
	
	var RepairClockInPendingRecord = (function (_Component) {
		_inherits(RepairClockInPendingRecord, _Component);
	
		_createClass(RepairClockInPendingRecord, null, [{
			key: 'getStores',
			value: function getStores() {
				return [_storesRepairClockInStore2['default']];
			}
		}, {
			key: 'calculateState',
			value: function calculateState() {
				return _storesRepairClockInStore2['default'].getState();
			}
		}]);
	
		function RepairClockInPendingRecord(props) {
			_classCallCheck(this, RepairClockInPendingRecord);
	
			_get(Object.getPrototypeOf(RepairClockInPendingRecord.prototype), 'constructor', this).call(this, props);
	
			// OvertimeDataUtils.getEmpOtRecord(this.props.routeParams.id);
		}
	
		/**
	  * Approve a record
	  * @param {boolean} agreeOrNot
	  */
	
		_createClass(RepairClockInPendingRecord, [{
			key: 'approve',
			value: function approve(agreeOrNot) {
				_dataUtilsRepairClockInDataUtils2['default'].mssApproveRecord({
					id: this.props.params.id,
					appOpinion: _react2['default'].findDOMNode(this.refs.opinion).value,
					agreeOrNot: agreeOrNot
				});
			}
		}, {
			key: 'render',
			value: function render() {
				var _state = this.state;
				var _state$empOtRecord = _state.empOtRecord;
				var empOtRecord = _state$empOtRecord === undefined ? {} : _state$empOtRecord;
				var _state$status = _state.status;
				var status = _state$status === undefined ? 'loading' : _state$status;
				var baseInfo = empOtRecord.baseInfo;
				var appInfo = empOtRecord.appInfo;
	
				return _react2['default'].createElement(
					'div',
					null,
					_react2['default'].createElement(_componentsHeaderHeaderJsx2['default'], { goBack: true, title: (0, _commonLang.getItem)('MY_RCI') }),
					_react2['default'].createElement(
						'div',
						{ className: 'row gap-t' },
						_react2['default'].createElement(
							'div',
							{ className: 'col-1-1' },
							_react2['default'].createElement(
								_componentsFormControlFormControlJsx2['default'],
								{ label: (0, _commonLang.getItem)('APPROVE_OPINION') },
								_react2['default'].createElement(_componentsTextInputTextInputJsx2['default'], { ref: 'opinion' })
							)
						)
					),
					_react2['default'].createElement(
						'div',
						{ className: 'row' },
						_react2['default'].createElement(
							'div',
							{ className: 'col-1-2' },
							_react2['default'].createElement(_componentsButtonButtonJsx2['default'], { text: (0, _commonLang.getItem)('APPROVE'),
								onTouchTap: this.approve.bind(this, true) })
						),
						_react2['default'].createElement(
							'div',
							{ className: 'col-1-2' },
							_react2['default'].createElement(_componentsButtonButtonJsx2['default'], { hollow: true, className: 'text-primary',
								text: (0, _commonLang.getItem)('REJECT'),
								onTouchTap: this.approve.bind(this, false) })
						)
					)
				);
			}
		}]);
	
		return RepairClockInPendingRecord;
	})(_react.Component);
	
	exports['default'] = _fluxUtils.Container.create(RepairClockInPendingRecord);
	module.exports = exports['default'];

/***/ }),
/* 402 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
		value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(23);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _fluxUtils = __webpack_require__(228);
	
	var _dispatcherDispatcher = __webpack_require__(223);
	
	var _commonLang = __webpack_require__(245);
	
	var _componentsHeaderHeaderJsx = __webpack_require__(247);
	
	var _componentsHeaderHeaderJsx2 = _interopRequireDefault(_componentsHeaderHeaderJsx);
	
	var _componentsPullLoaderPullLoaderJsx = __webpack_require__(340);
	
	var _componentsPullLoaderPullLoaderJsx2 = _interopRequireDefault(_componentsPullLoaderPullLoaderJsx);
	
	var _componentsRecordListRecordListJsx = __webpack_require__(359);
	
	var _componentsRecordListRecordListJsx2 = _interopRequireDefault(_componentsRecordListRecordListJsx);
	
	var _componentsFormControlFormControlJsx = __webpack_require__(291);
	
	var _componentsFormControlFormControlJsx2 = _interopRequireDefault(_componentsFormControlFormControlJsx);
	
	var _componentsTextInputTextInputJsx = __webpack_require__(283);
	
	var _componentsTextInputTextInputJsx2 = _interopRequireDefault(_componentsTextInputTextInputJsx);
	
	var _componentsButtonButtonJsx = __webpack_require__(250);
	
	var _componentsButtonButtonJsx2 = _interopRequireDefault(_componentsButtonButtonJsx);
	
	var _componentsFormFormJsx = __webpack_require__(280);
	
	var _componentsFormFormJsx2 = _interopRequireDefault(_componentsFormFormJsx);
	
	var _componentsLoaderLoaderJsx = __webpack_require__(315);
	
	var _componentsLoaderLoaderJsx2 = _interopRequireDefault(_componentsLoaderLoaderJsx);
	
	var _componentsPageOpenerPageOpenerJsx = __webpack_require__(294);
	
	var _componentsPageOpenerPageOpenerJsx2 = _interopRequireDefault(_componentsPageOpenerPageOpenerJsx);
	
	var _storesRepairClockInStore = __webpack_require__(390);
	
	var _storesRepairClockInStore2 = _interopRequireDefault(_storesRepairClockInStore);
	
	var _dataUtilsRepairClockInDataUtils = __webpack_require__(304);
	
	var _dataUtilsRepairClockInDataUtils2 = _interopRequireDefault(_dataUtilsRepairClockInDataUtils);
	
	var RepairClockInMgrHistory = (function (_Component) {
		_inherits(RepairClockInMgrHistory, _Component);
	
		_createClass(RepairClockInMgrHistory, null, [{
			key: 'getStores',
			value: function getStores() {
				return [_storesRepairClockInStore2['default']];
			}
		}, {
			key: 'calculateState',
			value: function calculateState() {
				return _storesRepairClockInStore2['default'].getState();
			}
		}]);
	
		function RepairClockInMgrHistory(props) {
			_classCallCheck(this, RepairClockInMgrHistory);
	
			_get(Object.getPrototypeOf(RepairClockInMgrHistory.prototype), 'constructor', this).call(this, props);
		}
	
		_createClass(RepairClockInMgrHistory, [{
			key: 'render',
			value: function render() {
				var _state = this.state;
				var _state$submitting = _state.submitting;
				var submitting = _state$submitting === undefined ? false : _state$submitting;
				var selectTable = _state.selectTable;
				var _state$empRciList = _state.empRciList;
				var empRciList = _state$empRciList === undefined ? [{
					id: 1,
					essCode: '9527',
					startTime: '2017/16/15 09:00',
					endTime: '2017/16/15 18:00',
					content: '打卡机坏了',
					status: 'approved'
				}, {
					id: 2,
					essCode: '9527',
					startTime: '2017/16/15 09:00',
					endTime: '2017/16/15 18:00',
					content: '忘记了',
					status: 'pending'
				}, {
					id: 3,
					essCode: '9527',
					startTime: '2017/16/15 09:00',
					endTime: '2017/16/15 18:00',
					content: '停电了',
					status: 'pending'
				}, {
					id: 4,
					essCode: '9527',
					startTime: '2017/16/15 09:00',
					endTime: '2017/16/15 18:00',
					content: '系统出错了',
					status: 'approved'
				}, {
					id: 5,
					essCode: '9527',
					startTime: '2017-16-15 09:00',
					endTime: '2017-16-15 18:00',
					content: '打卡机坏了',
					status: 'approved'
				}, {
					id: 6,
					essCode: '9527',
					startTime: '2017/16/15 09:00',
					endTime: '2017/16/15 18:00',
					content: '打卡机坏了',
					status: 'approved'
				}] : _state$empRciList;
				var _state$status = _state.status;
				var status = _state$status === undefined ? 'loading' : _state$status;
	
				return _react2['default'].createElement(
					'div',
					null,
					_react2['default'].createElement(_componentsHeaderHeaderJsx2['default'], {
						back: true,
						title: '审批历史'
					}),
					_react2['default'].createElement(
						'ul',
						{ className: 'record-list' + (selectTable ? ' record-list-selectable' : '') },
						empRciList.map(function (record, index) {
							return _react2['default'].createElement(
								'li',
								null,
								_react2['default'].createElement(
									'a',
									{ className: 'record-item', href: '#/my-rci/record/1' },
									_react2['default'].createElement(
										'span',
										{ className: 'record-item-name' },
										record.empName,
										' - ',
										record.app_001_c001v
									),
									_react2['default'].createElement(
										'span',
										{ className: 'record-item-time' },
										record.startTime,
										' - ',
										record.endTime
									),
									_react2['default'].createElement(
										'span',
										{ className: 'record-item-status record-item-status-' + record.status },
										record.status
									)
								)
							);
						})
					),
					_react2['default'].createElement(_componentsButtonButtonJsx2['default'], { icon: 'plus', action: true, onClick: this.openApply.bind(this) }),
					_react2['default'].createElement(
						_componentsPageOpenerPageOpenerJsx2['default'],
						{ ref: 'apply' },
						_react2['default'].createElement(
							_componentsLoaderLoaderJsx2['default'],
							{ status: 'loaded' },
							_react2['default'].createElement(
								'div',
								{ className: 'login-forgot-page' },
								_react2['default'].createElement(
									_componentsFormControlFormControlJsx2['default'],
									{ label: '理由', tips: (0, _commonLang.getItem)('REQUIRED') },
									_react2['default'].createElement(_componentsTextInputTextInputJsx2['default'], { ref: 'tbReason', id: 'tbReason', name: 'tbReason',
										type: 'text', required: true })
								),
								_react2['default'].createElement(
									_componentsFormControlFormControlJsx2['default'],
									{ label: '开始时间', tips: (0, _commonLang.getItem)('REQUIRED') },
									_react2['default'].createElement(_componentsTextInputTextInputJsx2['default'], { ref: 'tbStartTime', id: 'tbStartTime', name: 'tbStartTime',
										type: 'datetime', required: true })
								),
								_react2['default'].createElement(
									_componentsFormControlFormControlJsx2['default'],
									{ label: '结束时间', tips: (0, _commonLang.getItem)('REQUIRED') },
									_react2['default'].createElement(_componentsTextInputTextInputJsx2['default'], { ref: 'tbEndTime', id: 'tbEndTime', name: 'tbEndTime',
										type: 'datetime', required: true })
								)
							),
							_react2['default'].createElement(
								'div',
								{ className: 'row' },
								_react2['default'].createElement(
									'div',
									{ className: 'col-1-2' },
									_react2['default'].createElement(_componentsButtonButtonJsx2['default'], { type: 'button',
										disabled: submitting,
										text: (0, _commonLang.getItem)('SAVE') })
								),
								_react2['default'].createElement(
									'div',
									{ className: 'col-1-2' },
									_react2['default'].createElement(_componentsButtonButtonJsx2['default'], { type: 'button',
										disabled: submitting,
										text: (0, _commonLang.getItem)('SUBMIT') })
								)
							)
						)
					)
				);
			}
		}, {
			key: 'openApply',
			value: function openApply(e) {
				this.refs.apply.open(e);
			}
		}]);
	
		return RepairClockInMgrHistory;
	})(_react.Component);
	
	exports['default'] = _fluxUtils.Container.create(RepairClockInMgrHistory);
	module.exports = exports['default'];

/***/ }),
/* 403 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _objectAssign = __webpack_require__(279);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	var _react = __webpack_require__(23);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _fluxUtils = __webpack_require__(228);
	
	// import { dispatch } from '../../dispatcher/Dispatcher';
	// import { getItem as getLang } from '../../common/lang';
	
	var _commonUtilsAjax = __webpack_require__(222);
	
	var _commonUtilsAjax2 = _interopRequireDefault(_commonUtilsAjax);
	
	// import UserDataUtils from '../../data-utils/UserDataUtils';
	
	var _dataUtilsRepairClockInDataUtils = __webpack_require__(304);
	
	var _dataUtilsRepairClockInDataUtils2 = _interopRequireDefault(_dataUtilsRepairClockInDataUtils);
	
	var Test = (function (_Component) {
	  _inherits(Test, _Component);
	
	  function Test(props) {
	    _classCallCheck(this, Test);
	
	    _get(Object.getPrototypeOf(Test.prototype), 'constructor', this).call(this, props);
	    // ajax.get('http://101.230.3.2:8088/ess-calc-exce-timeclock?peroid=')
	    //     .then((res) => {
	    //         console.log(res);
	    //     });
	
	    _dataUtilsRepairClockInDataUtils2['default'].getEmpRciPeriodList('');
	  }
	
	  _createClass(Test, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {}
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {}
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2['default'].createElement(
	        'div',
	        null,
	        _react2['default'].createElement(
	          'h3',
	          null,
	          'hello world!'
	        )
	      );
	    }
	  }]);
	
	  return Test;
	})(_react.Component);
	
	exports['default'] = Test;
	module.exports = exports['default'];

/***/ })
]);


// WEBPACK FOOTER //
// app.4113c10458685a1096a2.js